webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return INTEGRATIONS_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return KIBANA_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TOKEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LOGOUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return RPC_FIRMWARE_REVISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EDID_FIRMWARE_REVISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_ID_FOR_EXTENDED_TESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PLAYER_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GRAFANA_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GRAFANA_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GRAFANA_DEFAULT_DATASOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GRAFANA_ORIGIN_DATASOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GRAFANA_UPTIME_URL; });
/* unused harmony export GRAFANA_DASHBOARD_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DASHBOARD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NEW_ADMIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return HUBSPOT_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PANDADOC_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PANDADOC_SECRET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PANDADOC_REDIRECT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INTERCOM_BASE_URL; });
// Login redirects to production, https://admin.boxcast.com/
var API_ROOT = 'https://rest.boxcast.com';
var INTEGRATIONS_ROOT = 'https://integration.boxcast.com';
var KIBANA_URL = 'https://kibana.boxcast.com';
var LOGIN_URL = 'https://login.boxcast.com';
var AUTH_URL = 'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=N5YrtbykHOw-ry2FVocJ&redirect_uri=https%3A%2F%2Fadmin.boxcast.com%2F&scope=admin';
var TOKEN_URL = 'https://rest.boxcast.com/oauth2/token';
var LOGOUT_URL = 'https://rest.boxcast.com/oauth2/auth/sessions/login/revoke';
var RPC_FIRMWARE_REVISION = 632;
var EDID_FIRMWARE_REVISION = 4008;
var ACCOUNT_ID_FOR_EXTENDED_TESTS = 'MANUFFIL';
var PLAYER_ENV = 'prod';
var ENV = 'prod';
var GRAFANA_API_KEY = 'eyJrIjoiZXU5cDhwSHlLY2U5YkEyc0tIZzBUQlc5U3h6TGJmamEiLCJuIjoiYWRtaW4iLCJpZCI6MX0=';
var GRAFANA_API_URL = 'https://grafana.boxcast.com/api/datasources/proxy';
var GRAFANA_DEFAULT_DATASOURCE = '1';
var GRAFANA_ORIGIN_DATASOURCE = '6';
var GRAFANA_UPTIME_URL = 'https://grafana.boxcast.com/dashboard/db/boxcaster-uptime';
var GRAFANA_DASHBOARD_URL = 'https://grafana.boxcast.com/dashboard/db';
var DASHBOARD_URL = 'https://dashboard.boxcast.com';
var NEW_ADMIN_URL = 'https://admin3.boxcast.com';
var HUBSPOT_BASE_URL = 'https://app.hubspot.com/contacts/484866';
var PANDADOC_CLIENT_ID = '439e935dfb976e339628';
var PANDADOC_SECRET = 'de54b39bca4c2732497cb6ae512dadc19cf209c3';
var PANDADOC_REDIRECT_URL = 'https://admin.boxcast.com/pandadoc';
var INTERCOM_BASE_URL = 'https://app.intercom.com/a/apps/n4ioj8zx';

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canPaginate; });
function canPaginate($scope, $location) {
  _.extend($scope, _.pick($location.search(), 'q', 's', 'p'), {
    query: function query(q) {
      return $location.search('q', q);
    },
    sort: function sort(s) {
      return $location.search('s', $scope.s !== s ? s : "-".concat(s));
    },
    page: function page(p) {
      return $location.search('p', p);
    }
  });
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canFilter; });
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function canFilter($scope, $location) {
  var f;
  $scope.f = {};

  if (f = $location.search().f) {
    _.each(f.split(' '), function (tag) {
      var kv = tag.split(':');
      var k = kv.shift();
      var v = kv.length > 0 ? decodeURIComponent(kv.join(':')) : true;

      if (v[0] === '{') {
        v = JSON.parse(v);
      }

      return $scope.f[k] = v;
    });
  }

  $scope.filter = function (k, v) {
    if (k.indexOf('.') >= 0) {
      var context = $scope.f;
      var chain = k.split('.');

      while (context && chain.length > 1) {
        context = context[chain.shift()];
      }

      context[chain[0]] = v;
    } else {
      $scope.f[k] = v;
    }

    f = $scope.getFilterParam();
    return $location.search('f', f || undefined);
  };

  $scope.getFilterParam = function () {
    return _.map($scope.f, function (v, k) {
      if (v === true) {
        return k;
      } else if (v === false || v === undefined) {
        return "";
      } else {
        if (_typeof(v) === 'object') {
          v = JSON.stringify(v);
        }

        return "".concat(k, ":").concat(encodeURIComponent(v));
      }
    }).sort().join(' ').replace(/\s\s+/g, ' ').trim();
  };
}

;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var STORAGE_DURATIONS = [{
  value: "7",
  label: "7 Days"
}, {
  value: "30",
  label: "30 Days"
}, {
  value: "60",
  label: "60 Days"
}, {
  value: "90",
  label: "90 Days"
}, {
  value: "365",
  label: "365 Days"
}, {
  value: "731",
  label: "2 Years"
}, {
  value: "1096",
  label: "3 Years"
}, {
  value: "1461",
  label: "4 Years"
}, {
  value: "1826",
  label: "5 Years"
}];
angular.module('app.views').controller('AccountFormController', ["$scope", "$location", "$routeParams", "$modalInstance", "$filter", "Account", "Config", "Reseller", "User", "FeatureBillingService", "Manufacturer", "AccountSubscriptions", function ($scope, $location, $routeParams, $modalInstance, $filter, Account, Config, Reseller, User, FeatureBillingService, Manufacturer, AccountSubscriptions) {
  $scope.config = Config;
  $scope.isSaving = false;
  var now = new Date();
  var expiry = new Date(new Date().getTime() + 42 * 86400000); // 6 weeks from now

  $scope.storageDurations = _.clone(STORAGE_DURATIONS);

  function randomPassword(len) {
    var alphabet, i, jumble;
    alphabet = '23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghikmnpqrstuvwxyz';

    jumble = function () {
      var j, ref, results;
      results = [];

      for (i = j = 1, ref = len; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        results.push(alphabet.substr(Math.floor(Math.random() * alphabet.length), 1));
      }

      return results;
    }();

    return jumble.join('');
  }

  ; // new account defaults

  $scope.tags = [];

  $scope.toggleTag = function (tag) {
    hasTag(tag) ? removeTag(tag) : addTag(tag);
  };

  $scope.flags = {
    showAdvancedConfig: false,
    streamQuality: null
  };
  $scope.usageFlags = [];

  $scope.toggleUsageFlag = function (usageFlag) {
    hasUsageFlag(usageFlag) ? removeUsageFlag(usageFlag) : addUsageFlag(usageFlag);
  };

  $scope.extraFeatures = [];

  $scope.toggleExtraFeature = function (extraFeature) {
    hasExtraFeature(extraFeature) ? removeExtraFeature(extraFeature) : addExtraFeature(extraFeature);
  };

  $scope.behaviorModifications = [];

  $scope.toggleBehaviorModification = function (behaviorModification) {
    hasBehaviorModification(behaviorModification) ? removeBehaviorModification(behaviorModification) : addBehaviorModification(behaviorModification);
  };

  $scope.resellers = Reseller.query({
    l: 1000
  });
  $scope.isNew = !$routeParams.id;

  if ($scope.isNew) {
    // Defaults for new account
    $scope.account = {
      expires_on: "".concat(expiry.getMonth() + 1, "/").concat(expiry.getDate(), "/").concat(expiry.getFullYear()),
      time_zone: 'Eastern Time (US & Canada)',
      status: 'initial',
      payment_status: 'info_requested',
      ticket_revenue_share: '75',
      sale_closed_on: "".concat(now.getMonth() + 1, "/").concat(now.getDate(), "/").concat(now.getFullYear()),
      metadata: {},
      reseller: ''
    };
    $scope.newUser = {
      enabled: true,
      sendVerification: true,
      sendPayment: true,
      user: {}
    };
    $scope.newManufacturer = {
      doCreate: false,
      manufacturer: {}
    };
  } else {
    $scope.account = Account.get({
      id: $routeParams.id
    }, function (data) {
      tagsFromString(data.tags, data.resolution_limit);
      $scope.usageFlags = data.usage_flags ? data.usage_flags.split(' ') : [];
      $scope.extraFeatures = data.extra_features ? data.extra_features.split(' ') : [];
      $scope.behaviorModifications = data.behavior_modifications ? data.behavior_modifications.split(' ') : [];

      if (!data.storage_policy) {
        $scope.storageDurations.unshift({
          value: "0",
          label: "No expiration"
        });
        $scope.accountNeedsAStoragePolicy = true;
      }
    });
    $scope.account.$promise.then(function () {
      if ($scope.account.stripe_customer_handle) {
        $scope.subscriptions = AccountSubscriptions.get({
          account_id: $routeParams.id
        });
        $scope.subscriptions.$promise.then(function () {
          $scope.featureSummary = FeatureBillingService.featureSummary($scope.account, $scope.subscriptions.features);
          $scope.flags.showAdvancedConfig = $scope.featureSummary.extraFlags.length || $scope.featureSummary.missingFlags.length;
        });
      } else {
        $scope.flags.showAdvancedConfig = true;
      }

      if (!$scope.account.metadata) {
        $scope.account.metadata = {};
      }
    });
  }

  $scope.isExtraTag = function (tag) {
    if (!$scope.featureSummary) return undefined;
    return $scope.featureSummary.extraFlags.find(function (obj) {
      return obj.value == tag;
    });
  };

  $scope.isMissingTag = function (tag) {
    if (!$scope.featureSummary) return undefined;
    return $scope.featureSummary.missingFlags.find(function (obj) {
      return obj.value == tag;
    });
  };

  function hasTag(tag) {
    return $scope.tags.indexOf(tag) >= 0;
  }

  function addTag(tag) {
    $scope.tags.push(tag);
  }

  function removeTag(tag) {
    $scope.tags = FeatureBillingService.removeTag($scope.tags, tag);
  }

  $scope.specialTagsToSkip = ['low_cost_plan'];

  function tagsFromString(tagStr, resolutionLimit) {
    // turn space-delimited string into array
    $scope.tags = "".concat(tagStr) === '' ? [] : tagStr.split(' '); // also extract/stash a few separate fields directly onto scope

    if (resolutionLimit == 480) {
      $scope.flags.streamQuality = 'sd';
    } else if (hasTag('low_cost_plan')) {
      removeTag('low_cost_plan');
      $scope.flags.streamQuality = 'low_cost';
    } else if (resolutionLimit == 720) {
      $scope.flags.streamQuality = '720';
    } else if (resolutionLimit == 1080) {
      $scope.flags.streamQuality = 'hd';
    } else {
      $scope.flags.streamQuality = '4k';
    }
  }

  function tagsToString() {
    // array to string
    // also re-encode the separately-managed fields from scope
    switch ($scope.flags.streamQuality) {
      case 'sd':
        $scope.account.resolution_limit = 480;
        break;

      case 'low_cost':
        $scope.account.resolution_limit = 720;
        addTag('low_cost_plan');
        break;

      case '720':
        $scope.account.resolution_limit = 720;
        break;

      case 'hd':
        $scope.account.resolution_limit = 1080;
        break;

      case '4k':
        $scope.account.resolution_limit = 2160;
        break;

      default:
        throw new Error('Streaming quality is required');
    }

    return $scope.tags.sort().join(' ');
  }

  function hasUsageFlag(usageFlag) {
    return $scope.usageFlags.indexOf(usageFlag) >= 0;
  }

  function addUsageFlag(usageFlag) {
    $scope.usageFlags.push(usageFlag);
  }

  function removeUsageFlag(usageFlag) {
    var idx = $scope.usageFlags.indexOf(usageFlag);

    if (idx >= 0) {
      $scope.usageFlags.splice(idx, 1);
    }
  }

  function hasExtraFeature(extraFeature) {
    return $scope.extraFeatures.indexOf(extraFeature) >= 0;
  }

  function addExtraFeature(extraFeature) {
    $scope.extraFeatures.push(extraFeature);
  }

  function removeExtraFeature(extraFeature) {
    var idx = $scope.extraFeatures.indexOf(extraFeature);

    if (idx >= 0) {
      $scope.extraFeatures.splice(idx, 1);
    }
  }

  function hasBehaviorModification(behaviorModification) {
    return $scope.behaviorModifications.indexOf(behaviorModification) >= 0;
  }

  function addBehaviorModification(behaviorModification) {
    $scope.behaviorModifications.push(behaviorModification);
  }

  function removeBehaviorModification(behaviorModification) {
    var idx = $scope.behaviorModifications.indexOf(behaviorModification);

    if (idx >= 0) {
      $scope.behaviorModifications.splice(idx, 1);
    }
  }

  $scope.ok = function () {
    var account;

    if ($scope.account.storage_policy && !$scope.account.storage_duration_days) {
      alert("Please select a storage duration.");
      return;
    }

    if (!$scope.account.storage_policy) {
      $scope.account.storage_duration_days = '0';
    }

    $scope.account.tags = tagsToString();
    $scope.account.usage_flags = $scope.usageFlags.sort().join(' ');
    $scope.account.extra_features = $scope.extraFeatures.sort().join(' ');
    $scope.account.behavior_modifications = $scope.behaviorModifications.sort().join(' ');

    if (!$scope.account.metadata.show_sunday_streams_import) {
      delete $scope.account.metadata.show_sunday_streams_import;
    }

    $scope.isSaving = true;
    expiry = new Date($scope.account.expires_on);

    if (expiry.getTime() > 0) {
      $scope.account.expires_on = expiry.toISOString().substr(0, 10);
    }

    var sale_closed_on = new Date($scope.account.sale_closed_on);

    if (sale_closed_on.getTime() > 0) {
      $scope.account.sale_closed_on = sale_closed_on.toISOString().substr(0, 10);
    }

    if (!$scope.account.payment_status) {
      delete $scope.account.payment_status;
    }

    if ($scope.isNew) {
      // Force lowercase e-mail for dupe checking
      $scope.newUser.user.email = $filter('lowercase')($scope.newUser.user.email);
      $scope.newManufacturer.manufacturer.name = $scope.account.name; // New account wizard artifically separates name to enforce consistency

      account = angular.copy($scope.account);

      if (account.city_state) {
        account.name = "".concat(account.name.trim(), " - ").concat(account.city_state.trim());
      }

      delete account.city_state;
      var promise1 = Account.save(account).$promise;
      var promise2 = promise1.then(function (a) {
        if ($scope.newManufacturer.doCreate) {
          var m = angular.copy($scope.newManufacturer.manufacturer);
          var generatedPassword = randomPassword(16);
          m.account_id = a.id;
          m.password = generatedPassword;
          return Manufacturer.save(m, function (m) {
            // download a yaml file with credentials to be used in the manufacturing process
            var ymlStr = "---\nuser: ".concat(m.id, "\npassword: ").concat(generatedPassword);
            var downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute("href", "data:text;charset=utf-8,".concat(encodeURIComponent(ymlStr)));
            downloadAnchorNode.setAttribute("download", "creds.yml");
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
          }, function (err) {
            alert('Error creating manufacturer');
          }).$promise;
        }
      });
      return Promise.all([promise1, promise2]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            a = _ref2[0],
            m = _ref2[1];

        // create initial user (and send emails) if necessary before closing modal
        if ($scope.newUser.enabled) {
          var u = angular.copy($scope.newUser.user);
          u.account_id = a.id;
          u.name = u.email; //shortcut

          u.roles = ['standard-user'];

          if ($scope.newUser.sendVerification) {
            u.requires_verification = true;
          }

          if ($scope.newUser.sendPayment) {
            u.request_payment_email = true;
          }

          return User.save(u, function (u) {
            return $modalInstance.close(a);
          }, function (err) {
            // account was created but first user was not
            alert('You will now be taken to the new account page. Please create the user again there.');
            return $modalInstance.close(a);
          });
        } else {
          return $modalInstance.close(a);
        }
      });
    } else {
      var promise = Account.update($scope.account).$promise;
      return promise.then(function (a) {
        return $modalInstance.close(a);
      })["catch"](function (err) {
        $scope.isSaving = false;
      });
    }
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// shouldShowAdminRole determines if an admin role should be shown in the list of roles from which
// the user is allowed to choose.
var shouldShowAdminRole = function shouldShowAdminRole(rootScope, account, user, role) {
  if (!!account.reseller_id) {
    // For reseller accounts, we only consider the 'reseller-admin' role, which we only want to
    // allow if the current user is a system admin.
    return role.value == 'reseller-admin' && rootScope.me.isSystemAdmin();
  } // Otherwise, for non-reseller-admin roles, always show the other admin roles if the current user
  // is a system admin OR the user being edited already has this role.


  return role.value != 'reseller-admin' && (rootScope.me.isSystemAdmin() || _.contains(user.roles, role.value));
};

angular.module('app.views').controller('UserFormController', ["$rootScope", "$scope", "$location", "$routeParams", "$modalInstance", "$filter", "$modal", "User", "Config", "account", function ($rootScope, $scope, $location, $routeParams, $modalInstance, $filter, $modal, User, Config, account) {
  $scope.isSaving = false;
  $scope.user = {
    role: 'standard-user'
  };
  $scope.userRoles = angular.copy(Config.userRoles);
  $scope.resetPasswordConfirmation = false;
  $scope.requiresVerification = false;
  $scope.requestPaymentConfirmation = false;
  $scope.formChange = false;
  $scope.confirmDowngradeOwner = {
    val: false
  };
  $scope.ownerErrorMessage = '', $scope.verifiedText = 'VERIFIED';
  $scope.pendingText = 'PENDING';
  $scope.pristineUser = {
    role: 'standard-user'
  };

  var addAdminRoles = function addAdminRoles(user) {
    _.each(Config.adminRoles, function (r) {
      if (shouldShowAdminRole($rootScope, account, user, r)) {
        $scope.userRoles.push(r);
        return;
      }
    });
  };

  var removeOwnerRole = function removeOwnerRole() {
    var index = _.findIndex($scope.userRoles, function (r) {
      return r.value = 'owner';
    });

    if (index > -1) {
      $scope.userRoles.splice(index, 1);
    }
  };

  $scope.isNew = !$routeParams.account_id;

  if (!$scope.isNew) {
    User.get({
      account_id: $routeParams.account_id,
      id: $routeParams.id
    }).$promise.then(function (res) {
      $scope.user = res;
      addAdminRoles($scope.user); // Turn roles into role for convenience

      if ($scope.user.roles.length > 0) {
        $scope.user.role = $scope.user.roles[0];
      }

      ;
      $scope.pristineUser = angular.copy($scope.user);
    });
  } else {
    addAdminRoles($scope.user);
    removeOwnerRole();
  }

  $scope.isDowngradingOwner = function () {
    return $scope.pristineUser.role == 'owner' && $scope.user.role != 'owner';
  };

  $scope.sendPasswordReset = function () {
    if (!confirm('Are you sure you want to send a password reset link to this user?')) {
      return;
    }

    User.passwordReset({
      account_id: $routeParams.account_id,
      id: $routeParams.id
    });
    $scope.resetPasswordConfirmation = true;
  };

  $scope.resendVerificationEmail = function () {
    if (!confirm('Are you sure you want to resend the verification email to this user?')) {
      return;
    }

    return User.update({
      account_id: $scope.user.account_id,
      id: $scope.user.id,
      requires_verification: true
    }).$promise.then(function (res) {
      $scope.requiresVerification = true;
      $scope.user = res;
    });
  };

  $scope.sendPaymentRequest = function () {
    if (!confirm('Are you sure you want to send a payment request to this user?')) {
      return;
    }

    return User.update({
      account_id: $scope.user.account_id,
      id: $scope.user.id,
      request_payment_email: true
    }).$promise.then(function (res) {
      $scope.requestPaymentConfirmation = true;
      $scope.user = res;
    });
  };

  $scope.addAuthorizedAccount = function () {
    var modalInstance = $modal.open({
      template: __webpack_require__(203),
      controller: 'AddAuthorizedAccountController',
      size: 'md',
      backdrop: 'static'
    });
    modalInstance.result.then(function (res) {
      $scope.user = res;
      $scope.user.role = res.roles[0];
    });
  };

  $scope.deleteAuthorizedAccount = function (a) {
    if (!confirm("Are you sure you want to delete this authorized account?")) {
      return;
    }

    var ids = _.pluck($scope.user.authorized_accounts, 'id');

    if (ids.length == 0) {
      ids = [$scope.user.account_id];
    }

    var index = ids.indexOf(a.id);
    ids.splice(index, 1);
    return User.update({
      account_id: $scope.user.account_id,
      id: $scope.user.id,
      authorized_account_ids: ids
    }).$promise.then(function (res) {
      $scope.user = res;
      $scope.user.role = res.roles[0];
    });
  };

  $scope.$watch('user', function () {
    $scope.formChange = !angular.equals($scope.user, $scope.pristineUser);
    $scope.roleChange = $scope.user.role != $scope.pristineUser.role;
    $scope.emailChange = $scope.pristineUser.email != $scope.user.email;
    $scope.upgradingRole = $scope.pristineUser.role != 'owner' && $scope.user.role == 'owner';
  }, true);

  $scope.checkPendingEmailChange = function () {
    if ($scope.user.pending_email_update != $scope.pristineUser.pending_email_update) {
      $scope.pendingText = 'UNVERIFIED';
      document.getElementById('pending-text').style.backgroundColor = '#777';
    } else {
      $scope.pendingText = 'PENDING';
      document.getElementById('pending-text').style.backgroundColor = '#EEAD4D';
    }
  };

  $scope.isVerified = function () {
    if ($scope.user.email != $scope.pristineUser.email) {
      $scope.verifiedText = 'UNVERIFIED';
      document.getElementById('verified-text').style.backgroundColor = '#777';
    } else if ($scope.user.email == $scope.pristineUser.email) {
      $scope.verifiedText = 'VERIFIED';
      document.getElementById('verified-text').style.backgroundColor = '#1CA6A0';
    }
  };

  $scope.ownerError = function () {
    if ($scope.user.role == 'owner' && $scope.user.authorized_accounts.length > 1) {
      $scope.ownerErrorMessage = "This email is associated with multiple BoxCast accounts. Users who are authorized to access multiple accounts are not able to be assigned the Owner role.";
      return true;
    } else if ($scope.roleChange && $scope.user.role == 'owner' && !$scope.user.is_verified) {
      $scope.ownerErrorMessage = "Users with an unverified email address cannot be made the Owner of an account. Please have the user verify their email or assign the Owner role to a different user.";
      return true;
    }

    return false;
  };

  $scope.ok = function () {
    $scope.isSaving = true;

    if ($scope.user.pending_email_update) {
      $scope.user.email = $scope.user.pending_email_update;
    } // Change "role" into "roles"


    if ($scope.user.role && $scope.user.role !== '') {
      $scope.user.roles = [$scope.user.role];
    } else {
      $scope.user.roles = ['standard-user'];
    }

    delete $scope.user.role; // Force lowercase e-mail for dupe checking

    $scope.user.email = $filter('lowercase')($scope.user.email);

    if ($scope.isNew) {
      $scope.user.account_id = $routeParams.id;
      return User.save($scope.user, function (u) {
        return $modalInstance.close(u);
      }, function (err) {
        return $scope.isSaving = false;
      });
    } else {
      if ($scope.user.pending_email_update) {
        $scope.user.email = $scope.user.pending_email_update;
      }

      if ($scope.pristineUser.role == 'owner' && $scope.user.roles[0] === 'owner') {
        delete $scope.user.roles;
      }

      $scope.user.account_id = $routeParams.account_id;
      return User.update($scope.user, function (u) {
        return $modalInstance.close(u);
      }, function (err) {
        return $scope.isSaving = false;
      });
    }
  };

  $scope["delete"] = function () {
    if ($scope.user.id == $rootScope.me.id) {
      alert('You cannot delete your own user.');
      return;
    }

    if (!confirm('Are you sure you want to delete this user? The action cannot be undone.')) {
      return;
    }

    $scope.isSaving = true;
    User["delete"]($scope.user, function (ok) {
      $modalInstance.close(ok);
      history.go(-1);
    }, function (err) {
      console.error(err);
      alert('Unable to delete: ' + err);
      $scope.isSaving = false;
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(moment, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').controller('ChangeSubscriptionFormController', ["$scope", "$modalInstance", "$http", "$q", "$routeParams", "toaster", "subscription", function ($scope, $modalInstance, $http, $q, $routeParams, toaster, subscription) {
  $scope.$http = $http;
  $scope.$routeParams = $routeParams;
  $scope.toaster = toaster;
  $scope.subscription = subscription;
  $scope.loading = true;
  $http.get("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/checkout/free_trial_plans")).then(function (result) {
    $scope.plans = result.data; // Use sane defaults for selected base plan and end date

    $scope.selectedPlan = $scope.plans[0].product_id;
    $scope.endDate = moment().add(14, 'days').toISOString();

    if (subscription) {
      $scope.initFromSub(subscription);
    }

    $scope.loading = false;
  })["catch"](function (err) {
    console.error(err);
    $scope.toaster.pop({
      type: 'error',
      body: "Error loading free trial options. Please try again.",
      timeout: 2000
    });
    $scope.loading = false;
  });

  $scope.initFromSub = function (sub) {
    // Initialize selected base plan
    var items = sub.items || [];

    _.forEach(items, function (item) {
      var matchedPlan = _.find($scope.plans, function (p) {
        return p.product_id == item.product_id;
      });

      if (matchedPlan) {
        $scope.selectedPlan = matchedPlan.product_id;
      }
    });

    $scope.endDate = moment(sub.period_end).toISOString();
  };

  $scope.onSelectPlan = function (plan) {
    $scope.selectedPlan = plan;
  };

  $scope.update = function () {
    $scope.isUpdating = true;

    if ($scope.loading) {
      return;
    }

    var endDate = moment($scope.endDate);
    $scope.$http.post("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/checkout/try"), {
      account_id: $scope.$routeParams.id,
      plan: $scope.selectedPlan,
      trial_end_date: endDate.toISOString()
    }).success(function (data) {
      $modalInstance.close(data);
    }).error(function (error) {
      $scope.isUpdating = false;
      console.error(error);
      $scope.toaster.pop({
        type: 'error',
        body: "Error updating subscription. Please try again.",
        timeout: 2000
      });
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28), __webpack_require__(1)))

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">{{ isNew ? 'Create a New' : 'Edit' }} User</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <div ng-show=\"user.is_archived\" class=\"text-danger bg-danger text-center\" style=\"padding:15px;margin:15px\">\n    This user ({{user.email}}) has been deleted and will not be able to log in anymore.\n  </div>\n  <form name=\"form\" role=\"form\" ng-hide=\"user.is_archived\">\n    <div class=\"col-sm-8\">\n      <div class=\"form-group\">\n        <label for=\"name\">Name</label>\n        <input id=\"name\" type=\"text\" ng-model=\"user.name\" required placeholder=\"Enter the user's full name\" class=\"form-control\">\n      </div>\n      <div class=\"form-group\">\n        <label for=\"email\">Email</label>\n        <div class=\"form-group row\">\n          <div class=\"col-md-9\">\n            <input id=\"email\" type=\"email\" ng-if=\"!user.pending_email_update\" ng-model=\"user.email\" ng-keyup=\"isVerified()\" required placeholder=\"Enter the user's email address\" class=\"form-control\">\n            <input id=\"email\" type=\"email\" ng-if=\"user.pending_email_update\" ng-model=\"user.pending_email_update\" ng-keyup=\"checkPendingEmailChange()\" required placeholder=\"Enter the user's email address\" class=\"form-control\">\n          </div>\n          <div class=\"col-md-3\">\n            <label ng-if=\"user.is_verified && !user.pending_email_update\" class=\"badge badge-secondary\" id=\"verified-text\" style=\"margin-top: 6px; background-color: #1CA6A0;\">{{verifiedText}}</label>\n            <label ng-if=\"!user.is_verified\" class=\"badge badge-secondary\" style=\"margin-top: 6px;\">UNVERIFIED</label>\n            <label ng-if=\"user.pending_email_update\" class=\"badge\" id=\"pending-text\" style=\"margin-top: 6px; background-color: #EEAD4D;\">{{ pendingText }}</label>\n          </div>\n\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"hubspot_contact_handle\">\n          HubSpot Contact ID\n          <i class=\"fa fa-info-circle pull-right\" tooltip=\"/contacts/484866/contact/123456789\"></i>\n        </label>\n        <input id=\"hubspot_contact_handle\" type=\"text\" ng-model=\"user.hubspot_contact_handle\" placeholder=\"123456789\" class=\"form-control\">\n      </div>\n      <div class=\"form-group\">\n        <label for=\"role\">Role</label>\n        <p ng-hide=\"isNew\" class=\"help-text\" style=\"font-size:0.8em;opacity:0.8;\">\n          Updating a user’s role will automatically log them out of their account.\n        </p>\n        <select id=\"role\" class=\"form-control\" \n          ng-model=\"user.role\"\n          ng-options=\"option.value as option.label for option in userRoles\">\n        </select>\n        <p ng-repeat=\"option in userRoles\"\n           ng-show=\"option.value == user.role\"\n           class=\"help-text\" style=\"font-size:0.8em;margin-top:5px;opacity:0.8;\">\n          <i class=\"fa fa-info-circle\"></i> {{option.hint}}\n        </p>\n        <p ng-show=\"ownerError(user)\" class=\"help-text\" style=\"font-size:0.8em;margin-top:5px;opacity:0.8;color: red;\">{{ ownerErrorMessage }}</p>\n        <p ng-show=\"isNew && user.role == 'owner'\" class=\"help-text\" style=\"font-size:0.8em;margin-top:5px;opacity:0.8;color: red;\">Users with an unverified email address cannot be made the Owner of an account. Please have the user verify their email or assign the Owner role to a different user.</p>\n      </div>\n      <div class=\"form-group\" ng-if=\"pristineUser.role == 'owner' && user.role != 'owner'\">\n        <div class=\"checkbox\">\n          <label><input type=\"checkbox\" ng-click=\"confirmDowngradeOwner.val = !confirmDowngradeOwner.val\">I understand that downgrading this user from their status as the account Owner will immediately log them out and revoke all relevant permissions. Upon logging back in they will be prevented from managing other users on this account.</label>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-sm-4\" style=\"padding-top: 25px;\" ng-if=\"!isNew\">\n      <div class=\"form-group\">\n        <button class=\"btn btn-sm btn-primary\" ng-click=\"sendPasswordReset()\" ng-show=\"!resetPasswordConfirmation\">Send Password Reset</button>\n        <p class=\"text-warning\" ng-show=\"resetPasswordConfirmation\">\n          Password Reset Email Sent.\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <button class=\"btn btn-sm btn-primary\" ng-click=\"resendVerificationEmail()\" ng-show=\"!requiresVerification\" ng-disabled=\"formChange || user.is_verified && !user.pending_email_update\">Resend Verification Email</button>\n        <p class=\"text-warning\" ng-show=\"requiresVerification\">\n          Verification Email Sent.\n        </p>\n      </div>\n      <div class=\"form-group\">\n        <button class=\"btn btn-sm btn-primary\" ng-click=\"sendPaymentRequest()\" ng-show=\"!requestPaymentConfirmation\">Send Payment Request</button>\n        <p class=\"text-warning\" ng-show=\"requestPaymentConfirmation\">\n          Payment Request Email Sent.\n        </p>\n      </div>\n      <hr>\n      <div class=\"form-group\">\n        <p class=\"text-warning\" ng-show=\"user.requires_verification && user.suppressed_reason\">\n          <i class=\"fa fa-warning\"></i> The user's email is suppressed.\n        </p>\n      </div>\n    </div>\n    <div class=\"col-sm-4\" ng-show=\"user.role != 'owner'\">\n      <div class=\"form-group\">\n        <label for=\"authorized_accounts\">Authorized Accounts</label>\n        <p ng-if=\"user.authorized_accounts.length == 0\" class=\"help-text\" style=\"font-size:0.8em;margin-top:5px;opacity:0.8;\">\n          There are no additional authorized accounts listed.\n        </p>\n        <table class=\"table table-striped\" ng-repeat=\"a in user.authorized_accounts\">\n          <tr>\n            <td>{{a.name}}</td>\n            <td class=\"text-right\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"deleteAuthorizedAccount(a)\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button></td>\n          </tr>\n        </table>\n        <button class=\"btn btn-sm btn-default\" ng-hide=\"user.isAdmin()\" ng-click=\"addAuthorizedAccount()\">Add Authorized Account</button>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-hide=\"user.is_archived || user.id == $root.me.id\" class=\"pull-left btn btn-link\" ng-click=\"delete()\"><i class=\"fa fa-trash\"></i> Delete</button>\n  <button ng-hide=\"user.is_archived\" ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving || !formChange || (isDowngradingOwner() && !confirmDowngradeOwner.val) || ownerError() || (emailChange && upgradingRole)\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Create New {{isRma ? 'RMA': 'Upgrade'}} Deal</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form ng-show=\"isRma\" style=\"margin-bottom:25px\" id=\"rma-form\" name=\"form\" role=\"form\">\n    <div class=\"form-group\">\n      <label for=\"summary\">\n          Summary\n      </label>\n      <input id=\"summary\" type=\"text\" ng-model=\"summary\" class=\"form-control\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"customerExpectation\">Customer Expectation</label>\n      <select id=\"customerExpectation\" class=\"form-control\" required\n        ng-model=\"customerExpectation\"\n        ng-options=\"option for option in ::CUSTOMER_EXPECTATION_VALUES\">\n      </select>\n      <p ng-repeat=\"option in ::CUSTOMER_EXPECTATION_VALUES\"\n      ng-show=\"option == customerExpectation\">\n      </p>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"productType\">Product Type</label>\n      <select id=\"productType\" class=\"form-control\" required\n        ng-model=\"productType\"\n        ng-options=\"option for option in ::PRODUCT_TYPE_VALUES\">\n      </select>\n      <p ng-repeat=\"option in ::PRODUCT_TYPE_VALUES\"\n      ng-show=\"option == productType\">\n      </p>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"serialNumber\">\n        Serial Number\n      </label>\n      <tags-input required class=\"bootstrap\" ng-model=\"serialNumber\" add-on-paste=\"true\" max-tags=\"1\" min-tags=\"1\">\n          <auto-complete source=\"loadBoxcasters($query)\" min-length=\"0\" debounce-delay=\"0\"></auto-complete>\n      </tags-input>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"supportLink\">\n        Intercom Conversation Link (or ZenDesk Ticket Link)\n      </label>\n      <input id=\"supportLink\" type=\"text\" ng-model=\"supportLink\" class=\"form-control\" required>\n    </div>\n  </form>\n\n  <div class=\"checkbox\" style=\"margin-bottom:25px\">\n    <label><input type=\"checkbox\" ng-model=\"generateProposal\">Automatically generate a proposal and attach it to the HubSpot Deal</label>\n  </div>\n\n  <div ng-show=\"generateProposal\" class=\"form-group\">\n    <label for=\"recipient\">PandaDoc Recipient</label>\n    <select id=\"recipient\" class=\"form-control\" required\n      ng-model=\"recipient\"\n      ng-options=\"option as option.email for option in users\">\n    </select>\n    <p ng-repeat=\"option in users\"\n    ng-show=\"option.email == recipient.email\">\n    </p>\n  </div>\n  <div ng-show=\"generateProposal\">\n    <label for=\"select-template\">PandaDoc Template</label>\n    <div ng-if=\"template == null\">\n      <button id=\"select-template\" type=\"button\" class=\"btn btn-primary\" ng-click=\"onSelectTemplate()\">Select template</button>\n    </div>\n    <div ng-if=\"template != null\">\n      <span style=\"margin-right:5px\">{{template.name}}</span>\n      <button id=\"select-template\" type=\"button\" class=\"btn btn-default\" ng-click=\"onSelectTemplate()\">Change</button>\n    </div>\n  </div>\n  <div ng-show=\"dealId\" style=\"margin-top:20px\">\n    <small>Existing HubSpot Deal <strong>{{dealId}}</strong> will be used for this upgrade.</small>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n  <button ng-click=\"ok()\" ng-disabled=\"isCreating || !isValid()\" class=\"btn btn-primary\"><i ng-show=\"isCreating\" class=\"fa fa-cog fa-spin\"></i> Create</button>\n</div>\n"

/***/ }),
/* 102 */
/***/ (function(module, exports) {

angular.module('app.views').controller('BoxcasterFormController', ["$scope", "$routeParams", "$modalInstance", "Boxcaster", "Config", "ElasticsearchService", function ($scope, $routeParams, $modalInstance, Boxcaster, Config, ElasticsearchService) {
  $scope.config = Config;
  $scope.isSaving = false;
  $scope.isNew = !$routeParams.id;

  if (!$scope.isNew) {
    $scope.boxcaster = Boxcaster.get({
      id: $routeParams.id
    });
    $scope.boxcaster.$promise.then(function (b) {
      if (!b.ethernet_address) {
        $scope.suggested_ethernet_address = b.id.substring(1);
      }

      if (!b.wireless_address) {
        if ($scope.canHaveWirelessMac(b)) {
          console.log('Attempting to look up wireless mac'); // Poor-man's "last couple of days"

          var now = new Date(),
              yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
          ElasticsearchService.query(ElasticsearchService.formatIndices(yesterday, now), {
            query: {
              bool: {
                filter: [{
                  query_string: {
                    query: "hostname:(".concat(b.id, ")")
                  }
                }, {
                  query_string: {
                    query: "tag:(\"boxcaster.syslog.user\")"
                  }
                }, {
                  query_string: {
                    query: "message:(\"wpa_action: address=\")"
                  }
                }]
              }
            },
            size: 1,
            sort: [{
              '@timestamp': {
                order: 'desc'
              }
            }]
          }).then(function (resp) {
            if (resp.data && resp.data.hits && resp.data.hits.hits && resp.data.hits.hits.length > 0 && resp.data.hits.hits[0]['_source'] && resp.data.hits.hits[0]['_source'].message) {
              var m = resp.data.hits.hits[0]['_source'].message.match(/wpa_action: address=([0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2}:[0-9a-f]{2})/);

              if (m && m[1]) {
                $scope.suggested_wireless_address = m[1].replace(/:/g, '').toLowerCase();
              } else {
                console.log('Wireless mac not found in hits', resp.data.hits);
              }
            } else {
              console.log('Wireless mac not found (no hits returned)', resp);
            }
          })["catch"](function (e) {
            return console.error(e);
          });
        } else {
          console.log('Not attempting to look up wireless mac');
        }
      }
    })["catch"](function (e) {
      return console.error(e);
    });
  }

  $scope.$watch('boxcaster.ethernet_address', function () {
    if ($scope.boxcaster && $scope.boxcaster.ethernet_address !== null && $scope.boxcaster.ethernet_address !== undefined) {
      return $scope.boxcaster.ethernet_address = $scope.boxcaster.ethernet_address.toLowerCase().replace(/[^0-9a-f]/g, '');
    }
  });
  $scope.$watch('boxcaster.wireless_address', function () {
    if ($scope.boxcaster && $scope.boxcaster.wireless_address !== null && $scope.boxcaster.wireless_address !== undefined) {
      return $scope.boxcaster.wireless_address = $scope.boxcaster.wireless_address.toLowerCase().replace(/[^0-9a-f]/g, '');
    }
  });

  $scope.canHaveWirelessMac = function (b) {
    return b && b.id && (b.id[0] === 'o' || b.id[0] === 'p');
  };

  $scope.useSuggestedEthernetAddress = function () {
    $scope.boxcaster.ethernet_address = $scope.suggested_ethernet_address;
    $scope.suggested_ethernet_address = null;
  };

  $scope.useSuggestedWirelessAddress = function () {
    $scope.boxcaster.wireless_address = $scope.suggested_wireless_address;
    $scope.suggested_wireless_address = null;
  };

  $scope.ok = function () {
    $scope.isSaving = true;
    var b = $scope.boxcaster;
    var updated = {
      id: b.id,
      backhaul_protocol: b.backhaul_protocol
    };

    if (b.ethernet_address) {
      updated.ethernet_address = b.ethernet_address;
    }

    if (b.wireless_address) {
      updated.wireless_address = b.wireless_address;
    }

    return Boxcaster.update(updated, function (b) {
      return $modalInstance.close(b);
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);

/***/ }),
/* 103 */
/***/ (function(module, exports) {

angular.module('app.views').controller('BoxcasterInventoryFormController', ["$scope", "$routeParams", "$modalInstance", "Boxcaster", "Account", "Config", function ($scope, $routeParams, $modalInstance, Boxcaster, Account, Config) {
  $scope.config = Config;
  $scope.isSaving = false;
  $scope.isNew = !$routeParams.id;

  if (!$scope.isNew) {
    $scope.boxcaster = Boxcaster.get({
      id: $routeParams.id
    });
    $scope.boxcaster.$promise.then(function (b) {
      return $scope.selectedAccount = b.account_id ? [Account.get({
        id: b.account_id
      })] : null;
    });
  }

  $scope.searchAccounts = function (text) {
    return Account.query({
      q: text
    }).$promise;
  };

  $scope.ok = function () {
    $scope.isSaving = true;
    var b = $scope.boxcaster;
    var updated = {
      id: b.id,
      physical_status: b.physical_status,
      payment_status: b.payment_status,
      special_notes: b.special_notes //account_id: $scope.selectedAccount[0].id

    };
    return Boxcaster.update(updated, function (b) {
      return $modalInstance.close(b);
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {angular.module('app.views').controller('BoxcasterRegisterFormController', ["$scope", "$routeParams", "$modalInstance", "$timeout", "Boxcaster", "Account", function ($scope, $routeParams, $modalInstance, $timeout, Boxcaster, Account) {
  $scope.isSaving = false;
  $scope.selectedAccount = null;
  $scope.isNew = !$routeParams.id;

  if (!$scope.isNew) {
    $scope.boxcaster = Boxcaster.get({
      id: $routeParams.id
    });
  }

  $scope.searchAccounts = function (text) {
    return Account.query({
      q: text
    }).$promise;
  };

  $scope.ok = function () {
    $scope.isSaving = true;
    return Boxcaster.update({
      id: $scope.boxcaster.id,
      account_id: $scope.selectedAccount[0].id
    }, function (a) {
      return $modalInstance.close(a);
    }, function (error) {
      return alert("Error saving: ".concat(error.error_description));
    });
  };

  $timeout(function () {
    $('tags-input input').focus();
  }, 300);

  $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OriginThumbnail;
var GENERIC_SERVER_IMAGES = ['apple-ii', 'bleep-bloop', 'enigma', 'potato', 'you-gotta-be-kitten-me']; // genericServerImageIndex returns the index into GENERIC_SERVER_IMAGES
// that is used for the provided originName. The algorithm is consistent
// and should return the same index for the same origin name (i.e. it's
// not randomized).

function genericServerImageIndex(originName) {
  var charCodeSum = originName.split('').map(function (c) {
    return c.charCodeAt(0);
  }).reduce(function (m, v) {
    return m + v;
  });
  return charCodeSum % GENERIC_SERVER_IMAGES.length;
} // OriginThumbnail returns a promise that should resolve to the URL of a thumbnail image for the
// given origin name.
//
// First, it attempts to load the "expected" origin thumbnail (for origin thumbnails that exist).
// If that succeeds, this returns an object URL for the thumbnail blob (to avoid requesting the
// image again). If the request 404s (meaning there's no thumbnail for this origin), it resolves
// to a relative URL for one of several "generic" server images (defined in GENERIC_SERVER_IMAGES).


function OriginThumbnail($http, $q, originName) {
  return $q(function (resolve, reject) {
    // First, try to get the normally-named thumbnail
    $http({
      method: 'GET',
      url: "/assets/images/origins/".concat(originName, ".jpg"),
      responseType: 'arraybuffer',
      // so we get binary data rather than a string
      'Interceptor-Ignore-Errors': true // to tell the interceptor not to alert on an error

    }).then(function (response) {
      var contentType = response.headers('content-type');

      if (contentType.toLowerCase().startsWith('image/')) {
        // Success! Return an object URL with the contents.
        var blob = new Blob([response.data], {
          type: contentType
        });
        resolve((window.URL || window.webkitURL).createObjectURL(blob));
      } else {
        // The admin CloudFront distribution turns 403s/404s into 200s returning
        // index.html so that direct links into admin work correctly. That means
        // that we're not likely to actually get 403s/404s (as handled by the
        // block below), but will get a 200 with a non-image content type.
        // So this block assumes we _would_ have gotten a 404 and uses the generic
        // image.
        resolve("/assets/images/origins/".concat(GENERIC_SERVER_IMAGES[genericServerImageIndex(originName)], ".jpg"));
      }
    })["catch"](function (err) {
      if (err.status == 403 || err.status == 404) {
        // 404 -- use a generic image
        resolve("/assets/images/origins/".concat(GENERIC_SERVER_IMAGES[genericServerImageIndex(originName)], ".jpg"));
      } else {
        // Not sure what went wrong here, so reject with the error.
        reject(err);
      }
    });
  });
}
;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {angular.module("app.views").controller("TicketsRefundFormController", ["$scope", "tickets", "broadcast", "channel", "account", "Ticket", "ChannelTicket", "$modalInstance", "$q", function ($scope, tickets, broadcast, channel, account, Ticket, ChannelTicket, $modalInstance, $q) {
  var CONCURRENCY_LIMIT = 6;
  $scope.tickets = tickets;
  $scope.broadcast = broadcast;
  $scope.account = account;
  $scope.channel = channel;
  $scope.confirmRefund = {
    confirm: false
  };
  $scope.totalRefund = $scope.tickets.length * $scope.tickets[0].price;

  $scope.ok = function () {
    $scope.loading = true;
    $scope.isRefunding = true;
    var d = $q.defer();
    $scope.refundInBatches($scope.tickets).then(function (result) {
      d.resolve(result);
      $modalInstance.close();
    })["catch"](function (err) {
      d.reject(err);
    });
  };

  $scope.refundInBatches = function (tickets) {
    return $q(function (resolve, reject) {
      var refundQuery = function refundQuery(remaining) {
        var chunk = remaining.slice(0, CONCURRENCY_LIMIT);
        var leftover = remaining.slice(CONCURRENCY_LIMIT);
        var promises = [];

        _.forEach(chunk, function (c) {
          if ($scope.broadcast) {
            promises.push(Ticket.refund({
              broadcast_id: c.broadcast_id,
              id: c.id
            }).$promise);
          }

          if ($scope.channel) {
            promises.push(ChannelTicket.refund({
              channel_id: c.channel_id,
              id: c.id
            }).$promise);
          }
        });

        $q.all(promises).then(function (result) {
          if (leftover.length <= 0) {
            resolve(result);
          } else {
            refundQuery(leftover);
          }
        })["catch"](function (err) {
          reject(err);
        });
      };

      refundQuery(tickets);
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss("cancel");
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\">Refund Tickets</h3>\n</div>\n<div class=\"modal-body clearfix\" ng-if=\"loading\">\n    <div class=\"alert alert-info alert-loading\" style=\"margin-bottom: 30px; max-width: 100% !important;\">\n        <span>Processing Refunds... This may take a few minutes.</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n<div class=\"modal-body clearfix\" ng-if=\"!loading\">\n    <p style=\"margin-bottom: 15px\">\n        <b ng-if=\"broadcast\">{{ broadcast.name }}</b>\n        <b ng-if=\"channel\">{{ channel.name }}</b>\n    </p>\n    <p>{{ account.name }}</p>\n    <p ng-if=\"tickets.length == 1\">Ticket Purchaser: <b>1</b></p>\n    <p ng-if=\"tickets.length > 1\">Ticket Purchaser(s): <b>{{ tickets.length }}</b></p>\n    <p>Total Refund: <b>{{ totalRefund|currency }}</b></p>\n    <p style=\"margin-top: 15px;\"><input type=\"checkbox\" ng-model=\"confirmRefund.confirm\" style=\"margin-right: 15px;\" />I have reviewed the ticket purchaser(s) and total refund for accuracy</p>\n</div>\n<div class=\"modal-footer\" ng-if=\"!isRefunding\">\n    <button ng-click=\"ok()\" ng-disabled=\"!confirmRefund.confirm\" class=\"btn btn-primary\">Confirm</button>\n    <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>"

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Terminate Origin?</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-sm-12\">\n      <p style=\"padding-bottom: 12px;\">\n        When an origin is terminated, all streams on that origin will be stopped and brought up on different origin\n        servers. This can cause a disruption of several minutes. In addition, existing stream/recording data may be\n        lost.\n      </p>\n      <p style=\"color: red; font-weight: bold; padding-bottom: 12px;\">\n        You will disrupt {{ total_viewer_count }} viewer{{ total_viewer_count === 1 ? '' : 's' }} watching {{ broadcast_count }} broadcast{{ broadcast_count === 1 ? '' : 's' }}, plus any linked\n        simulcasts.\n      </p>\n      <div class=\"input-group\" style=\"font-weight: bold; padding-bottom: 12px;\">\n        <div>\n          If you are sure about this, type the name of the origin you intend to terminate here:\n        </div>\n        <input id=\"confirm_origin_name\" type=\"text\" ng-model=\"confirm_origin_name\" ng-pattern=\"origin\" required class=\"form-control\">\n      </div>\n      <div class=\"input-group\" style=\"font-weight: bold; padding-bottom: 12px;\">\n        <div>\n          Enter a note indicating your reason for terminating the origin (this is sent to the product team):\n        </div>\n        <textarea id=\"note\" ng-model=\"note\" required class=\"form-control\"></textarea>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || !dataValid() || isWorking\" class=\"btn btn-danger\"><i ng-show=\"isWorking\" class=\"fa fa-cog fa-spin\"></i> Terminate</button>\n  <button ng-click=\"cancel()\" ng-disabled=\"isWorking\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha256__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_sha256__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }

  _createClass(AuthService, [{
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var token = window.localStorage.oauthAdminToken;
      return typeof token === 'string' || token instanceof String;
    }
  }, {
    key: "isCallback",
    value: function isCallback() {
      var state = window.localStorage.oauthState;

      if (typeof state === 'string' || state instanceof String) {
        var params = parseQueryString(window.location.search.substring(1));
        var code = params.code;
        if (params.state == state && (typeof code === 'string' || code instanceof String)) return true;
        if (params.state !== undefined && params.error) return true;
      }

      return false;
    }
  }, {
    key: "redirectToLogin",
    value: function redirectToLogin() {
      var state = generateRandomString(8);
      var verifier = generateRandomString(48);
      var challenge = b64(__WEBPACK_IMPORTED_MODULE_1_js_sha256___default.a.array(verifier));
      window.localStorage.oauthState = state;
      window.localStorage.oauthVerifier = verifier;
      window.localStorage.oauthAdminPath = window.location.href;
      window.location.replace(__WEBPACK_IMPORTED_MODULE_0_environment__["c" /* AUTH_URL */] + '&state=' + state + '&code_challenge_method=S256&code_challenge=' + challenge);
      throw new Error('halt');
    }
  }, {
    key: "handleCallback",
    value: function handleCallback() {
      var params = parseQueryString(window.location.search.substring(1));

      if (params.code) {
        var code = params.code;
        var verifier = window.localStorage.oauthVerifier;
        params = parseQueryString(__WEBPACK_IMPORTED_MODULE_0_environment__["c" /* AUTH_URL */].substring(__WEBPACK_IMPORTED_MODULE_0_environment__["c" /* AUTH_URL */].indexOf('?') + 1));
        var data = "grant_type=authorization_code&client_id=".concat(params.client_id, "&redirect_uri=").concat(params.redirect_uri, "&code=").concat(code, "&code_verifier=").concat(verifier);
        var post = $.ajax(__WEBPACK_IMPORTED_MODULE_0_environment__["x" /* TOKEN_URL */], {
          'method': 'POST',
          'data': data
        });
        post.done(function (resp) {
          if (resp.token_type === 'bearer') {
            var token = resp.access_token;

            if (token && token.length > 0) {
              window.localStorage.oauthAdminToken = token;
              window.location.replace(window.localStorage.oauthAdminPath || '/');
              throw new Error('halt');
            }
          }
        });
        post.fail(function (resp) {
          console.error('error ' + resp.status + ': ' + resp.statusText);
          var error = 'unknown_error';
          var error_description = 'An unknown error occurred; network status code ' + resp.status;
          var error_hint = '';
          var err = $.parseJSON(resp.responseText);

          if (_typeof(err) === 'object') {
            if (err['error']) error = err['error'];
            if (err['error_description']) error_description = err['error_description'];
            if (err['error_hint']) error_hint = err['error_hint'];
          }

          clearStorage(window.localStorage);
          var l = window.location;
          window.location.replace(__WEBPACK_IMPORTED_MODULE_0_environment__["p" /* LOGIN_URL */] + '/error?error=' + encodeURIComponent(error) + '&error_description=' + encodeURIComponent(error_description) + '&error_hint=' + encodeURIComponent(error_hint) + '&link=' + encodeURIComponent('Return to BoxCast Admin') + '&href=' + encodeURIComponent(l.protocol + '//' + l.hostname + (l.port ? ':' + l.port : '')));
          throw new Error('halt');
        });
        return post;
      } else {
        clearStorage(window.localStorage);
        var error_url = __WEBPACK_IMPORTED_MODULE_0_environment__["p" /* LOGIN_URL */] + '/error?error=' + params['error'];
        if (params['error_description']) error_url += '&error_description=' + params['error_description'];
        if (params['error_hint']) error_url += '&error_hint=' + params['error_hint'];
        window.location.replace(error_url);
        throw new Error('halt');
        return $.Deferred();
      }
    }
  }, {
    key: "logOut",
    value: function logOut() {
      clearStorage(window.localStorage);
      window.location.replace(__WEBPACK_IMPORTED_MODULE_0_environment__["q" /* LOGOUT_URL */]);
      throw new Error('halt');
    }
  }]);

  return AuthService;
}();

/* harmony default export */ __webpack_exports__["default"] = (AuthService);
angular.module('app.services').service('AuthService', AuthService);

function parseQueryString(qs) {
  var params = {};
  var pairs = qs.split('&');

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    params[pair[0]] = pair[1];
  }

  return params;
}

function generateRandomString(n) {
  var bytes = new Uint8Array((n * 3 + 3) / 4);
  crypto.getRandomValues(bytes);
  return b64(bytes).substring(0, n);
}

function b64(bytes) {
  return btoa(String.fromCharCode.apply(null, bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function clearStorage(localStorage) {
  ['oauthAdminPath', 'oauthAdminToken', 'oauthState', 'oauthVerifier'].forEach(function (k) {
    return localStorage.removeItem(k);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_main_scss__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_config__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_date_polyfill__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_date_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mixins_date_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_auth_service__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_vs_repeat__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_vs_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angular_vs_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_environment__ = __webpack_require__(0);
// Import Styles










 // Create angular app and specify dependencies

angular.module('app', ['ngResource', 'ngRoute', 'ngTouch', 'ngSanitize', 'ngTagsInput', 'angulartics', 'angulartics.google.analytics', 'ui.bootstrap', 'toaster', 'app.views', 'app.directives', 'app.filters', 'app.resources', 'app.services', 'vs-repeat']).config(__WEBPACK_IMPORTED_MODULE_1__app_config__["a" /* appConfig */]).run(__WEBPACK_IMPORTED_MODULE_1__app_config__["b" /* appRun */]); // Work a little magic to delay app bootstrap until we've loaded the Config from the API
// Note: this relies on the Config service maintaining state on the window scope :-/

$(document).ready(function () {
  var auth = new __WEBPACK_IMPORTED_MODULE_8__services_auth_service__["default"]();

  if (auth.isCallback()) {
    return auth.handleCallback();
  } else if (!auth.isLoggedIn()) {
    return auth.redirectToLogin();
  }

  var Config = angular.injector(['app']).get('Config');
  Config.promise.then(function () {
    return angular.bootstrap($('html'), ['app']);
  })["catch"](function (err) {
    if (err && err.message != 'halt') {
      console.error(err);
      alert('Unable to load configuration. Please refresh the dashboard and try again.');
    }

    $('body > *').hide();
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appRun; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_environment__ = __webpack_require__(0);
// Grab the respective environment's login url

 // Main angular app config

function appConfig($httpProvider, $locationProvider, $routeProvider, $analyticsProvider) {
  // Injector error thrown as $location isn't ready right away
  // This is a documented issue with implementation of angulartics:
  // https://github.com/angulartics/angulartics/issues/29
  $analyticsProvider.firstPageview(false);
  $analyticsProvider.virtualPageviews(false); // Track exceptions with angular's $exceptionHandler decorator.

  $analyticsProvider.trackExceptions(true); // Prevent sending analytics unless we're in prod.

  if (__WEBPACK_IMPORTED_MODULE_1_environment__["v" /* PLAYER_ENV */] !== 'prod') {
    $analyticsProvider.developerMode(true);
  } // Router html5 configuration and 404 handling


  $locationProvider.html5Mode(true).hashPrefix('!');
  $routeProvider.otherwise({
    redirectTo: '/'
  }); // Pass token on request and force users to login again if token is invalid

  return $httpProvider.interceptors.push(function ($injector, $q, $window) {
    return {
      request: function request(config) {
        var token = $window.localStorage.oauthAdminToken;

        if (config.url.match(/__no_auth__/)) {
          return config;
        }

        if (config.url.match(/^https:\/\/[^\.]+(\.dev)?.boxcast.com\//) || config.url.match(/^http:\/\/localhost:3000\//)) {
          if (!config.headers['Authorization']) {
            config.headers['Authorization'] = "Bearer ".concat(token);
          }
        }

        return config;
      },
      responseError: function responseError(rejection) {
        var data = rejection.data;
        var status = rejection.status || 0;

        if (status === 401 && data.error === 'invalid_token') {
          $injector.get('AuthService').redirectToLogin();
        } else if (status >= 400 && data && !rejection.config['Interceptor-Ignore-Errors']) {
          var message = "ERROR ".concat(status);
          if (data.error) message += " (".concat(data.error, ")");
          if (data.error_description) message += "\n\n".concat(data.error_description);
          if (data.invalid_fields && _.size(data.invalid_fields) > 0) message += "\n\nInvalid fields: ".concat(JSON.stringify(data.invalid_fields));
          alert(message);
          var origin = $window.location.origin;
          var path = $window.location.pathname;
          $window.location.replace(origin + path);
        }

        return $q.reject(rejection);
      }
    };
  });
} // Main angular app run block


function appRun($window, $rootScope) {
  var token = $window.localStorage.oauthAdminToken;
  var hash = $window.location.hash;

  if (hash.indexOf('token_type=bearer') >= 0) {
    var i = hash.indexOf('access_token=') + 13;
    var j = hash.indexOf('&', i);
    token = hash.substring(i, j);

    if (token && token.length > 0) {
      $window.localStorage.oauthAdminToken = token;
      $window.location.replace($window.localStorage.oauthAdminPath || '/');
      throw new Error('halt');
    }
  } // Template helpers


  $rootScope._ = _; // Track page views

  $rootScope.$on("$routeChangeSuccess", function (e, next, current) {
    if (next && $window.location.pathname) {
      gtag('set', 'page_location', $window.location.pathname);
      gtag('event', 'page_view', $window.location.pathname);
    }

    ;
  }); // Open URL helpers

  $rootScope.openURL = function (url, $event) {
    var $location = angular.element(document.body).injector().get("$location");

    if ($event.metaKey) {
      window.open(url, '_blank');
    } else if (url.includes(__WEBPACK_IMPORTED_MODULE_1_environment__["r" /* NEW_ADMIN_URL */])) {
      window.open(url, '_self');
    } else {
      $location.url(url);
    }
  };
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.views', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(189);

__webpack_require__(199);

__webpack_require__(210);

__webpack_require__(212);

__webpack_require__(48);

__webpack_require__(214);

__webpack_require__(216);

__webpack_require__(218);

__webpack_require__(99);

__webpack_require__(220);

__webpack_require__(223);

__webpack_require__(225);

__webpack_require__(102);

__webpack_require__(103);

__webpack_require__(104);

__webpack_require__(232);

__webpack_require__(235);

__webpack_require__(236);

__webpack_require__(238);

__webpack_require__(241);

__webpack_require__(243);

__webpack_require__(245);

__webpack_require__(248);

__webpack_require__(252);

__webpack_require__(254);

__webpack_require__(257);

__webpack_require__(258);

__webpack_require__(260);

__webpack_require__(261);

__webpack_require__(263);

__webpack_require__(265);

__webpack_require__(271);

__webpack_require__(274);

__webpack_require__(275);

__webpack_require__(277);

__webpack_require__(280);

__webpack_require__(282);

__webpack_require__(286);

__webpack_require__(288);

__webpack_require__(290);

__webpack_require__(291);

__webpack_require__(49);

__webpack_require__(293);

__webpack_require__(295);

/* unused harmony default export */ var _unused_webpack_default_export = (module);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jszip__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var IMAGE_PROPERTY_LIST = ['launch_image', 'top_shelf_image_2x', 'top_shelf_image', 'top_shelf_wide_image_2x', 'top_shelf_wide_image', 'app_icon_background_layer', 'app_icon_foreground_layer', 'app_icon_small_background_layer_2x', 'app_icon_small_background_layer', 'app_icon_small_foreground_layer_2x', 'app_icon_small_foreground_layer', 'splash_screen_fhd', 'splash_screen_hd', 'splash_screen_sd', 'channel_store_icon_fhd', 'channel_store_icon_large', 'channel_store_icon_small', 'logo', 'icon'];
angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/branded_apps', {
    template: __webpack_require__(198),
    controller: 'AccountBrandedAppsController'
  });
}]).controller('AccountBrandedAppsController', ["$scope", "$location", "$q", "$routeParams", "$http", "$timeout", "$window", "toaster", "Account", "AccountAppleTvApp", "AccountRokuApp", function ($scope, $location, $q, $routeParams, $http, $timeout, $window, toaster, Account, AccountAppleTvApp, AccountRokuApp) {
  $scope.account = Account.get({
    id: $routeParams.account_id
  });
  $scope.appleTvApps = AccountAppleTvApp.query({
    account_id: $routeParams.account_id
  });
  $scope.rokuApps = AccountRokuApp.query({
    account_id: $routeParams.account_id
  });
  $scope.$window = $window;
  $scope.toaster = toaster;
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];
  $scope.loading = true;
  $q.all([$scope.account.$promise, $scope.appleTvApps.$promise, $scope.rokuApps.$promise]).then(function () {
    return $scope.loading = false;
  });

  $scope.setAppleDeveloperAccountName = function (app) {
    var newValue = $scope.$window.prompt("Enter Apple developer account name:", app.apple_developer_account_name || '');

    if (newValue != null) {
      AccountAppleTvApp.update({
        id: app.id,
        account_id: app.account_id,
        apple_developer_account_name: newValue
      }, function (updatedApp) {
        return app.apple_developer_account_name = updatedApp.apple_developer_account_name;
      }, function (err) {
        console.error(err);
        $scope.toaster.pop({
          type: 'error',
          body: "Error updating Apple developer account name. Please try again.",
          timeout: 2000
        });
      });
    }
  };

  $scope.setRokuDeveloperAccountName = function (app) {
    var newValue = $scope.$window.prompt("Enter Roku developer account name:", app.roku_developer_account_name || '');

    if (newValue != null) {
      AccountRokuApp.update({
        id: app.id,
        account_id: app.account_id,
        roku_developer_account_name: newValue
      }, function (updatedApp) {
        return app.roku_developer_account_name = updatedApp.roku_developer_account_name;
      }, function (err) {
        console.error(err);
        $scope.toaster.pop({
          type: 'error',
          body: "Error updating Roku developer account name. Please try again.",
          timeout: 2000
        });
      });
    }
  };

  var resourceForApp = function resourceForApp(app) {
    return app.hasOwnProperty('apple_developer_account_name') ? AccountAppleTvApp : AccountRokuApp;
  };

  $scope.setStatus = function (app, newStatus) {
    resourceForApp(app).update({
      id: app.id,
      account_id: app.account_id,
      status: newStatus
    }, function (updatedApp) {
      return app.status = updatedApp.status;
    }, function (err) {
      console.error(err);
      $scope.toaster.pop({
        type: 'error',
        body: "Error updating app status. Please try again.",
        timeout: 2000
      });
    });
  };

  $scope.remove = function (app) {
    if ($scope.$window.confirm("Are you sure you wish to remove this app?")) {
      $scope.setStatus(app, 'removed');
    }
  };

  var isImageProperty = function isImageProperty(propertyName) {
    return _.contains(IMAGE_PROPERTY_LIST, propertyName);
  };

  $scope.downloadBundle = function (app) {
    // Helper function for errors below; captures `app` in closure.
    var alertError = function alertError(whatWasHappening, err) {
      // Gratuitously wrapping in $timeout so this can be used in or out of a digest-aware place
      $timeout(function () {
        console.error(err);
        $scope.toaster.pop({
          type: 'error',
          body: "Error ".concat(whatWasHappening, ". Please try again."),
          timeout: 2000
        });
        delete app._downloading;
      });
    };

    app._downloading = true; // First, go get the app

    resourceForApp(app).get({
      id: app.id,
      account_id: app.account_id
    }, function (appShow) {
      var zip = new __WEBPACK_IMPORTED_MODULE_0_jszip__();
      var folder = zip.folder(appShow.id); // Start with just a pretty-print JSON dump of the app resource itself

      folder.file("".concat(appShow.id, ".json"), JSON.stringify(appShow, null, '\t')); // Fetch all the image files

      var imagePromises = [];

      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (isImageProperty(key) && value) {
          imagePromises.push($http.get(value, {
            responseType: 'arraybuffer'
          }).then(function (resp) {
            var extension = resp.headers("content-type") == 'image/png' ? '.png' : '.jpg';
            folder.file("".concat(key).concat(extension), resp.data, {
              binary: true
            });
          }));
        }
      };

      for (var _i = 0, _Object$entries = Object.entries(appShow); _i < _Object$entries.length; _i++) {
        _loop();
      }

      $q.all(imagePromises).then(function () {
        zip.generateAsync({
          type: "blob"
        }).then(function (content) {
          Object(__WEBPACK_IMPORTED_MODULE_1_file_saver__["saveAs"])(content, "".concat(appShow.id, ".zip"));
          $timeout(function () {
            return delete app._downloading;
          });
        })["catch"](function (err) {
          return alertError('downloading app bundle', err);
        });
      })["catch"](function (err) {
        return alertError('downloading app images', err);
      });
    }, function (err) {
      return alertError('getting app', err);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Buffer, setImmediate) {var require;var require;/*!

JSZip v3.6.0 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE
*/

!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).JSZip=e()}}(function(){return function s(a,o,u){function h(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof require&&require;if(!e&&t)return require(r,!0);if(f)return f(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return h(t||e)},i,i.exports,s,a,o,u)}return o[r].exports}for(var f="function"==typeof require&&require,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(l,t,n){(function(r){!function(e){"object"==typeof n&&void 0!==t?t.exports=e():("undefined"!=typeof window?window:void 0!==r?r:"undefined"!=typeof self?self:this).JSZip=e()}(function(){return function s(a,o,u){function h(t,e){if(!o[t]){if(!a[t]){var r="function"==typeof l&&l;if(!e&&r)return r(t,!0);if(f)return f(t,!0);var n=new Error("Cannot find module '"+t+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[t]={exports:{}};a[t][0].call(i.exports,function(e){return h(a[t][1][e]||e)},i,i.exports,s,a,o,u)}return o[t].exports}for(var f="function"==typeof l&&l,e=0;e<u.length;e++)h(u[e]);return h}({1:[function(e,t,r){"use strict";var c=e("./utils"),l=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,u=[],h=0,f=e.length,l=f,d="string"!==c.getTypeOf(e);h<e.length;)l=f-h,n=d?(t=e[h++],r=h<f?e[h++]:0,h<f?e[h++]:0):(t=e.charCodeAt(h++),r=h<f?e.charCodeAt(h++):0,h<f?e.charCodeAt(h++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<l?(15&r)<<2|n>>6:64,o=2<l?63&n:64,u.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return u.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,u=0;if("data:"===e.substr(0,"data:".length))throw new Error("Invalid base64 input, it looks like a data url.");var h,f=3*(e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(h=l.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),h[u++]=t,64!==s&&(h[u++]=r),64!==a&&(h[u++]=n);return h}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(e){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils"),a=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r){var n=a,i=0+r;e^=-1;for(var s=0;s<i;s++)e=e>>>8^n[255&(e^t[s])];return-1^e}(0|t,e,e.length):function(e,t,r){var n=a,i=0+r;e^=-1;for(var s=0;s<i;s++)e=e>>>8^n[255&(e^t.charCodeAt(s))];return-1^e}(0|t,e,e.length):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function u(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(u,a),u.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},u.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},u.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},u.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new u("Deflate",e)},r.uncompressWorker=function(){return new u("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function I(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function i(e,t,r,n,i,s){var a,o,u=e.file,h=e.compression,f=s!==B.utf8encode,l=O.transformTo("string",s(u.name)),d=O.transformTo("string",B.utf8encode(u.name)),c=u.comment,p=O.transformTo("string",s(c)),m=O.transformTo("string",B.utf8encode(c)),_=d.length!==u.name.length,g=m.length!==c.length,v="",b="",w="",y=u.dir,k=u.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),f||!_&&!g||(S|=2048);var z,E=0,C=0;y&&(E|=16),"UNIX"===i?(C=798,E|=((z=u.unixPermissions)||(z=y?16893:33204),(65535&z)<<16)):(C=20,E|=63&(u.dosPermissions||0)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v+="up"+I((b=I(1,1)+I(T(l),4)+d).length,2)+b),g&&(v+="uc"+I((w=I(1,1)+I(T(p),4)+m).length,2)+w);var A="";return A+="\n\0",A+=I(S,2),A+=h.magic,A+=I(a,2),A+=I(o,2),A+=I(x.crc32,4),A+=I(x.compressedSize,4),A+=I(x.uncompressedSize,4),A+=I(l.length,2),A+=I(v.length,2),{fileRecord:R.LOCAL_FILE_HEADER+A+l+v,dirRecord:R.CENTRAL_FILE_HEADER+I(C,2)+A+I(p.length,2)+"\0\0\0\0"+I(E,4)+I(n,4)+l+v+p}}var O=e("../utils"),s=e("../stream/GenericWorker"),B=e("../utf8"),T=e("../crc32"),R=e("../signature");function n(e,t,r,n){s.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}O.inherits(n,s),n.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,s.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},n.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=i(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},n.prototype.closedSource=function(e){this.accumulate=!1;var t,r=this.streamFiles&&!e.file.dir,n=i(e,r,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(n.dirRecord),r)this.push({data:(t=e,R.DATA_DESCRIPTOR+I(t.crc32,4)+I(t.compressedSize,4)+I(t.uncompressedSize,4)),meta:{percent:100}});else for(this.push({data:n.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},n.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r,n,i,s,a,o,u=this.bytesWritten-e,h=(r=this.dirRecords.length,n=u,i=e,s=this.zipComment,a=this.encodeFileName,o=O.transformTo("string",a(s)),R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+I(r,2)+I(r,2)+I(n,4)+I(i,4)+I(o.length,2)+o);this.push({data:h,meta:{percent:100}})},n.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},n.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},n.prototype.resume=function(){return!!s.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},n.prototype.error=function(e){var t=this._sources;if(!s.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},n.prototype.lock=function(){s.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=n},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var h=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),u=0;try{e.forEach(function(e,t){u++;var r=function(e,t){var r=e||t,n=h[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=u}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files={},this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.5.0",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var n=e("./utils"),i=e("./external"),o=e("./utf8"),u=e("./zipEntries"),s=e("./stream/Crc32Probe"),h=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new s);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,s){var a=this;return s=n.extend(s||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:o.utf8decode}),h.isNode&&h.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):n.prepareContent("the loaded zip file",e,!0,s.optimizedBinaryString,s.base64).then(function(e){var t=new u(s);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(s.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n];a.file(i.fileNameStr,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:s.createFolders})}return t.zipComment.length&&(a.comment=t.zipComment),a})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=f.getTypeOf(t),s=f.extend(r||{},d);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=h(e)),s.createFolders&&(n=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""}(e))&&g.call(this,n,!0);var a,o="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!o),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string"),a=t instanceof c||t instanceof l?t:m.isNode&&m.isStream(t)?new _(e,t):f.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var u=new p(e,a,s);this.files[e]=u}function h(e){return"/"!==e.slice(-1)&&(e+="/"),e}var i=e("./utf8"),f=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),d=e("./defaults"),c=e("./compressedObject"),p=e("./zipObject"),o=e("./generate"),m=e("./nodejsUtils"),_=e("./nodejs/NodejsStreamInputAdapter"),g=function(e,t){return t=void 0!==t?t:d.createFolders,e=h(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function u(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)this.files.hasOwnProperty(t)&&(n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n))},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(u(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(u(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=g.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(e){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=f.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");f.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(e){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(e){},lastIndexOfSignature:function(e){},readAndCheckSignature:function(e){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),u=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new u(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)this.extraStreamInfo.hasOwnProperty(e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),f=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function u(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}u.prototype={accumulate:function(e){return o=this,u=e,new a.Promise(function(t,r){var n=[],i=o._internalType,s=o._outputType,a=o._mimeType;o.on("data",function(e,t){n.push(e),u&&u(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return f.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()});var o,u},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=u},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),u=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),h=new Array(256),i=0;i<256;i++)h[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function f(){n.call(this,"utf-8 encode")}h[254]=h[254]=1,s.utf8encode=function(e){return u.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=u.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return u.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=h[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(u.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(u.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(u.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+h[e[r]]>t?r:t}(t),i=t;n!==t.length&&(u.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(f,n),f.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=f},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,o){"use strict";var u=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),n=e("set-immediate-shim"),f=e("./external");function i(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}o.newBlob=function(t,r){o.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var s={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return u.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return u.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function a(e){var t=65536,r=o.getTypeOf(e),n=!0;if("uint8array"===r?n=s.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=s.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return s.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return s.stringifyByChar(e)}function d(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}o.applyFromCharCode=a;var c={};c.string={string:i,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:a,array:i,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return a(new Uint8Array(e))},array:function(e){return d(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:i,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:a,array:function(e){return d(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:i,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:a,array:function(e){return d(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return d(e,new Uint8Array(e.length))},nodebuffer:i},o.transformTo=function(e,t){if(t=t||"",!e)return t;o.checkSupport(e);var r=o.getTypeOf(t);return c[r][e](t)},o.getTypeOf=function(e){return"string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":u.nodebuffer&&r.isBuffer(e)?"nodebuffer":u.uint8array&&e instanceof Uint8Array?"uint8array":u.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},o.checkSupport=function(e){if(!u[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},o.MAX_VALUE_16BITS=65535,o.MAX_VALUE_32BITS=-1,o.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},o.delay=function(e,t,r){n(function(){e.apply(r||null,t||[])})},o.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},o.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])arguments[e].hasOwnProperty(t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},o.prepareContent=function(n,e,i,s,a){return f.Promise.resolve(e).then(function(n){return u.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new f.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):n}).then(function(e){var t,r=o.getTypeOf(e);return r?("arraybuffer"===r?e=o.transformTo("uint8array",e):"string"===r&&(a?e=h.decode(e):i&&!0!==s&&(e=l(t=e,u.uint8array?new Uint8Array(t.length):new Array(t.length)))),e):f.Promise.reject(new Error("Can't read the data of '"+n+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,"set-immediate-shim":54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=(e("./utf8"),e("./support"));function u(e){this.files=[],this.loadOptions=e}u.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Corrupted zip: can't find end of central directory"):new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=u},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utf8":31,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),u=e("./compressions"),h=e("./support");function f(e,t){this.options=e,this.loadOptions=t}f.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in u)if(u.hasOwnProperty(t)&&u[t].magic===e)return u[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(e){if(this.extraFields[1]){var t=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=t.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=t.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=t.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=t.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=h.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=f},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),u=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new u("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof u?this._data:new i(this._data)}};for(var h=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],f=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},l=0;l<h.length;l++)n.prototype[h[l]]=f;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,f,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(h),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){h(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(h,0)};else{var o=new t.MessageChannel;o.port1.onmessage=h,r=function(){o.port2.postMessage(0)}}var u=[];function h(){var e,t;n=!0;for(var r=u.length;r;){for(t=u,u=[],e=-1;++e<r;)t[e]();r=u.length}n=!1}f.exports=function(e){1!==u.push(e)||n||r()}}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function h(){}var f={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==h&&c(this,e)}function u(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function l(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return f.reject(t,e)}e===t?f.reject(t,new TypeError("Cannot resolve promise with itself")):f.resolve(t,e)})}function d(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function c(t,e){var r=!1;function n(e){r||(r=!0,f.reject(t,e))}function i(e){r||(r=!0,f.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(h);return this.state!==n?l(r,this.state===a?e:t,this.outcome):this.queue.push(new u(r,e,t)),r},u.prototype.callFulfilled=function(e){f.resolve(this.promise,e)},u.prototype.otherCallFulfilled=function(e){l(this.promise,this.onFulfilled,e)},u.prototype.callRejected=function(e){f.reject(this.promise,e)},u.prototype.otherCallRejected=function(e){l(this.promise,this.onRejected,e)},f.resolve=function(e,t){var r=p(d,t);if("error"===r.status)return f.reject(e,r.value);var n=r.value;if(n)c(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},f.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){return e instanceof this?e:f.resolve(new this(h),e)},o.reject=function(e){var t=new this(h);return f.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);for(var s=new Array(n),a=0,t=-1,o=new this(h);++t<n;)u(e[t],t);return o;function u(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,f.resolve(o,s))},function(e){i||(i=!0,f.reject(o,e))})}},o.race=function(e){if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var t=e.length,r=!1;if(!t)return this.resolve([]);for(var n,i=-1,s=new this(h);++i<t;)n=e[i],this.resolve(n).then(function(e){r||(r=!0,f.resolve(s,e))},function(e){r||(r=!0,f.reject(s,e))});return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),u=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),h=Object.prototype.toString,f=0,l=-1,d=0,c=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:l,method:c,chunkSize:16384,windowBits:15,memLevel:8,strategy:d,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==f)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?u.string2buf(t.dictionary):"[object ArrayBuffer]"===h.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==f)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=u.string2buf(e):"[object ArrayBuffer]"===h.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==f)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(u.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===f):2!==n||(this.onEnd(f),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===f&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var d=e("./zlib/inflate"),c=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=c.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=d.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,d.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,u=this.strm,h=this.options.chunkSize,f=this.options.dictionary,l=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?u.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?u.input=new Uint8Array(e):u.input=e,u.next_in=0,u.avail_in=u.input.length;do{if(0===u.avail_out&&(u.output=new c.Buf8(h),u.next_out=0,u.avail_out=h),(r=d.inflate(u,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&f&&(o="string"==typeof f?p.string2buf(f):"[object ArrayBuffer]"===_.call(f)?new Uint8Array(f):f,r=d.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===l&&(r=m.Z_OK,l=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);u.next_out&&(0!==u.avail_out&&r!==m.Z_STREAM_END&&(0!==u.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(u.output,u.next_out),s=u.next_out-i,a=p.buf2string(u.output,i),u.next_out=s,u.avail_out=h-s,s&&c.arraySet(u.output,u.output,i,s,0),this.onData(a)):this.onData(c.shrinkBuf(u.output,u.next_out)))),0===u.avail_in&&0===u.avail_out&&(l=!0)}while((0<u.avail_in||0===u.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=d.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(u.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=c.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var u=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var h=new u.Buf8(256),n=0;n<256;n++)h[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function f(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,u.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}h[254]=h[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new u.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return f(e,e.length)},r.binstring2buf=function(e){for(var t=new u.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=h[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return f(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+h[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var u,d=e("../utils/common"),h=e("./trees"),c=e("./adler32"),p=e("./crc32"),n=e("./messages"),f=0,l=0,m=-2,i=2,_=8,s=286,a=30,o=19,g=2*s+1,v=15,b=3,w=258,y=w+b+1,k=42,x=113;function S(e,t){return e.msg=n[t],t}function z(e){return(e<<1)-(4<e?9:0)}function E(e){for(var t=e.length;0<=--t;)e[t]=0}function C(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(d.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function A(e,t){h._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,C(e.strm)}function I(e,t){e.pending_buf[e.pending++]=t}function O(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function B(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,u=e.strstart>e.w_size-y?e.strstart-(e.w_size-y):0,h=e.window,f=e.w_mask,l=e.prev,d=e.strstart+w,c=h[s+a-1],p=h[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(h[(r=t)+a]===p&&h[r+a-1]===c&&h[r]===h[s]&&h[++r]===h[s+1]){s+=2,r++;do{}while(h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&h[++s]===h[++r]&&s<d);if(n=w-(d-s),s=d-w,a<n){if(e.match_start=t,o<=(a=n))break;c=h[s+a-1],p=h[s+a]}}}while((t=l[t&f])>u&&0!=--i);return a<=e.lookahead?a:e.lookahead}function T(e){var t,r,n,i,s,a,o,u,h,f,l=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=l+(l-y)){for(d.arraySet(e.window,e.window,l,l,0),e.match_start-=l,e.strstart-=l,e.block_start-=l,t=r=e.hash_size;n=e.head[--t],e.head[t]=l<=n?n-l:0,--r;);for(t=r=l;n=e.prev[--t],e.prev[t]=l<=n?n-l:0,--r;);i+=l}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,u=e.strstart+e.lookahead,f=void 0,(h=i)<(f=a.avail_in)&&(f=h),r=0===f?0:(a.avail_in-=f,d.arraySet(o,a.input,a.next_in,f,u),1===a.state.wrap?a.adler=c(a.adler,o,f,u):2===a.state.wrap&&(a.adler=p(a.adler,o,f,u)),a.next_in+=f,a.total_in+=f,f),e.lookahead+=r,e.lookahead+e.insert>=b)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+b-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<b)););}while(e.lookahead<y&&0!==e.strm.avail_in)}function R(e,t){for(var r,n;;){if(e.lookahead<y){if(T(e),e.lookahead<y&&t===f)return 1;if(0===e.lookahead)break}if(r=0,e.lookahead>=b&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-y&&(e.match_length=B(e,r)),e.match_length>=b)if(n=h._tr_tally(e,e.strstart-e.match_start,e.match_length-b),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=b){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=h._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=e.strstart<b-1?e.strstart:b-1,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}function D(e,t){for(var r,n,i;;){if(e.lookahead<y){if(T(e),e.lookahead<y&&t===f)return 1;if(0===e.lookahead)break}if(r=0,e.lookahead>=b&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=b-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-y&&(e.match_length=B(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===b&&4096<e.strstart-e.match_start)&&(e.match_length=b-1)),e.prev_length>=b&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-b,n=h._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-b),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+b-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=b-1,e.strstart++,n&&(A(e,!1),0===e.strm.avail_out))return 1}else if(e.match_available){if((n=h._tr_tally(e,0,e.window[e.strstart-1]))&&A(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return 1}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=h._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<b-1?e.strstart:b-1,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}function F(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function N(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=_,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new d.Buf16(2*g),this.dyn_dtree=new d.Buf16(2*(2*a+1)),this.bl_tree=new d.Buf16(2*(2*o+1)),E(this.dyn_ltree),E(this.dyn_dtree),E(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new d.Buf16(v+1),this.heap=new d.Buf16(2*s+1),E(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new d.Buf16(2*s+1),E(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function U(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?k:x,e.adler=2===t.wrap?0:1,t.last_flush=f,h._tr_init(t),l):S(e,m)}function P(e){var t,r=U(e);return r===l&&((t=e.state).window_size=2*t.w_size,E(t.head),t.max_lazy_match=u[t.level].max_lazy,t.good_match=u[t.level].good_length,t.nice_match=u[t.level].nice_length,t.max_chain_length=u[t.level].max_chain,t.strstart=0,t.block_start=0,t.lookahead=0,t.insert=0,t.match_length=t.prev_length=b-1,t.match_available=0,t.ins_h=0),r}function L(e,t,r,n,i,s){if(!e)return m;var a=1;if(-1===t&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||9<i||r!==_||n<8||15<n||t<0||9<t||s<0||4<s)return S(e,m);8===n&&(n=9);var o=new N;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+b-1)/b),o.window=new d.Buf8(2*o.w_size),o.head=new d.Buf16(o.hash_size),o.prev=new d.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new d.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,P(e)}u=[new F(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(T(e),0===e.lookahead&&t===f)return 1;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,A(e,!1),0===e.strm.avail_out))return 1;if(e.strstart-e.block_start>=e.w_size-y&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(A(e,!0),0===e.strm.avail_out?3:4):(e.strstart>e.block_start&&(A(e,!1),e.strm.avail_out),1)}),new F(4,4,8,4,R),new F(4,5,16,8,R),new F(4,6,32,32,R),new F(4,4,16,16,D),new F(8,16,32,32,D),new F(8,16,128,128,D),new F(8,32,128,256,D),new F(32,128,258,1024,D),new F(32,258,258,4096,D)],r.deflateInit=function(e,t){return L(e,t,_,15,8,0)},r.deflateInit2=L,r.deflateReset=P,r.deflateResetKeep=U,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?m:(e.state.gzhead=t,l):m},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?S(e,m):m;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&4!==t)return S(e,0===e.avail_out?-5:m);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===k)if(2===n.wrap)e.adler=0,I(n,31),I(n,139),I(n,8),n.gzhead?(I(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),I(n,255&n.gzhead.time),I(n,n.gzhead.time>>8&255),I(n,n.gzhead.time>>16&255),I(n,n.gzhead.time>>24&255),I(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),I(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(I(n,255&n.gzhead.extra.length),I(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(I(n,0),I(n,0),I(n,0),I(n,0),I(n,0),I(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),I(n,3),n.status=x);else{var a=_+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=x,O(n,a),0!==n.strstart&&(O(n,e.adler>>>16),O(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),C(e),i=n.pending,n.pending!==n.pending_buf_size));)I(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),C(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,I(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),C(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,I(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&C(e),n.pending+2<=n.pending_buf_size&&(I(n,255&e.adler),I(n,e.adler>>8&255),e.adler=0,n.status=x)):n.status=x),0!==n.pending){if(C(e),0===e.avail_out)return n.last_flush=-1,l}else if(0===e.avail_in&&z(t)<=z(r)&&4!==t)return S(e,-5);if(666===n.status&&0!==e.avail_in)return S(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==f&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(T(e),0===e.lookahead)){if(t===f)return 1;break}if(e.match_length=0,r=h._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=w){if(T(e),e.lookahead<=w&&t===f)return 1;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=b&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+w;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=w-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=b?(r=h._tr_tally(e,1,e.match_length-b),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=h._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(A(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(A(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(A(e,!1),0===e.strm.avail_out)?1:2}(n,t):u[n.level].func(n,t);if(3!==o&&4!==o||(n.status=666),1===o||3===o)return 0===e.avail_out&&(n.last_flush=-1),l;if(2===o&&(1===t?h._tr_align(n):5!==t&&(h._tr_stored_block(n,0,0,!1),3===t&&(E(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),C(e),0===e.avail_out))return n.last_flush=-1,l}return 4!==t?l:n.wrap<=0?1:(2===n.wrap?(I(n,255&e.adler),I(n,e.adler>>8&255),I(n,e.adler>>16&255),I(n,e.adler>>24&255),I(n,255&e.total_in),I(n,e.total_in>>8&255),I(n,e.total_in>>16&255),I(n,e.total_in>>24&255)):(O(n,e.adler>>>16),O(n,65535&e.adler)),C(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?l:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==k&&69!==t&&73!==t&&91!==t&&103!==t&&t!==x&&666!==t?S(e,m):(e.state=null,t===x?S(e,-3):l):m},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,u,h,f=t.length;if(!e||!e.state)return m;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==k||r.lookahead)return m;for(1===s&&(e.adler=c(e.adler,t,f,0)),r.wrap=0,f>=r.w_size&&(0===s&&(E(r.head),r.strstart=0,r.block_start=0,r.insert=0),h=new d.Buf8(r.w_size),d.arraySet(h,t,f-r.w_size,r.w_size,0),t=h,f=r.w_size),a=e.avail_in,o=e.next_in,u=e.input,e.avail_in=f,e.next_in=0,e.input=t,T(r);r.lookahead>=b;){for(n=r.strstart,i=r.lookahead-(b-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+b-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=b-1,T(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=b-1,r.match_available=0,e.next_in=o,e.input=u,e.avail_in=a,r.wrap=s,l},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,u,h,f,l,d,c,p,m,_,g,v,b,w,y,k,x,S,z,E;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,E=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),u=r.dmax,h=r.wsize,f=r.whave,l=r.wnext,d=r.window,c=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,v=(1<<r.distbits)-1;e:do{p<15&&(c+=z[n++]<<p,p+=8,c+=z[n++]<<p,p+=8),b=m[c&g];t:for(;;){if(c>>>=w=b>>>24,p-=w,0==(w=b>>>16&255))E[s++]=65535&b;else{if(!(16&w)){if(0==(64&w)){b=m[(65535&b)+(c&(1<<w)-1)];continue t}if(32&w){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}y=65535&b,(w&=15)&&(p<w&&(c+=z[n++]<<p,p+=8),y+=c&(1<<w)-1,c>>>=w,p-=w),p<15&&(c+=z[n++]<<p,p+=8,c+=z[n++]<<p,p+=8),b=_[c&v];r:for(;;){if(c>>>=w=b>>>24,p-=w,!(16&(w=b>>>16&255))){if(0==(64&w)){b=_[(65535&b)+(c&(1<<w)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&b,p<(w&=15)&&(c+=z[n++]<<p,(p+=8)<w&&(c+=z[n++]<<p,p+=8)),u<(k+=c&(1<<w)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(c>>>=w,p-=w,(w=s-a)<k){if(f<(w=k-w)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=d,(x=0)===l){if(x+=h-w,w<y){for(y-=w;E[s++]=d[x++],--w;);x=s-k,S=E}}else if(l<w){if(x+=h+l-w,(w-=l)<y){for(y-=w;E[s++]=d[x++],--w;);if(x=0,l<y){for(y-=w=l;E[s++]=d[x++],--w;);x=s-k,S=E}}}else if(x+=l-w,w<y){for(y-=w;E[s++]=d[x++],--w;);x=s-k,S=E}for(;2<y;)E[s++]=S[x++],E[s++]=S[x++],E[s++]=S[x++],y-=3;y&&(E[s++]=S[x++],1<y&&(E[s++]=S[x++]))}else{for(x=s-k;E[s++]=E[x++],E[s++]=E[x++],E[s++]=E[x++],2<(y-=3););y&&(E[s++]=E[x++],1<y&&(E[s++]=E[x++]))}break}}break}}while(n<i&&s<o);n-=y=p>>3,c&=(1<<(p-=y<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=c,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),T=e("./inffast"),R=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function u(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function h(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=u(e,t))!==N&&(e.state=null),r):U}var f,l,d=!0;function j(e){if(d){var t;for(f=new I.Buf32(512),l=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(R(D,e.lens,0,288,f,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;R(F,e.lens,0,32,l,0,e.work,{bits:5}),d=!1}e.lencode=f,e.lenbits=9,e.distcode=l,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=u,r.inflateResetKeep=a,r.inflateInit=function(e){return h(e,15)},r.inflateInit2=h,r.inflate=function(e,t){var r,n,i,s,a,o,u,h,f,l,d,c,p,m,_,g,v,b,w,y,k,x,S,z,E=0,C=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,u=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,h=r.hold,f=r.bits,l=o,d=u,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(2&r.wrap&&35615===h){C[r.check=0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0),f=h=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&h)<<8)+(h>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&h)){e.msg="unknown compression method",r.mode=30;break}if(f-=4,k=8+(15&(h>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&h?10:12,f=h=0;break;case 2:for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(r.flags=h,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=h>>8&1),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0)),f=h=0,r.mode=3;case 3:for(;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.head&&(r.head.time=h),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,C[2]=h>>>16&255,C[3]=h>>>24&255,r.check=B(r.check,C,4,0)),f=h=0,r.mode=4;case 4:for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.head&&(r.head.xflags=255&h,r.head.os=h>>8),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0)),f=h=0,r.mode=5;case 5:if(1024&r.flags){for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.length=h,r.head&&(r.head.extra_len=h),512&r.flags&&(C[0]=255&h,C[1]=h>>>8&255,r.check=B(r.check,C,2,0)),f=h=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(c=r.length)&&(c=o),c&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,c,k)),512&r.flags&&(r.check=B(r.check,n,c,s)),o-=c,s+=c,r.length-=c),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(c=0;k=n[s+c++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&c<o;);if(512&r.flags&&(r.check=B(r.check,n,c,s)),o-=c,s+=c,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(c=0;k=n[s+c++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&c<o;);if(512&r.flags&&(r.check=B(r.check,n,c,s)),o-=c,s+=c,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;f<16;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(h!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}f=h=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}e.adler=r.check=L(h),f=h=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=u,e.next_in=s,e.avail_in=o,r.hold=h,r.bits=f,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){h>>>=7&f,f-=7&f,r.mode=27;break}for(;f<3;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}switch(r.last=1&h,f-=1,3&(h>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;h>>>=2,f-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}h>>>=2,f-=2;break;case 14:for(h>>>=7&f,f-=7&f;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if((65535&h)!=(h>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&h,f=h=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(c=r.length){if(o<c&&(c=o),u<c&&(c=u),0===c)break e;I.arraySet(i,n,s,c,a),o-=c,s+=c,u-=c,a+=c,r.length-=c;break}r.mode=12;break;case 17:for(;f<14;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(r.nlen=257+(31&h),h>>>=5,f-=5,r.ndist=1+(31&h),h>>>=5,f-=5,r.ncode=4+(15&h),h>>>=4,f-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;f<3;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.lens[A[r.have++]]=7&h,h>>>=3,f-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=R(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(E=r.lencode[h&(1<<r.lenbits)-1])>>>16&255,v=65535&E,!((_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(v<16)h>>>=_,f-=_,r.lens[r.have++]=v;else{if(16===v){for(z=_+2;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(h>>>=_,f-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],c=3+(3&h),h>>>=2,f-=2}else if(17===v){for(z=_+3;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}f-=_,k=0,c=3+(7&(h>>>=_)),h>>>=3,f-=3}else{for(z=_+7;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}f-=_,k=0,c=11+(127&(h>>>=_)),h>>>=7,f-=7}if(r.have+c>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;c--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=R(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=R(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=u){e.next_out=a,e.avail_out=u,e.next_in=s,e.avail_in=o,r.hold=h,r.bits=f,T(e,d),a=e.next_out,i=e.output,u=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,h=r.hold,f=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(E=r.lencode[h&(1<<r.lenbits)-1])>>>16&255,v=65535&E,!((_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(g&&0==(240&g)){for(b=_,w=g,y=v;g=(E=r.lencode[y+((h&(1<<b+w)-1)>>b)])>>>16&255,v=65535&E,!(b+(_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}h>>>=b,f-=b,r.back+=b}if(h>>>=_,f-=_,r.back+=_,r.length=v,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.length+=h&(1<<r.extra)-1,h>>>=r.extra,f-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(E=r.distcode[h&(1<<r.distbits)-1])>>>16&255,v=65535&E,!((_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(0==(240&g)){for(b=_,w=g,y=v;g=(E=r.distcode[y+((h&(1<<b+w)-1)>>b)])>>>16&255,v=65535&E,!(b+(_=E>>>24)<=f);){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}h>>>=b,f-=b,r.back+=b}if(h>>>=_,f-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=v,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;f<z;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}r.offset+=h&(1<<r.extra)-1,h>>>=r.extra,f-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===u)break e;if(c=d-u,r.offset>c){if((c=r.offset-c)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=c>r.wnext?(c-=r.wnext,r.wsize-c):r.wnext-c,c>r.length&&(c=r.length),m=r.window}else m=i,p=a-r.offset,c=r.length;for(u<c&&(c=u),u-=c,r.length-=c;i[a++]=m[p++],--c;);0===r.length&&(r.mode=21);break;case 26:if(0===u)break e;i[a++]=r.length,u--,r.mode=21;break;case 27:if(r.wrap){for(;f<32;){if(0===o)break e;o--,h|=n[s++]<<f,f+=8}if(d-=u,e.total_out+=d,r.total+=d,d&&(e.adler=r.check=r.flags?B(r.check,i,d,a-d):O(r.check,i,d,a-d)),d=u,(r.flags?h:L(h))!==r.check){e.msg="incorrect data check",r.mode=30;break}f=h=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;f<32;){if(0===o)break e;o--,h+=n[s++]<<f,f+=8}if(h!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}f=h=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=u,e.next_in=s,e.avail_in=o,r.hold=h,r.bits=f,(r.wsize||d!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,d-e.avail_out)?(r.mode=31,-4):(l-=e.avail_in,d-=e.avail_out,e.total_in+=l,e.total_out+=d,r.total+=d,r.wrap&&d&&(e.adler=r.check=r.flags?B(r.check,i,d,e.next_out-d):O(r.check,i,d,e.next_out-d)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==l&&0===d||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var u,h,f,l,d,c,p,m,_,g=o.bits,v=0,b=0,w=0,y=0,k=0,x=0,S=0,z=0,E=0,C=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),T=null,R=0;for(v=0;v<=15;v++)O[v]=0;for(b=0;b<n;b++)O[t[r+b]]++;for(k=g,y=15;1<=y&&0===O[y];y--);if(y<k&&(k=y),0===y)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(w=1;w<y&&0===O[w];w++);for(k<w&&(k=w),v=z=1;v<=15;v++)if(z<<=1,(z-=O[v])<0)return-1;if(0<z&&(0===e||1!==y))return-1;for(B[1]=0,v=1;v<15;v++)B[v+1]=B[v]+O[v];for(b=0;b<n;b++)0!==t[r+b]&&(a[B[t[r+b]]++]=b);if(c=0===e?(A=T=a,19):1===e?(A=F,I-=257,T=N,R-=257,256):(A=U,T=P,-1),v=w,d=s,S=b=C=0,f=-1,l=(E=1<<(x=k))-1,1===e&&852<E||2===e&&592<E)return 1;for(;;){for(p=v-S,_=a[b]<c?(m=0,a[b]):a[b]>c?(m=T[R+a[b]],A[I+a[b]]):(m=96,0),u=1<<v-S,w=h=1<<x;i[d+(C>>S)+(h-=u)]=p<<24|m<<16|_|0,0!==h;);for(u=1<<v-1;C&u;)u>>=1;if(0!==u?(C&=u-1,C+=u):C=0,b++,0==--O[v]){if(v===y)break;v=t[r+a[b]]}if(k<v&&(C&l)!==f){for(0===S&&(S=k),d+=w,z=1<<(x=v-S);x+S<y&&!((z-=O[x+S])<=0);)x++,z<<=1;if(E+=1<<x,1===e&&852<E||2===e&&592<E)return 1;i[f=C&l]=k<<24|x<<16|d-s|0}}return 0!==C&&(i[d+C]=v-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var o=e("../utils/common");function n(e){for(var t=e.length;0<=--t;)e[t]=0}var _=15,i=16,u=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],h=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],a=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],f=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],l=new Array(576);n(l);var d=new Array(60);n(d);var c=new Array(512);n(c);var p=new Array(256);n(p);var m=new Array(29);n(m);var g,v,b,w=new Array(30);function y(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function s(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function k(e){return e<256?c[e]:c[256+(e>>>7)]}function x(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function S(e,t,r){e.bi_valid>i-r?(e.bi_buf|=t<<e.bi_valid&65535,x(e,e.bi_buf),e.bi_buf=t>>i-e.bi_valid,e.bi_valid+=r-i):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function z(e,t,r){S(e,r[2*t],r[2*t+1])}function E(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function C(e,t,r){var n,i,s=new Array(_+1),a=0;for(n=1;n<=_;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=E(s[o]++,o))}}function A(e){var t;for(t=0;t<286;t++)e.dyn_ltree[2*t]=0;for(t=0;t<30;t++)e.dyn_dtree[2*t]=0;for(t=0;t<19;t++)e.bl_tree[2*t]=0;e.dyn_ltree[512]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function I(e){8<e.bi_valid?x(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function O(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function B(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&O(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!O(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function T(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?z(e,i,t):(z(e,(s=p[i])+256+1,t),0!==(a=u[s])&&S(e,i-=m[s],a),z(e,s=k(--n),r),0!==(a=h[s])&&S(e,n-=w[s],a)),o<e.last_lit;);z(e,256,t)}function R(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,u=t.stat_desc.elems,h=-1;for(e.heap_len=0,e.heap_max=573,r=0;r<u;r++)0!==s[2*r]?(e.heap[++e.heap_len]=h=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=h<2?++h:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=h,r=e.heap_len>>1;1<=r;r--)B(e,s,r);for(i=u;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],B(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,B(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,u=t.dyn_tree,h=t.max_code,f=t.stat_desc.static_tree,l=t.stat_desc.has_stree,d=t.stat_desc.extra_bits,c=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=_;s++)e.bl_count[s]=0;for(u[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<573;r++)p<(s=u[2*u[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),u[2*n+1]=s,h<n||(e.bl_count[s]++,a=0,c<=n&&(a=d[n-c]),o=u[2*n],e.opt_len+=o*(s+a),l&&(e.static_len+=o*(f[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)h<(i=e.heap[--r])||(u[2*i+1]!==s&&(e.opt_len+=(s-u[2*i+1])*u[2*i],u[2*i+1]=s),n--)}}(e,t),C(s,h,e.bl_count)}function D(e,t,r){var n,i,s=-1,a=t[1],o=0,u=7,h=4;for(0===a&&(u=138,h=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<u&&i===a||(o<h?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[32]++):o<=10?e.bl_tree[34]++:e.bl_tree[36]++,s=i,h=(o=0)===a?(u=138,3):i===a?(u=6,3):(u=7,4))}function F(e,t,r){var n,i,s=-1,a=t[1],o=0,u=7,h=4;for(0===a&&(u=138,h=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<u&&i===a)){if(o<h)for(;z(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(z(e,i,e.bl_tree),o--),z(e,16,e.bl_tree),S(e,o-3,2)):o<=10?(z(e,17,e.bl_tree),S(e,o-3,3)):(z(e,18,e.bl_tree),S(e,o-11,7));s=i,h=(o=0)===a?(u=138,3):i===a?(u=6,3):(u=7,4)}}n(w);var N=!1;function U(e,t,r,n){var i,s,a;S(e,0+(n?1:0),3),s=t,a=r,I(i=e),x(i,a),x(i,~a),o.arraySet(i.pending_buf,i.window,s,a,i.pending),i.pending+=a}r._tr_init=function(e){N||(function(){var e,t,r,n,i,s=new Array(_+1);for(n=r=0;n<28;n++)for(m[n]=r,e=0;e<1<<u[n];e++)p[r++]=n;for(p[r-1]=n,n=i=0;n<16;n++)for(w[n]=i,e=0;e<1<<h[n];e++)c[i++]=n;for(i>>=7;n<30;n++)for(w[n]=i<<7,e=0;e<1<<h[n]-7;e++)c[256+i++]=n;for(t=0;t<=_;t++)s[t]=0;for(e=0;e<=143;)l[2*e+1]=8,e++,s[8]++;for(;e<=255;)l[2*e+1]=9,e++,s[9]++;for(;e<=279;)l[2*e+1]=7,e++,s[7]++;for(;e<=287;)l[2*e+1]=8,e++,s[8]++;for(C(l,287,s),e=0;e<30;e++)d[2*e+1]=5,d[2*e]=E(e,5);g=new y(l,u,257,286,_),v=new y(d,h,0,30,_),b=new y(new Array(0),a,0,19,7)}(),N=!0),e.l_desc=new s(e.dyn_ltree,g),e.d_desc=new s(e.dyn_dtree,v),e.bl_desc=new s(e.bl_tree,b),e.bi_buf=0,e.bi_valid=0,A(e)},r._tr_stored_block=U,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return 0;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return 1;for(t=32;t<256;t++)if(0!==e.dyn_ltree[2*t])return 1;return 0}(e)),R(e,e.l_desc),R(e,e.d_desc),a=function(e){var t;for(D(e,e.dyn_ltree,e.l_desc.max_code),D(e,e.dyn_dtree,e.d_desc.max_code),R(e,e.bl_desc),t=18;3<=t&&0===e.bl_tree[2*f[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?U(e,t,r,n):4===e.strategy||s===i?(S(e,2+(n?1:0),3),T(e,l,d)):(S(e,4+(n?1:0),3),function(e,t,r,n){var i;for(S(e,t-257,5),S(e,r-1,5),S(e,n-4,4),i=0;i<n;i++)S(e,e.bl_tree[2*f[i]+1],3);F(e,e.dyn_ltree,t-1),F(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),T(e,e.dyn_ltree,e.dyn_dtree)),A(e),n&&I(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(p[r]+256+1)]++,e.dyn_dtree[2*k(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){var t;S(e,2,3),z(e,256,l),16===(t=e).bi_valid?(x(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):8<=t.bi_valid&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){"use strict";t.exports="function"==typeof setImmediate?setImmediate:function(){var e=[].slice.apply(arguments);e.splice(1,0,0),setTimeout.apply(null,e)}},{}]},{},[10])(10)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,void 0!==r?r:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)})}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[1])(1)});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(191).Buffer, __webpack_require__(195).setImmediate))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(192)
var ieee754 = __webpack_require__(193)
var isArray = __webpack_require__(194)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 193 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 194 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(196);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(98)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Branded Apps</h3>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\" ng-if=\"loading\">\n      <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n\n    <div class=\"alert alert-info alert-no-broadcasts text-center\" role=\"alert\" ng-if=\"!loading && appleTvApps.length == 0 && rokuApps.length == 0\">\n      <div>No branded apps.</div>\n    </div>\n\n    <table class=\"table table-striped table-dark-border table-hover table-condensed\" ng-if=\"!loading && (appleTvApps.length > 0 || rokuApps.length > 0)\">\n      <thead>\n        <tr>\n          <th>Platform</th>\n          <th>Name</th>\n          <th>Dev Account</th>\n          <th>Status</th>\n          <th>&nbsp;</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"app in appleTvApps\">\n          <td>AppleTV</td>\n          <td>\n            <span ng-show=\"app.name\">{{ app.name }}</span>\n            <span ng-hide=\"app.name\"><em>(none)</em></span>\n          </td>\n          <td>\n            <span ng-show=\"app.apple_developer_account_name\">\n              {{ app.apple_developer_account_name }}\n              <button ng-if=\"$root.me.isCustomAppDev()\" ng-click=\"setAppleDeveloperAccountName(app)\" class=\"btn btn-xs btn-primary\">Edit</button>\n            </span>\n            <span ng-hide=\"app.apple_developer_account_name\">\n              Not configured\n              <button ng-if=\"$root.me.isCustomAppDev()\" ng-click=\"setAppleDeveloperAccountName(app)\" class=\"btn btn-xs btn-primary\">Set</button>\n            </span>\n          </td>\n          <td>{{ app.status | brandedAppStatus }}</td>\n          <td>\n            <span ng-show=\"$root.me.isCustomAppDev() && app.status == 'submitted_to_boxcast'\">\n              <button ng-click=\"setStatus(app, 'waiting_on_customer')\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-arrow-circle-left\"></i> Send back to customer</button>\n              <button ng-click=\"downloadBundle(app)\" ng-disabled=\"app._downloading\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-arrow-circle-down\"></i> Download bundle</button>\n              <button ng-click=\"setStatus(app, 'submitted_for_review')\" class=\"btn btn-xs btn-primary\">Sent for review <i class=\"fa fa-arrow-circle-right\"></i></button>\n            </span>\n            <span ng-show=\"$root.me.isCustomAppDev() && app.status == 'submitted_for_review'\">\n              <button ng-click=\"setStatus(app, 'submitted_to_boxcast')\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-arrow-circle-left\"></i> Send back to BoxCast</button>\n              <button ng-click=\"setStatus(app, 'released')\" class=\"btn btn-xs btn-primary\">Set to released <i class=\"fa fa-arrow-circle-right\"></i></button>\n            </span>\n            <span ng-show=\"$root.me.isCustomAppDev() && app.status == 'released'\">\n              <button ng-click=\"remove(app)\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-trash\"></i> Remove</button>\n            </span>\n          </td>\n        </tr>\n        <tr ng-repeat=\"app in rokuApps\">\n          <td>Roku</td>\n          <td>\n            <span ng-show=\"app.channel_name\">{{ app.channel_name }}</span>\n            <span ng-hide=\"app.channel_name\"><em>(none)</em></span>\n          </td>\n          <td>\n            <span ng-show=\"app.roku_developer_account_name\">\n              {{ app.roku_developer_account_name }}\n              <button ng-if=\"$root.me.isCustomAppDev()\" ng-click=\"setRokuDeveloperAccountName(app)\" class=\"btn btn-xs btn-primary\">Edit</button>\n            </span>\n            <span ng-hide=\"app.roku_developer_account_name\">\n              Not configured\n              <button ng-if=\"$root.me.isCustomAppDev()\" ng-click=\"setRokuDeveloperAccountName(app)\" class=\"btn btn-xs btn-primary\">Set</button>\n            </span>\n          </td>\n          <td>{{ app.status | brandedAppStatus }}</td>\n          <td>\n            <span ng-show=\"$root.me.isCustomAppDev() && app.status == 'submitted_to_boxcast'\">\n              <button ng-click=\"setStatus(app, 'waiting_on_customer')\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-arrow-circle-left\"></i> Send back to customer</button>\n              <button ng-click=\"downloadBundle(app)\" ng-disabled=\"app._downloading\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-arrow-circle-down\"></i> Download bundle</button>\n              <button ng-click=\"setStatus(app, 'submitted_for_review')\" class=\"btn btn-xs btn-primary\">Sent for review <i class=\"fa fa-arrow-circle-right\"></i></button>\n            </span>\n            <span ng-show=\"$root.me.isCustomAppDev() && app.status == 'submitted_for_review'\">\n              <button ng-click=\"setStatus(app, 'submitted_to_boxcast')\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-arrow-circle-left\"></i> Send back to BoxCast</button>\n              <button ng-click=\"setStatus(app, 'released')\" class=\"btn btn-xs btn-primary\">Set to released <i class=\"fa fa-arrow-circle-right\"></i></button>\n            </span>\n            <span ng-show=\"$root.me.isCustomAppDev() && app.status == 'released'\">\n              <button ng-click=\"remove(app)\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-trash\"></i> Remove</button>\n            </span>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_form_controller__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__account_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__change_subscription_form_controller__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_user_form_controller__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_user_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__user_user_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__upgrade_upgrade_form_controller__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_environment__ = __webpack_require__(0);





angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:id', {
    template: __webpack_require__(207),
    controller: 'AccountController'
  });
}]).controller('AccountController', ["$scope", "$location", "$routeParams", "$modal", "Account", "User", "AccountChannel", "FeatureBillingService", "$rootScope", "$q", "Ticket", "ActivationCodes", "PandadocService", "AccountSubscriptions", "Config", function ($scope, $location, $routeParams, $modal, Account, User, AccountChannel, FeatureBillingService, $rootScope, $q, Ticket, ActivationCodes, PandadocService, AccountSubscriptions, Config) {
  var stripeCustomer;
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_4_environment__["r" /* NEW_ADMIN_URL */];
  $scope.loading = true;
  $scope.rtmpAllowed = false;
  $scope.roles = angular.copy(Config.roles);
  $scope.activeTab = {};
  Account.get({
    id: $routeParams.id
  }).$promise.then(function (res) {
    $scope.updateAccount(res);
    $scope.loading = false;
    $scope.loadTab($location.hash());
  });
  $scope.authURL = PandadocService.authURL;

  $scope.updateAccount = function (a) {
    stripeCustomer = a.stripe_customer_handle.length;
    $scope.account = a;
    $scope.rtmpAllowed = a.feature_flags.indexOf("rtmp") !== -1; // Accounts migrated from Sunday Streams have migration IDs prefixed
    // with "ss:"; those from Stream Monkey are prefixed with "sm:".

    $scope.migratedFromSundayStreams = !!a.migration_service_id && a.migration_service_id.indexOf("ss:") === 0;
    $scope.migratedFromStreamMonkey = !!a.migration_service_id && a.migration_service_id.indexOf("sm:") === 0;
    $scope.chatSupport = a.internal_metadata.chat_support;
  };

  $scope.loadBilling = function () {
    $scope.loading = true;
    PandadocService.getUserAccessToken().then(function (token) {
      $scope.pandadocToken = token;
    })["catch"](function () {// no token found
    });

    if ($scope.subscriptions || !stripeCustomer) {
      $scope.loading = false;
      return;
    }

    var a = ActivationCodes.queryAccount({
      account_id: $routeParams.id
    });
    var s = AccountSubscriptions.get({
      account_id: $routeParams.id
    });
    $q.all([a.$promise, s.$promise]).then(function () {
      $scope.activationCodes = a;
      $scope.subscriptions = s;
      $scope.featureSummary = FeatureBillingService.featureSummary($scope.account, $scope.subscriptions.features);
    })["finally"](function () {
      return $scope.loading = false;
    });
  };

  $scope.loadUsers = function () {
    $scope.loading = true;

    if ($scope.users) {
      $scope.loading = false;
      return;
    }

    User.query({
      account_id: $routeParams.id,
      'filter.include_archived': 'false',
      l: 100
    }).$promise.then(function (res) {
      $scope.loading = false;
      $scope.users = res;
      $scope.userCount = _.filter(res, function (user) {
        return !user.is_impersonating;
      }).length;
    });
  };

  $scope.loadChannels = function () {
    $scope.loading = true;

    if ($scope.channels) {
      $scope.loading = false;
      return;
    }

    AccountChannel.query({
      account_id: $routeParams.id,
      l: 1000
    }).$promise.then(function (res) {
      $scope.loading = false;
      $scope.channels = res;
    });
  };

  $scope.loadTickets = function () {
    $scope.loading = true;

    if ($scope.tickets) {
      $scope.loading = false;
      return;
    } // XXX: TODO: the ticket summary doesn't work in admin scope per account ... it just
    // acts on the current logged in user's account only.  Will need to fix API if we want this.


    var p1 = Ticket.queryAccount({
      account_id: $routeParams.id,
      type: 'broadcast',
      s: '-created_at'
    }).$promise;
    var p2 = Ticket.queryAccount({
      account_id: $routeParams.id,
      type: 'channel',
      s: '-created_at'
    }).$promise;
    $q.all([p1, p2
    /*, p3, p4*/
    ]).then(function (results) {
      $scope.tickets = results[0];
      $scope.channelTickets = results[1];
      $scope.loading = false;
    });
  };

  $scope.showTicket = function (ticket) {};

  $scope.showTicket = function (t) {
    return $location.path("/broadcasts/".concat(t.broadcast_id, "/tickets/").concat(t.id));
  };

  $scope.showChannelTicket = function (t) {
    return $location.path("/accounts/".concat($routeParams.id, "/channels/").concat(t.channel_id, "/tickets/").concat(t.id));
  };

  $scope.boxcastersUrl = function () {
    return "/boxcasters?f=account:".concat(encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({
      active: true
    }, _.pick($scope.account, 'id', 'name'))))));
  };

  $scope.staticRtmpsUrl = function () {
    return "/accounts/".concat($routeParams.id, "/static_rtmps");
  };

  $scope.broadcastsUrl = function () {
    return "".concat(__WEBPACK_IMPORTED_MODULE_4_environment__["r" /* NEW_ADMIN_URL */], "/broadcasts?f=account:").concat(encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({
      active: true
    }, _.pick($scope.account, 'id', 'name'))))), "+only_today");
  };

  $scope.donationsUrl = function () {
    return "/accounts/".concat($routeParams.id, "/donations");
  };

  $scope.storageBillsUrl = function () {
    return "/accounts/".concat($routeParams.id, "/storage_bills");
  };

  $scope.brandedAppsUrl = function () {
    return "/accounts/".concat($routeParams.id, "/branded_apps");
  };

  $scope.scoreboardAssistsUrl = function () {
    return "/scoreboard_assists?f=account:".concat(encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({
      active: true
    }, _.pick($scope.account, 'id', 'name'))))));
  };

  $scope.ordersUrl = function () {
    return "/orders?f=account:".concat(encodeURIComponent(encodeURIComponent(JSON.stringify(_.extend({
      active: true
    }, _.pick($scope.account, 'id', 'name'))))));
  };

  $scope.hubspotCompanyUrl = function () {
    return "".concat(__WEBPACK_IMPORTED_MODULE_4_environment__["l" /* HUBSPOT_BASE_URL */], "/company/").concat($scope.account.hubspot_handle);
  };

  $scope.intercomCompanyUrl = function () {
    return "".concat(__WEBPACK_IMPORTED_MODULE_4_environment__["n" /* INTERCOM_BASE_URL */], "/companies/").concat($scope.account.intercom_company_id);
  };

  $scope.showUser = function (e) {
    return window.open("".concat($scope.newAdminURL, "/accounts/").concat($routeParams.id, "/users/").concat(e.id), '_self');
  };

  $scope.requestPayment = function (user) {
    if (confirm("Please confirm that you want to email ".concat(user.email, " to request updated payment information"))) {
      console.log(user);
      return User.update({
        account_id: $routeParams.id,
        id: user.id,
        request_payment_email: true
      }, function (u) {
        return alert('Payment request sent!');
      });
    }
  };

  $scope.showChannel = function (e) {
    return $location.path("/accounts/".concat($routeParams.id, "/channels/").concat(e.id));
  };

  $scope.showHubspotDeal = function (d) {
    return window.open("".concat(__WEBPACK_IMPORTED_MODULE_4_environment__["l" /* HUBSPOT_BASE_URL */], "/deal/").concat(d, "/"), '_blank');
  };

  $scope.edit = function () {
    return $modal.open({
      template: __webpack_require__(208),
      controller: 'AccountFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        mode: function mode() {
          return 'edit';
        }
      }
    }).result.then(function (a) {
      $scope.updateAccount(a);
    });
  };

  $scope.editUser = function () {
    return $modal.open({
      template: __webpack_require__(100),
      controller: 'UserFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        account: function account() {
          return $scope.account;
        }
      }
    }).result.then(function (u) {
      return $scope.showUser(u);
    });
  };

  $scope.impersonate = function () {
    Account.impersonate({
      id: $scope.account.id
    }, function (token) {
      var token_type = token.token_type,
          access_token = token.access_token,
          scope = token.scope;
      window.open("".concat(__WEBPACK_IMPORTED_MODULE_4_environment__["d" /* DASHBOARD_URL */], "#").concat(jQuery.param({
        token_type: token_type,
        access_token: access_token,
        scope: scope
      })));
      $rootScope.$broadcast('impersonate_initiated');
    });
  };

  $scope.copyToClipboard = function (c) {
    var selBox = document.createElement('textarea');
    selBox.value = c;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  };

  $scope.getLinkedTrialDeals = function () {
    var deals = [];
    $scope.account.external_account_links.forEach(function (l) {
      if (l.link_type == 'hubspot:deal' && l.status == 'trial') {
        deals.push(l.external_id);
      }
    });
    return deals;
  };

  $scope.createUpgrade = function () {
    // Check for existing transition deal
    var _dealId = null;
    var trialDeals = $scope.getLinkedTrialDeals();

    if ($scope.account.contract == 'trial' && trialDeals.length > 0) {
      _dealId = trialDeals[trialDeals.length - 1];
    } // Default to creating a new deal


    $modal.open({
      template: __webpack_require__(101),
      controller: 'UpgradeFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        isRma: function isRma() {
          return false;
        },
        dealId: function dealId() {
          return _dealId;
        },
        pandadocToken: function pandadocToken() {
          return $scope.pandadocToken;
        }
      }
    }).result.then(function (u) {
      return $scope.showHubspotDeal(u.dealid);
    });
  };

  $scope.createRmaUpgrade = function () {
    return $modal.open({
      template: __webpack_require__(101),
      controller: 'UpgradeFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        isRma: function isRma() {
          return true;
        },
        dealId: function dealId() {
          return null;
        },
        pandadocToken: function pandadocToken() {
          return $scope.pandadocToken;
        }
      }
    }).result.then(function (u) {
      return $scope.showHubspotDeal(u.dealid);
    });
  };

  $scope.openChangeSubscription = function () {
    var _subscription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return $modal.open({
      template: __webpack_require__(209),
      controller: 'ChangeSubscriptionFormController',
      backdrop: 'static',
      resolve: {
        subscription: function subscription() {
          return _subscription;
        }
      }
    }).result.then(function () {
      $scope.subscriptions = null;
      $scope.loadBilling();
    });
  };

  $scope.addUrlScheme = function (url) {
    if (/^https?:\/\//i.test(url)) {
      return url;
    } else {
      return 'http://' + url;
    }
  };

  $scope.enableChatSupport = function () {
    if (confirm("Are you sure you want to enable chat support? Once enabled, it cannot be disabled.")) {
      var newInternalMetadata = _.clone($scope.account.internal_metadata);

      newInternalMetadata.chat_support = true;
      $scope.loading = true;
      Account.update({
        id: $scope.account.id,
        internal_metadata: newInternalMetadata
      }).$promise.then(function (a) {
        $scope.updateAccount(a);
        $scope.loading = false;
      })["catch"](function (err) {
        console.error("Error updating account", err);
        alert('Error updating account! Please check the console for more information.');
        $scope.loading = false;
      });
    }
  };

  $scope.loadTab = function (tab) {
    if (tab == '') {
      tab = 'overview';
    }

    $scope.activeTab = {};
    $scope.activeTab[tab] = true;

    switch (tab) {
      case 'billing':
        $scope.loadBilling();
        break;

      case 'users':
        $scope.loadUsers();
        break;

      case 'channels':
        $scope.loadChannels();
        break;

      case 'tickets':
        $scope.loadTickets();
        break;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Add Authorized Account</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-sm-12\">\n      <div class=\"form-group\">\n        <label for=\"account\">Account</label>\n        <tags-input\n            placeholder=\"Type to search accounts...\"\n            display-property=\"name\",\n            key-property=\"id\"\n            min-tags=\"1\"\n            add-from-autocomplete-only=\"true\"\n            ng-model=\"selectedAccount\">\n          <auto-complete source=\"searchAccounts($query)\"></auto-complete>\n        </tags-input>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_chooser_controller__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_chooser_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__template_chooser_controller__);

angular.module('app.views').config(["tagsInputConfigProvider", function (tagsInputConfigProvider) {
  tagsInputConfigProvider.setDefaults('tagsInput', {
    placeholder: ''
  });
}]).controller('UpgradeFormController', ["$scope", "$modalInstance", "Boxcaster", "Upgrade", "$routeParams", "User", "$modal", "isRma", "dealId", "pandadocToken", function ($scope, $modalInstance, Boxcaster, Upgrade, $routeParams, User, $modal, isRma, dealId, pandadocToken) {
  var boxcasters = [];
  Boxcaster.query({
    "filter.account_id": $routeParams.id
  }).$promise.then(function (b) {
    boxcasters = b.map(function (b) {
      return b.id;
    });
  });
  User.query({
    account_id: $routeParams.id,
    'filter.include_archived': 'false',
    l: 50
  }).$promise.then(function (res) {
    $scope.users = res;
    $scope.recipient = $scope.users[0];
  }); // These map to HS Deal property values: https://app.hubspot.com/property-settings/484866/deal/rma_customer_expectation

  $scope.CUSTOMER_EXPECTATION_VALUES = ['Replacement Order Entered', 'No Replacement Needed', 'Repair and Return', '30 Day Money Back Guarantee'];
  $scope.DEFAULT_CUSTOMER_EXPECTATION = 'Replacement Order Entered'; // These map to HS Deal property values: https://app.hubspot.com/property-settings/484866/deal/rma_product_type

  $scope.PRODUCT_TYPE_VALUES = ['BoxCaster', 'BoxCaster Pro', 'Wired Scoreboard Adapter', 'Wireless Scoreboard Adapter', 'Magewell Rental Encoder', 'LiveShell X Rental Encoder', 'LiveShell Pro Rental Encoder', 'LiveShell 2 Rental Encoder', 'Scoreboard Assist'];
  $scope.DEFAULT_PRODUCT_TYPE = 'BoxCaster';
  $scope.template = null;
  $scope.isRma = isRma;
  $scope.dealId = dealId;
  $scope.pandadocToken = pandadocToken;
  $scope.generateProposal = true;
  $scope.isCreating = false;
  $scope.customerExpectation = $scope.DEFAULT_CUSTOMER_EXPECTATION;
  $scope.productType = $scope.DEFAULT_PRODUCT_TYPE;
  $scope.serialNumber = null;
  $scope.summary = null;
  $scope.supportLink = null;

  $scope.loadBoxcasters = function (query) {
    return boxcasters.filter(function (b) {
      return b.indexOf(query) > -1;
    });
  };

  $scope.onSelectTemplate = function () {
    $modal.open({
      template: __webpack_require__(206),
      controller: 'TemplateChooserController',
      size: 'md',
      backdrop: 'static'
    }).result.then(function (template) {
      return $scope.template = template;
    });
  };

  $scope.ok = function () {
    if (!$scope.isRma && !$scope.template && !!$scope.dealId) {
      // Nothing to do - the deal already exists and no proposal template was selected
      $modalInstance.close({
        dealid: $scope.dealId
      });
      return;
    }

    $scope.submit();
  };

  $scope.submit = function () {
    $scope.isCreating = true;
    Upgrade.create({
      account_id: $routeParams.id,
      rma_customer_expectation: $scope.isRma ? $scope.customerExpectation : null,
      rma_product_type: $scope.isRma ? $scope.productType : null,
      rma_serial_number: $scope.isRma ? $scope.serialNumber.pop().text : null,
      rma_summary: $scope.summary,
      rma_support_link: $scope.supportLink,
      pandadoc_template_id: ($scope.template || {}).id,
      recipient_email: $scope.recipient.email,
      hubspot_deal_id: $scope.dealId,
      pandadoc_access_token: $scope.pandadocToken
    }).$promise.then(function (u) {
      $modalInstance.close(u);
    })["catch"](function (err) {
      console.error(err);
      alert('Error creating RMA deal');
    })["finally"](function () {
      $scope.isCreating = false;
    });
  };

  $scope.isValid = function () {
    if ($scope.isRma && !$scope.form.$valid) {
      return false;
    }

    if ($scope.generateProposal && !$scope.template) {
      return false;
    }

    return true;
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);

/***/ }),
/* 205 */
/***/ (function(module, exports) {

angular.module('app.views').controller('TemplateChooserController', ["$scope", "$modalInstance", "$q", "Pandadoc", function ($scope, $modalInstance, $q, Pandadoc) {
  $scope.folderStack = [{
    uuid: "",
    name: ""
  }];

  $scope.loadFolder = function (folder) {
    $scope.isLoading = true;
    var p1 = Pandadoc.getTemplates({
      folder_id: folder.uuid
    }).$promise;
    var p2 = Pandadoc.getTemplateFolders({
      folder_id: folder.uuid
    }).$promise;
    $q.all([p1, p2]).then(function (results) {
      $scope.templates = results[0];
      $scope.folders = results[1];
      $scope.isLoading = false;
    });
  };

  $scope.selectFolder = function (folder) {
    $scope.folderStack.push(folder);
    $scope.loadFolder(folder);
  };

  $scope.selectTemplate = function (template) {
    $modalInstance.close(template);
  };

  $scope.loadFolder($scope.folderStack[0]);

  $scope.back = function (folder) {
    while ($scope.folderStack[$scope.folderStack.length - 1].uuid != folder.uuid) {
      $scope.folderStack.pop();
    }

    $scope.loadFolder(folder);
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Select Template</h3>\n  <div class=\"modal-body clearfix\">\n    <div ng-show=\"folderStack.length > 1\" style=\"margin-bottom:25px\">\n      <span ng-repeat=\"f in folderStack\">\n        <i ng-show=\"f.name != ''\" class=\"fa fa-caret-right\" style=\"margin:0 5px;color:grey\"></i> \n        <a ng-show=\"f.uuid != folderStack[folderStack.length-1].uuid\" ng-click=\"back(f)\" style=\"cursor:pointer;\">{{f.name == '' ? 'Templates' : f.name}}</a>\n        <span ng-show=\"f.uuid == folderStack[folderStack.length-1].uuid\"><strong>{{f.name == '' ? 'Templates' : f.name}}</strong></span>\n      </span>\n    </div>\n    <div ng-show=\"isLoading\" class=\"text-center\" style=\"padding:50px\">\n      <i class=\"fa fa-spinner fa-spin\" style=\"font-size:2em\" aria-hidden=\"true\"></i>\n    </div>\n    <table ng-show=\"!isLoading\" class=\"table table-striped table-hover table-condensed table-animate\">\n      <tbody>\n        <tr ng-show=\"folder.has_folders || folder.has_items\" ng-repeat=\"folder in folders\" ng-click=\"selectFolder(folder)\" class=\"clickable\">\n          <td><i class=\"fa fa-folder\"></i></td>\n          <td>{{ folder.name }}</td>\n        </tr>\n        <tr ng-repeat=\"template in templates\" ng-click=\"selectTemplate(template)\" class=\"clickable\">\n          <td><i class=\"fa fa-file-text-o\"></i></td>\n          <td><span ng-if=\"template.version == '2'\" class=\"label label-default\">2.0</span> {{ template.name }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"modal-footer\">\n    <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n  </div>\n</div>\n"

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div style=\"margin: 0 50px\">\n    <div ng-if=\"migratedFromSundayStreams\" class=\"label label-info\" style=\"float:right\">\n      Migrated from <img src=\"/assets/images/suns-logo.png\" style=\"max-height: 25px;\">\n    </div>\n    <div ng-if=\"migratedFromStreamMonkey\" class=\"label label-info\" style=\"float:right\">\n      Migrated from <img src=\"/assets/images/stream-monkey-logo.png\" style=\"max-height: 25px;\">\n    </div>\n    <h4>{{account.name}}</h4>\n    <span ng-if=\"account.support_plan == 'reduced'\" class=\"label label-default\"><i class=\"fa fa-ban\"></i> Reduced Support</span>\n    <span ng-if=\"account.support_plan == 'priority'\" class=\"label label-warning\"><i class=\"fa fa-star\"></i> Priority Support</span>\n    <span ng-if=\"account.contract == 'trial'\" class=\"label label-info\">Trial</span>\n    <span ng-if=\"account.contract == 'free'\" class=\"label\" style=\"background-color: #FA4C3C\">Free</span>\n\n    <hr style=\"margin:10px 0 10px 0;\">\n\n    <tabset>\n      <tab heading=\"Overview\" active=\"activeTab['overview']\" ng-click=\"openURL('{{ newAdminURL }}'+'/accounts/'+account.id+'?tab=overview', $event)\">\n      </tab>\n      <tab heading=\"Billing\" active=\"activeTab['billing']\" ng-click=\"openURL('{{ newAdminURL }}'+'/accounts/'+account.id+'?tab=settings', $event)\">\n      </tab>\n      <tab heading=\"Users\" active=\"activeTab['users']\" ng-click=\"openURL('{{ newAdminURL }}'+'/accounts/'+account.id+'?tab=users', $event)\">\n      </tab>\n      <tab heading=\"Channels\" active=\"activeTab['channels']\" ng-click=\"loadTab('channels')\">\n\n        <div ng-if=\"loading\">\n          <div class=\"alert alert-info alert-loading\">\n              <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n          </div>\n        </div>\n\n        <table class=\"table table-striped table-light-border table-hover table-animate table-condensed\" ng-if=\"!loading\">\n          <thead>\n            <tr>\n              <th class=\"col-xs-8\">Name</th>\n              <th class=\"col-xs-4\">Accessibility</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr ng-if=\"!loading && !channels.length\" class=\"tr--no-results\"><td colspan=\"2\">No channels to display.</td></tr>\n            <tr ng-repeat=\"e in channels\" ng-click=\"showChannel(e)\" class=\"clickable\">\n              <td>{{ e.name }}</td>\n              <td>{{ e | accessibility }}</td>\n            </tr>\n          </tbody>\n        </table>\n      </tab>\n      <tab heading=\"Tickets\" active=\"activeTab['tickets']\" ng-click=\"loadTab('tickets')\">\n\n        <div ng-if=\"loading\">\n          <div class=\"alert alert-info alert-loading\">\n              <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n          </div>\n        </div>\n\n        <div ng-if=\"!loading\">\n          <!--\n          <div class=\"row text-center\">\n            <div class=\"col-sm-3\">\n              <strong>Gross Ticket Revenue</strong>\n              <h1>{{ticketSummary.total | currency}}</h1>\n              <p class=\"help-block\"><small>\n                (Total value of {{ticketSummary.count}} tickets sold for all time)\n              </small></p>\n            </div>\n            <div class=\"col-sm-3\">\n              <strong>Gross Minus Refunds </strong>\n              <h1>{{ticketSummary.total - ticketSummary.total_refund | currency}}</h1>\n              <p class=\"help-block\"><small>\n                (Gross ticket revenue minus {{ticketSummary.count_refund}} refunds)\n              </small></p>\n            </div>\n            <div class=\"col-sm-3\">\n              <strong>Gross Channel Ticket Revenue</strong>\n              <h1>{{channelTicketSummary.total | currency}}</h1>\n              <p class=\"help-block\"><small>\n                (Total value of {{channelTicketSummary.count}} tickets sold for all time)\n              </small></p>\n            </div>\n            <div class=\"col-sm-3\">\n              <strong>Channel Gross Minus Refunds </strong>\n              <h1>{{channelTicketSummary.total - channelTicketSummary.total_refund | currency}}</h1>\n              <p class=\"help-block\"><small>\n                (Gross ticket revenue minus {{channelTicketSummary.count_refund}} refunds)\n              </small></p>\n            </div>\n          </div>\n          -->\n          <h4>Recent Single Broadcast Tickets</h4>\n          <p ng-if=\"tickets.length == 20\" class=\"help-block\">\n            <em>Only the first 20 results are shown here.</em>\n          </p>\n          <table class=\"table table-striped table-light-border table-hover table-animate table-condensed\">\n            <thead>\n              <tr>\n                <th class=\"col-xs-2\">Purchased</th>\n                <th class=\"col-xs-3\">Broadcast</th>\n                <th class=\"col-xs-3\">Name</th>\n                <th class=\"col-xs-3\">Email</th>\n                <th class=\"col-xs-2\">Invoice</th>\n                <th class=\"col-xs-1\">Amount</th>\n                <th class=\"col-xs-1\">Email Suppressed?</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-if=\"!tickets.length\" class=\"tr--no-results\"><td colspan=\"7\">No tickets to display.</td></tr>\n              <tr ng-repeat=\"ticket in tickets\"\n                  ng-click=\"showTicket(ticket)\"\n                  class=\"clickable\"\n                  ng-style=\"{color:ticket.is_refunded?'rgba(0,0,0,0.4)':'inherit'}\">\n                <td>{{ ticket.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td>\n                <td>{{ ticket.broadcast_name }}</td>\n                <td>{{ ticket.name }}</td>\n                <td>{{ ticket.email }}</td>\n                <td>{{ ticket.invoice_handle }}</td>\n                <td>\n                  <span ng-hide=\"ticket.is_refunded\">\n                    {{ ticket.price|currency }}\n                  </span>\n                  <span ng-show=\"ticket.is_refunded\">\n                    <strike>{{ ticket.price|currency }}</strike> <span class=\"badge\">Refunded</span>\n                  </span>\n                </td>\n                <td><i ng-show=\"ticket.suppressed_reason\" class=\"fa fa-ban\" style=\"color:red\" aria-hidden=\"true\"></i></td>\n              </tr>\n            </tbody>\n          </table>\n\n          <h4>Recent Channel Tickets</h4>\n          <p ng-if=\"channelTickets.length == 20\" class=\"help-block\">\n            <em>Only the first 20 results are shown here.</em>\n          </p>\n          <table class=\"table table-striped table-light-border table-hover table-animate table-condensed\">\n            <thead>\n              <tr>\n                <th class=\"col-xs-2\">Purchased</th>\n                <th class=\"col-xs-3\">Channel</th>\n                <th class=\"col-xs-3\">Name</th>\n                <th class=\"col-xs-3\">Email</th>\n                <th class=\"col-xs-2\">Invoice</th>\n                <th class=\"col-xs-1\">Amount</th>\n                <th class=\"col-xs-1\">Email Suppressed?</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-if=\"!channelTickets.length\" class=\"tr--no-results\"><td colspan=\"7\">No tickets to display.</td></tr>\n              <tr ng-repeat=\"ticket in channelTickets\"\n                  ng-click=\"showChannelTicket(ticket)\"\n                  class=\"clickable\"\n                  ng-style=\"{color:ticket.is_refunded?'rgba(0,0,0,0.4)':'inherit'}\">\n                <td>{{ ticket.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td>\n                <td>{{ ticket.channel_name }}</td>\n                <td>{{ ticket.name }}</td>\n                <td>{{ ticket.email }}</td>\n                <td>{{ ticket.invoice_handle }}</td>\n                <td>\n                  <span ng-hide=\"ticket.is_refunded\">\n                    {{ ticket.price|currency }}\n                  </span>\n                  <span ng-show=\"ticket.is_refunded\">\n                    <strike>{{ ticket.price|currency }}</strike> <span class=\"badge\">Refunded</span>\n                  </span>\n                </td>\n                <td><i ng-show=\"ticket.suppressed_reason\" class=\"fa fa-ban\" style=\"color:red\" aria-hidden=\"true\"></i></td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </tab>\n  </div>\n</div>\n"

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = "<style>\n  @media (min-width: 768px) {\n    .form-inline .form-group {\n      margin-bottom: 15px;\n      display: block;\n    }\n    .form-inline .form-group label {\n      width: 160px;\n      margin-right: 15px;\n    }\n    .form-inline .form-group input,\n    .form-inline .form-group select {\n      width: calc(100% - 179px);\n    }\n    .form-inline.tight .form-group label {\n      width: 85px;\n      margin-right: 0px;\n      font-weight:normal;\n      font-size:13px;\n    }\n    .form-inline.tight .form-group input,\n    .form-inline.tight .form-group select {\n      width: calc(100% - 94px);\n    }\n  }\n</style>\n<div class=\"modal-header\" style=\"border-bottom:0\">\n  <div class=\"col-md-3\">\n    <h3 class=\"modal-title\">Edit Account</h3>\n  </div>\n  <div class=\"col-md-9\">\n    <div ng-show=\"featureSummary.extraFlags.length || featureSummary.missingFlags.length\">\n      <span class=\"label label-warning col-xs-12\" style=\"margin:0 0 5px 0\">\n        <i class=\"fa fa-warning\"></i>\n        Flag Mismatch:\n        <span tooltip=\"{{_.pluck(featureSummary.extraFlags, 'label').join(', ')}}\">{{featureSummary.extraFlags.length}} extra</span> and\n        <span tooltip=\"{{_.pluck(featureSummary.missingFlags, 'label').join(', ')}}\">{{featureSummary.missingFlags.length}} missing</span>\n        compared to subscription.\n      </span>\n    </div>\n    <div ng-show=\"featureSummary.storagePlanMismatch\">\n      <span class=\"label label-warning col-xs-12\" style=\"margin:0 0 5px 0\">\n        <i class=\"fa fa-warning\"></i>\n        Storage plan mismatch (paying for\n        \"{{featureSummary.storagePlanMismatch.billedPolicy}}\"/{{featureSummary.storagePlanMismatch.billedDurationDays}} days\n        but\n        \"{{featureSummary.storagePlanMismatch.currentPolicy}}\"/{{featureSummary.storagePlanMismatch.currentDurationDays}} days\n        is selected)\n      </span>\n    </div>\n    <div ng-show=\"featureSummary.supportPlanMismatch\">\n      <span class=\"label label-warning col-xs-12\" style=\"margin:0 0 5px 0\">\n        <i class=\"fa fa-warning\"></i>\n        Support plan mismatch (paying for \"{{featureSummary.supportPlanMismatch.billedPlan}}\" but \"{{featureSummary.supportPlanMismatch.currentPlan}}\" is selected)\n      </span>\n    </div>\n    <div ng-show=\"featureSummary.streamingQualityMismatch\">\n      <span class=\"label label-warning col-xs-12\" style=\"margin:0 0 5px 0\">\n        <i class=\"fa fa-warning\"></i>\n        Resolution limit mismatch (paying for \"{{featureSummary.streamingQualityMismatch.billedStreamingQuality}}\" but \"{{featureSummary.streamingQualityMismatch.currentStreamingQuality}}p\" is selected)\n      </span>\n    </div>\n    <div ng-show=\"featureSummary.maxDurationMismatch\">\n      <span class=\"label label-warning col-xs-12\" style=\"margin:0 0 5px 0\">\n        <i class=\"fa fa-warning\"></i>\n        Max broadcast duration mismatch (paying for \"{{featureSummary.maxDurationMismatch.billedMaxDuration}} hours\" but \"{{featureSummary.maxDurationMismatch.currentMaxDuration}} hours\" is selected)\n      </span>\n    </div>\n    <div ng-show=\"featureSummary.maxSimultaneousMismatch\">\n      <span class=\"label label-warning col-xs-12\" style=\"margin:0 0 5px 0\">\n        <i class=\"fa fa-warning\"></i>\n        Max simultaneous streams mismatch (paying for {{featureSummary.maxSimultaneousMismatch.billedMaxSimultaneous}} but {{featureSummary.maxSimultaneousMismatch.currentMaxSimultaneous}} is selected)\n      </span>\n    </div>\n  </div>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-sm-8\">\n      <div class=\"form-group\">\n        <label for=\"name\">Account Name</label>\n        <input id=\"name\" type=\"text\" ng-model=\"account.name\" required placeholder=\"Enter the organization's full name\" class=\"form-control\">\n      </div>\n      <div class=\"form-group\">\n        <label for=\"reseller\">Reseller</label>\n        <select id=\"reseller\" ng-model=\"account.reseller_id\" class=\"form-control input-sm\">\n          <option value=\"\">None</option>\n          <option ng-repeat=\"r in resellers\" value=\"{{ r.id }}\">{{ r.name }}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"description\">CS Notes</label>\n        <textarea id=\"description\" type=\"text\" ng-model=\"account.internal_description\" class=\"form-control\"></textarea>\n      </div>\n      <div class=\"form-inline\">\n        <div class=\"form-group\">\n          <label for=\"hubspot_handle\">\n            HubSpot Company ID\n            <i class=\"fa fa-info-circle pull-right\" tooltip=\"/contacts/484866/company/123456789\"></i>\n          </label>\n          <input id=\"hubspot_handle\" type=\"text\" ng-model=\"account.hubspot_handle\" placeholder=\"123456789\" class=\"form-control input-sm\">\n        </div>\n        <div class=\"form-group\">\n          <label for=\"xero_handle\">\n            Xero Customer ID\n            <i class=\"fa fa-info-circle pull-right\" tooltip=\"/Contacts/View.aspx?contactID=01234567-89AB-CDEF-0123-456789ABCDEF\"></i>\n          </label>\n          <input id=\"xero_handle\" type=\"text\" ng-model=\"account.xero_handle\" placeholder=\"01234567-89AB-CDEF-0123-456789ABCDEF\" class=\"form-control input-sm\">\n        </div>\n        <div class=\"form-group\">\n          <label for=\"stripe_handle\">\n            Stripe Customer ID\n            <i class=\"fa fa-info-circle pull-right\" tooltip=\"/customers/cus_01234aBcDe5678\"></i>\n          </label>\n          <input id=\"stripe_handle\" type=\"text\" ng-model=\"account.stripe_customer_handle\" placeholder=\"cus_01234aBcDe5678\" class=\"form-control input-sm\">\n        </div>\n\n        <div class=\"form-group\" ng-show=\"billing\" style=\"display:flex\">\n          <label>Stripe Plan / Features</label>\n          <div class=\"form-control input-sm\" disabled style=\"flex: 1; height: auto; min-height: 30px; margin-left:3px;\">\n            <ol class=\"list-inline\" ng-repeat=\"sub in ::billing.subscriptions.data\">\n              <li ng-repeat=\"p in ::sub.items.data\">\n                {{ p.plan.id }}\n                <span class=\"label label-default\">{{sub.status}}</span>\n              </li>\n            </ol>\n            <ol class=\"list-inline\" ng-repeat=\"plan in ::billing.metadata.manually_billed_plans\">\n              <li>{{ plan.id }} <span class=\"label label-default\">manual</span></li>\n            </ol>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <button ng-click=\"flags.showAdvancedFlagConfig = !flags.showAdvancedFlagConfig\" class=\"pull-right btn btn-default btn-sm\" type=\"button\">\n            <span ng-bind-html=\"flags.showAdvancedFlagConfig?'Hide':'Show'\" /> All Flags\n          </button>\n          <label for=\"stream_quality\">Streaming Quality</label>\n          <select id=\"stream_quality\" ng-model=\"flags.streamQuality\" required class=\"form-control input-sm\">\n            <option ng-repeat=\"e in ::config.streamingQualityLevels\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n      </div>\n\n      <div ng-show=\"flags.showAdvancedFlagConfig\">\n        <div class=\"form-group\" ng-repeat=\"(category, tagList) in ::config.accountTagsByCategory\">\n          <label style=\"text-transform:capitalize\">{{category}}</label>\n          <div class=\"checkbox row\">\n            <div class=\"col-sm-6\"\n                 style=\"height:2em\"\n                 ng-repeat=\"e in ::tagList\"\n                 ng-if=\"specialTagsToSkip.indexOf(e.value) < 0\">\n              <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"tags.indexOf(e.value) >= 0\" ng-click=\"toggleTag(e.value)\">&nbsp;{{ e.label }}\n                <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n                <i ng-if=\"isMissingTag(e.value)\" class=\"fa fa-warning text-danger\" tooltip=\"This flag should be checked according to the subscription\" tooltip-placement=\"right\"></i>\n                <i ng-if=\"isExtraTag(e.value)\" class=\"fa fa-warning text-danger\" tooltip=\"This flag should *not* be checked according to the subscription\" tooltip-placement=\"right\"></i>\n              </label>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label style=\"text-transform:capitalize\">Usage Flags</label>\n          <div class=\"checkbox row\">\n            <div class=\"col-sm-6\"\n                 style=\"height:2em\"\n                 ng-repeat=\"e in ::config.usageFlags\">\n              <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"usageFlags.indexOf(e.value) >= 0\" ng-click=\"toggleUsageFlag(e.value)\">&nbsp;{{ e.label }}\n                <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n              </label>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label style=\"text-transform:capitalize\">Extra Features</label>\n          <div class=\"checkbox row\">\n            <div class=\"col-sm-6\"\n                 style=\"height:2em\"\n                 ng-repeat=\"e in ::config.extraFeatures\">\n              <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"extraFeatures.indexOf(e.value) >= 0\" ng-click=\"toggleExtraFeature(e.value)\">&nbsp;{{ e.label }}\n                <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n              </label>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label style=\"text-transform:capitalize\">Behavior Modification</label>\n          <div class=\"checkbox row\">\n            <div class=\"col-sm-6\"\n                 style=\"height:2em\"\n                 ng-repeat=\"e in ::config.behaviorModifications\">\n              <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"behaviorModifications.indexOf(e.value) >= 0\" ng-click=\"toggleBehaviorModification(e.value)\">&nbsp;{{ e.label }}\n                <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n    <div class=\"col-sm-4\">\n      <div class=\"form-inline tight\">\n        <div class=\"form-group\">\n          <label for=\"market\">Market</label>\n          <select id=\"market\" ng-model=\"account.market\" required class=\"form-control\">\n            <option ng-repeat=\"e in ::config.markets\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"contract\">Contract</label>\n          <select id=\"contract\" ng-model=\"account.contract\" required class=\"form-control\">\n            <option ng-repeat=\"e in ::config.contractTypes\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"status\">Status</label>\n          <select id=\"status\" ng-model=\"account.status\" required class=\"form-control\">\n            <option ng-repeat=\"e in ::config.accountStatuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"payment_status\">Payment</label>\n          <select id=\"payment_status\" ng-model=\"account.payment_status\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.paymentStatuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"payment_method\">Method</label>\n          <select id=\"payment_method\" ng-model=\"account.payment_method\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.paymentMethods\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n      </div>\n\n      <div class=\"form-inline tight\">\n        <p style=\"border-bottom:1px solid #eee\"><strong>Storage</strong></p>\n        <div class=\"form-group\" ng-show=\"accountNeedsAStoragePolicy\">\n          <label for=\"storage_policy\">Policy</label>\n          <select id=\"storage_policy\" ng-model=\"account.storage_policy\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.storagePolicies\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"storage_duration\">Duration</label>\n          <select id=\"storage_duration\" ng-model=\"account.storage_duration_days\" class=\"form-control\">\n            <option ng-repeat=\"e in storageDurations\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\" ng-show=\"account.storage_policy == 'auto-bill'\">\n          <label for=\"storage_rate\">Rate</label>\n          <select id=\"storage_rate\" ng-model=\"account.storage_rate\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.storageRates\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n      </div>\n\n      <div class=\"form-inline tight\">\n        <p style=\"border-bottom:1px solid #eee\"><strong>Misc</strong></p>\n        <div class=\"form-group\">\n          <label for=\"support_plan\">Support</label>\n          <select id=\"support_plan\" ng-model=\"account.support_plan\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.supportPlans\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"sale_closed_on\">Sale Closed</label>\n          <input id=\"sale_closed_on\" type=\"text\" ng-model=\"account.sale_closed_on\" datepicker-popup=\"MM/dd/yyyy\" is-open=\"saleClosedOnIsOpen\" ng-click=\"saleClosedOnIsOpen=true\" required class=\"form-control\">\n        </div>\n        <div class=\"form-group\">\n          <label for=\"expires_on\">Expires</label>\n          <input id=\"expires_on\" type=\"text\" ng-model=\"account.expires_on\" datepicker-popup=\"MM/dd/yyyy\" is-open=\"expiresOnIsOpen\" ng-click=\"expiresOnIsOpen=true\" required class=\"form-control\">\n        </div>\n        <div class=\"form-group\">\n          <label for=\"backhaul_protocol\">Backhaul</label>\n          <select id=\"backhaul_protocol\" ng-model=\"account.backhaul_protocol\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.backhaulProtocols\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"ticket_revenue_share\">\n            Ticket Rev.\n          </label>\n          <select id=\"ticket_revenue_share\" ng-model=\"account.ticket_revenue_share\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.ticketRevenueShareOptions\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"max_broadcast_duration\">Max Duration</label>\n          <select id=\"max_broadcast_duration\" ng-model=\"account.max_broadcast_duration_hrs\" class=\"form-control\">\n            <option ng-repeat=\"e in ::config.maxBroadcastDurations\" value=\"{{ e.value }}\">{{ e.label }}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"max_simultaneous_streams\">Max Simultaneous Streams</label>\n          <input type=\"number\" id=\"max_simultaneous_streams\" ng-model=\"account.max_simultaneous_streams\" min=\"0\" max=\"100\" class=\"form-control\">\n          <i tooltip=\"Use 0 for unlimited simultaneous streaming\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"max_simultaneous_streams\">Max Users</label>\n          <input type=\"number\" id=\"max_users\" ng-model=\"account.max_users\" min=\"1\" max=\"500\" class=\"form-control\">\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = "<style>\n  td.selected {\n    background-color: #1aa8a1;\n  }\n  td.inactive {\n    background-color: #EFEFEF;\n  }\n  div.button-well {\n    margin-bottom:5px;\n    border-radius: 4px;\n  }\n  div.selected {\n    border: 1px solid #1aa8a1;\n  }\n  div.inactive {\n    border: 1px solid #EFEFEF;\n  }\n</style>\n\n<div class=\"modal-header\">\n  <h3 ng-show=\"subscription\" class=\"modal-title\">Change Subscription</h3>\n  <h3 ng-show=\"!subscription\" class=\"modal-title\">Add Subscription</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <div ng-show=\"loading\">\n    <span>Loading... </span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n  </div>\n  <form ng-show=\"!loading\" id=\"change-subscription-form\" name=\"form\" role=\"form\">\n    <div class=\"form-group\" style=\"margin-bottom:20px\">\n      <h4>End Date:</h4>\n      <input id=\"endDate\" type=\"text\" ng-model=\"endDate\" datepicker-popup=\"MM/dd/yyyy\" is-open=\"endDateIsOpen\" ng-click=\"endDateIsOpen=true\" required class=\"form-control\">\n    </div>\n\n    <h4>Base Plan:</h4>\n    <div ng-repeat=\"p in plans\" class=\"button-well\" ng-class=\"p.product_id == selectedPlan ? 'selected' : 'inactive'\">\n      <table class=\"table\" style=\"margin:0\">\n        <tr>\n          <td ng-class=\"p.product_id == selectedPlan ? 'selected' : 'inactive'\" width=\"50px\">\n            <a ng-click=\"onSelectPlan(p.product_id)\" href=\"javascript://\">\n              <i ng-hide=\"p.product_id == selectedPlan\" class=\"fa fa-circle\" style=\"color:white\"></i>\n            </a>\n          </td>\n          <td>{{ p.display_name }}</td>\n        </tr>\n      </table>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n  <button ng-click=\"update()\" ng-disabled=\"isUpdating\" class=\"btn btn-primary\"><i ng-show=\"isUpdating\" class=\"fa fa-cog fa-spin\"></i>\n    <span ng-show=\"subscription\">Update</span>\n    <span ng-show=\"!subscription\">Create</span>\n  </button>\n</div>\n"

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/donations/:id', {
    template: __webpack_require__(211),
    controller: 'AccountDonationController'
  });
}]).controller('AccountDonationController', ["$scope", "$location", "$routeParams", "Account", "Donation", function ($scope, $location, $routeParams, Account, Donation) {
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  $scope.account = Account.get({
    id: $routeParams.account_id
  });
  $scope.donation = Donation.get({
    account_id: $routeParams.account_id,
    id: $routeParams.id
  });
  $scope.isRefunding = false;
  return $scope.refund = function () {
    if (confirm('Are you sure you want to refund this donation?')) {
      $scope.isRefunding = true;
      return Donation.refund({
        account_id: $routeParams.account_id,
        id: $routeParams.id
      }, {
        id: $routeParams.id
      }, function (data) {
        return $scope.donation = data;
      });
    }
  };
}]);

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"/accounts/{{ account.id }}/donations\">Donations</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Donation {{ donation.id }}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <button ng-show=\"!donation.is_refunded && donation.stripe_charge_id\"\n                ng-disabled=\"isRefunding\"\n                ng-click=\"refund()\"\n                class=\"btn btn-danger btn-xs refund\">{{ isRefunding ? 'Refunding donation' : 'Refund donation' }}</button>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <h4>{{ donation.name }}</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr><th class=\"col-xs-2\">Email</th><td>{{ donation.email }}</td></tr>\n      <tr><th>Amount</th><td>{{ donation.amount | currency }} &emsp; <span ng-show=\"donation.is_refunded\" class=\"badge\">Refunded</span></td></tr>\n      <tr><th>Donated</th><td>{{ donation.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td></tr>\n      <tr><th>Invoice</th><td>{{ donation.invoice_handle }}</td></tr>\n      <tr ng-show=\"donation.stripe_charge_id\">\n        <th>Stripe Charge</th>\n        <td>{{ donation.stripe_charge_id }} &emsp; <a href=\"https://dashboard.stripe.com/payments/{{ donation.stripe_charge_id }}\" target=\"_blank\"><i class=\"fa fa-external-link\"></i></a>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/donations', {
    template: __webpack_require__(213),
    controller: 'AccountDonationsController'
  });
}]).controller('AccountDonationsController', ["$scope", "$location", "$routeParams", "Account", "Donation", function ($scope, $location, $routeParams, Account, Donation) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];
  $scope.s || ($scope.s = '-created_at');

  var params = _.pick($scope, 'q', 's', 'p');

  params.account_id = $routeParams.account_id;
  $scope.donations = Donation.query(params, function (data, getResponseHeader) {
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });
  return $scope.account = Account.get({
    id: $routeParams.account_id
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Donations</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search...\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n\n        <p class=\"help-block\" style=\"margin-top:30px\">\n        <small>\n        Example searches:<br>\n        <code>John Doe</code><br>\n        <code>invoice_handle:D01475866247251526</code><br>\n        <code>email:john.doe@example.com</code><br>\n        </small>\n        </p>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <table class=\"table table-striped table-dark-border table-hover table-condensed\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('created_at')\" class=\"clickable\">\n            Date\n            <i ng-show=\"s.indexOf('created_at') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'created_at'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-created_at'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th ng-click=\"sort('name')\" class=\"clickable\">\n            Name\n            <i ng-show=\"s.indexOf('name') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th ng-click=\"sort('email')\" class=\"clickable\">\n            Email\n            <i ng-show=\"s.indexOf('email') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'email'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-email'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th ng-click=\"sort('invoice_handle')\" class=\"clickable\">\n            Invoice\n            <i ng-show=\"s.indexOf('invoice_handle') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'invoice_handle'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-invoice_handle'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Amount</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"d in donations\" ng-click=\"openURL('/accounts/'+account.id+'/donations/'+d.id, $event)\" class=\"clickable\">\n          <td>{{ d.created_at | date }}</td>\n          <td>{{ d.name }}</td>\n          <td>{{ d.email }}</td>\n          <td>{{ d.invoice_handle}}</td>\n          <td>\n            <span ng-hide=\"d.is_refunded\">\n              {{ d.amount|currency }}\n            </span>\n            <span ng-show=\"d.is_refunded\">\n              <strike>{{ d.amount|currency }}</strike> <span class=\"badge\">Refunded</span>\n            </span>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/static_rtmps', {
    template: __webpack_require__(215),
    controller: 'AccountStaticRtmpsController'
  });
}]).controller('AccountStaticRtmpsController', ["$scope", "$location", "$routeParams", "$window", "Account", "AccountStaticRtmp", function ($scope, $location, $routeParams, $window, Account, AccountStaticRtmp) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];
  $scope.s || ($scope.s = 'name');

  var params = _.pick($scope, 'q', 's', 'p');

  params.account_id = $routeParams.account_id;

  $scope.loadStaticRtmps = function () {
    $scope.static_rtmps = AccountStaticRtmp.query(params, function (data, getResponseHeader) {
      var pagination = getResponseHeader('X-Pagination');
      return $scope.pagination = pagination ? JSON.parse(pagination) : {};
    });
  };

  $scope.loadStaticRtmps();
  $scope.account = Account.get({
    id: $routeParams.account_id
  });

  $scope.create = function () {
    var account = new AccountStaticRtmp({
      account_id: $routeParams.account_id,
      name: "Channel ".concat($scope.static_rtmps.length + 1)
    });
    account.$save().then(function () {
      return $scope.loadStaticRtmps();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> RTMP Sources</h3>\n      </div>\n    </div>\n    <p class=\"pull-right\"><button ng-click=\"create()\" class=\"btn btn-primary\"><i class=\"fa fa-plus\"></i> Create a New Source</button></p>\n    <div class=\"clearfix\"></div>\n  </div>\n  <div class=\"col-md-9\">\n    <table class=\"table table-striped table-light-border table-hover table-condensed table-animate\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('name')\" class=\"clickable\">\n            Name\n            <i ng-show=\"s.indexOf('name') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Server URL</th>\n          <th ng-click=\"sort('stream_key')\" class=\"clickable\">\n            Stream Key\n            <i ng-show=\"s.indexOf('stream_key') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'stream_key'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-stream_key'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"r in static_rtmps\" ng-click=\"openURL('/accounts/'+account.id+'/static_rtmps/'+r.id, $event)\" class=\"clickable\">\n          <td>{{ r.name }}</td>\n          <td>{{ r.server_url }}</td>\n          <td>{{ r.stream_key }}</td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/static_rtmps/:id', {
    template: __webpack_require__(217),
    controller: 'AccountStaticRtmpController'
  });
}]).controller('AccountStaticRtmpController', ["$scope", "$routeParams", "$window", "$log", "$modal", "Account", "AccountStaticRtmp", function ($scope, $routeParams, $window, $log, $modal, Account, AccountStaticRtmp) {
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  $scope.account = Account.get({
    id: $routeParams.account_id
  });
  AccountStaticRtmp.get({
    account_id: $routeParams.account_id,
    id: $routeParams.id,
    include_diagnostics: true
  }, function (data) {
    $scope.staticRTMP = data;
  });

  $scope.getStatus = function (diagnostics) {
    var d = diagnostics || {};

    if (d.broadcasting) {
      return 'Broadcasting';
    } else if (d.connected) {
      return 'Connected';
    } else {
      return 'Offline';
    }
  };

  $scope.getResolution = function (diagnostics) {
    var d = diagnostics || {};
    var height = d.video_height || 0;
    var width = d.video_width || 0;

    if (height == 0 || width == 0) {
      return '';
    }

    return "".concat(width, "x").concat(height);
  };

  $scope.getFrameRate = function (diagnostics) {
    var d = diagnostics || {};
    var frameRate = d.frame_rate || 0;

    if (frameRate == 0) {
      return '';
    }

    return frameRate;
  };
}]);

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"/accounts/{{ account.id }}/static_rtmps\">RTMP Sources</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i>{{ staticRTMP.name }}</h3>\n      </div>\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n  <div class=\"col-md-9\">\n      <h4>{{ staticRTMP.name }}</h4>\n      <table class=\"table table-striped table-condensed\">\n        <tr><th>Server URL</th><td>{{ staticRTMP.server_url }}</td></tr>\n        <tr><th>Stream Key</th><td>{{ staticRTMP.stream_key }}</td></tr>\n        <tr><th>Status</th><td>{{ getStatus(staticRTMP.diagnostics) }}</td></tr>\n        <tr><th>Input Resolution</th><td>{{ getResolution(staticRTMP.diagnostics) || '-' }}</td></tr>\n        <tr><th>Input Frame Rate</th><td>{{ getFrameRate(staticRTMP.diagnostics) || '-' }}</td></tr>\n      </table>\n  </div>\n</div>\n"

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/storage_bills', {
    template: __webpack_require__(219),
    controller: 'AccountStorageBillsController'
  });
}]).controller('AccountStorageBillsController', ["$scope", "$location", "$routeParams", "Account", "AccountStorageBill", function ($scope, $location, $routeParams, Account, AccountStorageBill) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];
  $scope.s || ($scope.s = '-starts_at');

  var params = _.pick($scope, 'q', 's', 'p');

  params.account_id = $routeParams.account_id;
  params['filter.is_archived'] = 'false';
  $scope.storageBills = AccountStorageBill.query(params, function (data, getResponseHeader) {
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });
  $scope.account = Account.get({
    id: $routeParams.account_id
  });

  $scope.peek = function () {
    var now = new Date();
    var year = now.getUTCFullYear();
    var month = now.getUTCMonth();
    var startsAt = new Date(new Date(year, month, 1).getTime() - now.getTimezoneOffset() * 60000);
    month += 1;

    if (month > 11) {
      year += 1;
      month = 0;
    }

    var endsAt = new Date(new Date(year, month, 1).getTime() - 1000 - now.getTimezoneOffset() * 60000);
    $location.url("/storage_bill/peek?account_id=".concat($routeParams.account_id, "&starts_at=").concat(startsAt.toISOString(), "&ends_at=").concat(endsAt.toISOString()));
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Storage Bills</h3>\n      </div>\n      <div class=\"panel-body\">\n        <p ng-show=\"account.storage_policy == 'auto-bill'\"><a href=\"#\" ng-click=\"peek()\">\n          <i class=\"fa fa-eye\"></i>\n          Peek at Next Month's Bill\n        </a></p>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <table class=\"table table-striped table-dark-border table-hover table-condensed\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('starts_at')\" class=\"clickable\">\n            Date\n            <i ng-show=\"s.indexOf('starts_at') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'starts_at'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-starts_at'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Amount</th>\n          <th>Hours</th>\n          <th>Charged?</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"bill in storageBills\" ng-click=\"openURL('{{ newAdminURL }}'+'/storage-bills/'+bill.id, $event)\" class=\"clickable\">\n          <td>{{ bill.starts_at | date: 'yyyy-MM-dd' : 'UTC' }}</td>\n          <td>{{ bill.total_charge | currency }}</td>\n          <td>{{ bill.total_broadcast_hours | number:2 }}</td>\n          <td>\n            <span ng-show=\"bill.stripe_charge_id\">\n              <i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i>\n            </span>\n          </td>\n          <td class=\"text-right\">\n            <span ng-show=\"bill.stripe_charge_id\">\n              <a href=\"https://dashboard.stripe.com/payments/{{bill.stripe_charge_id}}\" target=\"_blank\">\n                <i class=\"fa fa-external-link\"></i>\n                View in Stripe\n              </a>\n            </span>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_account_form_controller__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_account_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__account_account_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts', {
    template: __webpack_require__(221),
    controller: 'AccountsController'
  });
}]).controller('AccountsController', ["$scope", "$location", "$modal", "Account", "Config", function ($scope, $location, $modal, Account, Config) {
  $scope.config = Config;
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];
  $scope.loading = true;
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = 'name');
  $scope.accounts = Account.query(_.pick($scope, 'q', 's', 'p'), function (data, getResponseHeader) {
    $scope.loading = false;
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });

  $scope.create = function () {
    return $modal.open({
      template: __webpack_require__(222),
      controller: 'AccountFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        mode: function mode() {
          return 'standard';
        }
      }
    }).result.then(function (a) {
      return $scope.show(a);
    });
  };

  $scope.extraFields = localStorage.getItem('accounts.fields');

  if ($scope.extraFields) {
    $scope.extraFields = JSON.parse($scope.extraFields);
  } else {
    $scope.extraFields = {
      market: true,
      contract: false,
      payment_status: false,
      physical_status: false,
      created: true,
      expires: true,
      support_plan: false
    };
  } // Count the number of columns visible


  var baseCount = 2;
  $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter(function (key) {
    return $scope.extraFields[key] === true;
  }).length;

  $scope.toggle = function (field, e) {
    $scope.extraFields[field] = !$scope.extraFields[field];
    localStorage.setItem('accounts.fields', JSON.stringify($scope.extraFields));
    $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter(function (key) {
      return $scope.extraFields[key] === true;
    }).length;
    e.preventDefault();
    e.stopPropagation();
    return false;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div ng-if=\"loading\" class=\"col-md-12\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-3 table-animate-aside\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Accounts</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by Name\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n\n        <p class=\"help-block\" style=\"margin-top:30px\">\n        <small>\n        Example searches:<br>\n        <code title=\"Use quotes for exact match\">\"Full Name\"</code><br>\n        <code title=\"Use * for partial match\">Partialname*</code><br>\n        <code title=\"Search for all in a specified market\">market:house-of-worship</code><br>\n        <code title=\"Search for all in a specific contract type\">contract:recurring</code><br>\n        <code title=\"Match one or more statuses\">status:active status:onboarding</code><br>\n        <code title=\"Match contract AND status\">+contract:recurring +status:active</code><br>\n        </small>\n        </p>\n      </div>\n    </div>\n    <p class=\"text-left\">\n      <button ng-click=\"create()\" class=\"btn btn-primary btn-block\"><i class=\"fa fa-plus\"></i> Create a New Account</button>\n    </p>\n    <div class=\"clearfix\"></div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9 table-animate\">\n    <div class=\"table-header-dropdown\">\n      <div class=\"btn-group\" dropdown>\n        <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" dropdown-toggle=\"\">\n            <i class=\"fa fa-cog\" aria-hidden=\"true\"></i>\n        </button>\n        <ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\">\n          <li><a href=\"javascript://\" ng-click=\"toggle('market', $event)\"><i style=\"width:20px\" class=\"fa\" ng-class=\"extraFields.market?'fa-check-square-o':'fa-square-o'\"></i> Market</a></li>\n          <li><a href=\"javascript://\" ng-click=\"toggle('contract', $event)\"><i style=\"width:20px\" class=\"fa\" ng-class=\"extraFields.contract?'fa-check-square-o':'fa-square-o'\"></i> Contract</a></li>\n          <li><a href=\"javascript://\" ng-click=\"toggle('created', $event)\"><i style=\"width:20px\" class=\"fa\" ng-class=\"extraFields.created?'fa-check-square-o':'fa-square-o'\"></i> Created</a></li>\n          <li><a href=\"javascript://\" ng-click=\"toggle('expires', $event)\"><i style=\"width:20px\" class=\"fa\" ng-class=\"extraFields.expires?'fa-check-square-o':'fa-square-o'\"></i> Expires</a></li>\n          <li><a href=\"javascript://\" ng-click=\"toggle('support_plan', $event)\"><i style=\"width:20px\" class=\"fa\" ng-class=\"extraFields.support_plan?'fa-check-square-o':'fa-square-o'\"></i> Support Plan</a></li>\n        </ul>\n      </div>\n    </div>\n    <table class=\"table table-striped table-light-border table-hover table-condensed\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('name')\" class=\"clickable\">\n            Name\n            <i ng-show=\"s.indexOf('name') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Status</th>\n          <th ng-if=\"extraFields.market\">Market</th>\n          <th ng-if=\"extraFields.contract\">Contract</th>\n          <th ng-if=\"extraFields.support_plan\">Support Plan</th>\n          <th ng-if=\"extraFields.created\" ng-click=\"sort('created_at')\" class=\"clickable\">\n            Created\n            <i ng-show=\"s.indexOf('created_at') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'created_at'\" class=\"fa fa-sort-numeric-asc\"></i>\n            <i ng-show=\"s === '-created_at'\" class=\"fa fa-sort-numeric-desc\"></i>\n          </th>\n          <th ng-if=\"extraFields.expires\" ng-click=\"sort('expires_on')\" class=\"clickable\">\n            Expires\n            <i ng-show=\"s.indexOf('expires_on') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'expires_on'\" class=\"fa fa-sort-numeric-asc\"></i>\n            <i ng-show=\"s === '-expires_on'\" class=\"fa fa-sort-numeric-desc\"></i>\n          </th>\n        </tr>        \n      </thead>\n      <tbody>\n        <tr ng-if=\"!loading && !accounts.length\" class=\"tr--no-results\"><td colspan=\"{{ fieldCount }}\">No accounts were found.</td></tr>\n        <tr ng-repeat=\"a in accounts\" ng-click=\"openURL('{{ newAdminURL }}'+'/accounts/'+a.id, $event)\" class=\"clickable\">\n          <td>\n            {{ a.name }}\n            <div class=\"bottom-row\" ng-if=\"a.status != 'closed'\" style=\"opacity:.75;\">\n              <span ng-if=\"a.support_plan == 'reduced'\" style=\"margin-right:10px;\"><i class=\"fa fa-ban\"></i> Reduced Support</span>\n              <span ng-if=\"a.support_plan == 'priority'\" class=\"text text-warning\" style=\"margin-right:10px;\"><i class=\"fa fa-star\"></i> Priority Support</span>\n              <span ng-if=\"a.contract == 'trial'\" class=\"text text-info\" style=\"margin-right:10px;\"><i class=\"fa fa-circle\"></i> Trial</span>\n              <span ng-if=\"a.contract == 'free'\" class=\"text\" style=\"margin-right:10px; color: #FA4C3C\"><i class=\"fa fa-circle\"></i> Free</span>\n            </div>\n          </td>\n          <td>{{ a.status | label: 'accountStatuses' }}</td>\n          <td ng-if=\"extraFields.market\">{{ a.market | label: 'markets' }}</td>\n          <td ng-if=\"extraFields.contract\">{{ a.contract | label: 'contractTypes' }}</td>\n          <td ng-if=\"extraFields.support_plan\">{{ a.support_plan | label: 'supportPlans' }}</td>\n          <td ng-if=\"extraFields.created\">{{ a.created_at | date: 'MM/dd/yyyy' }}</td>\n          <td ng-if=\"extraFields.expires\">{{ a.expires_on | date: 'MM/dd/yyyy' }}</td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = "<style>\n  @media (min-width: 768px) {\n    .form-inline .form-group {\n      margin-bottom: 15px;\n      display: block;\n    }\n    .form-inline .form-group label {\n      width: 160px;\n      margin-right: 15px;\n    }\n    .form-inline .form-group input {\n      width: calc(100% - 179px);\n    }\n    .modal-content .nav-tabs {\n      float: right;\n      margin-top: -41px;\n      margin-right: 15px;\n    }\n  }\n</style>\n<div class=\"modal-header\">\n  <h3 class=\"modal-title\">{{ isNew ? 'Create a New' : 'Edit' }} Account</h3>\n</div>\n\n<!-- XXX: The <tabset> and <tab> directives create new isolated scopes, so we need to nest the entire <form> plus modal\n     footer inside each one separately, making it difficult to share components between the Quick and Advanced tabs.\n-->\n<tabset class=\"modal-tabset\">\n  <tab heading=\"Quick\">\n\n    <div class=\"modal-body clearfix\">\n      <form name=\"quick_form\" role=\"form\" style=\"margin-top:15px\">\n        <div class=\"col-xs-12\">\n          <p>Enter as much information as you can for this new account. If you need to edit advanced settings, switch to the\n          Advanced tab or enter them on the account editor after you're done here.</p>\n        </div>\n        <div class=\"col-sm-8\">\n          <div class=\"form-group\">\n            <label for=\"name\">Organization Name</label>\n            <input id=\"name\" type=\"text\" ng-model=\"account.name\" required placeholder=\"Full Name of Organization\" class=\"form-control\">\n          </div>\n          <div class=\"form-group\">\n            <label for=\"city_state\">Organization City, State</label>\n            <input id=\"city_state\" type=\"text\" ng-model=\"account.city_state\" required placeholder=\"Cleveland, OH\" class=\"form-control\">\n          </div>\n          <div ng-if=\"newUser.enabled\" class=\"well\">\n            <div class=\"form-group\">\n              <label for=\"user_email\">User Email Address <small style=\"font-weight:normal\">(Will be sent verification/payment emails)</small></label>\n              <input id=\"user_email\" type=\"text\" ng-model=\"newUser.user.email\" required placeholder=\"joe@example.com\" class=\"form-control\">\n            </div>\n            <div class=\"form-group\">\n              <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"newUser.sendPayment\">&nbsp;Send payment request email <small style=\"font-weight:normal\">(link to dashboard)</small></label>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"$root.me.isSystemAdmin()\">\n            <div class=\"form-group\">\n              <div class=\"checkbox\">\n                <label><input type=\"checkbox\" ng-model=\"newManufacturer.doCreate\">&nbsp;Create a Manufacturer for this Account</label>\n              </div>\n              <small ng-show=\"newManufacturer.doCreate\" class=\"text-danger\">\n                <i class=\"fa fa-exclamation-triangle\"></i> \n                Only select this option if you are setting up a manufacturer for fulfillment\n              </small>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-sm-4\">\n          <div class=\"form-group\">\n            <label for=\"stream_quality\">Streaming Quality</label>\n            <select id=\"stream_quality\" ng-model=\"flags.streamQuality\" required class=\"form-control input-sm\">\n              <option ng-repeat=\"e in config.streamingQualityLevels\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"market\">Market</label>\n            <select id=\"market\" ng-model=\"account.market\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.markets\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"contract\">Contract</label>\n            <select id=\"contract\" ng-model=\"account.contract\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.contractTypes\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"status\">Status</label>\n            <select id=\"status\" ng-model=\"account.status\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.accountStatuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"payment_status\">Payment Status</label>\n            <select id=\"payment_status\" ng-model=\"account.payment_status\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.paymentStatuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"payment_method\">Payment Method</label>\n            <select id=\"payment_method\" ng-model=\"account.payment_method\" class=\"form-control\">\n              <option ng-repeat=\"e in config.paymentMethods\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <!--\n          <div class=\"form-group\">\n            <label for=\"sale_closed_on\">Sale Closed On</label>\n            <input id=\"sale_closed_on\" type=\"text\" ng-model=\"account.sale_closed_on\" datepicker-popup=\"MM/dd/yyyy\" is-open=\"saleClosedOnIsOpen\" ng-click=\"saleClosedOnIsOpen=true\" required class=\"form-control\">\n          </div>\n          <div class=\"form-group\">\n            <label for=\"expires_on\">Expires</label>\n            <input id=\"expires_on\" type=\"text\" ng-model=\"account.expires_on\" datepicker-popup=\"MM/dd/yyyy\" is-open=\"expiresOnIsOpen\" ng-click=\"expiresOnIsOpen=true\" required class=\"form-control\">\n          </div>\n          <div class=\"form-group\">\n            <label for=\"time_zone\">Time Zone</label>\n            <select id=\"time_zone\" ng-model=\"account.time_zone\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.timeZones\" value=\"{{ e.value }}\" ng-disabled=\"!e.value\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"backhaul_protocol\">Backhaul Protocol</label>\n            <select id=\"backhaul_protocol\" ng-model=\"account.backhaul_protocol\" class=\"form-control\">\n              <option ng-repeat=\"e in config.backhaulProtocols\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          -->\n        </div>\n      </form>\n\n    </div>\n\n    <div class=\"modal-footer\">\n      <button ng-click=\"ok()\" ng-disabled=\"!quick_form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n      <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n    </div>\n\n  </tab>\n  <tab heading=\"Advanced\">\n\n    <div class=\"modal-body clearfix\">\n      <form name=\"form\" role=\"form\" style=\"margin-top:15px\">\n        <div class=\"col-sm-8\">\n          <div class=\"form-group\">\n            <label for=\"name\">Account Name</label>\n            <input id=\"name\" type=\"text\" ng-model=\"account.name\" required placeholder=\"Enter the organization's full name\" class=\"form-control\">\n          </div>\n          <div class=\"form-group\">\n            <label for=\"description\">CS Notes</label>\n            <textarea id=\"description\" type=\"text\" ng-model=\"account.internal_description\" class=\"form-control\"></textarea>\n          </div>\n          <div class=\"form-inline\">\n            <div class=\"form-group\">\n              <label for=\"hubspot_handle\">\n                HubSpot Company ID\n                <i class=\"fa fa-info-circle pull-right\" tooltip=\"/contacts/484866/company/123456789\"></i>\n              </label>\n              <input id=\"hubspot_handle\" type=\"text\" ng-model=\"account.hubspot_handle\" placeholder=\"123456789\" class=\"form-control input-sm\">\n            </div>\n            <div class=\"form-group\">\n              <label for=\"xero_handle\">\n                Xero Customer ID\n                <i class=\"fa fa-info-circle pull-right\" tooltip=\"/Contacts/View.aspx?contactID=01234567-89AB-CDEF-0123-456789ABCDEF\"></i>\n              </label>\n              <input id=\"xero_handle\" type=\"text\" ng-model=\"account.xero_handle\" placeholder=\"01234567-89AB-CDEF-0123-456789ABCDEF\" class=\"form-control input-sm\">\n            </div>\n            <div class=\"form-group\">\n              <label for=\"stripe_handle\">\n                Stripe Customer ID\n                <i class=\"fa fa-info-circle pull-right\" tooltip=\"/customers/cus_01234aBcDe5678\"></i>\n              </label>\n              <input id=\"stripe_handle\" type=\"text\" ng-model=\"account.stripe_customer_handle\" placeholder=\"cus_01234aBcDe5678\" class=\"form-control input-sm\">\n            </div>\n            <div class=\"form-group\">\n              <label for=\"stream_quality\">Streaming Quality</label>\n              <select id=\"stream_quality\" ng-model=\"flags.streamQuality\" required class=\"form-control input-sm\">\n                <option ng-repeat=\"e in config.streamingQualityLevels\" value=\"{{ e.value }}\">{{ e.label }}</option>\n              </select>\n            </div>\n          </div>\n\n          <!-- feature flags / restrictions -->\n          <div class=\"form-group\" ng-repeat=\"(category, tagList) in ::config.accountTagsByCategory\">\n            <label style=\"text-transform:capitalize\">{{category}}</label>\n            <div class=\"checkbox row\">\n              <div class=\"col-sm-6\"\n                  style=\"height:2em\"\n                  ng-repeat=\"e in ::tagList\"\n                  ng-if=\"specialTagsToSkip.indexOf(e.value) < 0\">\n                <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"tags.indexOf(e.value) >= 0\" ng-click=\"toggleTag(e.value)\">&nbsp;{{ e.label }}\n                  <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                  <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n                  <i ng-if=\"isMissingTag(e.value)\" class=\"fa fa-warning text-danger\" tooltip=\"This flag should be checked according to the subscription\" tooltip-placement=\"right\"></i>\n                  <i ng-if=\"isExtraTag(e.value)\" class=\"fa fa-warning text-danger\" tooltip=\"This flag should *not* be checked according to the subscription\" tooltip-placement=\"right\"></i>\n                </label>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label style=\"text-transform:capitalize\">Usage Flags</label>\n              <div class=\"checkbox row\">\n                <div class=\"col-sm-6\"\n                     style=\"height:2em\"\n                     ng-repeat=\"e in ::config.usageFlags\">\n                  <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"usageFlags.indexOf(e.value) >= 0\" ng-click=\"toggleUsageFlag(e.value)\">&nbsp;{{ e.label }}\n                    <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                    <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label style=\"text-transform:capitalize\">Extra Features</label>\n              <div class=\"checkbox row\">\n                <div class=\"col-sm-6\"\n                     style=\"height:2em\"\n                     ng-repeat=\"e in ::config.extraFeatures\">\n                  <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"extraFeatures.indexOf(e.value) >= 0\" ng-click=\"toggleExtraFeature(e.value)\">&nbsp;{{ e.label }}\n                    <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                    <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <label style=\"text-transform:capitalize\">Behavior Modification</label>\n              <div class=\"checkbox row\">\n                <div class=\"col-sm-6\"\n                     style=\"height:2em\"\n                     ng-repeat=\"e in ::config.behaviorModifications\">\n                  <label><input type=\"checkbox\" value=\"{{ e.value }}\" ng-checked=\"behaviorModifications.indexOf(e.value) >= 0\" ng-click=\"toggleBehaviorModification(e.value)\">&nbsp;{{ e.label }}\n                    <span ng-show=\"e.beta\" class=\"label label-info\">BETA</span>\n                    <i ng-show=\"e.hint\" tooltip=\"{{ e.hint }}\" tooltip-placement=\"right\" class=\"fa fa-info-circle\"></i>\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n\n        </div>\n        <div class=\"col-sm-4\">\n          <div class=\"form-group\">\n            <label for=\"market\">Market</label>\n            <select id=\"market\" ng-model=\"account.market\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.markets\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"contract\">Contract</label>\n            <select id=\"contract\" ng-model=\"account.contract\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.contractTypes\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"status\">Status</label>\n            <select id=\"status\" ng-model=\"account.status\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.accountStatuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"payment_status\">Payment Status</label>\n            <select id=\"payment_status\" ng-model=\"account.payment_status\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.paymentStatuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"payment_method\">Payment Method</label>\n            <select id=\"payment_method\" ng-model=\"account.payment_method\" class=\"form-control\">\n              <option ng-repeat=\"e in config.paymentMethods\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"storage_policy\">Storage Policy</label>\n            <select id=\"storage_policy\" ng-model=\"account.storage_policy\" class=\"form-control\">\n              <option ng-repeat=\"e in config.storagePolicies\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\" ng-show=\"account.storage_policy\">\n            <label for=\"storage_duration\">Storage Duration</label>\n            <select id=\"storage_duration\" ng-model=\"account.storage_duration_days\" class=\"form-control\">\n              <option ng-repeat=\"e in storageDurations\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"support_plan\">Support Plan</label>\n            <select id=\"support_plan\" ng-model=\"account.support_plan\" class=\"form-control\">\n              <option ng-repeat=\"e in config.supportPlans\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"sale_closed_on\">Sale Closed On</label>\n            <input id=\"sale_closed_on\" type=\"text\" ng-model=\"account.sale_closed_on\" datepicker-popup=\"MM/dd/yyyy\" is-open=\"saleClosedOnIsOpen\" ng-click=\"saleClosedOnIsOpen=true\" required class=\"form-control\">\n          </div>\n          <div class=\"form-group\">\n            <label for=\"expires_on\">Expires</label>\n            <input id=\"expires_on\" type=\"text\" ng-model=\"account.expires_on\" datepicker-popup=\"MM/dd/yyyy\" is-open=\"expiresOnIsOpen\" ng-click=\"expiresOnIsOpen=true\" required class=\"form-control\">\n          </div>\n          <div class=\"form-group\">\n            <label for=\"time_zone\">Time Zone</label>\n            <select id=\"time_zone\" ng-model=\"account.time_zone\" required class=\"form-control\">\n              <option ng-repeat=\"e in config.timeZones\" value=\"{{ e.value }}\" ng-disabled=\"!e.value\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"backhaul_protocol\">Backhaul Protocol</label>\n            <select id=\"backhaul_protocol\" ng-model=\"account.backhaul_protocol\" class=\"form-control\">\n              <option ng-repeat=\"e in config.backhaulProtocols\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"ticket_revenue_share\">\n              Ticket Revenue Share\n            </label>\n            <select id=\"ticket_revenue_share\" ng-model=\"account.ticket_revenue_share\" class=\"form-control\">\n              <option ng-repeat=\"e in config.ticketRevenueShareOptions\" value=\"{{ e.value }}\">{{ e.label }}</option>\n            </select>\n          </div>\n        </div>\n      </form>\n\n    </div>\n\n    <div class=\"modal-footer\">\n      <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n      <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n    </div>\n\n  </tab>\n</tabset>\n"

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);


angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/activation_codes', {
    template: __webpack_require__(224),
    controller: 'ActivationCodesController',
    controllerAs: '$ctrl'
  });
}]).controller('ActivationCodesController', ["ActivationCodes", "toaster", "$routeParams", "$scope", "$location", "$route", function (ActivationCodes, toaster, $routeParams, $scope, $location, $route) {
  'ngInject'; // BoxCast API standard filtration/pagination

  var _this = this;

  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location); // Hoist scope

  var self = this;

  var params = _.pick($scope, 'q', 's', 'p');

  this.loading = true;
  ActivationCodes.list(params, function (res, getResponseHeader) {
    var pagination = getResponseHeader('X-Pagination');
    $scope.pagination = pagination ? JSON.parse(pagination) : {};
    res.forEach(function (code) {
      return code.row_expanded = false;
    });
    _this.codes = res;
  }, function (err) {
    toaster.pop({
      type: 'error',
      body: "Whoops, we weren't able to list the activation codes.",
      timeout: 2000
    });
  });

  this.copyToClipboard = function (e, value) {
    var selBox = document.createElement('textarea');
    selBox.value = value;
    e.target.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    e.target.removeChild(selBox);
  };

  this.statuses = [{
    label: 'Created',
    value: 'created'
  }, {
    label: 'Distributed',
    value: 'distributed'
  }, {
    label: 'Activated',
    value: 'activated'
  }];
  this.resellers = [{
    label: 'None',
    value: ''
  }, {
    label: 'B & H',
    value: 'bh'
  }, {
    label: 'Adorama',
    value: 'adorama'
  }, {
    label: 'DVE Store',
    value: 'dve_store'
  }, {
    label: 'Tie Photo',
    value: 'tie_photo'
  }];
  this.distributors = [{
    label: 'BoxCast Inventory',
    value: 'boxcast'
  }, {
    label: '1SourceVideo',
    value: '1sv'
  }]; // Values must align with stripe plan names

  this.stripePlans = [{
    label: 'BoxCast Essential Plan (1-Year Live Streaming Subscription)',
    value: 'essential:annual'
  }, {
    label: 'BoxCast Live (1-Year Live Streaming Subscription)',
    value: 'partner:live:12mo:annual'
  }, {
    label: 'BoxCast Standard (1-Year Live Streaming Subscription)',
    value: 'partner:standard:12mo:annual'
  }, {
    label: 'BoxCast Advanced (1-Year Live Streaming Subscription)',
    value: 'partner:advanced:12mo:annual'
  }, {
    label: 'BoxCast Advanced Plus (1-Year Live Streaming Subscription)',
    value: 'partner:advanced_plus:12mo:annual'
  }, {
    label: 'BoxCast RTMP Encoder Activation',
    value: 'partner:addon:rtmp:annual'
  }, {
    label: 'Feature: Multi-site Player',
    value: 'addon:multisite:annual'
  }, {
    label: 'Feature: Password Protection',
    value: 'addon:password:annual'
  }, {
    label: 'Feature: Graphic Overlays',
    value: 'partner:addon:overlays:annual'
  }, {
    label: 'Feature: Additional Simulcast Broadcast',
    value: 'partner:addon:simultaneous:annual'
  }, {
    label: 'Feature: GeoBlocking',
    value: 'partner:addon:geoblocking:annual'
  }, {
    label: 'Feature: Ticketing',
    value: 'partner:addon:ticketing:annual'
  }, {
    label: 'Feature: Pro Bundle',
    value: 'addon:pro-bundle:annual:600'
  }, {
    label: 'Feature: Experience Bundle',
    value: 'addon:experiencebundle:annual:1200'
  }]; // Form for generating codes defaults

  this.stripe_plan = this.stripePlans[0].value;
  this.num_codes = 1;

  this.onGenerateClick = function () {
    if (_this.num_codes === undefined) {
      toaster.pop({
        type: 'error',
        body: "Whoops, you can only generate 10 codes at a time.",
        timeout: 3000
      });
      return;
    }

    ActivationCodes.create({
      'stripe_plan': _this.stripe_plan,
      'num_codes': _this.num_codes
    }).$promise.then(function (res) {
      $route.reload();
    });
  }; // Expand/collapse individual codes for more info


  this.toggleRow = function (code) {
    if (!code.row_expanded) {
      _this.loadActivationCode(code);
    } else {
      code.row_expanded = false;
    }
  }; // Fetch data for expanded row


  this.loadActivationCode = function (code) {
    code.row_loading = true;
    ActivationCodes.get({
      id: code.code
    }).$promise.then(function (res) {
      code.row_loading = false;
      code.row_expanded = true;
      code.details = res;
    });
  }; // Edit existing code


  this.edit = function (code, idx) {
    _this.editing = idx;
    _this.editCode = angular.copy(code);
    _this.editCode.reseller = _this.resellers.find(function (item) {
      return item.value === code.reseller;
    }).value;
    _this.editCode.distributor = _this.distributors.find(function (item) {
      return item.value === code.distributor;
    }).value;
    _this.editCode.status = _this.statuses.find(function (item) {
      return item.value === code.status;
    }).value;
  }; // Save existing code


  this.save = function (code) {
    ActivationCodes.update({
      'reseller': _this.editCode.reseller,
      'status': _this.editCode.status,
      'distributor': _this.editCode.distributor,
      'id': _this.editCode.code
    }).$promise.then(function (res) {
      // Update the view's table row fields without refreshing/hitting api
      code.details = _this.editCode;
      code.status = _this.editCode.status;
      _this.editCode = null;
      self.editing = false;
    });
  }; // Cancel editing of existing quote


  this.cancel = function () {
    _this.editCode = null;
    _this.editing = false;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row activation-codes\">\n  <div class=\"col-md-3 table-animate-aside\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Search Codes</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by Code\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Generate Codes</h3>\n      </div>\n      <div class=\"panel-body\">\n        <form name=\"form\" role=\"form\">\n          <div class=\"form-group\">\n            <label for=\"stripe_plan\">Stripe Plans</label>\n            <select\n              id=\"stripe_plan\"\n              class=\"form-control input-sm\"\n              ng-model=\"$ctrl.stripe_plan\"\n              ng-options=\"e.value as e.label for e in $ctrl.stripePlans\">\n            </select>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"num_codes\">Num Codes To Generate</label>\n            <input id=\"num_codes\" type=\"number\" min=\"1\" max=\"10\" class=\"form-control\" ng-model=\"$ctrl.num_codes\" />\n          </div>\n\n          <div class=\"form-group\">\n            <button ng-click=\"$ctrl.onGenerateClick($event)\" class=\"btn btn-default\" type=\"button\">Generate</button>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-9\">\n    <table class=\"table table-striped table-light-border table-animate table-condensed\">\n      <thead>\n        <tr>\n          <th style=\"width:50px;\"></th>\n          <th>Status</th>\n          <th>Code</th>\n          <th>Stripe Plan</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!$ctrl.loading && !$ctrl.codes.length\" class=\"tr--no-results\"><td colspan=\"5\">No codes have been created.</td></tr>\n        <tr ng-repeat-start=\"e in $ctrl.codes | orderBy: '-created_at'\" ng-click=\"$ctrl.toggleRow(e)\" class=\"clickable\">\n          <td class=\"text-center\"><i class=\"fa\" ng-class=\"{ 'fa-plus-square-o': !e.row_expanded && !e.row_loading, 'fa-minus-square-o': e.row_expanded && !e.row_loading, 'fa-spinner fa-spin': e.row_loading }\"aria-hidden=\"true\"></i></td>\n          <td>{{ e.status }}</td>\n          <td>{{ ::e.code }}</td>\n          <td>{{ ::e.plan_name }}</td>\n        </tr>\n        <tr ng-repeat-end=\"\" ng-if=\"e.row_expanded\" class=\"table-row-expanded\">\n          <td colspan=\"5\" class=\"table-row-expanded-inner\">\n            <table class=\"table table-condensed\">\n              <tbody ng-if=\"$ctrl.editing !== $index\">\n                <tr><th>Status:</th><td>{{ ::e.details.status }}</a></td></tr>\n                <tr ng-if=\"!e.details.boxcaster_id\">\n                  <th>Code:</th>\n                  <td>{{ e.details.code }} <button class=\"btn btn-default btn-xs\" ng-click=\"$ctrl.copyToClipboard($event, e.details.code)\"><i class=\"fa fa-copy\"></i></button></td>\n                </tr>\n                <tr ng-if=\"e.details.boxcaster_id\">\n                  <th>BoxCaster:</th>\n                  <td><a href=\"/boxcasters/{{ e.details.boxcaster_id }}\">{{e.details.boxcaster_id}}</a> <button class=\"btn btn-default btn-xs\" ng-click=\"$ctrl.copyToClipboard($event, e.details.code)\"><i class=\"fa fa-copy\"></i></button></td>\n                </tr>\n                <tr><th>Stripe Plan:</th><td>{{ e.details.plan_name }}</a></td></tr>\n                <tr><th>Stripe Plan ID:</th><td>{{ e.details.stripe_plan }}</a></td></tr>\n                <tr><th>Add-On ID(s):</th><td>{{ e.details.bundles || 'None' }}</a></td></tr>\n                <tr><th>Created At:</th><td>{{ e.details.created_at | date: 'MM/dd/yyyy h:mm a' }}</td></tr>\n                <tr><th>Account Name:</th><td>{{ e.details.account_name }}</td></tr>\n                <tr><th>Activated On:</th><td>{{ e.details.activated_at | date: 'MM/dd/yyyy h:mm a' }}</td></tr>\n                <tr><th>Distributor:</th><td>{{ e.details.distributor | label: $ctrl.distributors }}</td></tr>\n                <tr><th>Reseller:</th><td>{{ e.details.reseller | label: $ctrl.resellers }}</td></tr>\n              </tbody>\n\n              <tbody ng-if=\"$ctrl.editing === $index\">\n                <tr><th class=\"col-sm-2\">Status:</th><td>\n                  <select\n                    ng-model=\"$ctrl.editCode.status\"\n                    ng-options=\"item.value as item.label for item in $ctrl.statuses\"\n                    class=\"form-control\">\n                  </select>\n                </td></tr>\n                <tr><th>Code:</th><td>{{ ::e.details.code }}</a></td></tr>\n                <tr><th>Stripe Plan:</th><td>{{ e.details.plan_name }}</a></td></tr>\n                <tr><th>Stripe Plan ID:</th><td>{{ e.details.stripe_plan }}</a></td></tr>\n                <tr><th>Add-On ID(s):</th><td>{{ e.details.bundles || 'None' }}</a></td></tr>\n                <tr><th>Created At:</th><td>{{ e.details.created_at | date: 'MM/dd/yyyy h:mm a' }}</td></tr>\n                <tr><th>Account Name:</th><td>{{ e.details.account_name }}</td></tr>\n                <tr><th>Activated On:</th><td>{{ e.details.activated_at | date: 'MM/dd/yyyy h:mm a' }}</td></tr>\n                <tr><th class=\"col-sm-2\">Distributor:</th><td>\n                  <select\n                    ng-model=\"$ctrl.editCode.distributor\"\n                    ng-options=\"item.value as item.label for item in $ctrl.distributors\"\n                    class=\"form-control\">\n                  </select>\n                </td></tr>\n                <tr><th class=\"col-sm-2\">Reseller:</th><td>\n                  <select\n                    ng-model=\"$ctrl.editCode.reseller\"\n                    ng-options=\"item.value as item.label for item in $ctrl.resellers\"\n                    class=\"form-control\">\n                  </select>\n                </td></tr>\n              </tbody>\n\n              <tfoot>\n                <tr><td colspan=\"2\">\n                  <hr>\n                </td></tr>\n                <tr>\n                  <td colspan=\"2\">\n                    <div class=\"btn-group--edit-code\">\n                      <button type=\"button\" ng-if=\"$ctrl.editing !== $index\" class=\"btn btn-info\" ng-click=\"$ctrl.edit(e.details, $index)\">Update</button>\n                      <button type=\"button\" ng-if=\"$ctrl.editing === $index\" class=\"btn btn-info\" ng-click=\"$ctrl.save(e)\">Save</button>\n                      <button type=\"button\" ng-if=\"$ctrl.editing === $index\" class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n                    </div>\n                  </td>\n                </tr>\n              </tfoot>\n            </table>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boxcaster_form_controller__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boxcaster_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__boxcaster_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boxcaster_inventory_form_controller__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boxcaster_inventory_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__boxcaster_inventory_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boxcaster_register_form_controller__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boxcaster_register_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__boxcaster_register_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_edid__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_boxcast_edid__ = __webpack_require__(227);






var BOXCASTER_PRO_INCLUDED_PLAN_ID = 'essential:annual';
var BOXCASTER_HDSD2_INCLUDED_PLAN_ID = 'free-social-streaming:annual';
angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/boxcasters/:id', {
    template: __webpack_require__(228),
    controller: 'BoxcasterController'
  });
}]).controller('BoxcasterController', ["ActivationCodes", "$scope", "$routeParams", "$window", "$log", "$modal", "Boxcaster", "Config", "RPC", function (ActivationCodes, $scope, $routeParams, $window, $log, $modal, Boxcaster, Config, RPC) {
  $scope.config = Config;
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  $scope.backhaulProtocols = Config.boxcaster.backhaul_protocols;
  $scope.$on('$destroy', function () {
    return RPC.cancelAll();
  });

  var onBoxCasterFetchSuccess = function onBoxCasterFetchSuccess() {
    if ($scope.hasRpc($scope.boxcaster) && $scope.isOnline($scope.boxcaster)) {
      if ($scope.platformoptKey) {
        RPC.call($scope.boxcasterId, {
          request: {
            message: 'get_key',
            key: $scope.platformoptKey
          }
        }).then(function (data) {
          if (data.error != null) {
            $log.error(data);
            return $window.alert("There was an error processing the get_key RPC. Check the console for more details.");
          } else {
            return $scope.platformOption = data;
          }
        });
      }

      if ($scope.enforcecertsKey) {
        $scope.certRpcInFlight = true;
        RPC.call($scope.boxcasterId, {
          request: {
            message: 'get_key',
            key: $scope.enforcecertsKey
          }
        }).then(function (data) {
          if (data.error != null) {
            $log.error(data);
            return $window.alert("There was an error processing the get_key RPC. Check the console for more details.");
          } else {
            $scope.certRpcInFlight = false;
            return $scope.certificateVerification = $scope.interpretCertValue(data);
          }
        });
      }
    }
  };

  $scope.boxcasterId = $routeParams.id;
  $scope.platformoptKey = null;
  $scope.enforcecertsKey = null;

  if (/^[pv][a-f0-9]{12}$/.test($scope.boxcasterId)) {
    $scope.platformoptKey = 'platformopt';
    $scope.enforcecertsKey = 'enforcecerts';
  } else if (/^[l-o][a-f0-9]{12}$/.test($scope.boxcasterId)) {
    $scope.platformoptKey = 'uboot.platformopt';
    $scope.enforcecertsKey = 'uboot.enforcecerts';
  }

  $scope.boxcaster = Boxcaster.get({
    id: $routeParams.id
  }, onBoxCasterFetchSuccess);
  $scope.activation = ActivationCodes.getSafe({
    id: $routeParams.id
  });
  $scope.manifestCollapsed = true;
  $scope.isRebooting = false;
  $scope.hdmiOutputEdidExpanded = false;
  $scope.wirelessExpanded = false;

  $scope.boxcasterLogsUrl = function (boxcaster) {
    return "https://app.datadoghq.com/dashboard/zem-zn4-p8d/boxcaster?live=true&tpl_var_boxcaster_id=".concat(boxcaster.id, "&tpl_var_env=").concat(__WEBPACK_IMPORTED_MODULE_0_environment__["f" /* ENV */]);
  };

  $scope.canUnregister = function (boxcaster) {
    return ['ready', 'preparing_broadcast', 'broadcasting', 'offline'].includes(boxcaster.status);
  };

  $scope.canRegister = function (boxcaster) {
    return !boxcaster.account_id;
  };

  $scope.canEdit = function (boxcaster) {
    return $scope.canRegister(boxcaster) || $scope.canUnregister(boxcaster);
  };

  $scope.unregister = function (boxcaster) {
    if (confirm('Are you sure you want to unregister this boxcaster?')) {
      return Boxcaster.update({
        id: boxcaster.id,
        account_id: ''
      }, function (data) {
        return $scope.boxcaster = data;
      });
    }
  };

  $scope.register = function (boxcaster) {
    $modal.open({
      template: __webpack_require__(229),
      controller: 'BoxcasterRegisterFormController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function (b) {
      return $scope.boxcaster = b;
    });
  };

  $scope.makeActivation = function (boxcaster) {
    if (!confirm('Please confirm that this BoxCaster will be sold through distribution. This will create an activation code entry.')) {
      return;
    }

    var stripe_plan;

    if (boxcaster.id.startsWith('p')) {
      stripe_plan = BOXCASTER_PRO_INCLUDED_PLAN_ID;
    } else {
      stripe_plan = BOXCASTER_HDSD2_INCLUDED_PLAN_ID;
    }

    ActivationCodes.create({
      boxcaster_id: boxcaster.id,
      num_codes: 1,
      stripe_plan: stripe_plan,
      status: 'distributed'
    }).$promise.then(function (res) {
      $scope.activation = ActivationCodes.getSafe({
        id: $routeParams.id
      });
    });
  };

  $scope.isOnline = function (boxcaster) {
    return ['ready', 'preparing_broadcast', 'broadcasting'].includes(boxcaster.status);
  };

  $scope.isPro = function (boxcaster) {
    return boxcaster != null && boxcaster.id != null && /^p/.test(boxcaster.id);
  };

  $scope.isVision = function (boxcaster) {
    return boxcaster != null && boxcaster.id != null && /^v/.test(boxcaster.id);
  };

  $scope.isReady = function (boxcaster) {
    return boxcaster.status === 'ready';
  };

  $scope.reboot = function (boxcaster) {
    if (confirm('Are you sure you want to reboot this boxcaster?')) {
      $scope.isRebooting = true;
      return RPC.call($scope.boxcasterId, {
        request: 'reboot'
      }).then(function (data) {
        if (data.error != null) {
          $log.error(data);
          return $window.alert("There was an error processing the reboot RPC. Check the console for more details.");
        } else {
          return $scope.isRebooting = false;
        }
      });
    }
  };

  $scope.interpretCertValue = function (data) {
    if (/^[pv][a-f0-9]{12}$/.test($scope.boxcasterId)) {
      if (data.value === null || data.value === undefined || data.value === true || /true/i.test(data.value)) {
        return 'set';
      } else {
        return 'not set';
      }
    } else {
      if (data.value === true || /true/i.test(data.value)) {
        return 'set';
      } else {
        return 'not set';
      }
    }
  };

  $scope.toggleCertVerification = function (boxcaster, certVerification) {
    var existingStatus = certVerification == 'set';
    var aboutTo = existingStatus ? 'disable' : 'enable';
    var newValue;

    if (/^[pv][a-f0-9]{12}$/.test($scope.boxcasterId)) {
      newValue = !existingStatus;
    } else {
      newValue = existingStatus ? null : 'true';
    }

    if (confirm("Are you sure you want to ".concat(aboutTo, " SSL certification verification for this boxcaster?"))) {
      $scope.certRpcInFlight = true;
      return RPC.call($scope.boxcasterId, {
        request: {
          message: 'set_key',
          key: $scope.enforcecertsKey,
          value: newValue
        }
      }).then(function (data) {
        if (data.error != null) {
          $log.error(data);
          return $window.alert("There was an error processing the set_key RPC. Check the console for more details.");
        } else {
          $scope.certRpcInFlight = false;
          return $scope.certificateVerification = $scope.interpretCertValue(data);
        }
      });
    }
  };

  $scope.loadHdmiOutputEdid = function () {
    $scope.edidRpcInFlight = true;
    RPC.call($scope.boxcasterId, {
      request: 'get_hdmi_out_edid'
    }).then(function (data) {
      if (data.error != null) {
        if (data.error === 'no_output') {
          $scope.edidError = "No HDMI output present, or EDID could not be loaded.";
        } else {
          $log.error(data);
          $scope.edidError = "Error loading EDID! Check the console for more details.";
        }
      } else {
        $scope.edid = new __WEBPACK_IMPORTED_MODULE_4__utils_edid__["a" /* default */](Uint8Array.from(atob(data), function (c) {
          return c.charCodeAt(0);
        }));
        $scope.edid.supportedBoxCastResolutions = Object(__WEBPACK_IMPORTED_MODULE_5__utils_boxcast_edid__["a" /* ParseSupportedBoxCastResolutions */])($scope.edid);
      }

      $scope.edidRpcInFlight = false;
    }, function (error) {
      $log.error(data);
      $scope.edidError = "Error loading EDID! Check the console for more details.";
      $scope.edidRpcInFlight = false;
    });
  };

  $scope.reloadHdmiOutputEdid = function () {
    $scope.edid = null;
    $scope.edidError = null;
    $scope.hdmiOutputEdidExpanded = true;
    $scope.loadHdmiOutputEdid();
  };

  $scope.toggleHdmiOutputEdidExpanded = function () {
    if (!$scope.hdmiOutputEdidExpanded && !$scope.edid && !$scope.edidError && !$scope.edidRpcInFlight) {
      $scope.loadHdmiOutputEdid();
    }

    $scope.hdmiOutputEdidExpanded = !$scope.hdmiOutputEdidExpanded;
  };

  $scope.loadWireless = function () {
    $scope.wifiConfigInFlight = true;
    RPC.call($scope.boxcasterId, {
      request: 'get_wifi_config'
    }).then(function (data) {
      data.scan_results = $scope.reduceScanResults(data.scan_results);
      $scope.wifiConfig = data;
      $scope.wifiConfigInFlight = false;
    }, function (error) {
      $log.error(data);
      $scope.wifiConfig = {
        "error": data
      };
      $scope.wifiConfigInFlight = false;
    });
  };

  $scope.reloadWireless = function () {
    $scope.wifiConfig = null;
    $scope.wirelessExpanded = true;
    $scope.loadWireless();
  };

  $scope.toggleWirelessExpanded = function () {
    if (!$scope.wirelessExpanded && !$scope.wifiConfig && !$scope.wifiConfigInFlight) {
      $scope.loadWireless();
    }

    $scope.wirelessExpanded = !$scope.wirelessExpanded;
  };

  $scope.setPlatformOption = function (boxcaster, platformOption) {
    var newValue = prompt("Enter new platform option value:", platformOption.value || '');

    if (newValue != null) {
      if (newValue.length === 0) {
        newValue = null;
      }

      $scope.platformOption = null;
      return RPC.call($scope.boxcasterId, {
        request: {
          message: 'set_key',
          key: $scope.platformoptKey,
          value: newValue
        }
      }).then(function (data) {
        if (data.error != null) {
          $log.error(data);
          return $window.alert("There was an error processing the set_key RPC. Check the console for more details.");
        } else {
          return $scope.platformOption = data;
        }
      });
    }
  };

  $scope.hasEdid = function (boxcaster) {
    return boxcaster.id != null && ($scope.isPro(boxcaster) || $scope.isVision(boxcaster)) && boxcaster.firmware_revision != null && boxcaster.firmware_revision >= __WEBPACK_IMPORTED_MODULE_0_environment__["e" /* EDID_FIRMWARE_REVISION */];
  };

  $scope.hasRpc = function (boxcaster) {
    if (boxcaster.id != null && ($scope.isPro(boxcaster) || $scope.isVision(boxcaster))) {
      return true;
    } else {
      return boxcaster.firmware_revision != null && boxcaster.firmware_revision >= __WEBPACK_IMPORTED_MODULE_0_environment__["w" /* RPC_FIRMWARE_REVISION */];
    }
  };

  $scope.hasWifi = function (boxcaster) {
    return boxcaster != null && boxcaster.id != null && boxcaster.id.match(/^[opv]/) != null && $scope.hasRpc(boxcaster);
  };

  $scope.isConnectedToSsid = function (config, ssid) {
    return config != null && config.scan_results != null && _.find(config.scan_results, function (r) {
      return r.ssid === ssid && r.connected;
    }) != null;
  };

  $scope.isConfiguredNetwork = function (config, ssid) {
    return _.findWhere(config.current.networks, {
      ssid: ssid
    }) != undefined;
  };

  $scope.reduceScanResults = function (scanResults) {
    var map = {};

    _.each(scanResults, function (r) {
      if (map[r.ssid] == undefined || map[r.ssid].signal_strength < r.signal_strength) {
        map[r.ssid] = r;
      }
    });

    var results = [];

    _.each(map, function (v) {
      return results.push(v);
    });

    return _.sortBy(results, function (i) {
      return i.ssid.toLowerCase();
    });
  }; // TODO: replace with filter?


  $scope.getStatusWarning = function (boxcaster) {
    if (boxcaster.status === 'offline') {
      if (Date.now() >= boxcaster.next_broadcast_at) {
        return 'offline (missing_broadcast)';
      } else {
        return 'offline';
      }
    } else if (boxcaster.warning !== 'none') {
      return "".concat(boxcaster.status, " (").concat(boxcaster.warning, ")");
    } else {
      return boxcaster.status;
    }
  };

  $scope.editInventory = function (boxcaster) {
    return $modal.open({
      template: __webpack_require__(230),
      controller: 'BoxcasterInventoryFormController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function (editedBoxCaster) {
      return $scope.boxcaster = editedBoxCaster;
    });
  };

  return $scope.edit = function (boxcaster) {
    return $modal.open({
      template: __webpack_require__(231),
      controller: 'BoxcasterFormController',
      size: 'md',
      backdrop: 'static'
    }).result.then(function (editedBoxCaster) {
      return $scope.boxcaster = editedBoxCaster;
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Edid; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// This code begged/borrowed/stolen from https://github.com/dgallegos/edidreader/blob/master/app/js/edid.js
// and lightly refactored into an ES6 class and added known manufacturer names.
// TODO: This code assumes all descriptor blocks are detailed timing descriptors. They can be other things too.
function intToAscii(intCode) {
  var abc = "0ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  return abc[intCode];
}

var Edid = /*#__PURE__*/function () {
  function Edid(edidData) {
    _classCallCheck(this, Edid);

    this.edidData = edidData;
    this.EDID_BLOCK_LENGTH = 128;
    this.WhiteAndSyncLevels = ["+0.7/−0.3 V", "+0.714/−0.286 V", "+1.0/−0.4 V", "+0.7/0 V"];
    this.digitalColorSpace = ["RGB 4:4:4", "RGB 4:4:4 + YCrCb 4:4:4", "RGB 4:4:4 + YCrCb 4:2:2", "RGB 4:4:4 + YCrCb 4:4:4 + YCrCb 4:2:2"];
    this.analogColorSpace = ["Monochrome or Grayscale", "RGB color", "Non-RGB color", "Undefined"];
    this.establishedTimingBitmaps = ["720×400 @ 70 Hz", "720×400 @ 88 Hz", "640×480 @ 60 Hz", "640×480 @ 67 Hz", "640×480 @ 72 Hz", "640×480 @ 75 Hz", "800×600 @ 56 Hz", "800×600 @ 60 Hz", "800×600 @ 72 Hz", "800×600 @ 75 Hz", "832×624 @ 75 Hz", "1024×768i @ 87 Hz", "1024×768 @ 60 Hz", "1024×768 @ 72 Hz", "1024×768 @ 75 Hz", "1280×1024 @ 75 Hz", "1152x870 @ 75 Hz"];
    this.DTD_LENGTH = 18;
    this.xyPixelRatioEnum = [{
      "string": "16:10"
    }, {
      "string": "4:3"
    }, {
      "string": "5:4"
    }, {
      "string": "16:9"
    }];
    this.syncTypeEnum = {
      "ANALOG_COMPOSITE": 0x00,
      "BIPOLAR_ANALOG_COMPOSITE": 0x01,
      "DIGITAL_COMPOSITE": 0x02,
      "DIGITAL_SEPARATE": 0x03
    };
    this.dataBlockType = {
      RESERVED: {
        string: "RESERVED",
        value: 0
      },
      AUDIO: {
        string: "AUDIO",
        value: 1
      },
      VIDEO: {
        string: "VIDEO",
        value: 2
      },
      VENDOR_SPECIFIC: {
        string: "VENDOR SPECIFIC",
        value: 3
      },
      SPEAKER_ALLOCATION: {
        string: "SPEAKER ALLOCATION",
        value: 4
      },
      EXTENDED_TAG: {
        string: "EXTENDED TAG",
        value: 7
      }
    }; // Taken from http://edid.tv/manufacturer

    this.eisaIDs = {
      "AAA": "Avolites Ltd",
      "ACI": "Ancor Communications Inc",
      "ACR": "Acer Technologies",
      "ADA": "Addi-Data GmbH",
      "APP": "Apple Computer Inc",
      "APT": "Audio Processing Technology Ltd",
      "ASK": "Ask A/S",
      "AVT": "Avtek (Electronics) Pty Ltd",
      "BMD": "Blackmagic Design",
      "BNO": "Bang & Olufsen",
      "BOE": "BOE",
      "BOX": "BoxCast",
      "CMN": "Chimei Innolux Corporation",
      "CMO": "Chi Mei Optoelectronics corp.",
      "CRO": "Extraordinary Technologies PTY Limited",
      "DEL": "Dell Inc.",
      "DGC": "Data General Corporation",
      "DON": "DENON, Ltd.",
      "ENC": "Eizo Nanao Corporation",
      "EPH": "Epiphan Systems Inc.",
      "EXP": "Data Export Corporation",
      "FNI": "Funai Electric Co., Ltd.",
      "FUS": "Fujitsu Siemens Computers GmbH",
      "GSM": "Goldstar Company Ltd",
      "HIQ": "Kaohsiung Opto Electronics Americas, Inc.",
      "HSD": "HannStar Display Corp",
      "HTC": "Hitachi Ltd",
      "HWP": "Hewlett Packard",
      "INT": "Interphase Corporation",
      "INX": "Communications Supply Corporation (A division of WESCO)",
      "ITE": "Integrated Tech Express Inc",
      "IVM": "Iiyama North America",
      "LEN": "Lenovo Group Limited",
      "MAX": "Rogen Tech Distribution Inc",
      "MEG": "Abeam Tech Ltd",
      "MEI": "Panasonic Industry Company",
      "MTC": "Mars-Tech Corporation",
      "MTX": "Matrox",
      "NEC": "NEC Corporation",
      "NEX": "Nexgen Mediatech Inc.",
      "ONK": "ONKYO Corporation",
      "ORN": "ORION ELECTRIC CO., LTD.",
      "OTM": "Optoma Corporation",
      "OVR": "Oculus VR, Inc.",
      "PHL": "Philips Consumer Electronics Company",
      "PIO": "Pioneer Electronic Corporation",
      "PNR": "Planar Systems, Inc.",
      "QDS": "Quanta Display Inc.",
      "RAT": "Rent-A-Tech",
      "REN": "Renesas Technology Corp.",
      "SAM": "Samsung Electric Company",
      "SAN": "Sanyo Electric Co.,Ltd.",
      "SCE": "Sun Corporation",
      "SEC": "Seiko Epson Corporation",
      "SHP": "Sharp Corporation",
      "SII": "Silicon Image, Inc.",
      "SNY": "Sony",
      "STD": "STD Computer Inc",
      "SVS": "SVSI",
      "SYN": "Synaptics Inc",
      "TCL": "Technical Concepts Ltd",
      "TOP": "Orion Communications Co., Ltd.",
      "TSB": "Toshiba America Info Systems Inc",
      "TST": "Transtream Inc",
      "VES": "Vestel Elektronik Sanayi ve Ticaret A. S.",
      "VIT": "Visitech AS",
      "VIZ": "VIZIO, Inc",
      "VSC": "ViewSonic Corporation",
      "YMH": "Yamaha Corporation"
    };
    this.extendedDataBlockType = {
      VIDEO_CAPABILITY: {
        string: "VIDEO CAPABILITY",
        value: 0
      },
      COLORIMETRY: {
        string: "COLORIMETRY",
        value: 5
      },
      YCBCR420_VIDEO: {
        string: "YCBCR420 VIDEO DATA",
        value: 14
      },
      YCBCR420_CAPABILITY_MAP: {
        string: "YCBCR420_CAPABILITY_MAP",
        value: 15
      }
    };
    this.ieeeOuiType = {
      HDMI14: {
        string: "HDMI14",
        value: 0x000C03
      },
      HDMI20: {
        string: "HDMI20",
        value: 0xC45DD8
      }
    };
    this.overscanBehavior = ["No data", "Always overscanned", "Always underscanned", "Supports both overscan and underscan"];
    this.audioFormatArray = [1, 8, 13, 14, 15];
    this.shortAudioDescriptors = ["RESERVED", "LPCM", "AC-3", "MPEG-1", "MP3", "MPEG2", "AAC LC", "DTS", "ATRAC", "DSD", "E-AC-3", "DTS-HD", "MLP", "DST", "WMA Pro"];
    this.sadSampleRates = ["32 kHz", "44.1 kHz", "48 kHz", "88.2 kHz", "96 kHz", "176.4 kHz", "192 kHz"];
    this.sadBitDepths = ["16 bit", "20 bit", "24 bit"];
    this.shortVideoDescriptors = [{
      "vic": 0
    }, {
      "vic": 1,
      "format": "640x480p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 2,
      "format": "720x480p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:9"
    }, {
      "vic": 3,
      "format": "720x480p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:27"
    }, {
      "vic": 4,
      "format": "1280x720p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 5,
      "format": "1920x1080i",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 6,
      "format": "720(1440)x480i",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:9"
    }, {
      "vic": 7,
      "format": "720(1440)x480i",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:27"
    }, {
      "vic": 8,
      "format": "720(1440)x240p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "4:9"
    }, {
      "vic": 9,
      "format": "720(1440)x240p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "16:27"
    }, {
      "vic": 10,
      "format": "2880x480i",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "2:9 – 20:9"
    }, {
      "vic": 11,
      "format": "2880x480i",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "8:27 -80:27"
    }, {
      "vic": 12,
      "format": "2880x240p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "1:9 – 10:9"
    }, {
      "vic": 13,
      "format": "2880x240p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "4:27 – 40:27"
    }, {
      "vic": 14,
      "format": "1440x480p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "4:9 or 8:9"
    }, {
      "vic": 15,
      "format": "1440x480p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "16:27 or 32:27"
    }, {
      "vic": 16,
      "format": "1920x1080p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 17,
      "format": "720x576p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "16:15"
    }, {
      "vic": 18,
      "format": "720x576p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "64:45"
    }, {
      "vic": 19,
      "format": "1280x720p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 20,
      "format": "1920x1080i",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 21,
      "format": "720(1440)x576i",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "16:15"
    }, {
      "vic": 22,
      "format": "720(1440)x576i",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "64:45"
    }, {
      "vic": 23,
      "format": "720(1440)x288p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:15"
    }, {
      "vic": 24,
      "format": "720(1440)x288p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:45"
    }, {
      "vic": 25,
      "format": "2880x576i",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "2:15 – 20:15"
    }, {
      "vic": 26,
      "format": "2880x576i",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "16:45-160:45"
    }, {
      "vic": 27,
      "format": "2880x288p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "1:15 – 10:15"
    }, {
      "vic": 28,
      "format": "2880x288p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "8:45 – 80:45"
    }, {
      "vic": 29,
      "format": "1440x576p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:15 or 16:15"
    }, {
      "vic": 30,
      "format": "1440x576p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:45 or 64:45"
    }, {
      "vic": 31,
      "format": "1920x1080p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 32,
      "format": "1920x1080p",
      "fieldRate": "23.97Hz/24Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 33,
      "format": "1920x1080p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 34,
      "format": "1920x1080p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 35,
      "format": "2880x480p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "2:9, 4:9, or 8:9"
    }, {
      "vic": 36,
      "format": "2880x480p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "8:27, 16:27, or 32:27"
    }, {
      "vic": 37,
      "format": "2880x576p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "4:15, 8:15, or 16:15"
    }, {
      "vic": 38,
      "format": "2880x576p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "16:45, 32:45, or 64:45"
    }, {
      "vic": 39,
      "format": "1920x1080i (1250 total)",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 40,
      "format": "1920x1080i",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 41,
      "format": "1280x720p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 42,
      "format": "720x576p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "16:15"
    }, {
      "vic": 43,
      "format": "720x576p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "64:45"
    }, {
      "vic": 44,
      "format": "720(1440)x576i",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "16:15"
    }, {
      "vic": 45,
      "format": "720(1440)x576i",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "64:45"
    }, {
      "vic": 46,
      "format": "1920x1080i",
      "fieldRate": "119.88/120Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 47,
      "format": "1280x720p",
      "fieldRate": "119.88/120Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 48,
      "format": "720x480p",
      "fieldRate": "119.88/120Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:9"
    }, {
      "vic": 49,
      "format": "720x480p",
      "fieldRate": "119.88/120Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:27"
    }, {
      "vic": 50,
      "format": "720(1440)x480i",
      "fieldRate": "119.88/120Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:9"
    }, {
      "vic": 51,
      "format": "720(1440)x480i",
      "fieldRate": "119.88/120Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:27"
    }, {
      "vic": 52,
      "format": "720x576p",
      "fieldRate": "200Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "16:15"
    }, {
      "vic": 53,
      "format": "720x576p",
      "fieldRate": "200Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "64:45"
    }, {
      "vic": 54,
      "format": "720(1440)x576i",
      "fieldRate": "200Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "16:15"
    }, {
      "vic": 55,
      "format": "720(1440)x576i",
      "fieldRate": "200Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "64:45"
    }, {
      "vic": 56,
      "format": "720x480p",
      "fieldRate": "239.76/240Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:9"
    }, {
      "vic": 57,
      "format": "720x480p",
      "fieldRate": "239.76/240Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:27"
    }, {
      "vic": 58,
      "format": "720(1440)x480i",
      "fieldRate": "239.76/240Hz",
      "pictureAspectRatio": "4:3",
      "pixelAspectRatio": "8:9"
    }, {
      "vic": 59,
      "format": "720(1440)x480i",
      "fieldRate": "239.76/240Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "32:27"
    }, {
      "vic": 60,
      "format": "1280x720p",
      "fieldRate": "23.97Hz/24Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 61,
      "format": "1280x720p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 62,
      "format": "1280x720p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 63,
      "format": "1920x1080p",
      "fieldRate": "119.88/120Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 64,
      "format": "1920x1080p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 65,
      "format": "1280x720p",
      "fieldRate": "23.98Hz/24Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 66,
      "format": "1280x720p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 67,
      "format": "1280x720p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 68,
      "format": "1280x720p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 69,
      "format": "1280x720p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 70,
      "format": "1280x720p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 71,
      "format": "1280x720p",
      "fieldRate": "119.88Hz/120Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 72,
      "format": "1920x1080p",
      "fieldRate": "23.98Hz/24Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 73,
      "format": "1920x1080p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 74,
      "format": "1920x1080p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 75,
      "format": "1920x1080p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 76,
      "format": "1920x1080p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 77,
      "format": "1920x1080p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 78,
      "format": "1920x1080p",
      "fieldRate": "119.88Hz/120Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "4:3"
    }, {
      "vic": 79,
      "format": "1680x720p",
      "fieldRate": "23.98Hz/24Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "64:63"
    }, {
      "vic": 80,
      "format": "1680x720p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "64:63"
    }, {
      "vic": 81,
      "format": "1680x720p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "64:63"
    }, {
      "vic": 82,
      "format": "1680x720p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "64:63"
    }, {
      "vic": 83,
      "format": "1680x720p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "64:63"
    }, {
      "vic": 84,
      "format": "1680x720p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "64:63"
    }, {
      "vic": 85,
      "format": "1680x720p",
      "fieldRate": "119.88Hz/120Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "64:63"
    }, {
      "vic": 86,
      "format": "2560p1080p",
      "fieldRate": "23.98Hz/24Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 87,
      "format": "2560p1080p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 88,
      "format": "2560p1080p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 89,
      "format": "2560p1080p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 90,
      "format": "2560p1080p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 91,
      "format": "2560p1080p",
      "fieldRate": "100Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 92,
      "format": "2560p1080p",
      "fieldRate": "119.88Hz/120Hz",
      "pictureAspectRatio": "64:27",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 93,
      "format": "3840x2160p",
      "fieldRate": "23.98Hz/24Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 94,
      "format": "3840x2160p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 95,
      "format": "3840x2160p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 96,
      "format": "3840x2160p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 97,
      "format": "3840x2160p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 98,
      "format": "4096x2160p",
      "fieldRate": "23.98Hz/24Hz",
      "pictureAspectRatio": "256:135",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 99,
      "format": "4096x2160p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "256:135",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 100,
      "format": "4096x2160p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "256:135",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 101,
      "format": "4096x2160p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "256:135",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 102,
      "format": "4096x2160p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "256:135",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 103,
      "format": "3840x2160p",
      "fieldRate": "23.98Hz/24Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 104,
      "format": "3840x2160p",
      "fieldRate": "25Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 105,
      "format": "3840x2160p",
      "fieldRate": "29.97Hz/30Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 106,
      "format": "3840x2160p",
      "fieldRate": "50Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }, {
      "vic": 107,
      "format": "3840x2160p",
      "fieldRate": "59.94Hz/60Hz",
      "pictureAspectRatio": "16:9",
      "pixelAspectRatio": "1:1"
    }];
    this.speakerAllocation = ["Front Left/Front Right (FL/FR)", "Low Frequency Effort (LFE)", "Front Center (FC)", "Rear Left/Rear Right (RL/RR)", "Rear Center (RC)", "Front Left Center/Front Right Center (FLC/FRC)", "Rear Left Center/Rear Right Center (RLC/RRC)", "Front Left Wide/Front Right Wide (FLW/FRW)", "Front Left High/Frong Right High (FLH/FRH)", "Top Center (TC)", "Front Center High (FCH)"];

    if (this.validateHeader() == true) {
      this.validHeader = "OK";
    } else {
      this.validHeader = "ERROR";
    }

    this.eisaId = this.getEisaId();
    this.manufacturerName = this.getManufacturerName();
    this.productCode = this.getProductCode();
    this.serialNumber = this.getSerialNumber();
    this.manufactureWeek = this.getManufactureWeek();
    this.manufactureYear = this.getManufactureYear();
    this.manufactureDate = this.manufactureWeek + "/" + this.manufactureYear;
    this.edidVersion = this.getEdidVersion() + "." + this.getEdidRevision();
    this.bdp = this.getBasicDisplayParams();
    this.chromaticity = this.getChromaticityCoordinates();
    this.timingBitmap = this.getTimingBitmap();
    this.standardDisplayModes = this.getStandardDisplayModes();
    this.dtds = this.getDtds();
    this.numberOfExtensions = this.getNumberExtensions();
    this.checksum = this.getChecksum();
    this.exts = new Array(); // Begin Parsing Extension blocks

    for (var extIndex = 0; extIndex < this.numberOfExtensions; extIndex++) {
      this.exts[extIndex] = new Object();
      this.exts[extIndex].blockNumber = extIndex + 1;
      this.exts[extIndex].extTag = this.getExtTag(extIndex);
      this.exts[extIndex].revisionNumber = this.getRevisionNumber(extIndex);
      this.exts[extIndex].dtdStart = this.getDtdStart(extIndex);
      this.exts[extIndex].numDtds = this.getNumberExtDtds(extIndex);
      this.exts[extIndex].underscan = this.getUnderscan(extIndex);
      this.exts[extIndex].basicAudio = this.getBasicAudio(extIndex);
      this.exts[extIndex].ycbcr444 = this.getYcBcR444(extIndex);
      this.exts[extIndex].ycbcr422 = this.getYcBcR422(extIndex); // If DTDs don't start at byte 4

      if (this.exts[extIndex].dtdStart != 4) {
        // Parse Data Collection block
        this.exts[extIndex].dataBlockCollection = this.parseDataBlockCollection(extIndex);
      } // Parse DTDs


      this.exts[extIndex].dtds = this.getExtDtds(extIndex, this.exts[extIndex].dtdStart); // Get Checkum

      this.exts[extIndex].checksum = this.getExtChecksum(extIndex);
    }
  }

  _createClass(Edid, [{
    key: "validateHeader",
    value: function validateHeader() {
      var validHeader = new Boolean();

      if (this.edidData[0] == 0x00 && this.edidData[1] == 0xFF && this.edidData[2] == 0xFF && this.edidData[3] == 0xFF && this.edidData[4] == 0xFF && this.edidData[5] == 0xFF && this.edidData[6] == 0xFF && this.edidData[7] == 0x00) {
        validHeader = true;
      } else {
        validHeader = false;
      }

      return validHeader;
    }
  }, {
    key: "getEisaId",
    value: function getEisaId() {
      var FIVE_BIT_LETTER_MASK = 0x1F;
      var EISA_ID_BYTE1 = 8;
      var EISA_ID_BYTE2 = 9;
      var EISA_LETTER1_OFF = 2;
      var EISA_LETTER2_OFF = 5;
      var LETTER2_TOP_BYTES = 3;
      var LETTER2_TOP_MASK = 0x03;
      var LETTER2_BOT_MASK = 0x07;
      var firstLetter = this.edidData[EISA_ID_BYTE1] >> EISA_LETTER1_OFF & FIVE_BIT_LETTER_MASK; // Get the first two bits [2:0] of the top byte

      var secondLetterTop = this.edidData[EISA_ID_BYTE1] & LETTER2_TOP_MASK; // Get the last three bits [7:5] of the bottom byte

      var secondLetterBottom = this.edidData[EISA_ID_BYTE2] >> EISA_LETTER2_OFF & LETTER2_BOT_MASK; // Combine the top and bottom

      var secondLetter = secondLetterTop << LETTER2_TOP_BYTES | secondLetterBottom;
      var thirdLetter = this.edidData[EISA_ID_BYTE2] & FIVE_BIT_LETTER_MASK;
      return intToAscii(firstLetter) + intToAscii(secondLetter) + intToAscii(thirdLetter);
    }
  }, {
    key: "getManufacturerName",
    value: function getManufacturerName() {
      var manufacturerName = this.eisaIDs[this.eisaId];

      if (!manufacturerName) {
        manufacturerName = "Unknown (".concat(this.eisaId, ")");
      }

      return manufacturerName;
    }
  }, {
    key: "getProductCode",
    value: function getProductCode() {
      var PRODUCT_CODE1 = 10;
      var PRODUCT_CODE2 = 11;
      return this.edidData[PRODUCT_CODE2] << 8 | this.edidData[PRODUCT_CODE1];
    }
  }, {
    key: "getSerialNumber",
    value: function getSerialNumber() {
      var SERIAL_NUMBER1 = 12;
      var SERIAL_NUMBER2 = 13;
      var SERIAL_NUMBER3 = 14;
      var SERIAL_NUMBER4 = 15;
      return this.edidData[SERIAL_NUMBER4] << 24 | this.edidData[SERIAL_NUMBER3] << 16 | this.edidData[SERIAL_NUMBER2] << 8 | this.edidData[SERIAL_NUMBER1];
    }
  }, {
    key: "getManufactureWeek",
    value: function getManufactureWeek() {
      var MANUFACTURE_WEEK = 16;
      return this.edidData[MANUFACTURE_WEEK];
    }
  }, {
    key: "getManufactureYear",
    value: function getManufactureYear() {
      var MANUFACTURE_YEAR = 17;
      return this.edidData[MANUFACTURE_YEAR] + 1990;
    }
  }, {
    key: "getEdidVersion",
    value: function getEdidVersion() {
      var EDID_VERSION = 18;
      return this.edidData[EDID_VERSION];
    }
  }, {
    key: "getEdidRevision",
    value: function getEdidRevision() {
      var EDID_REVISION = 19;
      return this.edidData[EDID_REVISION];
    }
  }, {
    key: "getBasicDisplayParams",
    value: function getBasicDisplayParams() {
      var bdp = new Object();
      var VIDEO_IN_PARAMS_BITMAP = 20;
      var DIGITAL_INPUT = 0x80;

      if (this.edidData[VIDEO_IN_PARAMS_BITMAP] & DIGITAL_INPUT) {
        var VESA_DFP_COMPATIBLE = 0x01;
        bdp.digitalInput = true;

        if (this.edidData[VIDEO_IN_PARAMS_BITMAP] & VESA_DFP_COMPATIBLE) {
          bdp.vesaDfpCompatible = true;
        } else {
          bdp.vesaDfpCompatible = false;
        }
      } else {
        bdp.digitalInput = false;
        var WHITE_SYNC_LVLS_OFF = 5;
        var WHITE_SYNC_LVLS_MASK = 0x03;
        bdp.whiteSyncLevels = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> WHITE_SYNC_LVLS_OFF & WHITE_SYNC_LVLS_MASK;
        var BLANK_TO_BLACK_OFF = 4;
        var BLANK_TO_BLACK_MASK = 0x01;
        bdp.blankToBlack = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> BLANK_TO_BLACK_OFF & BLANK_TO_BLACK_MASK ? true : false;
        var SEPARATE_SYNC_OFF = 3;
        var SEPARATE_SYNC_MASK = 0x01;
        bdp.separateSyncSupported = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> SEPARATE_SYNC_OFF & SEPARATE_SYNC_MASK ? true : false;
        var COMPOSITE_SYNC_OFF = 2;
        var COMPOSITE_SYNC_MASK = 0x01;
        bdp.compositeSyncSupported = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> COMPOSITE_SYNC_OFF & COMPOSITE_SYNC_MASK ? true : false;
        var SYNC_ON_GREEN_OFF = 1;
        var SYNC_ON_GREEN_MASK = 0x01;
        bdp.synOnGreen = this.edidData[VIDEO_IN_PARAMS_BITMAP] >> SYNC_ON_GREEN_OFF & SYNC_ON_GREEN_MASK ? true : false;
        var VSYNC_SERRATED_MASK = 0x01;
        bdp.vsyncSerrated = this.edidData[VIDEO_IN_PARAMS_BITMAP] & VSYNC_SERRATED_MASK ? true : false;
      }

      var MAX_HOR_IMG_SIZE = 21;
      bdp.maxHorImgSize = this.edidData[MAX_HOR_IMG_SIZE];
      var MAX_VERT_IMG_SIZE = 22;
      bdp.maxVertImgSize = this.edidData[MAX_VERT_IMG_SIZE];
      var DISPLAY_GAMMA = 23;
      bdp.displayGamma = this.edidData[DISPLAY_GAMMA] * (2.54 / 255) + 1;
      var SUPPORTED_FEATURES_BITMAP = 24;
      var DPMS_STANDBY = 0x80;
      bdp.dpmsStandby = this.edidData[SUPPORTED_FEATURES_BITMAP] & DPMS_STANDBY ? true : false;
      var DPMS_SUSPEND = 0x40;
      bdp.dpmsSuspend = this.edidData[SUPPORTED_FEATURES_BITMAP] & DPMS_SUSPEND ? true : false;
      var DPMS_ACTIVE_OFF = 0x20;
      bdp.dpmsActiveOff = this.edidData[SUPPORTED_FEATURES_BITMAP] & DPMS_ACTIVE_OFF ? true : false;
      var DISPLAY_TYPE_OFF = 3;
      var DISPLAY_TYPE_MASK = 0x03;
      bdp.displayType = this.edidData[SUPPORTED_FEATURES_BITMAP] >> DISPLAY_TYPE_OFF & DISPLAY_TYPE_MASK;
      var STANDARD_SRGB = 0x04;
      bdp.standardSRgb = this.edidData[SUPPORTED_FEATURES_BITMAP] & STANDARD_SRGB ? true : false;
      var PREFERRED_TIMING = 0x02;
      bdp.preferredTiming = this.edidData[SUPPORTED_FEATURES_BITMAP] & PREFERRED_TIMING ? true : false;
      var GTF_SUPPORTED = 0x01;
      bdp.gtfSupported = this.edidData[SUPPORTED_FEATURES_BITMAP] & GTF_SUPPORTED ? true : false;
      return bdp;
    }
  }, {
    key: "getChromaticityCoordinates",
    value: function getChromaticityCoordinates() {
      var chromaticity = new Object();
      var TWO_BIT_MASK = 0x03;
      var TWO_BIT_OFF = 2;
      var FOUR_BIT_OFF = 4;
      var SIX_BIT_OFF = 6;
      var RED_GREEN_LSB = 25;
      var RED_X_MSB = 27;
      chromaticity.redX = this.edidData[RED_X_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] >> SIX_BIT_OFF & TWO_BIT_MASK;
      chromaticity.redXCoords = chromaticity.redX / 1024;
      var RED_Y_MSB = 28;
      chromaticity.redY = this.edidData[RED_Y_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] >> FOUR_BIT_OFF & TWO_BIT_MASK;
      chromaticity.redYCoords = chromaticity.redY / 1024;
      var GREEN_X_MSB = 29;
      chromaticity.greenX = this.edidData[GREEN_X_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] >> TWO_BIT_OFF & TWO_BIT_MASK;
      chromaticity.greenXCoords = chromaticity.greenX / 1024;
      var GREEN_Y_MSB = 30;
      chromaticity.greenY = this.edidData[GREEN_Y_MSB] << TWO_BIT_OFF | this.edidData[RED_GREEN_LSB] & TWO_BIT_MASK;
      chromaticity.greenYCoords = chromaticity.greenY / 1024;
      var BLUE_WHITE_LSB = 26;
      var BLUE_X_MSB = 31;
      chromaticity.blueX = this.edidData[BLUE_X_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] >> SIX_BIT_OFF & TWO_BIT_MASK;
      chromaticity.blueXCoords = chromaticity.blueX / 1024;
      var BLUE_Y_MSB = 32;
      chromaticity.blueY = this.edidData[BLUE_Y_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] >> FOUR_BIT_OFF & TWO_BIT_MASK;
      chromaticity.blueYCoords = chromaticity.blueY / 1024;
      var WHITE_X_MSB = 33;
      chromaticity.whiteX = this.edidData[WHITE_X_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] >> TWO_BIT_OFF & TWO_BIT_MASK;
      chromaticity.whiteXCoords = chromaticity.whiteX / 1024;
      var WHITE_Y_MSB = 34;
      chromaticity.whiteY = this.edidData[WHITE_Y_MSB] << TWO_BIT_OFF | this.edidData[BLUE_WHITE_LSB] & TWO_BIT_MASK;
      chromaticity.whiteYCoords = chromaticity.whiteY / 1024;
      return chromaticity;
    }
  }, {
    key: "getTimingBitmap",
    value: function getTimingBitmap() {
      var TIMING_BITMAP1 = 35;
      var TIMING_BITMAP2 = 36;
      var TIMING_BITMAP3 = 37;
      var timingBitmap = this.edidData[TIMING_BITMAP1] << 16 | this.edidData[TIMING_BITMAP2] << 8 | this.edidData[TIMING_BITMAP3];
      return timingBitmap;
    }
  }, {
    key: "getStandardDisplayModes",
    value: function getStandardDisplayModes() {
      var STD_DISPLAY_MODES_START = 38;
      var STD_DISPLAY_MODES_END = 53;
      var stdDispModesArray = new Array();
      var arrayCounter = 0;
      var index = STD_DISPLAY_MODES_START;

      while (index < STD_DISPLAY_MODES_END) {
        if (this.edidData[index] != 0x01 && this.edidData[index + 1] != 0x01) {
          var standardDisplayModes = new Object();
          standardDisplayModes.xResolution = (this.edidData[index] + 31) * 8;
          var XY_PIXEL_RATIO_OFF = 6;
          var XY_PIXEL_RATIO_MASK = 0x03;
          standardDisplayModes.xyPixelRatio = this.edidData[index + 1] >> XY_PIXEL_RATIO_OFF & XY_PIXEL_RATIO_MASK;
          var VERTICAL_FREQUENCY_MASK = 0x3F;
          standardDisplayModes.vertFreq = (this.edidData[index + 1] & VERTICAL_FREQUENCY_MASK) + 60;
          stdDispModesArray[arrayCounter] = standardDisplayModes;
          arrayCounter++;
        }

        index += 2;
      }

      return stdDispModesArray;
    }
  }, {
    key: "parseDtd",
    value: function parseDtd(dtdIndex) {
      var dtd = new Object(); // Pixel Clock in MHz

      dtd.pixelClock = (this.edidData[dtdIndex + 1] << 8 | this.edidData[dtdIndex]) / 100;
      var HOR_ACTIVE_OFF = 4;
      var HOR_ACTIVE_PIX_MASK = 0x0F;
      dtd.horActivePixels = (this.edidData[dtdIndex + 4] >> HOR_ACTIVE_OFF & HOR_ACTIVE_PIX_MASK) << 8 | this.edidData[dtdIndex + 2];
      var HOR_BLANK_MASK = 0x0F;
      dtd.horBlankPixels = (this.edidData[dtdIndex + 4] & HOR_BLANK_MASK) << 8 | this.edidData[dtdIndex + 3];
      var VERT_ACTIVE_OFF = 4;
      var VERT_ACTIVE_MASK = 0x0F;
      dtd.vertActivePixels = (this.edidData[dtdIndex + 7] >> VERT_ACTIVE_OFF & VERT_ACTIVE_MASK) << 8 | this.edidData[dtdIndex + 5];
      ;
      var VERT_BLANK_MASK = 0x0F;
      dtd.vertBlankPixels = (this.edidData[dtdIndex + 7] & VERT_BLANK_MASK) << 8 | this.edidData[dtdIndex + 6];
      var HOR_SYNC_OFF_OFF = 6;
      var HOR_SYNC_OFF_MASK = 0x03;
      dtd.horSyncOff = (this.edidData[dtdIndex + 11] >> HOR_SYNC_OFF_OFF & HOR_SYNC_OFF_MASK) << 8 | this.edidData[dtdIndex + 8];
      var HOR_SYNC_PULSE_OFF = 4;
      var HOR_SYNC_PULSE_MASK = 0x03;
      dtd.horSyncPulse = (this.edidData[dtdIndex + 11] >> HOR_SYNC_PULSE_OFF & HOR_SYNC_PULSE_MASK) << 8 | this.edidData[dtdIndex + 9];
      var VERT_SYNC_OFF_TOP_OFF = 2;
      var VERT_SYNC_OFF_TOP_MASK = 0x03;
      var VERT_SYNC_OFF_BOT_OFF = 4;
      var VERT_SYNC_OFF_BOT_MASK = 0x0F;
      dtd.vertSyncOff = (this.edidData[dtdIndex + 11] >> VERT_SYNC_OFF_TOP_OFF & VERT_SYNC_OFF_TOP_MASK) << 4 | this.edidData[dtdIndex + 10] >> VERT_SYNC_OFF_BOT_OFF & VERT_SYNC_OFF_BOT_MASK;
      var VERT_SYNC_PULSE_TOP_MASK = 0x03;
      var VERT_SYNC_PULSE_BOT_MASK = 0x0F;
      dtd.vertSyncPulse = (this.edidData[dtdIndex + 11] & VERT_SYNC_PULSE_TOP_MASK) << 4 | this.edidData[dtdIndex + 10] & VERT_SYNC_PULSE_BOT_MASK;
      var HOR_DISPLAY_TOP_OFF = 4;
      var HOR_DISPLAY_TOP_MASK = 0x0F;
      dtd.horDisplaySize = (this.edidData[dtdIndex + 14] >> HOR_DISPLAY_TOP_OFF & HOR_DISPLAY_TOP_MASK) << 8 | this.edidData[dtdIndex + 12];
      var VERT_DISPLAY_TOP_MASK = 0x0F;
      dtd.vertDisplaySize = (this.edidData[dtdIndex + 14] & VERT_DISPLAY_TOP_MASK) << 8 | this.edidData[dtdIndex + 13];
      dtd.horBorderPixels = this.edidData[dtdIndex + 15];
      dtd.vertBorderLines = this.edidData[dtdIndex + 16];
      var INTERLACED_MASK = 0x80;
      dtd.interlaced = this.edidData[dtdIndex + 17] & INTERLACED_MASK ? true : false;
      var STEREO_MODE_OFFSET = 5;
      var STEREO_MODE_MASK = 0x03;
      dtd.stereoMode = this.edidData[dtdIndex + 17] >> STEREO_MODE_OFFSET & STEREO_MODE_MASK;
      var SYNC_TYPE_OFFSET = 3;
      var SYNC_TYPE_MASK = 0x03;
      dtd.syncType = this.edidData[dtdIndex + 17] >> SYNC_TYPE_OFFSET & SYNC_TYPE_MASK; // Bit is dependent on sync type

      if (dtd.syncType == this.syncTypeEnum.DIGITAL_SEPARATE) {
        var VSYNC_POLARITY_MASK = 0x04;
        dtd.vSyncPolarity = this.edidData[dtdIndex + 17] & VSYNC_POLARITY_MASK ? true : false;
      } else {
        var VSYNC_SERRATED_MASK = 0x04;
        dtd.vSyncSerrated = this.edidData[dtdIndex + 17] & VSYNC_SERRATED_MASK ? true : false;
      } // Bit is dependent on syn type


      if (dtd.syncType == this.syncTypeEnum.ANALOG_COMPOSITE || dtd.syncType == this.syncTypeEnum.BIPOLAR_ANALOG_COMPOSITE) {
        var SYNC_ALL_RGB_MASK = 0x02;
        dtd.syncAllRGBLines = this.edidData[dtdIndex + 17] & SYNC_ALL_RGB_MASK ? true : false;
      } else {
        var HSYNC_POLARY_MASK = 0x02;
        dtd.hSyncPolarity = this.edidData[dtdIndex + 17] & HSYNC_POLARY_MASK ? true : false;
      }

      var TWO_WAY_STEREO_MASK = 0x01;
      dtd.twoWayStereo = this.edidData[dtdIndex + 17] & TWO_WAY_STEREO_MASK ? true : false;
      return dtd;
    }
  }, {
    key: "getDtds",
    value: function getDtds() {
      var dtdArray = new Array();
      var dtdCounter = 0;
      var DTD_START = 54;
      var DTD_END = 125;
      var dtdIndex = DTD_START; // While the pixel clock is not equal to zero and
      // the DTD index is less than the last byte of the DTD

      while ((this.edidData[dtdIndex] != 0 || this.edidData[dtdIndex + 1] != 0) && dtdIndex < DTD_END) {
        var dtd = this.parseDtd(dtdIndex); // Add DTD to the DTD Array

        dtdArray[dtdCounter] = dtd; // Increment DTD Counter

        dtdCounter++; // Add a DTD length, to go to the next descriptor

        dtdIndex += this.DTD_LENGTH;
      }

      return dtdArray;
    }
  }, {
    key: "getNumberExtensions",
    value: function getNumberExtensions() {
      var NUMBER_OF_EXTENSIONS = 126;
      return this.edidData[NUMBER_OF_EXTENSIONS];
    }
  }, {
    key: "getChecksum",
    value: function getChecksum() {
      var CHECKSUM = 127;
      return this.edidData[CHECKSUM];
    }
  }, {
    key: "calcChecksum",
    value: function calcChecksum(block) {
      var startAddress = block * this.EDID_BLOCK_LENGTH;
      var endAddress = startAddress + this.EDID_BLOCK_LENGTH - 1;
      var checksum = 0;

      for (var index = startAddress; index < endAddress; index++) {
        checksum += this.edidData[index];
      }

      return 256 - checksum % 256;
    }
  }, {
    key: "validChecksum",
    value: function validChecksum(block) {
      var checksum = this.edidData[(block + 1) * this.EDID_BLOCK_LENGTH - 1];
      var calculatedChecksum = this.calcChecksum(block);
      var validChecksum = new Boolean();

      if (checksum == calculatedChecksum) {
        validChecksum = true;
      } else {
        validChecksum = false;
      }

      return validChecksum;
    }
  }, {
    key: "getExtTag",
    value: function getExtTag(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var EXT_TAG = BLOCK_OFFSET + 0;
      return this.edidData[EXT_TAG];
    }
  }, {
    key: "getRevisionNumber",
    value: function getRevisionNumber(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var REV_NUMBER = BLOCK_OFFSET + 1;
      return this.edidData[REV_NUMBER];
    }
  }, {
    key: "getDtdStart",
    value: function getDtdStart(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var DTD_START = BLOCK_OFFSET + 2;
      return this.edidData[DTD_START];
    }
  }, {
    key: "getNumberExtDtds",
    value: function getNumberExtDtds(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var NUM_DTDS = BLOCK_OFFSET + 3;
      var NUM_DTDS_MASK = 0x0F;
      return this.edidData[NUM_DTDS] & NUM_DTDS_MASK;
    }
  }, {
    key: "getUnderscan",
    value: function getUnderscan(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var UNDERSCAN = BLOCK_OFFSET + 3;
      var UNDERSCAN_MASK = 0x80;
      return this.edidData[UNDERSCAN] & UNDERSCAN_MASK ? true : false;
    }
  }, {
    key: "getBasicAudio",
    value: function getBasicAudio(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var BASIC_AUDIO = BLOCK_OFFSET + 3;
      var BASIC_AUDIO_MASK = 0x40;
      return this.edidData[BASIC_AUDIO] & BASIC_AUDIO_MASK ? true : false;
    }
  }, {
    key: "getYcBcR444",
    value: function getYcBcR444(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var YCBCR_444 = BLOCK_OFFSET + 3;
      var YCBCR_444_MASK = 0x20;
      return this.edidData[YCBCR_444] & YCBCR_444_MASK ? true : false;
    }
  }, {
    key: "getYcBcR422",
    value: function getYcBcR422(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var YCBCR_422 = BLOCK_OFFSET + 3;
      var YCBCR_422_MASK = 0x10;
      return this.edidData[YCBCR_422] & YCBCR_422_MASK ? true : false;
    }
  }, {
    key: "parseDataBlockCollection",
    value: function parseDataBlockCollection(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var START_DATA_BLOCK = 4;
      var startAddress = BLOCK_OFFSET + START_DATA_BLOCK;
      var dataBlockLength = this.exts[extIndex].dtdStart - START_DATA_BLOCK;
      var endAddress = startAddress + dataBlockLength;
      var dataBlockCollection = new Array();
      var TAG_CODE_MASK = 0x07;
      var TAG_CODE_OFFSET = 5;
      var DATA_BLOCK_LENGTH_MASK = 0x1F;
      var index = startAddress;
      var numberDataBlocks = 0;

      while (index < endAddress) {
        // Parse tag code
        var blockTagCode = this.edidData[index] >> TAG_CODE_OFFSET & TAG_CODE_MASK; // Parse Length

        var blockLength = this.edidData[index] & DATA_BLOCK_LENGTH_MASK; // Object that holds Parsed Data block

        var dataBlock; // Parse the data block by the tag code

        if (blockTagCode == this.dataBlockType.AUDIO.value) {
          dataBlock = this.parseAudioDataBlock(index + 1, blockLength);
        } else if (blockTagCode == this.dataBlockType.VIDEO.value) {
          dataBlock = this.parseVideoDataBlock(index + 1, blockLength);
        } else if (blockTagCode == this.dataBlockType.VENDOR_SPECIFIC.value) {
          dataBlock = this.parseVendorDataBlock(index + 1, blockLength);
        } else if (blockTagCode == this.dataBlockType.SPEAKER_ALLOCATION.value) {
          dataBlock = this.parseSpeakerDataBlock(index + 1, blockLength);
        } else if (blockTagCode == this.dataBlockType.EXTENDED_TAG.value) {
          dataBlock = this.parseExtendedTagDataBlock(index + 1, blockLength);
        } // Add the new object to the data block collection


        dataBlockCollection[numberDataBlocks] = dataBlock; // Increment the Index, to the location of the next block

        index += blockLength + 1; // Increment the number of data blocks

        numberDataBlocks++;
      }

      return dataBlockCollection;
    }
  }, {
    key: "parseAudioDataBlock",
    value: function parseAudioDataBlock(startAddress, blockLength) {
      var audioBlock = new Array(); // Audio blocks are made up of Short Audio Descriptors that are three bytes each

      var SHORT_AUDIO_DESC_LENGTH = 3; // The number of Short Audio Descriptors is the block length divided by the descriptor size

      var numberShortAudioDescriptors = blockLength / SHORT_AUDIO_DESC_LENGTH;
      var shortAudDescIndex = 0;
      var index = startAddress; // Set the Audio Block Tag

      audioBlock.tag = this.dataBlockType.AUDIO; // Set the Audio block length

      audioBlock.dataLength = blockLength; // Set the number of short audio descriptors

      audioBlock.length = numberShortAudioDescriptors; // Create array for short audio descriptors

      audioBlock.shortAudioDescriptors = new Array(); // Parse the short audio descriptors in the Audio Data Block

      var SHORT_AUDIO_DESC_MASK = 0x0F;
      var SHORT_AUDIO_DESC_OFF = 3;
      var MAX_CHANNELS_MASK = 0x07;
      var SAMPLE_RATE_MASK = 0x7F;

      while (shortAudDescIndex < numberShortAudioDescriptors) {
        // Each Short Audio Descriptor is a 3 byte object
        var shortAudDesc = new Object(); // Parse the format

        shortAudDesc.format = this.edidData[index] >> SHORT_AUDIO_DESC_OFF & SHORT_AUDIO_DESC_MASK; // Parse max number of channels

        shortAudDesc.maxChannels = (this.edidData[index] & MAX_CHANNELS_MASK) + 1; // Parse audio sample rates

        shortAudDesc.sampleRates = this.edidData[index + 1] & SAMPLE_RATE_MASK;

        if (shortAudDesc.format <= this.audioFormatArray[0]) {
          var BIT_DEPTH_MASK = 0x07;
          shortAudDesc.bitDepth = this.edidData[index + 2] & BIT_DEPTH_MASK;
        } else if (shortAudDesc.format <= this.audioFormatArray[1]) {
          var MAX_BIT_RATE_MASK = 0xFF;
          shortAudDesc.bitRate = (this.edidData[index + 2] & MAX_BIT_RATE_MASK) * 8;
        } else if (shortAudDesc.format <= this.audioFormatArray[2]) {
          var AUDIO_FORMAT_CODE_MASK = 0xFF;
          shortAudDesc.audioFormatCode = this.edidData[index + 2] & AUDIO_FORMAT_CODE_MASK;
        } else if (shortAudDesc.format <= this.audioFormatArray[3]) {
          var PROFILE_MASK = 0x07;
          shortAudDesc.profile = this.edidData[index + 2] & PROFILE_MASK;
        } else if (shortAudDesc.format <= this.audioFormatArray[4]) {
          var FORMAT_CODE_EXT_OFF = 3;
          var FORMAT_CODE_EXT_MASK = 0x1F;
          shortAudDesc.formatCodeExt = this.edidData[index + 2] >> FORMAT_CODE_EXT_OFF & FORMAT_CODE_EXT_MASK;
        } // Add Short Audio Descriptor to Audio Data Block


        audioBlock.shortAudioDescriptors[shortAudDescIndex] = shortAudDesc; // Move the index to the beginning of the next Short Audio Descriptor

        index += SHORT_AUDIO_DESC_LENGTH; // Increment the count to the next Short Audio Descriptor

        shortAudDescIndex++;
      }

      return audioBlock;
    }
  }, {
    key: "parseVideoDataBlock",
    value: function parseVideoDataBlock(startAddress, blockLength) {
      var videoBlock = new Object();
      videoBlock.tag = this.dataBlockType.VIDEO;
      videoBlock.length = blockLength;
      var index = 0;
      videoBlock.shortVideoDescriptors = new Array();
      var NATIVE_RESOLUTION_MASK = 0x80;
      var CEA861F_VIC_MASK = 0x40;
      var LOW_VIC_MASK = 0x3F;
      var HIGH_VIC_MASK = 0xFF;

      while (index < blockLength) {
        var shortVideoDescriptor = new Object();
        var dataByte = this.edidData[startAddress + index];

        if ((dataByte & CEA861F_VIC_MASK) > 0) {
          shortVideoDescriptor.vic = dataByte & HIGH_VIC_MASK;
          shortVideoDescriptor.nativeResolution = false;
        } else {
          shortVideoDescriptor.vic = dataByte & LOW_VIC_MASK;
          shortVideoDescriptor.nativeResolution = dataByte & NATIVE_RESOLUTION_MASK ? true : false;
        }

        videoBlock.shortVideoDescriptors[index] = shortVideoDescriptor;
        index++;
      } // Store the video block - it is referenced by other data blocks (e.g. YCbCr 4:2:0 Capability Map)


      this.videoBlock = videoBlock;
      return videoBlock;
    }
  }, {
    key: "parseVendorDataBlockHDMI14",
    value: function parseVendorDataBlockHDMI14(startAddress, blockLength, vendorBlock) {
      // Subtract one, so the indexing matches the HDMI Specification
      var vsdbAddress = startAddress - 1;
      var PHYSICAL_ADDRESS_1 = 4;
      var PHYSICAL_ADDRESS_2 = 5; // Physical Address

      vendorBlock.physicalAddress = this.edidData[vsdbAddress + PHYSICAL_ADDRESS_1] << 8 | this.edidData[vsdbAddress + PHYSICAL_ADDRESS_2];
      var AI_DC_DUAL_ADDRESS = 6;

      if (blockLength >= AI_DC_DUAL_ADDRESS) {
        var SUPPORT_AI_MASK = 0x80; // Parse Supports ACP, ISRC1, ISRC2

        vendorBlock.supportsAI = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & SUPPORT_AI_MASK ? true : false;
        var DEEP_COLOR_48_MASK = 0x40;
        vendorBlock.deepColor48 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_48_MASK ? true : false;
        var DEEP_COLOR_36_MASK = 0x20;
        vendorBlock.deepColor36 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_36_MASK ? true : false;
        var DEEP_COLOR_30_MASK = 0x10;
        vendorBlock.deepColor30 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_30_MASK ? true : false;
        var DEEP_COLOR_Y444_MASK = 0x08;
        vendorBlock.deepColorY444 = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DEEP_COLOR_Y444_MASK ? true : false;
        var DUAL_DVI_MASK = 0x01;
        vendorBlock.dualDvi = this.edidData[vsdbAddress + AI_DC_DUAL_ADDRESS] & DUAL_DVI_MASK ? true : false;
      }

      var MAX_TMDS_CLOCK_ADDRESS = 7;

      if (blockLength >= MAX_TMDS_CLOCK_ADDRESS) {
        // Parse Max TMDS rate, the edid has TMDS clock. Multiply TMDS clock x 5Mhz
        // and you'll get max TMDS rate
        vendorBlock.maxTmdsRate = this.edidData[vsdbAddress + MAX_TMDS_CLOCK_ADDRESS] * 5;
      }

      var LATENCY_PRESENT_ADDRESS = 8;

      if (blockLength >= LATENCY_PRESENT_ADDRESS) {
        var LATENCY_FIELDS_PRESENT_MASK = 0x80;
        vendorBlock.latencyPresent = this.edidData[vsdbAddress + LATENCY_PRESENT_ADDRESS] & LATENCY_FIELDS_PRESENT_MASK ? true : false;
        var I_LATENCY_FIELDS_PRESENT_MASK = 0x80;
        vendorBlock.iLatencyPresent = this.edidData[vsdbAddress + LATENCY_PRESENT_ADDRESS] & I_LATENCY_FIELDS_PRESENT_MASK ? true : false;
      } // If Latency fields are present


      if (vendorBlock.latencyPresent && blockLength >= AUDIO_LATENCY_ADDRESS) {
        var VIDEO_LATENCY_ADDRESS = 9; // TODO: Add description

        vendorBlock.videoLatency = (this.edidData[vsdbAddress + VIDEO_LATENCY_ADDRESS] - 1) * 2;
        var AUDIO_LATENCY_ADDRESS = 10; // TODO: Add description

        vendorBlock.audioLatency = (this.edidData[vsdbAddress + AUDIO_LATENCY_ADDRESS] - 1) * 2;
      } // If Interlaced Latency fields are present


      if (vendorBlock.iLatencyPresent && blockLength >= I_AUDIO_LATENCY_ADDRESS) {
        var I_VIDEO_LATENCY_ADDRESS = 11; // TODO: Add description

        vendorBlock.iVideoLatency = (this.edidData[vsdbAddress + I_VIDEO_LATENCY_ADDRESS] - 1) * 2;
        var I_AUDIO_LATENCY_ADDRESS = 12; // TODO: Add description

        vendorBlock.iAudioLatency = (this.edidData[vsdbAddress + I_AUDIO_LATENCY_ADDRESS] - 1) * 2;
      }

      return vendorBlock;
    }
  }, {
    key: "parseVendorDataBlockHDMI20",
    value: function parseVendorDataBlockHDMI20(startAddress, blockLength, vendorBlock) {
      // Subtract one, so the indexing matches the HDMI Specification
      var vsdbAddress = startAddress - 1;
      var FIELD_ADDRESS = 0;
      var FIELD_MASK = 0x0;
      FIELD_ADDRESS = 4; // VSDB version for HDMI Forum

      vendorBlock.versionHF = this.edidData[vsdbAddress + FIELD_ADDRESS];
      FIELD_ADDRESS = 5;
      vendorBlock.maxTmdsRateHF = this.edidData[vsdbAddress + FIELD_ADDRESS] * 5;
      FIELD_ADDRESS = 6;
      FIELD_MASK = 0x80;
      vendorBlock.supportsSCDC = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 6;
      FIELD_MASK = 0x40;
      vendorBlock.supportsSCDCRR = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 6;
      FIELD_MASK = 0x08;
      vendorBlock.supportsLTE340scramble = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 6;
      FIELD_MASK = 0x04;
      vendorBlock.supports3DIV = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 6;
      FIELD_MASK = 0x02;
      vendorBlock.supports3DDV = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 6;
      FIELD_MASK = 0x01;
      vendorBlock.supports3DOSD = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 7;
      FIELD_MASK = 0x04;
      vendorBlock.deepColorY420_30 = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 7;
      FIELD_MASK = 0x02;
      vendorBlock.deepColorY420_30 = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 7;
      FIELD_MASK = 0x01;
      vendorBlock.deepColorY420_30 = this.edidData[vsdbAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      return vendorBlock;
    }
  }, {
    key: "parseVendorDataBlock",
    value: function parseVendorDataBlock(startAddress, blockLength) {
      var vendorBlock = new Object();
      vendorBlock.tag = this.dataBlockType.VENDOR_SPECIFIC;
      vendorBlock.length = blockLength; // Subtract one, so the indexing matches the HDMI Specification

      var vsdbAddress = startAddress - 1;
      var IEEE_REG_IDENTIFIER_1 = 1;
      var IEEE_REG_IDENTIFIER_2 = 2;
      var IEEE_REG_IDENTIFIER_3 = 3; // 24-bit IEEE Registration Identifier

      vendorBlock.ieeeIdentifier = this.edidData[vsdbAddress + IEEE_REG_IDENTIFIER_3] << 16 | this.edidData[vsdbAddress + IEEE_REG_IDENTIFIER_2] << 8 | this.edidData[vsdbAddress + IEEE_REG_IDENTIFIER_1];

      if (vendorBlock.ieeeIdentifier == this.ieeeOuiType.HDMI14.value) {
        // HDMI 1.4 VSDB
        return this.parseVendorDataBlockHDMI14(startAddress, blockLength, vendorBlock);
      } else if (vendorBlock.ieeeIdentifier == this.ieeeOuiType.HDMI20.value) {
        // HDMI 2.0 VSDB
        return this.parseVendorDataBlockHDMI20(startAddress, blockLength, vendorBlock);
      }

      return vendorBlock;
    }
  }, {
    key: "parseVideoCapabilityDataBlock",
    value: function parseVideoCapabilityDataBlock(startAddress, blockLength, extendedTagBlock) {
      extendedTagBlock.extendedTag = this.extendedDataBlockType.VIDEO_CAPABILITY;
      var FIELD_ADDRESS = 0;
      var FIELD_MASK = 0x0;
      var FIELD_SHIFT = 0;
      var fieldData = 0;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x80;
      extendedTagBlock.quantizationRangeYCC = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x40;
      extendedTagBlock.quantizationRangeRGB = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x30;
      FIELD_SHIFT = 4;
      fieldData = (this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK) >> FIELD_SHIFT;
      extendedTagBlock.overscanPT = this.overscanBehavior[fieldData];
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x0C;
      FIELD_SHIFT = 2;
      fieldData = (this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK) >> FIELD_SHIFT;
      extendedTagBlock.overscanIT = this.overscanBehavior[fieldData];
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x03;
      FIELD_SHIFT = 0;
      fieldData = (this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK) >> FIELD_SHIFT;
      extendedTagBlock.overscanCE = this.overscanBehavior[fieldData];
      return extendedTagBlock;
    }
  }, {
    key: "parseColorimetryDataBlock",
    value: function parseColorimetryDataBlock(startAddress, blockLength, extendedTagBlock) {
      extendedTagBlock.extendedTag = this.extendedDataBlockType.COLORIMETRY;
      var FIELD_ADDRESS = 0;
      var FIELD_MASK = 0x0;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x80;
      extendedTagBlock.supportsBT2020RGB = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x40;
      extendedTagBlock.supportsBT2020YCC = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x20;
      extendedTagBlock.supportsBT2020cYCC = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x10;
      extendedTagBlock.supportsAdobeRGB = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x08;
      extendedTagBlock.supportsAdobeYCC601 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x04;
      extendedTagBlock.supportssYCC601 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x02;
      extendedTagBlock.supportsxvYCC709 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 1;
      FIELD_MASK = 0x01;
      extendedTagBlock.supportsxvYCC601 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;
      FIELD_ADDRESS = 2;
      FIELD_MASK = 0x08;
      extendedTagBlock.gamutMD3 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
      FIELD_ADDRESS = 2;
      FIELD_MASK = 0x04;
      extendedTagBlock.gamutMD2 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
      FIELD_ADDRESS = 2;
      FIELD_MASK = 0x02;
      extendedTagBlock.gamutMD1 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
      FIELD_ADDRESS = 2;
      FIELD_MASK = 0x01;
      extendedTagBlock.gamutMD0 = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? 1 : 0;
      return extendedTagBlock;
    }
  }, {
    key: "parseYCbCr420VideoDataBlock",
    value: function parseYCbCr420VideoDataBlock(startAddress, blockLength, extendedTagBlock) {
      extendedTagBlock.extendedTag = this.extendedDataBlockType.YCBCR420_VIDEO;
      var svdIndex = 0;
      var NATIVE_RESOLUTION_MASK = 0x80;
      var CEA861F_VIC_MASK = 0x40;
      var LOW_VIC_MASK = 0x3F;
      var HIGH_VIC_MASK = 0xFF; // SVDs listed in this block support only YCbCr 4:2:0 color format.
      // These SVDs are not listed in the standard Video data block.

      extendedTagBlock.YCbCr420OnlyShortVideoDescriptors = new Array();

      for (svdIndex = 0; svdIndex < blockLength - 1; svdIndex++) {
        var shortVideoDescriptor = new Object();
        var dataByte = this.edidData[startAddress + 1 + svdIndex]; // +1 as this is an extended tag data block

        if ((dataByte & CEA861F_VIC_MASK) > 0) {
          shortVideoDescriptor.vic = dataByte & HIGH_VIC_MASK;
          shortVideoDescriptor.nativeResolution = false;
        } else {
          shortVideoDescriptor.vic = dataByte & LOW_VIC_MASK;
          shortVideoDescriptor.nativeResolution = dataByte & NATIVE_RESOLUTION_MASK ? true : false;
        }

        extendedTagBlock.YCbCr420OnlyShortVideoDescriptors[svdIndex] = shortVideoDescriptor;
      }

      return extendedTagBlock;
    }
  }, {
    key: "parseYCbCr420CapabilityMapDataBlock",
    value: function parseYCbCr420CapabilityMapDataBlock(startAddress, blockLength, extendedTagBlock) {
      extendedTagBlock.extendedTag = this.extendedDataBlockType.YCBCR420_CAPABILITY_MAP;
      var FIELD_ADDRESS = 0;
      var FIELD_MASK = 0x0;
      var svdIndex = 0;
      var YCbCr420Capable = false;
      var YCbCr420svdIndex = 0; // YCbCr420 Capability Map block contains a bit map of SVDs from the Video block
      // If a bit is set to "1", the corresponding SVD supports YCbCr 4:2:0 color format
      // This data block is only used for SVDs which support 4:2:0 and some other colour
      // format (e.g. 4:2:2).
      // For SVDs which support only 4:2:0, YCbCr 4:2:0 Video data block is used.

      extendedTagBlock.YCbCr420CapableShortVideoDescriptors = new Array();

      for (FIELD_ADDRESS = 1; FIELD_ADDRESS < blockLength; FIELD_ADDRESS++) {
        for (FIELD_MASK = 0x01; FIELD_MASK <= 0x80; FIELD_MASK <<= 1) {
          YCbCr420Capable = this.edidData[startAddress + FIELD_ADDRESS] & FIELD_MASK ? true : false;

          if (YCbCr420Capable) {
            extendedTagBlock.YCbCr420CapableShortVideoDescriptors[YCbCr420svdIndex] = this.videoBlock.shortVideoDescriptors[svdIndex];
            YCbCr420svdIndex++;
          }

          svdIndex++;
        }
      }

      return extendedTagBlock;
    }
  }, {
    key: "parseSpeakerDataBlock",
    value: function parseSpeakerDataBlock(startAddress, blockLength) {
      var speakerBlock = new Object();
      speakerBlock.tag = this.dataBlockType.SPEAKER_ALLOCATION;
      speakerBlock.length = blockLength;
      speakerBlock.payload = this.edidData[startAddress + 2] << 16 | this.edidData[startAddress + 1] << 8 | this.edidData[startAddress];
      return speakerBlock;
    }
  }, {
    key: "parseExtendedTagDataBlock",
    value: function parseExtendedTagDataBlock(startAddress, blockLength) {
      var extendedTagBlock = new Object();
      extendedTagBlock.tag = this.dataBlockType.EXTENDED_TAG;
      extendedTagBlock.length = blockLength;
      var EXTENDED_TAG_ADDRESS = 0;
      var extendedBlockTagCode = this.edidData[startAddress + EXTENDED_TAG_ADDRESS];

      if (extendedBlockTagCode == this.extendedDataBlockType.VIDEO_CAPABILITY.value) {
        return this.parseVideoCapabilityDataBlock(startAddress, blockLength, extendedTagBlock);
      } else if (extendedBlockTagCode == this.extendedDataBlockType.COLORIMETRY.value) {
        return this.parseColorimetryDataBlock(startAddress, blockLength, extendedTagBlock);
      } else if (extendedBlockTagCode == this.extendedDataBlockType.YCBCR420_VIDEO.value) {
        return this.parseYCbCr420VideoDataBlock(startAddress, blockLength, extendedTagBlock);
      } else if (extendedBlockTagCode == this.extendedDataBlockType.YCBCR420_CAPABILITY_MAP.value) {
        return this.parseYCbCr420CapabilityMapDataBlock(startAddress, blockLength, extendedTagBlock);
      } else {
        extendedTagBlock.extendedTag = this.edidData[startAddress + EXTENDED_TAG_ADDRESS];
      }

      return extendedTagBlock;
    }
  }, {
    key: "getExtChecksum",
    value: function getExtChecksum(extIndex) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var CHECKSUM_OFFSET = 127;
      return this.edidData[BLOCK_OFFSET + CHECKSUM_OFFSET];
    }
  }, {
    key: "getExtDtds",
    value: function getExtDtds(extIndex, startAddress) {
      var BLOCK_OFFSET = this.EDID_BLOCK_LENGTH * (extIndex + 1);
      var dtdArray = new Array();
      var dtdCounter = 0;
      var dtdIndex = startAddress + BLOCK_OFFSET;
      var endAddress = this.EDID_BLOCK_LENGTH * (extIndex + 2) - 2;

      while ((this.edidData[dtdIndex] != 0 || this.edidData[dtdIndex + 1] != 0) && dtdIndex < endAddress) {
        var dtd = this.parseDtd(dtdIndex); // Add DTD to the DTD Array

        dtdArray[dtdCounter] = dtd; // Increment DTD Counter

        dtdCounter++; // Add a DTD length, to go to the next descriptor

        dtdIndex += this.DTD_LENGTH;
      }

      return dtdArray;
    }
  }]);

  return Edid;
}();



/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["a"] = ParseSupportedBoxCastResolutions;
// This file contains additional logic/functions used by the boxcaster controller in association
// with an EDID for parsing supported resolutions, but is BoxCast-specific (hence why it is not
// part of edid.js).
var BC_525P_30 = {
  height: 480,
  width: 720,
  progressive: true,
  framerate: 30,
  displayFramerate: "29.97/30"
};
var BC_525P_60 = {
  height: 480,
  width: 720,
  progressive: true,
  framerate: 60,
  displayFramerate: "59.94/60"
};
var BC_625P_25 = {
  height: 576,
  width: 720,
  progressive: true,
  framerate: 25,
  displayFramerate: "25"
};
var BC_625P_50 = {
  height: 576,
  width: 720,
  progressive: true,
  framerate: 50,
  displayFramerate: "50"
};
var BC_720P_24 = {
  height: 720,
  width: 1280,
  progressive: true,
  framerate: 24,
  displayFramerate: "23.98/24"
};
var BC_720P_25 = {
  height: 720,
  width: 1280,
  progressive: true,
  framerate: 25,
  displayFramerate: "25"
};
var BC_720P_30 = {
  height: 720,
  width: 1280,
  progressive: true,
  framerate: 30,
  displayFramerate: "29.97/30"
}; // TODO: No idea what the HFP for 720p48 is...

var BC_720P_50 = {
  height: 720,
  width: 1280,
  progressive: true,
  framerate: 50,
  displayFramerate: "50"
};
var BC_720P_60 = {
  height: 720,
  width: 1280,
  progressive: true,
  framerate: 60,
  displayFramerate: "59.94/60"
};
var BC_1080I_48 = {
  height: 1080,
  width: 1920,
  progressive: false,
  framerate: 48,
  displayFramerate: "48"
};
var BC_1080I_50 = {
  height: 1080,
  width: 1920,
  progressive: false,
  framerate: 50,
  displayFramerate: "50"
};
var BC_1080I_60 = {
  height: 1080,
  width: 1920,
  progressive: false,
  framerate: 60,
  displayFramerate: "59.94/60"
};
var BC_1080P_24 = {
  height: 1080,
  width: 1920,
  progressive: true,
  framerate: 24,
  displayFramerate: "23.98/24"
};
var BC_1080P_25 = {
  height: 1080,
  width: 1920,
  progressive: true,
  framerate: 25,
  displayFramerate: "25"
};
var BC_1080P_30 = {
  height: 1080,
  width: 1920,
  progressive: true,
  framerate: 30,
  displayFramerate: "29.97/30"
};
var BC_1080P_48 = {
  height: 1080,
  width: 1920,
  progressive: true,
  framerate: 48,
  displayFramerate: "48"
};
var BC_1080P_50 = {
  height: 1080,
  width: 1920,
  progressive: true,
  framerate: 50,
  displayFramerate: "50"
};
var BC_1080P_60 = {
  height: 1080,
  width: 1920,
  progressive: true,
  framerate: 60,
  displayFramerate: "59.94/60"
};
var BC_2160P_24 = {
  height: 2160,
  width: 3840,
  progressive: true,
  framerate: 24,
  displayFramerate: "23.98/24"
};
var BC_2160P_25 = {
  height: 2160,
  width: 3840,
  progressive: true,
  framerate: 25,
  displayFramerate: "25"
};
var BC_2160P_30 = {
  height: 2160,
  width: 3840,
  progressive: true,
  framerate: 30,
  displayFramerate: "29.97/30"
};
var BC_2160P_48 = {
  height: 2160,
  width: 3840,
  progressive: true,
  framerate: 48,
  displayFramerate: "48"
};
var BC_2160P_50 = {
  height: 2160,
  width: 3840,
  progressive: true,
  framerate: 50,
  displayFramerate: "50"
};
var BC_2160P_60 = {
  height: 2160,
  width: 3840,
  progressive: true,
  framerate: 60,
  displayFramerate: "59.94/60"
};

function dtdToBoxCastResolution(dtd) {
  if (dtd.interlaced) {
    if (dtd.horActivePixels === 1920 && dtd.vertActivePixels === 540 && dtd.pixelClock === 74.25) {
      switch (dtd.horSyncOff) {
        case 638:
          return BC_1080I_48;
          break;

        case 528:
          return BC_1080I_50;
          break;

        case 88:
          return BC_1080I_60;
          break;
      }
    }
  } else {
    if (dtd.horActivePixels === 3840 && dtd.vertActivePixels === 2160 && dtd.pixelClock === 594) {
      switch (dtd.horSyncOff) {
        case 1276:
          return BC_2160P_48;
          break;

        case 1056:
          return BC_2160P_50;
          break;

        case 176:
          return BC_2160P_60;
          break;
      }
    } else if (dtd.horActivePixels === 3840 && dtd.vertActivePixels === 2160 && dtd.pixelClock === 297) {
      switch (dtd.horSyncOff) {
        case 1276:
          return BC_2160P_24;
          break;

        case 1056:
          return BC_2160P_25;
          break;

        case 176:
          return BC_2160P_30;
          break;
      }
    } else if (dtd.horActivePixels === 1920 && dtd.vertActivePixels === 1080 && dtd.pixelClock === 148.5) {
      switch (dtd.horSyncOff) {
        case 638:
          return BC_1080P_48;
          break;

        case 528:
          return BC_1080P_50;
          break;

        case 88:
          return BC_1080P_60;
          break;
      }
    } else if (dtd.horActivePixels === 1920 && dtd.vertActivePixels === 1080 && dtd.pixelClock === 74.25) {
      switch (dtd.horSyncOff) {
        case 638:
          return BC_1080P_24;
          break;

        case 528:
          return BC_1080P_25;
          break;

        case 88:
          return BC_1080P_30;
          break;
      }
    } else if (dtd.horActivePixels === 1280 && dtd.vertActivePixels === 720 && dtd.pixelClock === 74.25) {
      switch (dtd.horSyncOff) {
        // TODO: No idea what the HFP for 720p48 is...
        case 440:
          return BC_720P_50;
          break;

        case 110:
          return BC_720P_60;
          break;
      }
    } else if (dtd.horActivePixels === 1280 && dtd.vertActivePixels === 720 && dtd.pixelClock === 37.125) {
      switch (dtd.horSyncOff) {
        // TODO: No idea what the HFP for 720p24 is...
        case 440:
          return BC_720P_25;
          break;

        case 110:
          return BC_720P_30;
          break;
      }
    } else if (dtd.horActivePixels === 720 && dtd.vertActivePixels === 576 && dtd.pixelClock === 27) {
      return BC_625P_50;
    } else if (dtd.horActivePixels === 720 && dtd.vertActivePixels === 576 && dtd.pixelClock === 13.5) {
      return BC_625P_25;
    } else if (dtd.horActivePixels === 720 && dtd.vertActivePixels === 480 && dtd.pixelClock === 27) {
      return BC_525P_60;
    } else if (dtd.horActivePixels === 720 && dtd.vertActivePixels === 480 && dtd.pixelClock === 13.5) {
      return BC_525P_30;
    }
  }

  return null;
}

;

function vicToBoxCastResolution(vic) {
  switch (vic) {
    case 2: // fall through

    case 3:
      return BC_525P_60;
      break;

    case 17: // fall through

    case 18:
      return BC_625P_50;
      break;

    case 60: // fall through

    case 65:
      return BC_720P_24;
      break;

    case 61: // fall through

    case 66:
      return BC_720P_25;
      break;

    case 62: // fall through

    case 67:
      return BC_720P_30;
      break;

    case 19: // fall through

    case 68:
      return BC_720P_50;
      break;

    case 4: // fall through

    case 69:
      return BC_720P_60;
      break;

    case 20:
      return BC_1080I_50;
      break;

    case 5:
      return BC_1080I_60;
      break;

    case 32: // fall through

    case 72:
      return BC_1080P_24;
      break;

    case 33: // fall through

    case 73:
      return BC_1080P_25;
      break;

    case 34: // fall through

    case 74:
      return BC_1080P_30;
      break;

    case 31: // fall through

    case 75:
      return BC_1080P_50;
      break;

    case 16: // fall through

    case 76:
      return BC_1080P_60;
      break;

    case 93: // fall through

    case 103:
      return BC_2160P_24;
      break;

    case 94: // fall through

    case 104:
      return BC_2160P_25;
      break;

    case 95: // fall through

    case 105:
      return BC_2160P_30;
      break;

    case 96: // fall through

    case 106:
      return BC_2160P_50;
      break;

    case 97: // fall through

    case 107:
      return BC_2160P_60;
      break;
  }
}

;
function ParseSupportedBoxCastResolutions(edid) {
  var supportedBoxCastResolutions = [];

  var f = function f(dtd) {
    var bcr = dtdToBoxCastResolution(dtd);

    if (bcr && !_.contains(supportedBoxCastResolutions, bcr)) {
      supportedBoxCastResolutions.push(bcr);
    }
  };

  if (edid.dtds) _.each(edid.dtds, f);

  if (edid.exts) {
    _.each(edid.exts, function (ext) {
      if (ext.dtds) _.each(ext.dtds, f);

      if (ext.dataBlockCollection) {
        _.each(ext.dataBlockCollection, function (dataBlock) {
          if (dataBlock.tag && dataBlock.tag.string && dataBlock.tag.string == "VIDEO" && dataBlock.shortVideoDescriptors) {
            _.each(dataBlock.shortVideoDescriptors, function (descriptor) {
              var bcr = vicToBoxCastResolution(descriptor.vic);

              if (bcr && !_.contains(supportedBoxCastResolutions, bcr)) {
                supportedBoxCastResolutions.push(bcr);
              }
            });
          }
        });
      }
    });
  }

  return supportedBoxCastResolutions.sort(function (a, b) {
    // first sort by height, highest to lowest
    if (a.height < b.height) {
      return 1;
    } else if (b.height < a.height) {
      return -1;
    } // next, width, highest to lowest


    if (a.width < b.width) {
      return 1;
    } else if (b.width < a.width) {
      return -1;
    } // Next, progressive before interlaced


    if (!a.progressive && b.progressive) {
      return 1;
    } else if (a.progressive && !b.progressive) {
      return -1;
    } // Next, framerate, highest to lowest


    if (a.framerate < b.framerate) {
      return 1;
    } else if (b.framerate < a.framerate) {
      return -1;
    }

    return 0;
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"/boxcasters\">BoxCasters</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ boxcaster.id }}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div ng-if=\"activation && activation.status\">\n          <div class=\"bg bg-info\" style=\"padding:10px;margin:15px 0;border:1px solid\">\n            BoxCaster is tied to an activation code. <a href=\"/activation_codes?q={{activation.code}}\">See details</a>.\n          </div>\n        </div>\n        <button ng-show=\"canEdit(boxcaster)\" ng-click=\"edit(boxcaster)\" class=\"btn btn-sm btn-block btn-info\">Edit</button>\n        <button ng-click=\"editInventory(boxcaster)\" class=\"btn btn-sm btn-block btn-info\">Edit Inventory Status</button>\n        <div ng-if=\"!(activation && activation.status)\" style=\"margin-top:5px\">\n          <button ng-show=\"canRegister(boxcaster)\" ng-click=\"register(boxcaster)\" class=\"btn btn-sm btn-block btn-primary\">Register</button>\n          <button ng-show=\"canRegister(boxcaster)\" ng-click=\"makeActivation(boxcaster)\" class=\"btn btn-sm btn-block btn-primary\">\n            Sell Through Distribution\n          </button>\n        </div>\n        <button ng-show=\"canUnregister(boxcaster)\" ng-click=\"unregister(boxcaster)\" class=\"btn btn-sm btn-block btn-danger\">Unregister</button>\n        <button ng-disabled=\"isRebooting\" ng-show=\"hasRpc(boxcaster) && isOnline(boxcaster)\" ng-click=\"reboot(boxcaster)\" class=\"btn btn-sm btn-block btn-danger\">{{ isRebooting ? 'Reboot Initiated' : 'Reboot' }}</button>\n        <div>\n          <hr>\n          <a href=\"{{ boxcasterLogsUrl(boxcaster) }}\" target=\"_blank\">\n            <i class=\"fa fa-external-link\"></i>\n            BoxCaster Logs\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <h4>{{ boxcaster.id }}</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr><th>Status/Warning</th><td>{{ getStatusWarning(boxcaster) }}</td></tr>\n      <tr ng-if=\"boxcaster.ethernet_address\"><th>Ethernet MAC:</th><td>{{ boxcaster.ethernet_address | macAddress }}</td></tr>\n      <tr ng-if=\"boxcaster.wireless_address\"><th>Wireless MAC:</th><td>{{ boxcaster.wireless_address | macAddress }}</td></tr>\n      <tr ng-show=\"boxcaster.account_id\"><th class=\"col-xs-2\">Account</th><td><a href=\"{{ newAdminURL }}/accounts/{{ boxcaster.account_id }}\">{{ boxcaster.account_name }}</a></td></tr>\n      <tr><th>Name</th><td>{{ boxcaster.name }}</td></tr>\n      <tr><th>Physical Status</th><td>{{ boxcaster.physical_status | label: config.boxcaster.physical_statuses }}</td></tr>\n      <tr><th>Payment Status</th><td>{{ boxcaster.payment_status | label: config.boxcaster.payment_statuses }}</td></tr>\n      <tr><th>Channel ID</th><td>{{ boxcaster.channel_id }}</td></tr>\n      <tr>\n        <th>Firmware</th>\n        <td>\n          <div class=\"panel-title\">\n            <button class=\"btn btn-link\" style=\"padding: 0px;\" ng-click=\"manifestCollapsed = !manifestCollapsed\">\n              <firmware-version ng-if=\"boxcaster\" boxcaster=\"boxcaster\" concise=\"false\"></firmware-version>\n            </button>\n          </div>\n          <div collapse=\"manifestCollapsed\">\n            <div ng-repeat=\"e in boxcaster.firmware_manifest.split('&')\">{{ e }}</div>\n          </div>\n        </td>\n      </tr>\n      <tr><th>Backhaul Protocol</th><td>{{ boxcaster.backhaul_protocol | label:backhaulProtocols }}</td></tr>\n      <tr><th>Last IP</th><td>{{ boxcaster.last_seen_ip }}</td></tr>\n      <tr><th>Last Seen</th><td>{{ boxcaster.last_seen_at | date: 'MM/dd/yyyy hh:mm a' }}</td></tr>\n      <tr><th>Show URL</th><td><a href=\"{{ boxcaster.show_url.replace('/view/', '/channel/') }}\" target=\"_blank\">{{ boxcaster.show_url.replace('/view/', '/channel/') }}</a></td></tr>\n      <tr ng-show=\"isOnline(boxcaster) && hasRpc(boxcaster)\">\n        <th>Platform Option</th>\n        <td ng-show=\"!platformOption\"><img src=\"/assets/images/ajax_spinner.gif\"></img></td>\n        <td ng-show=\"platformOption\">\n          {{ platformOption | boxcasterKey }}\n          <button ng-show=\"platformOption && platformoptKey\" ng-click=\"setPlatformOption(boxcaster, platformOption)\" class=\"btn btn-xs btn-danger\">Set</button>\n        </td>\n      </tr>\n      <tr ng-show=\"isOnline(boxcaster) && hasRpc(boxcaster) && enforcecertsKey\">\n        <th>Certificate Verification</th>\n        <td ng-show=\"certRpcInFlight\"><img src=\"/assets/images/ajax_spinner.gif\"></img></td>\n        <td ng-show=\"!certRpcInFlight\">\n          {{ certificateVerification }}\n          <button ng-click=\"toggleCertVerification(boxcaster, certificateVerification)\" class=\"btn btn-xs btn-danger\">{{ certificateVerification == 'set' ? 'Disable' : 'Enable' }}</button>\n        </td>\n      </tr>\n    </table>\n    <div class=\"panel panel-default\" ng-if=\"hasWifi(boxcaster) && isOnline(boxcaster)\">\n      <div class=\"panel-heading\">\n        <span ng-click=\"toggleWirelessExpanded()\">\n          <i class=\"fa\" ng-class=\"{ 'fa-chevron-right': !wirelessExpanded, 'fa-chevron-down': wirelessExpanded }\"></i>\n          Wireless\n        </span>\n        <button ng-show=\"!wifiConfigInFlight && !!wifiConfig\" ng-click=\"reloadWireless()\" class=\"btn btn-xs btn-primary\">Reload</button>\n      </div>\n      <div class=\"panel-body\" style=\"padding: 8px;\" ng-show=\"wirelessExpanded\" ng-class=\"(!!wifiConfig && !!wifiConfig.error) ? 'bg-warning' : ''\">\n        <span ng-show=\"wifiConfigInFlight\"><img src=\"/assets/images/ajax_spinner.gif\"></img></span>\n        <div ng-show=\"!wifiConfigInFlight && !!wifiConfig && !wifiConfig.error\">\n          <strong>Configured Wireless Networks</strong>:\n          <ul>\n            <li ng-repeat=\"n in wifiConfig.current.networks\">{{ n.ssid }}{{ isConnectedToSsid(wifiConfig, n.ssid) ? ' (Connected)' : '' }}</li>\n          </ul>\n          <strong>Available Wireless Networks</strong><span ng-show=\"!isReady(boxcaster)\"> <i>(results may be limited as BoxCaster is busy)</i></span>:\n          <ul>\n            <li ng-repeat=\"r in wifiConfig.scan_results\">{{ r.ssid }} ({{ r.signal_strength * 100.0 | number:0 }}%) {{ r.connected && !isConfiguredNetwork(wifiConfig, r.ssid) ? ' (Connected) ' : '' }}</li>\n          </ul>\n          <strong>Open networks are{{ wifiConfig.current.allow_open_networks ? '' : ' NOT' }} allowed.</strong>\n        </div>\n        <div ng-show=\"!wifiConfigInFlight && !!wifiConfig && !!wifiConfig.error\">\n          Error getting wireless configuration ('{{ wifiConfig.error }}'): {{ wifiConfig.error_description }}\n        </div>\n      </div>\n    </div>\n    <div class=\"panel panel-default\" ng-if=\"hasEdid(boxcaster) && isOnline(boxcaster)\">\n      <div class=\"panel-heading\">\n        <span ng-click=\"toggleHdmiOutputEdidExpanded()\">\n          <i class=\"fa\" ng-class=\"{ 'fa-chevron-right': !hdmiOutputEdidExpanded, 'fa-chevron-down': hdmiOutputEdidExpanded }\"></i>\n          HDMI Output EDID\n        </span>\n        <button ng-show=\"!edidRpcInFlight && (!!edid || !!edidError)\" ng-click=\"reloadHdmiOutputEdid()\" class=\"btn btn-xs btn-primary\">Reload</button>\n      </div>\n      <div class=\"panel-body\" style=\"padding: 8px;\" ng-show=\"hdmiOutputEdidExpanded\">\n        <span ng-show=\"edidRpcInFlight\"><img src=\"/assets/images/ajax_spinner.gif\"></img></span>\n        <div ng-show=\"!edidRpcInFlight && edidError\">\n          Error loading EDID: {{ edidError }}\n        </div>\n        <div ng-show=\"!edidRpcInFlight && edid\">\n          <table class=\"table table-striped table-condensed\">\n            <tr><th>Manufacturer</th><td>{{edid.manufacturerName}}</td></tr>\n            <tr ng-if=\"edid.manufactureWeek == 255\"><th>Model Year</th><td>{{edid.manufactureYear}}</td></tr>\n            <tr ng-if=\"edid.manufactureWeek != 255\"><th>Manufacture Week/Year</th><td>{{edid.manufactureDate}}</td></tr>\n            <tr><th>Product Code</th><td>{{edid.productCode}}</td></tr>\n            <tr><th>Serial Number</th><td>{{edid.serialNumber}}</td></tr>\n          </table>\n          <h5>Supported Display Modes:</h5>\n          <table class=\"table table-striped table-condensed\">\n            <tr><th>Resolution</th><th>Scan</th><th>Frame Rate</th></tr>\n            <tr ng-repeat=\"r in edid.supportedBoxCastResolutions\">\n              <td>{{r.width}}x{{r.height}}</td>\n              <td>{{r.progressive ? \"progressive\" : \"interlaced\"}}</td>\n              <td>{{r.displayFramerate}}</td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n\n    <app-boxcaster-graph boxcaster-id=\"boxcasterId\" ng-if=\"hasRpc(boxcaster)\"></app-boxcaster-graph>\n  </div>\n</div>\n"

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Register BoxCaster</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-sm-12\">\n      <div class=\"form-group\">\n        <label for=\"account\">Account</label>\n        <tags-input\n            placeholder=\"Type to search accounts...\"\n            display-property=\"name\",\n            key-property=\"id\"\n            max-tags=\"1\"\n            min-tags=\"1\"\n            add-from-autocomplete-only=\"true\"\n            ng-model=\"selectedAccount\">\n          <auto-complete source=\"searchAccounts($query)\"></auto-complete>\n        </tags-input>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Edit BoxCaster Inventory Status</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-md-6\">\n      <div class=\"form-group\">\n        <label for=\"account\">Account</label>\n        <div ng-show=\"selectedAccount[0]\">{{ selectedAccount[0].name }}</div>\n        <div ng-hide=\"selectedAccount[0]\"><em>Unregistered</em></div>\n        <!-- XXX: API does not allow changing without unregistering first\n        <tags-input\n            placeholder=\"Type to search accounts...\"\n            display-property=\"name\",\n            key-property=\"id\"\n            max-tags=\"1\"\n            min-tags=\"1\"\n            add-from-autocomplete-only=\"true\"\n            ng-model=\"selectedAccount\">\n          <auto-complete source=\"searchAccounts($query)\"></auto-complete>\n        </tags-input>\n        -->\n      </div>\n      <div class=\"form-group\">\n        <label for=\"market\">Physical Status</label>\n        <select id=\"market\" ng-model=\"boxcaster.physical_status\" class=\"form-control\">\n          <option value=\"unknown\"></option>\n          <option ng-repeat=\"e in config.boxcaster.physical_statuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"market\">Payment Status</label>\n        <select id=\"market\" ng-model=\"boxcaster.payment_status\" class=\"form-control\">\n          <option value=\"unknown\"></option>\n          <option ng-repeat=\"e in config.boxcaster.payment_statuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"col-md-6\">\n      <div class=\"form-group\">\n        <label for=\"special_notes\">Special Notes</label>\n        <textarea id=\"special_notes\" type=\"text\" rows=\"6\" ng-model=\"boxcaster.special_notes\" class=\"form-control\"></textarea>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Edit BoxCaster</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-xs-12\">\n      <div class=\"form-group\">\n        <label for=\"backhaul_protocol\">Backhaul Protocol</label>\n        <select id=\"backhaul_protocol\" ng-model=\"boxcaster.backhaul_protocol\" class=\"form-control\">\n          <option value=\"\">Unspecified (use system default)</option>\n          <option ng-repeat=\"e in config.backhaulProtocols\" value=\"{{ e.value }}\">{{ e.label }}</option>\n        </select>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"boxcaster\">\n        <label for=\"ethernet_address\">Ethernet MAC Address</label>\n        <input id=\"ethernet_address\" ng-required=\"true\" ng-minlength=\"12\" ng-maxlength=\"12\" ng-model='boxcaster.ethernet_address' ng-trim='false'/>\n        <button ng-if=\"suggested_ethernet_address\" ng-click=\"useSuggestedEthernetAddress()\" class=\"btn btn-primary\" style=\"padding-top:2px;padding-bottom:2px;padding-left:6px;padding-right:6px;\"><i class=\"fa fa-arrow-left\"></i> Use {{suggested_ethernet_address}}</button>\n      </div>\n\n      <div class=\"form-group\" ng-if=\"boxcaster && canHaveWirelessMac(boxcaster)\">\n        <label for=\"wireless_address\">Wireless MAC Address</label>\n        <input id=\"wireless_address\" ng-minlength=\"12\" ng-maxlength=\"12\" ng-model='boxcaster.wireless_address' ng-trim='false'/>\n        <button ng-if=\"suggested_wireless_address\" ng-click=\"useSuggestedWirelessAddress()\" class=\"btn btn-primary\" style=\"padding-top:2px;padding-bottom:2px;padding-left:6px;padding-right:6px;\"><i class=\"fa fa-arrow-left\"></i> Use {{suggested_wireless_address}}</button>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);


angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/boxcasters', {
    template: __webpack_require__(233),
    controller: 'BoxcastersController'
  });
}]).controller('BoxcastersController', ["$scope", "$location", "$modal", "Account", "Boxcaster", "Config", "toaster", function ($scope, $location, $modal, Account, Boxcaster, Config, toaster) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = 'id');
  $scope.config = Config;
  $scope.loading = true;

  var params = _.pick($scope, 'q', 's', 'p');

  if (params.q && params.q.match(/^[a-zA-Z0-9]+$/)) {
    params.q = "name:*".concat(params.q, "* id:*").concat(params.q, "*");
  }

  if ($scope.f.account && $scope.f.account.active) {
    params['filter.account_id'] = $scope.f.account.id;
  }

  if ($scope.f.credentialed && $scope.f.credentialed.active) {
    params['filter.credentialed'] = $scope.f.credentialed.value;
  }

  $scope.boxcasters = Boxcaster.query(params, function (data, getResponseHeader) {
    $scope.loading = false;
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });

  $scope.createManufacturingBoxcasters = function () {
    $modal.open({
      template: __webpack_require__(234),
      controller: 'BoxcastersNewMfgController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function (mfgAccountId) {
      Account.get({
        id: mfgAccountId
      }, function (a) {
        var accountFilter = "account:" + encodeURIComponent(JSON.stringify(_.extend({
          active: true
        }, _.pick(a, 'id', 'name'))));
        var credentialedFilter = "credentialed:" + encodeURIComponent(JSON.stringify({
          active: true,
          value: false
        }));
        $location.url("/boxcasters?f=".concat(encodeURIComponent(accountFilter + " " + credentialedFilter)));
      }, function (err) {
        console.error(err);
        toaster.pop({
          type: 'error',
          body: "Error loading manufacturing account. Please try again.",
          timeout: 2000
        });
      });
    });
  }; // TODO: replace with filter?


  $scope.getStatusWarning = function (boxcaster) {
    if (boxcaster.status === 'offline') {
      if (Date.now() >= boxcaster.next_broadcast_at) {
        return 'offline (missing_broadcast)';
      } else {
        return 'offline';
      }
    } else if (boxcaster.warning !== 'none') {
      return "".concat(boxcaster.status, " (").concat(boxcaster.warning, ")");
    } else {
      return boxcaster.status;
    }
  };

  $scope.extraFields = localStorage.getItem('boxcasters.fields');

  if ($scope.extraFields) {
    $scope.extraFields = JSON.parse($scope.extraFields);
  } else {
    $scope.extraFields = {
      last_ip: true,
      last_seen: true,
      payment_status: false,
      physical_status: false
    };
  } // Count the number of columns visible


  var baseCount = 4;
  $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter(function (key) {
    return $scope.extraFields[key] === true;
  }).length;
  return $scope.toggle = function (field, e) {
    $scope.extraFields[field] = !$scope.extraFields[field];
    localStorage.setItem('boxcasters.fields', JSON.stringify($scope.extraFields));
    $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter(function (key) {
      return $scope.extraFields[key] === true;
    }).length;
    e.preventDefault();
    e.stopPropagation();
    return false;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default table-animate-aside\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> BoxCasters</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by Name/ID\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n        <div ng-show=\"f.account\">\n          <hr>\n          <h5>Filter by Account</h5>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"f.account.active\" ng-click=\"filter('account.active', !f.account.active)\"> {{ f.account.name }}</label>\n          </div>\n        </div>\n        <div ng-show=\"f.credentialed\">\n          <hr>\n          <h5>Filter by Credentialing</h5>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"f.credentialed.active\" ng-click=\"filter('credentialed.active', !f.credentialed.active)\"> Credentialed: {{ f.credentialed.value }}</label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Manufacturing</h3>\n      </div>\n      <div class=\"panel-body\">\n        <p class=\"help-block\">Create a block of BoxCasters to be provided to a manufacturer. Go away unless you know what you're doing. :-)</p>\n        <button type=\"button\"\n                class=\"btn btn-default btn-block\"\n                ng-click=\"createManufacturingBoxcasters()\">\n          <i class=\"fa fa-plus\"></i> Create BoxCasters for Manufacturing\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"loading\" class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9\">\n    <div class=\"table-header-dropdown table-animate\">\n      <div class=\"btn-group\" dropdown>\n        <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\" dropdown-toggle=\"\">\n            <i class=\"fa fa-cog\" aria-hidden=\"true\"></i>\n        </button>\n        <ul class=\"dropdown-menu dropdown-menu-right\" role=\"menu\">\n          <li class=\"dropdown-checkbox\"><a href=\"javascript://\" ng-click=\"toggle('last_ip', $event)\"><i class=\"fa\" ng-class=\"extraFields.last_ip?'fa-check-square-o':'fa-square-o'\"></i> Last IP</a></li>\n          <li class=\"dropdown-checkbox\"><a href=\"javascript://\" ng-click=\"toggle('last_seen', $event)\"><i class=\"fa\" ng-class=\"extraFields.last_seen?'fa-check-square-o':'fa-square-o'\"></i> Last Seen</a></li>\n          <li class=\"dropdown-checkbox\"><a href=\"javascript://\" ng-click=\"toggle('payment_status', $event)\"><i class=\"fa\" ng-class=\"extraFields.payment_status?'fa-check-square-o':'fa-square-o'\"></i> Payment Status</a></li>\n          <li class=\"dropdown-checkbox\"><a href=\"javascript://\" ng-click=\"toggle('physical_status', $event)\"><i class=\"fa\" ng-class=\"extraFields.physical_status?'fa-check-square-o':'fa-square-o'\"></i> Physical Status</a></li>\n        </ul>\n      </div>\n    </div>\n\n    <table class=\"table table-striped table-light-border table-hover table-condensed table-animate\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('id')\" class=\"clickable\">\n            ID\n            <i ng-show=\"s.indexOf('id') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'id'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-id'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Status/Warning</th>\n          <th ng-click=\"sort('name')\" class=\"clickable\">\n            Name\n            <i ng-show=\"s.indexOf('name') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th ng-click=\"sort('firmware_revision')\" class=\"clickable\">\n            Firmware\n            <i ng-show=\"s.indexOf('firmware_revision') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'firmware_revision'\" class=\"fa fa-sort-numeric-asc\"></i>\n            <i ng-show=\"s === '-firmware_revision'\" class=\"fa fa-sort-numeric-desc\"></i>\n          </th>\n          <th ng-if=\"extraFields.last_ip\">Last IP</th>\n          <th ng-if=\"extraFields.last_seen\">Last Seen</th>\n          <th ng-if=\"extraFields.physical_status\" ng-click=\"sort('physical_status')\" class=\"clickable\">\n            Physical Status\n            <i ng-show=\"s.indexOf('physical_status') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'physical_status'\" class=\"fa fa-sort-numeric-asc\"></i>\n            <i ng-show=\"s === '-physical_status'\" class=\"fa fa-sort-numeric-desc\"></i>\n          </th>\n          <th ng-if=\"extraFields.payment_status\" ng-click=\"sort('payment_status')\" class=\"clickable\">\n            Payment Status\n            <i ng-show=\"s.indexOf('payment_status') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'payment_status'\" class=\"fa fa-sort-numeric-asc\"></i>\n            <i ng-show=\"s === '-payment_status'\" class=\"fa fa-sort-numeric-desc\"></i>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!loading && !boxcasters.length\" class=\"tr--no-results\"><td colspan=\"{{ fieldCount }}\">No BoxCasters were found.</td></tr>\n        <tr ng-repeat=\"b in boxcasters\" ng-click=\"openURL('/boxcasters/'+b.id, $event)\" class=\"clickable\">\n          <td>{{ b.id }}</td>\n          <td>{{ getStatusWarning(b) }}</td>\n          <td>{{ b.name }}</td>\n          <td><firmware-version boxcaster=\"b\" concise=\"true\" float=\"true\"></firmware-version></td>\n          <td ng-if=\"extraFields.last_ip\">{{ b.last_seen_ip }}</td>\n          <td ng-if=\"extraFields.last_seen\">{{ b.last_seen_at | date: 'MM/dd/yyyy hh:mm a' }}</td>\n          <td ng-if=\"extraFields.physical_status\">{{ b.physical_status | label: config.boxcaster.physical_statuses }}</td>\n          <td ng-if=\"extraFields.payment_status\">{{ b.payment_status | label: config.boxcaster.payment_statuses }}</td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Create BoxCasters for Manufacturer</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form id=\"recording-form\" name=\"form\" role=\"form\">\n    <div class=\"col-sm-5\">\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Manufacturer: </span>\n        <select id=\"manufacturerId\" ng-model=\"manufacturerId\" required class=\"form-control\" ng-change=\"updateMfgAccount()\">\n          <option ng-repeat=\"m in manufacturers\" value=\"{{ m.id }}\">{{ m.name }}</option>\n        </select>\n      </div>\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Count: </span>\n        <input id=\"count\" type=\"number\" ng-model=\"count\" required class=\"form-control\" min=\"1\" max=\"500\">\n      </div>\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Model: </span>\n        <select id=\"prefix\" ng-model=\"prefix\" required class=\"form-control\">\n          <option value=\"o\">HDSD2</option>\n          <option value=\"p\">BoxCaster Pro</option>\n        </select>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isCreating\" class=\"btn btn-primary\"><i ng-show=\"isCreating\" class=\"fa fa-cog fa-spin\"></i> Create</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {angular.module('app.views').controller('BoxcastersNewMfgController', ["$scope", "$routeParams", "$modalInstance", "Boxcaster", "Manufacturer", function ($scope, $routeParams, $modalInstance, Boxcaster, Manufacturer) {
  $scope.isCreating = false;
  $scope.manufacturerId = null;
  $scope.count = 1;
  $scope.prefix = "o";
  $scope.manufacturerAccountId = null;
  $scope.manufacturers = Manufacturer.query(function (data) {
    $scope.manufacturerId = data[0].id;
    $scope.manufacturerAccountId = data[0].account_id;
  });

  $scope.updateMfgAccount = function () {
    $scope.manufacturerAccountId = _.find($scope.manufacturers, function (m) {
      return m.id === $scope.manufacturerId;
    }).account_id;
  };

  $scope.ok = function () {
    $scope.isCreating = true;
    Boxcaster.createBatch({
      count: $scope.count,
      prefix: $scope.prefix,
      manufacturer_id: $scope.manufacturerId
    }, function (data) {
      // Okay... got the data -- format, convert to CSV, and download
      var csvStr = 'serial_num,mac_id,barcode_num\n';
      csvStr += data.map(function (boxcaster) {
        var macId = boxcaster.id.substring(1).toUpperCase().replace(/(.{2})/g, "$1-").slice(0, -1);
        return "".concat(boxcaster.id, ",").concat(macId, ",").concat(boxcaster.id);
      }).join('\n');
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href", "data:text/csv;charset=utf-8,".concat(encodeURIComponent(csvStr)));
      downloadAnchorNode.setAttribute("download", "boxcasters.csv");
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
      return $modalInstance.close($scope.manufacturerAccountId);
    }, function (err) {
      alert('There was an error creating the BoxCasters.');
    });
    $scope.isCreating = false;
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_, moment, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_origin_thumbnail__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tickets_refund_form_controller__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tickets_refund_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tickets_refund_form_controller__);





angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/broadcasts/:id', {
    template: __webpack_require__(237),
    controller: 'BroadcastController'
  });
}]).controller('BroadcastController', ["$scope", "$location", "$timeout", "$route", "$routeParams", "$modal", "Broadcast", "BroadcastUpload", "Ticket", "Account", "$rootScope", "$window", "$http", "$q", function ($scope, $location, $timeout, $route, $routeParams, $modal, Broadcast, BroadcastUpload, Ticket, Account, $rootScope, $window, $http, $q) {
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_2__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  $scope.selectedTickets = [];
  $scope.selectAll = false;
  $scope.validTicketCount = 0;
  $scope.selectedTicketTotal = 0;
  $scope.queryHasRun = false;
  $scope.queryRunning = false;
  $scope.defaultPageLength = 50;
  $scope.broadcast = Broadcast.get({
    id: $routeParams.id,
    include_recurrence: true,
    include_stream_diagnostics: true
  }, function (data) {
    $scope.soldTicketCount = data.sold_ticket_count;
    $scope.totalTicketRevenue = data.sold_ticket_total;
    $scope.netTicketRevenue = data.net_ticket_total;
    $scope.refundedTotal = data.refunded_ticket_count;
    $scope.validTicketCount = $scope.soldTicketCount - $scope.refundedTotal;
    calculateShowBoxCastFlowControl();

    var params = _.pick($scope, 'q', 's', 'p');

    params.broadcast_id = $routeParams.id;
    params.l = $scope.defaultPageLength;
    $scope.tickets = Ticket.query(params, function (data, getResponseHeader) {
      $scope.unrefunded = _.where($scope.tickets, {
        is_refunded: false
      });
      var pagination = getResponseHeader('X-Pagination');
      $scope.pagination = pagination ? JSON.parse(pagination) : {};
    });
    fixBroadcast();

    if ($scope.broadcast.stream_source === 'imported') {
      BroadcastUpload.query({
        broadcast_id: $routeParams.id
      }, function (data) {
        $scope.upload = _.find(data, function (u) {
          return u.recording_id === $scope.broadcast.recording_id;
        });
      });
    } else {
      BroadcastUpload.query({
        broadcast_id: $routeParams.id
      }, function (data) {
        $scope.upload = data[0];
      });
    }

    Account.get({
      id: data.account_id
    }, function (account) {
      $scope.account = account;
      calculateShowBoxCastFlowControl();
    });

    if (data.origin_name) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_origin_thumbnail__["a" /* OriginThumbnail */])($http, $q, data.origin_name).then(function (url) {
        return $scope.origin_thumbnail = url;
      });
    }
  });

  function calculateShowBoxCastFlowControl() {
    var account = $scope.account;

    if (account && account.hasFeatureFlag('boxcast_flow_control_disabled')) {
      $scope.showBoxCastFlowControl = false;
      return;
    }

    var broadcast = $scope.broadcast;

    if (!broadcast) {
      $scope.showBoxCastFlowControl = false;
      return;
    }

    switch (broadcast.stream_source) {
      case 'app': // fall-through

      case 'boxcaster-pro':
        $scope.showBoxCastFlowControl = true;
        break;

      case 'boxcaster':
        $scope.showBoxCastFlowControl = broadcast.boxcaster_id && broadcast.boxcaster_id[0] == "o";
        break;

      default:
        $scope.showBoxCastFlowControl = false;
        break;
    }
  }

  function fixBroadcast() {
    $scope.activeDiagnosticsAlerts = _.filter($scope.broadcast.stream_diagnostics.alerts, function (a) {
      return a.is_active;
    });
    $scope.requestedVideoResolution = $scope.broadcast.requested_video_resolution;
    $scope.actualVideoResolution = $scope.broadcast.actual_video_resolution;

    if ($scope.broadcast.transcoder_profile == '1080p:us') {
      $scope.requestedVideoResolution = 1080;
      $scope.actualVideoResolution = 1080;
    } // Limit graph to 24 hours in duration


    $scope.graphStart = $scope.broadcast.starts_at;
    $scope.graphStop = $scope.broadcast.stops_at;

    if (Date.parse($scope.graphStop) - Date.parse($scope.graphStart) > 1000 * 60 * 60 * 24) {
      console.warn('Limiting graph duration due to exceeding of 24 hour duration');
      $scope.graphStart = moment($scope.graphStop).add(-24, 'hour').format();
    } else {
      console.log('Using entire broadcast duration for graph');
    }
  }

  ;
  $scope.isUndeleting = false;

  $scope.undelete = function () {
    if (confirm('Are you sure you want to undelete this broadcast?')) {
      $scope.isUndeleting = true;
      Broadcast.undelete({
        id: $routeParams.id
      }).$promise.then(function () {
        return $route.reload();
      }, function (e) {
        $scope.isUndeleting = false;
        console.error(e);
        return alert("There was an error undeleting this broadcast. Check the console for more details.");
      });
    }
  };

  $scope.reloadMetadata = function () {
    var tmp = Broadcast.get({
      id: $routeParams.id,
      include_stream_diagnostics: true
    }, function (data) {
      $scope.broadcast = tmp;
      fixBroadcast();
    });
  };

  $scope.settings = {
    preview: false
  };

  $scope.showTicket = function (e) {
    return $location.path("/broadcasts/".concat($routeParams.id, "/tickets/").concat(e.id));
  };

  $scope.openScoreDataPage = function () {
    var isLive = $scope.broadcast.stream_id && !$scope.broadcast.recording_id;
    var from = new Date(Date.parse($scope.broadcast.starts_at));
    var to = isLive ? new Date() : new Date(Date.parse($scope.broadcast.stops_at));
    var streamId = isLive ? $scope.broadcast.stream_id : $scope.broadcast.recording_id;
    $window.open("https://app.datadoghq.com/logs?live=".concat(isLive, "&from_ts=").concat(from.getTime(), "&to_ts=").concat(to.getTime(), "&query=env:").concat(__WEBPACK_IMPORTED_MODULE_0_environment__["f" /* ENV */], "+@stream_id:").concat(streamId, "+service:origin+@tag:origin.scoredecode+\"received new score data\""), "_blank");
  };

  $scope.openScoreWarningsPage = function () {
    var isLive = $scope.broadcast.stream_id && !$scope.broadcast.recording_id;
    var streamId = isLive ? $scope.broadcast.stream_id : $scope.broadcast.recording_id;
    var from = new Date(Date.parse($scope.broadcast.starts_at));
    var to = isLive ? new Date() : new Date(Date.parse($scope.broadcast.stops_at));
    $window.open("https://app.datadoghq.com/logs?live=".concat(isLive, "&from_ts=").concat(from.getTime(), "&to_ts=").concat(to.getTime(), "&query=env:").concat(__WEBPACK_IMPORTED_MODULE_0_environment__["f" /* ENV */], "+@stream_id:").concat(streamId, "+service:origin+@tag:origin.scoredecode+status:warn"), "_blank");
  };

  $scope.adminToken = function (broadcast) {
    var url = broadcast.admin_viewer_url;

    if (!url) {
      return null;
    }

    var parts = url.split('/');

    if (parts.length <= 1) {
      return null;
    }

    return parts[parts.length - 1];
  };

  $scope.impersonate = function () {
    Account.impersonate({
      id: $scope.broadcast.account_id
    }, function (token) {
      var token_type = token.token_type,
          access_token = token.access_token,
          scope = token.scope;
      var path = "/#/events/".concat($scope.broadcast.id);
      window.open("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["d" /* DASHBOARD_URL */], "#").concat(jQuery.param({
        token_type: token_type,
        access_token: access_token,
        scope: scope,
        path: path
      })));
      $rootScope.$broadcast('impersonate_initiated');
    });
  };

  $scope.showAdvancedSettingsAndGraphs = function () {
    return $scope.broadcast.stream_source != 'imported' && $scope.broadcast.stream_source != 'recording';
  };

  $scope.broadcastsUrl = function () {
    return "/broadcasts?f=account:".concat(encodeURIComponent(encodeURIComponent(JSON.stringify({
      active: true,
      id: $scope.broadcast.account_id,
      name: $scope.broadcast.account_name
    }))), "+only_today");
  };

  $scope.recurringSeriesUrl = function () {
    var accountFilter = "account:" + encodeURIComponent(JSON.stringify({
      active: true,
      id: $scope.broadcast.account_id,
      name: $scope.broadcast.account_name
    }));
    var recurrenceIdFilter = "recurrence:" + encodeURIComponent(JSON.stringify({
      active: true,
      id: $scope.broadcast.recurrence.id
    }));
    return "/broadcasts?f=".concat(encodeURIComponent(accountFilter + " " + recurrenceIdFilter));
  };

  $scope.selectSingleTicket = function (ticket) {
    if (!$scope.selectedTickets.includes(ticket)) {
      $scope.selectedTickets.push(ticket);
    } else {
      $scope.selectedTickets = $scope.selectedTickets.filter(function (value) {
        return value.id != ticket.id;
      });
    }

    $scope.selectedTicketTotal = $scope.selectedTickets.length;
  };

  $scope.selectAllPageTickets = function () {
    if (!$scope.selectAll) {
      $scope.deselectAllTickets();
    } else {
      $scope.selectedTickets = $scope.unrefunded;
    }

    $scope.selectedTicketTotal = $scope.selectedTickets.length;
  };

  $scope.selectAllTickets = function () {
    $scope.selectAll = true;

    if (!$scope.queryHasRun) {
      $scope.queryRunning = true;

      var params = _.pick($scope, 'q', 's', 'p');

      params.broadcast_id = $routeParams.id;
      params.l = $scope.soldTicketCount;
      Ticket.query(params, function (data) {
        $scope.totalTickets = data;
        $scope.unrefundedAllTickets = _.where($scope.totalTickets, {
          is_refunded: false
        });
        $scope.queryHasRun = true;
        $scope.queryRunning = false;
        $scope.selectedTickets = $scope.unrefundedAllTickets;
        $scope.selectedTicketTotal = $scope.validTicketCount;
        $scope.allTicketsSelected = true;
      });
    } else {
      $scope.selectedTickets = $scope.unrefundedAllTickets;
      $scope.selectedTicketTotal = $scope.validTicketCount;
      $scope.allTicketsSelected = true;
    }

    ;
  };

  $scope.deselectAllTickets = function () {
    $scope.selectAll = false;
    $scope.selectedTickets = [];
    $scope.allTicketsSelected = false;
  };

  $scope.refundTickets = function () {
    return $modal.open({
      template: __webpack_require__(107),
      controller: 'TicketsRefundFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        tickets: function tickets() {
          return $scope.selectedTickets;
        },
        broadcast: function broadcast() {
          return $scope.broadcast;
        },
        account: function account() {
          return $scope.account;
        },
        channel: function channel() {}
      }
    }).result.then(function () {
      $route.reload();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(28), __webpack_require__(3)))

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/broadcasts?f=only_today\">Broadcasts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ broadcast.name }}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div ng-show=\"broadcast.is_archived\">\n          <button type=\"button\" class=\"btn btn-danger undelete\" ng-disabled=\"isUndeleting\" ng-click=\"undelete()\" style=\"margin-left:15px\">\n            <i class=\"fa fa-undo\" style=\"font-size:15px\"></i>\n            {{ isUndeleting ? 'Undeleting broadcast' : 'Undelete broadcast' }}\n          </button>\n        </div>\n\n        <div ng-show=\"broadcast.channel_id && !broadcast.is_archived\">\n          <app-player channel-id=\"broadcast.channel_id\" ticket-id=\"adminToken(broadcast)\" reload=\"channelUpdated\" on-refresh=\"reloadMetadata\" />\n        </div>\n\n        <div ng-if=\"broadcast.timeframe == 'current' && broadcast.status.startsWith('stalled')\">\n          <p class=\"help-block\" ng-if=\"broadcast.status.endsWith(':5') && broadcast.status.indexOf('offline') < 0\">\n            <em>If this broadcast gets stuck at 5%, it often means the BoxCaster is being used for another broadcast.\n            <a href=\"{{ broadcastsUrl() }}\">Show Account Broadcasts</a>\n            </em>\n          </p>\n          <p class=\"help-block\" ng-if=\"broadcast.status.endsWith(':10')\">\n            <em>If this broadcast gets stuck at 10%, it might mean that the origin is having issues coming online.</em>\n          </p>\n          <p class=\"help-block\" ng-if=\"broadcast.status.endsWith(':20')\">\n            <em>If this broadcast gets stuck at 20%, we are waiting for the BoxCaster to report its configuration.</em>\n          </p>\n          <p class=\"help-block\" ng-if=\"broadcast.status.endsWith(':40')\">\n            <em>If this broadcast gets stuck at 40%, we are waiting for the Origin to report its configuration.</em>\n          </p>\n          <p class=\"help-block\" ng-if=\"broadcast.stream_source == 'rtmp' && broadcast.status.endsWith(':90')\">\n            <em>If this broadcast gets stuck at 90%, we are waiting for the RTMP encoder to send video packets.</em>\n          </p>\n        </div>\n\n        <div ng-show=\"broadcast.scoreboard_configuration.sport && broadcast.origin_version\">\n          <hr>\n          <a href=\"javascript:void(0)\" ng-click=\"openScoreWarningsPage()\">\n            <i class=\"fa fa-external-link\"></i>\n            Score Overlay Warnings\n          </a>\n          <br/>\n          <a href=\"javascript:void(0)\" ng-click=\"openScoreDataPage()\">\n            <i class=\"fa fa-external-link\"></i>\n            Score Overlay Data\n          </a>\n        </div>\n      </div>\n    </div>\n    <div ng-if=\"broadcast.origin_version < 5 && broadcast.origin_name\" class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Origin Server</h3>\n      </div>\n      <div class=\"panel-body\">\n        <img ng-if=\"origin_thumbnail\" ng-src=\"{{ origin_thumbnail }}\" class=\"img-responsive img-thumbnail pull-right\" style=\"width:50%\">\n        <a href=\"/origins/{{ broadcast.origin_name }}\"><h4>{{ broadcast.origin_name }}</h4></a>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <div class=\"bg-danger text-danger\" ng-if=\"broadcast.is_limited_by_active_stream_count\" style=\"padding:10px;border:1px solid;margin-bottom:15px;\">\n      This broadcast is waiting for other live broadcasts to end (max simultaneous limit reached or exceeded)\n    </div>\n    <h4>{{ broadcast.name }}</h4>\n    <ol class=\"list-inline\">\n      <li>\n        <span class=\"label\" ng-class=\"{\n          'label-danger': broadcast.status == 'live',\n          'label-default': broadcast.status != 'live'\n        }\">\n          {{ broadcast.status }}\n        </span>\n      </li>\n      <li ng-if=\"broadcast.is_archived\">\n        <span class=\"label label-danger\">\n          <i class=\"fa fa-trash\"></i> Deleted\n        </span>\n      </li>\n      <li>\n        <span class=\"label\" ng-class=\"{\n          'label-danger': broadcast.status == 'live',\n          'label-default': broadcast.status != 'live'\n        }\">\n          {{ broadcast | accessibility }}\n        </span>\n      </li>\n      <li ng-if=\"broadcast.is_ticketed\">\n        <span class=\"badge\">\n          {{ broadcast.ticket_price | currency }}\n        </span>\n      </li>\n    </ol>\n    <table class=\"table table-striped table-condensed\">\n      <tr>\n        <th class=\"col-xs-2\">Date/Time</th>\n        <td>\n          {{ [broadcast.starts_at, broadcast.stops_at] | datespan }}\n          <span ng-if=\"broadcast.recurrence && broadcast.recurrence.broadcasts && broadcast.recurrence.broadcasts.length\">(part of <a href=\"{{ recurringSeriesUrl() }}\">a series of {{ broadcast.recurrence.broadcasts.length + 1 }} recurring broadcasts</a>)</span>\n        </td>\n      </tr>\n      <tr>\n        <th>Account</th>\n        <td>\n          <a href=\"{{ newAdminURL }}/accounts/{{ broadcast.account_id }}\">{{ broadcast.account_name }}</a>\n          <button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"impersonate()\" style=\"margin-left:15px\" tooltip=\"Impersonate account and view broadcast on dashboard\">\n            <i class=\"fa fa-user-secret\" style=\"font-size:15px\"></i>\n          </button>\n        </td>\n      </tr>\n      <tr><th>Description</th><td><p ng-repeat=\"e in broadcast.description.split('\\n\\n')\">{{ e }}</p></td></tr>\n      <tr>\n        <th>Analytics</th>\n        <td>\n          Active: {{ broadcast.total_active_viewer_count | number }};\n          Total Views: {{ broadcast.total_view_count | number }};\n          Total Mins: {{ broadcast.total_minutes_viewed | number }}\n        </td>\n      </tr>\n      <tr>\n        <th>Stream Source</th>\n        <td>\n          <a ng-show=\"broadcast.boxcaster_id\" href=\"/boxcasters/{{broadcast.boxcaster_id}}\">BoxCaster: {{ broadcast | boxcasterName }}</a>\n          <span ng-hide=\"broadcast.boxcaster_id\">{{ broadcast | boxcasterName }}</span>\n          <a ng-if=\"broadcast.stream_source == 'rtmp' && broadcast.static_rtmp_id\" href=\"/accounts/{{broadcast.account_id}}/static_rtmps/{{broadcast.static_rtmp_id}}\">RTMP Source: {{ broadcast.static_rtmp_name }}</a>\n          <div ng-if=\"broadcast.stream_source == 'rtmp' && !broadcast.static_rtmp_id\">\n            Single-Use RTMP\n          </div>\n          <div ng-if=\"broadcast.stream_source == 'imported'\">\n            Imported\n            <span ng-if=\"upload\">\n              from <code>{{ upload.filename }}</code> on {{ upload.created_at | date: 'MM/dd/yyyy hh:mm a' }}\n            </span>\n          </div>\n          <div ng-if=\"broadcast.stream_source == 'recording'\">\n            Simulated Live of <a ng-href=\"/broadcasts/{{broadcast.source_broadcast_id}}\">Broadcast {{ broadcast.source_broadcast_id }}</a>\n          </div>\n          <button class=\"pull-right btn btn-sm btn-default\"\n                  ng-if=\"broadcast.rtmp_preview_url\"\n                  ng-click=\"settings.preview = true\">Preview</button>\n        </td>\n      </tr>\n      <tr ng-if=\"broadcast.stream_source != 'imported' && upload\">\n        <th>Replacement</th>\n        <td>\n          Upload {{ upload.status }}\n          <span ng-if=\"upload.status == 'processing'\">({{ upload.progress }}%)</span>\n          <span ng-if=\"upload.filename\"> from <code>{{ upload.filename }}</code></span>\n          on {{ upload.created_at | date: 'MM/dd/yyyy hh:mm a' }}\n        </td>\n      </tr>\n      <tr ng-if=\"settings.preview\">\n        <th>Low Latency Preview</th>\n        <td class=\"text-center\">\n          <div class=\"low-latency-wrapper\">\n            <low-latency-player broadcast=\"broadcast\"></low-latency-player>\n            <button class=\"btn btn-link close-btn\" ng-click=\"settings.preview = false\">&times;</button>\n          </div>\n        </td>\n      </tr>\n      <tr>\n        <th>Admin Show URL</th>\n        <td>\n          <a href=\"{{ broadcast.admin_viewer_url }}\" target=\"_blank\">{{ broadcast.admin_viewer_url }}</a>\n        </td>\n      </tr>\n      <tr ng-show=\"broadcast.scoreboard_configuration.sport\">\n        <th>Scoreboard Config</th>\n        <td>\n          Sport: {{broadcast.scoreboard_configuration.sport}};\n          Make: {{broadcast.scoreboard_configuration.scoreboard_make ? broadcast.scoreboard_configuration.scoreboard_make : '(None)'}};\n          Model: {{broadcast.scoreboard_configuration.scoreboard_model ? broadcast.scoreboard_configuration.scoreboard_model : '(None)'}}\n        </td>\n      </tr>\n      <tr ng-show=\"broadcast.simulcast_configurations && broadcast.simulcast_configurations.length > 0\">\n        <th>Simulcasts</th>\n        <td>\n          <div ng-repeat=\"cfg in broadcast.simulcast_configurations\">\n            <span ng-switch=\"cfg.destination\">\n              <span ng-switch-when=\"facebook\" ng-bind-html=\"cfg | facebookLiveSettings\"></span>\n              <span ng-switch-when=\"periscope\" ng-bind-html=\"cfg | periscopeSettings\"></span>\n              <span ng-switch-when=\"twitter\" ng-bind-html=\"cfg | twitterSettings\"></span>\n              <span ng-switch-when=\"youtube\" ng-bind-html=\"cfg | youtubeLiveSettings\"></span>\n              <span ng-switch-when=\"generic\" ng-bind-html=\"cfg | genericRtmpPushSettings\"></span>\n              <span ng-switch-when=\"rtmp_push_channel\" ng-bind-html=\"cfg | rtmpPushChannelPushSettings\"></span>\n            </span>\n          </div>\n        </td>\n      </tr>\n    </table>\n\n    <div class=\"panel panel-default\" ng-if=\"showAdvancedSettingsAndGraphs()\">\n      <div class=\"panel-heading\">Advanced Settings</div>\n      <div class=\"panel-body\" style=\"padding: 0px; position: relative;\">\n        <table class=\"table\" style=\"width: 100%; margin: 0px;\">\n          <tr ng-show=\"broadcast.requested_video_resolution || broadcast.actual_video_resolution\">\n            <th>Video Resolution</th>\n            <td>\n              <span ng-show=\"broadcast.requested_video_resolution\">Requested: {{ requestedVideoResolution }};</span>\n              <span ng-show=\"broadcast.actual_video_resolution\">Actual: {{ actualVideoResolution }}</span>\n            </td>\n            <th>High Frame Rate</th>\n            <td>\n              <span ng-show=\"broadcast.requested_high_frame_rate !== ''\">\n                Requested: {{ broadcast.requested_high_frame_rate | highFrameRate }}\n              </span>\n              <span ng-show=\"broadcast.actual_high_frame_rate !== ''\">\n                Actual: {{ broadcast.actual_high_frame_rate | highFrameRate }}\n              </span>\n            </td>\n          </tr>\n          <tr ng-show=\"(broadcast.backhaul_protocol == 'rtp')\">\n            <th>Video Bitrate</th>\n            <td>\n              <span ng-show=\"broadcast.requested_video_bitrate\">Requested: {{ broadcast.requested_video_bitrate }};</span>\n              <span ng-show=\"broadcast.actual_video_bitrate\">Actual: {{ broadcast.actual_video_bitrate }}</span>\n            </td>\n            <th>Audio Bitrate</th>\n            <td>\n              <span ng-show=\"broadcast.requested_audio_bitrate\">Requested: {{ broadcast.requested_audio_bitrate }};</span>\n              <span ng-show=\"broadcast.actual_audio_bitrate\">Actual: {{ broadcast.actual_audio_bitrate }}</span>\n            </td>\n          </tr>\n          <tr ng-show=\"broadcast.backhaul_protocol != 'rtp'\">\n            <th>Target Video Bitrate</th>\n            <td ng-show=\"broadcast.requested_video_bitrate != '' && broadcast.requested_video_bitrate != 'auto'\">{{ broadcast.requested_video_bitrate | metricPrefix:'bps' }}</td>\n            <td ng-show=\"broadcast.requested_video_bitrate == '' || broadcast.requested_video_bitrate == 'auto'\">auto</td>\n            <th>Target Audio Bitrate</th>\n            <td ng-show=\"broadcast.requested_audio_bitrate != '' && broadcast.requested_audio_bitrate != 'auto'\">{{ broadcast.requested_audio_bitrate | metricPrefix:'bps' }}</td>\n            <td ng-show=\"broadcast.requested_audio_bitrate == '' || broadcast.requested_audio_bitrate == 'auto'\">auto</td>\n          </tr>\n          <tr>\n            <th>Backhaul Protocol</th>\n            <td>{{ broadcast.backhaul_protocol }} (to Origin v{{ broadcast.origin_version }})</td>\n            <th>Backhaul Video Codec</th>\n            <td>\n              <span ng-show=\"broadcast.requested_codec\">Requested: {{ broadcast.requested_codec }};</span>\n              <span ng-show=\"broadcast.actual_codec\">Actual: {{ broadcast.actual_codec }}</span>\n            </td>\n          </tr>\n          <tr ng-show=\"showBoxCastFlowControl\">\n            <th>BoxCast Flow Control</th>\n            <td>{{ [broadcast.requested_buffer_latency, broadcast.target_buffer_latency] | boxcastFlowControl }}</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n\n    <div class=\"panel panel-default\" ng-if=\"broadcast.timeframe == 'current'\">\n      <div class=\"panel-heading\">\n        Diagnostics\n        <small class=\"pull-right\">Updated {{broadcast.stream_diagnostics.updated_at|date:'medium'}}</small>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"row\">\n          <div class=\"col-sm-2\">\n            <h3 style=\"margin-top:0\" class=\"diagnostics-label--{{broadcast.stream_diagnostics.status}}\">{{broadcast.stream_diagnostics.status}}</h3>\n          </div>\n          <div class=\"col-sm-10\">\n            <div ng-if=\"!activeDiagnosticsAlerts.length\">\n              <p>No Active Alerts</p>\n            </div>\n            <div ng-if=\"activeDiagnosticsAlerts.length\">\n              <ul class=\"list-unstyled\">\n                <li ng-repeat=\"a in activeDiagnosticsAlerts\">{{a.message}} - {{a.status}} since {{a.detected_at|date:'medium'}}</li>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <p class=\"help-block\" ng-if=\"showAdvancedSettingsAndGraphs()\" ng-show=\"broadcast.starts_at && graphStart != broadcast.starts_at\">\n      <em>The graph durations have been limited to the most recent 24 hours.</em>\n    </p>\n\n    <broadcast-graph ng-if=\"showAdvancedSettingsAndGraphs() && broadcast.stream_id && !broadcast.recording_id\"\n                     stream-id=\"{{ broadcast.stream_id }}\"\n                     broadcast-id=\"{{ broadcast.id }}\"\n                     streamed-at=\"{{ broadcast.streamed_at }}\"\n                     is-live=\"true\"\n                     starts-at=\"{{ graphStart }}\"\n                     stops-at=\"{{ graphStop }}\"\n                     origin-version=\"{{ broadcast.origin_version }}\"\n                     is-rtmp=\"{{ broadcast.stream_source =='rtmp' || broadcast.stream_source =='switcher' }}\"></broadcast-graph>\n    <broadcast-graph ng-if=\"showAdvancedSettingsAndGraphs() && broadcast.recording_id\"\n                     stream-id=\"{{ broadcast.recording_id }}\"\n                     broadcast-id=\"{{ broadcast.id }}\"\n                     is-live=\"false\"\n                     streamed-at=\"{{ broadcast.streamed_at }}\"\n                     starts-at=\"{{ graphStart }}\"\n                     stops-at=\"{{ graphStop }}\"\n                     origin-version=\"{{ broadcast.origin_version }}\"\n                     is-rtmp=\"{{ broadcast.stream_source =='rtmp' || broadcast.stream_source =='switcher' }}\"></broadcast-graph>\n    <broadcaster-graph ng-if=\"showAdvancedSettingsAndGraphs() && broadcast.stream_source =='app' && broadcast.starts_at && broadcast.stops_at\"\n                       stream-id=\"{{ broadcast.stream_id }}\" starts-at=\"{{ graphStart }}\" stops-at=\"{{ graphStop }}\"></broadcaster-graph>\n    <backhaul-graph ng-if=\"showAdvancedSettingsAndGraphs() && broadcast.boxcaster_id && broadcast.backhaul_protocol && (broadcast.backhaul_protocol.slice(0, 3) == 'bbp') && broadcast.starts_at && broadcast.stops_at\"\n                    boxcaster-id=\"{{ broadcast.boxcaster_id }}\" starts-at=\"{{ graphStart }}\" stops-at=\"{{ graphStop }}\"></backhaul-graph>\n\n    <div ng-show=\"broadcast.is_ticketed || (tickets.length > 0)\">\n      <hr>\n      <h4>Tickets\n        ({{ soldTicketCount }} sold, {{ refundedTotal }} refunded)\n        &emsp; <span ng-show=\"tickets.length && refundedTotal\" class=\"badge\">{{ netTicketRevenue | currency }} After Refunds</span>\n        &emsp; <span ng-show=\"tickets.length\" class=\"badge\">{{ totalTicketRevenue | currency }} Total</span>\n        <button class=\"btn btn-danger pull-right btn-sm\" ng-if=\"!queryRunning\" ng-disabled=\"!selectedTickets.length\" ng-click=\"refundTickets()\">Refund Tickets</button>\n        <button class=\"btn btn-danger pull-right btn-sm\" ng-if=\"queryRunning\">Grabbing Tickets...</button>\n      </h4>\n      <h4 ng-if=\"!selectedTickets.length\"><b>{{ validTicketCount }} tickets available</b></h4>\n      <h4 ng-if=\"selectedTickets.length && (soldTicketCount > defaultPageLength) && !allTicketsSelected\">\n        <b>{{ selectedTicketTotal }} tickets selected</b> of {{ validTicketCount }} available\n        &emsp;<a href=\"#\" *ng-if=\"selectedTickets.length > defaultPageLength\" ng-click=\"selectAllTickets()\">Select all {{ validTicketCount }} </a>\n      </h4>\n      <h4 ng-if=\"allTicketsSelected\">\n        <b>{{ selectedTicketTotal }} tickets selected</b> of {{ validTicketCount }}\n        &emsp; <a href=\"#\" ng-click=\"deselectAllTickets()\">Clear Selection</a>\n      </h4>\n      <table class=\"table table-striped table-hover table-condensed\">\n        <thead>\n          <tr>\n            <th class=\"col-xs-1\"><input type=\"checkbox\" ng-disabled=\"unrefunded.length < 1\" ng-model=\"selectAll\" ng-change=\"selectAllPageTickets()\"/></th>\n            <th class=\"col-xs-2 clickable\" ng-click=\"sort('created_at')\">\n              Purchased\n              <i class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'created_at'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-created_at'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-3 clickable\" ng-click=\"sort('name')\">\n              Name\n              <i class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-3 clickable\" ng-click=\"sort('email')\">\n              Email\n              <i class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'email'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-email'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-2 clickable\" ng-click=\"sort('invoice_handle')\">\n              Invoice\n              <i class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'invoice_handle'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-invoice_handle'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-1\">Amount</th>\n            <th class=\"col-xs-1\">Email Suppressed?</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"ticket in tickets\"\n              class=\"clickable\"\n              ng-style=\"{color:ticket.is_refunded?'rgba(0,0,0,0.4)':'inherit'}\">\n            <td class=\"col-xs-1\">\n              <input ng-if=\"!ticket.is_refunded\" type=\"checkbox\" ng-disabled=\"allTicketsSelected\" ng-model=\"ticket.selected\" ng-click=\"selectSingleTicket(ticket)\" ng-checked=\"selectAll\" />\n              <span ng-if=\"ticket.is_refunded\">-</span>\n            </td>\n            <td ng-click=\"showTicket(ticket)\">{{ ticket.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td>\n            <td ng-click=\"showTicket(ticket)\">{{ ticket.name }}</td>\n            <td ng-click=\"showTicket(ticket)\">{{ ticket.email }}</td>\n            <td ng-click=\"showTicket(ticket)\">{{ ticket.invoice_handle }}</td>\n            <td ng-click=\"showTicket(ticket)\">\n              <span ng-hide=\"ticket.is_refunded\">\n                {{ ticket.price|currency }}\n              </span>\n              <span ng-show=\"ticket.is_refunded\">\n                <strike>{{ ticket.price|currency }}</strike> <span class=\"badge\">Refunded</span>\n              </span>\n            </td>\n            <td ng-click=\"showTicket(ticket)\"><i ng-show=\"ticket.suppressed_reason\" class=\"fa fa-ban\" style=\"color:red\" aria-hidden=\"true\"></i></td>\n          </tr>\n        </tbody>\n      </table>\n      <app-pagination />\n    </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__broadcasts_scss__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__broadcasts_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__broadcasts_scss__);




angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/broadcasts', {
    template: __webpack_require__(240),
    controller: 'BroadcastsController'
  });
}]).controller('BroadcastsController', ["$scope", "$location", "Broadcast", function ($scope, $location, Broadcast) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = 'starts_at');
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];

  var params = _.pick($scope, 'q', 's', 'p');

  var query = $location.search();
  $scope.timeframe = query.timeframe || 'all';

  switch ($scope.timeframe) {
    case 'today':
      var todayRange = new Date().todayRangeUTC();
      params.q = "+starts_at:[".concat(todayRange.from, " TO ").concat(todayRange.to, "] ").concat(params.q || '').trim();
      break;

    case 'specific_date':
      var ms = Date.parse(query.specific_date);

      if (!isNaN(ms)) {
        $scope.specific_date = new Date(ms);
        var dayRange = $scope.specific_date.rangeUTC();
        var dayRangeQuery = "[".concat(dayRange.from, " TO ").concat(dayRange.to, "]");
        params.q = "+starts_at:".concat(dayRangeQuery, " ").concat(params.q || '').trim();
      }

      break;

    case 'upcoming':
      params.q = "+timeframe:future ".concat(params.q || '').trim();
      break;

    case 'recent':
      params.q = "+timeframe:relevant ".concat(params.q || '').trim();
      break;
  }

  $scope.setTimeframe = function (t) {
    var params = {
      timeframe: t,
      p: 0,
      f: $scope.getFilterParam(),
      s: $scope.s,
      q: query.q
    };

    if (t == 'recent') {
      params.s = '-starts_at';
    } else if (t == 'upcoming') {
      params.s = 'starts_at';
    }

    $location.search(params);
  };

  $scope.filterDate = function (date) {
    $location.search({
      timeframe: 'specific_date',
      specific_date: date,
      p: 0,
      f: $scope.getFilterParam(),
      s: $scope.s
    });
  };

  if (!$scope.f.include_archived) {
    params['filter.include_archived'] = 'false';
  }

  if ($scope.f.account && $scope.f.account.active) {
    params['filter.account_id'] = $scope.f.account.id;
  }

  if ($scope.f.recurrence && $scope.f.recurrence.active) {
    params['filter.recurrence_id'] = $scope.f.recurrence.id;
  }

  params.include_stream_diagnostics = true;
  $scope.loading = true;
  $scope.broadcasts = Broadcast.query(params, function (data, getResponseHeader) {
    var pagination = getResponseHeader('X-Pagination');
    $scope.pagination = pagination ? JSON.parse(pagination) : {};
    return $scope.loading = false;
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n\n  <div class=\"col-md-3 table-animate-aside\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Broadcasts</h3>\n      </div>\n      <div class=\"panel-body\">\n\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by Name\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n        <div class=\"checkbox\">\n          <label><input type=\"checkbox\" ng-checked=\"f.include_archived\" ng-click=\"filter('include_archived', !f.include_archived)\"> Include Deleted</label>\n        </div>\n\n        <hr>\n        <h5>Timeframe</h5>\n        <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: timeframe=='all'}\" ng-click=\"setTimeframe('all')\">All</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: timeframe=='today'}\" ng-click=\"setTimeframe('today')\">Today</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: timeframe=='upcoming'}\" ng-click=\"setTimeframe('upcoming')\">Future</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: timeframe=='recent'}\" ng-click=\"setTimeframe('recent')\">Recent</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: timeframe=='specific_date'}\" ng-click=\"timeframe = 'specific_date'\">On Date...</button>\n        </div>\n\n\n        <div class=\"form-group\" ng-show=\"timeframe=='specific_date'\">\n          <p style=\"margin:15px 0 0 0\">Select Date</p>\n          <input id=\"specific_date\" type=\"text\"\n                 ng-model=\"specific_date\"\n                 datepicker-popup=\"MM/dd/yyyy\"\n                 is-open=\"specificDateIsOpen\"\n                 ng-click=\"specificDateIsOpen=true\"\n                 ng-change=\"filterDate(specific_date)\"\n                 class=\"form-control\">\n        </div>\n\n        <div ng-show=\"f.account\">\n          <hr>\n          <h5>Filter by Account</h5>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"f.account.active\" ng-click=\"filter('account.active', !f.account.active)\"> {{ f.account.name }}</label>\n          </div>\n        </div>\n\n        <div ng-show=\"f.recurrence\">\n          <hr>\n          <h5>Filter by Recurring Series</h5>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"f.recurrence.active\" ng-click=\"filter('recurrence.active', !f.recurrence.active)\"> Series ID: {{ f.recurrence.id }}</label>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"loading\" class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n  \n  <div ng-if=\"!loading\" class=\"col-md-9\">\n    <div>\n      <table class=\"table table-striped table-light-border table-animate table-hover table-condensed\">\n        <thead>\n          <tr>\n            <th ng-click=\"sort('starts_at')\" class=\"clickable col-xs-2\">\n              Date/Time\n              <i ng-show=\"s.indexOf('starts_at') === -1\" class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'starts_at'\" class=\"fa fa-sort-numeric-asc\"></i>\n              <i ng-show=\"s === '-starts_at'\" class=\"fa fa-sort-numeric-desc\"></i>\n            </th>\n            <th class=\"col-xs-2\">Status</th>\n            <th ng-click=\"sort('name')\" class=\"clickable col-xs-3\">\n              Name\n              <i ng-show=\"s.indexOf('name') === -1\" class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-1\">Sport</th>\n            <th class=\"col-xs-1\">Make</th>\n            <th class=\"col-xs-1\">Type</th>\n            <th class=\"col-xs-1\">Source</th>\n            <th class=\"col-xs-1\">Profile</th>\n            <th class=\"col-xs-1\">Stats</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-if=\"!loading && !broadcasts.length\" class=\"tr--no-results\"><td colspan=\"7\">No broadcasts to display.</td></tr>\n          <tr ng-repeat=\"b in broadcasts\" ng-click=\"openURL('{{ newAdminURL }}/broadcasts/'+b.id, $event)\"\n              class=\"clickable\"\n              ng-style=\"{'background-color': b.is_archived ? 'rgba(255,0,0,0.05)' : 'inherit'}\"\n              >\n            <td style=\"padding-left:10px\">\n              <i ng-if=\"::b.is_archived\" class=\"fa fa-minus-circle broadcast-deleted\" aria-hidden=\"true\" tooltip=\"Deleted Broadcast\" tooltip-append-to-body=\"true\"></i>\n              <small>{{ [b.starts_at, b.stops_at] | datespan }}</small>\n            </td>\n            <td>\n              <dash-status dash-status=\"{{ ::b.status }}\"\n                           diagnostic-status=\"{{ ::(b.stream_diagnostics.summary_status || b.stream_diagnostics.status) }}\"\n                           broadcast=\"::b\"\n                           bottom-row=\"true\"></dash-status>\n            </td>\n            <td>\n              {{ ::b.name }}\n              <div><small>{{ ::b.account_name }}</small></div>\n            </td>\n            <td class=\"icon-{{ ::b.scoreboard_configuration.sport_icon }}\" tooltip=\"{{ ::b.scoreboard_configuration.sport }}\" tooltip-append-to-body=\"true\"></td>\n            <td class=\"icon-{{ ::b.scoreboard_configuration.make_icon }}\" tooltip=\"{{ ::b.scoreboard_configuration | scoreboardMakeModel }}\" tooltip-append-to-body=\"true\"></td>\n            <td>\n              {{ ::b | accessibility }}\n            </td>\n            <td class=\"icon-{{ ::b.stream_source }}\" tooltip=\"{{ ::b.stream_source | source }}\" tooltip-append-to-body=\"true\"></td>\n            <td>\n              <span class=\"label label-info\">{{ ::b.transcoder_profile | transcoderProfile }}</span>\n            </td>\n            <td style=\"padding-right:0\">\n              <table class=\"stats-column-table\">\n                  <tbody>\n                      <tr class=\"row top-row\">\n                          <td class=\"col-xs-4\">{{ ::b.total_active_viewer_count | number }}</td>\n                          <td class=\"col-xs-4\">{{ ::b.total_view_count | number }}</td>\n                          <td class=\"col-xs-4\">{{ ::b.sold_ticket_count | number }}</td>\n                      </tr>\n                      <tr class=\"row bottom-row\">\n                          <td class=\"col-xs-4\">Active</td>\n                          <td class=\"col-xs-4\">Total</td>\n                          <td class=\"col-xs-4\">Sold</td>\n                      </tr>\n                  </tbody>\n              </table>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <app-pagination />\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__broadcast_tickets_refund_form_controller__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__broadcast_tickets_refund_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__broadcast_tickets_refund_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/channels/:id', {
    template: __webpack_require__(242),
    controller: 'ChannelController'
  });
}]).controller('ChannelController', ["$scope", "$location", "$route", "$routeParams", "$modal", "Account", "AccountChannel", "ChannelTicket", function ($scope, $location, $route, $routeParams, $modal, Account, AccountChannel, ChannelTicket) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.account = Account.get({
    id: $routeParams.account_id
  });
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];
  $scope.defaultPageLength = 50;
  $scope.channel = AccountChannel.get({
    account_id: $routeParams.account_id,
    id: $routeParams.id
  }, function (data) {
    if (data.is_ticketed) {
      $scope.soldTicketCount = $scope.channel.sold_ticket_count;
      $scope.selectedTickets = [];
      $scope.selectAll = false;
      $scope.validTicketCount = 0;
      $scope.selectedTicketTotal = 0;
      $scope.queryHasRun = false;
      $scope.queryRunning = false;

      var params = _.pick($scope, 'q', 's', 'p');

      params.channel_id = $routeParams.id;
      params.l = $scope.defaultPageLength;
      ChannelTicket.query(params, function (data, getResponseHeader) {
        $scope.tickets = data;
        $scope.unrefunded = _.where($scope.tickets, {
          is_refunded: false
        });
        $scope.totalTicketRevenue = _.reduce($scope.tickets, function (m, t) {
          return m + t.price;
        }, 0.0);
        $scope.netTicketRevenue = _.reduce($scope.unrefunded, function (m, t) {
          return m + t.price;
        }, 0.0);
        $scope.refundedTotal = $scope.tickets.length - $scope.unrefunded.length;
        $scope.validTicketCount = $scope.soldTicketCount - $scope.refundedTotal;
        var pagination = getResponseHeader('X-Pagination');
        $scope.pagination = pagination ? JSON.parse(pagination) : {};
      });

      $scope.selectSingleTicket = function (ticket) {
        if (!$scope.selectedTickets.includes(ticket)) {
          $scope.selectedTickets.push(ticket);
        } else {
          $scope.selectedTickets = $scope.selectedTickets.filter(function (value, index, arr) {
            return value != ticket;
          });
        }

        $scope.selectedTicketTotal = $scope.selectedTickets.length;
      };

      $scope.selectAllPageTickets = function () {
        if (!$scope.selectAll) {
          $scope.deselectAllTickets();
        } else {
          $scope.selectedTickets = $scope.unrefunded;
        }

        $scope.selectedTicketTotal = $scope.selectedTickets.length;
      };

      $scope.selectAllTickets = function () {
        $scope.selectAll = true;

        if (!$scope.queryHasRun) {
          $scope.queryRunning = true;
          $scope.l = $scope.soldTicketCount;
          ChannelTicket.query({
            channel_id: $routeParams.id,
            l: $scope.l
          }, function (data) {
            $scope.totalTickets = data;
            $scope.unrefundedAllTickets = _.where($scope.totalTickets, {
              is_refunded: false
            });
            $scope.queryHasRun = true;
            $scope.queryRunning = false;
            $scope.selectedTickets = $scope.unrefundedAllTickets;
            $scope.selectedTicketTotal = $scope.validTicketCount;
            $scope.allTicketsSelected = true;
          });
        } else {
          $scope.selectedTickets = $scope.unrefundedAllTickets;
          $scope.selectedTicketTotal = $scope.validTicketCount;
          $scope.allTicketsSelected = true;
        }
      };

      $scope.deselectAllTickets = function () {
        $scope.selectAll = false;
        $scope.selectedTickets = [];
        $scope.allTicketsSelected = false;
        $scope.selectAll = false;
      };

      $scope.refundTickets = function () {
        return $modal.open({
          template: __webpack_require__(107),
          controller: 'TicketsRefundFormController',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            tickets: function tickets() {
              return $scope.selectedTickets;
            },
            channel: function channel() {
              return $scope.channel;
            },
            account: function account() {
              return $scope.account;
            },
            broadcast: function broadcast() {}
          }
        }).result.then(function () {
          $route.reload();
        });
      };
    }
  });
  return $scope.showTicket = function (e) {
    return $location.path("/accounts/".concat($routeParams.account_id, "/channels/").concat($routeParams.id, "/tickets/").concat(e.id));
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a>\n        </h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a\n            href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ channel.name }}</h3>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <h4>{{ channel.name }}</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr>\n        <th>Description</th>\n        <td>\n          <p ng-repeat=\"e in channel.description.split('\\n\\n')\">{{ e }}</p>\n        </td>\n      </tr>\n      <tr>\n        <th>Accessibility</th>\n        <td>{{ channel | accessibility }} &emsp; <span ng-show=\"channel.is_ticketed\" class=\"badge\">{{\n            channel.ticket_price | currency }}</span></td>\n      </tr>\n      <tr>\n        <th>Admin Show URL</th>\n        <td>\n          <a href=\"{{ channel.admin_viewer_url.replace('/view/', '/channel/') }}\" target=\"_blank\">{{\n            channel.admin_viewer_url.replace('/view/', '/channel/') }}</a>\n        </td>\n      </tr>\n    </table>\n    <div ng-show=\"channel.is_ticketed\">\n      <hr>\n      <h4>Tickets\n        ({{ soldTicketCount }} sold, {{ refundedTotal }} refunded)\n        &emsp; <span ng-show=\"tickets.length && refundedTotal\" class=\"badge\">{{ netTicketRevenue | currency }} After\n          Refunds</span>\n        &emsp; <span ng-show=\"tickets.length\" class=\"badge\">{{ totalTicketRevenue | currency }} Total</span>\n        <button class=\"btn btn-danger pull-right btn-sm\" ng-if=\"!queryRunning\" ng-disabled=\"!selectedTickets.length\"\n          ng-click=\"refundTickets()\">Refund Tickets</button>\n        <button class=\"btn btn-danger pull-right btn-sm\" ng-if=\"queryRunning\">Grabbing Tickets...</button>\n      </h4>\n      <h4 ng-if=\"!selectedTickets.length\"><b>{{ validTicketCount }} tickets available</b></h4>\n      <h4 ng-if=\"selectedTickets.length && (soldTicketCount > defaultPageLength) && !allTicketsSelected\">\n        <b>{{ selectedTicketTotal }} tickets selected</b> of {{ validTicketCount }} available\n        &emsp; <a href=\"#\" *ng-if=\"selectedTickets.length > defaultPageLength\" ng-click=\"selectAllTickets()\">Select all\n          {{ validTicketCount }} </a>\n      </h4>\n      <h4 ng-if=\"allTicketsSelected\">\n        <b>{{ selectedTicketTotal }} tickets selected</b> of {{ validTicketCount }}\n        &emsp; <a href=\"#\" ng-click=\"deselectAllTickets()\">Clear Selection</a>\n      </h4>\n      <table class=\"table table-striped table-hover table-condensed\">\n        <thead>\n          <tr>\n            <th class=\"col-xs-1\"><input type=\"checkbox\" ng-disabled=\"unrefunded.length < 1\" ng-model=\"selectAll\"\n                ng-change=\"selectAllPageTickets()\" /></th>\n            <th class=\"col-xs-2 clickable\" ng-click=\"sort('created_at')\">\n              Purchased\n              <i ng-show=\"s.indexOf('created_at') === -1\" class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'created_at'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-created_at'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-3 clickable\" ng-click=\"sort('name')\">\n              Name\n              <i ng-show=\"s.indexOf('name') === -1\" class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-3 clickable\" ng-click=\"sort('email')\">\n              Email\n              <i ng-show=\"s.indexOf('email') === -1\" class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'email'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-email'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-2 clickable\" ng-click=\"sort('invoice_handle')\">\n              Invoice\n              <i ng-show=\"s.indexOf('invoice_handle') === -1\" class=\"fa fa-sort\"></i>\n              <i ng-show=\"s === 'invoice_handle'\" class=\"fa fa-sort-alpha-asc\"></i>\n              <i ng-show=\"s === '-invoice_handle'\" class=\"fa fa-sort-alpha-desc\"></i>\n            </th>\n            <th class=\"col-xs-2\">Amount</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"e in tickets\" class=\"clickable\">\n            <td class=\"col-xs-1\">\n              <input ng-if=\"!e.is_refunded\" type=\"checkbox\" ng-disabled=\"allTicketsSelected\" ng-model=\"selectAll\"\n                ng-change=\"selectSingleTicket(e)\" ng-checked=\"selectAll\" />\n              <span ng-if=\"e.is_refunded\">-</span>\n            </td>\n            <td ng-click=\"showTicket(e)\">{{ e.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td>\n            <td ng-click=\"showTicket(e)\">{{ e.name }}</td>\n            <td ng-click=\"showTicket(e)\">{{ e.email }}</td>\n            <td ng-click=\"showTicket(e)\">{{ e.invoice_handle }}</td>\n            <td ng-click=\"showTicket(e)\">\n              <span ng-hide=\"e.is_refunded\">\n                {{ e.price|currency }}\n              </span>\n              <span ng-show=\"e.is_refunded\">\n                <strike>{{ e.price|currency }}</strike> <span class=\"badge\">Refunded</span>\n              </span>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <app-pagination />\n    </div>\n  </div>\n</div>"

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/accounts/:account_id/channels/:channel_id/tickets/:id', {
    template: __webpack_require__(244),
    controller: 'ChannelTicketController'
  });
}]).controller('ChannelTicketController', ["$scope", "$location", "$q", "$routeParams", "$modal", "Account", "AccountChannel", "ChannelTicket", function ($scope, $location, $q, $routeParams, $modal, Account, AccountChannel, ChannelTicket) {
  $scope.account = Account.get({
    id: $routeParams.account_id
  });
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  $scope.channel = AccountChannel.get({
    account_id: $routeParams.account_id,
    id: $routeParams.channel_id,
    include_archived: true
  });
  $scope.ticket = ChannelTicket.get({
    channel_id: $routeParams.channel_id,
    id: $routeParams.id
  });
  $q.all([$scope.channel.$promise, $scope.ticket.$promise]).then(function (res) {
    var c = res[0],
        id = res[1].id;
    $scope.showURL = c.admin_viewer_url.replace(/\/\.[0-9A-Za-z]+$/, "/".concat(id)).replace('/view/', '/channel/');
  });
  $scope.isRefunding = false;
  return $scope.refund = function () {
    if (confirm('Are you sure you want to refund this ticket?')) {
      $scope.isRefunding = true;
      return ChannelTicket.refund({
        channel_id: $routeParams.channel_id,
        id: $routeParams.id
      }, null, function (data) {
        return $scope.ticket = data;
      });
    }
  };
}]);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> <a href=\"/accounts/{{ account.id }}/channels/{{ channel.id }}\">{{ channel.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ ticket.name }}</h3>\n      </div>\n      <div class=\"panel-body\">\n\n        <div ng-show=\"ticket.stripe_charge_id\">\n          <button ng-show=\"!ticket.is_refunded\" ng-disabled=\"isRefunding\" ng-click=\"refund()\" class=\"btn btn-danger btn-sm refund\">\n            {{ isRefunding ? 'Refunding...' : 'Refund Ticket' }}\n          </button>\n        </div>\n\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <h4>{{ ticket.name }}</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr><th class=\"col-xs-2\">Show URL</th><td>\n          <a href=\"{{ showURL }}\" target=\"_blank\">{{ showURL }}</a>\n      </td></tr>\n      <tr><th class=\"col-xs-2\">Email</th><td>{{ ticket.email }}</td></tr>\n      <tr><th>Price</th><td>{{ ticket.price | currency }} &emsp; <span ng-show=\"ticket.is_refunded\" class=\"badge\">Refunded</span></td></tr>\n      <tr><th>Purchased</th><td>{{ ticket.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td></tr>\n      <tr><th>Invoice</th><td>{{ ticket.invoice_handle }}</td></tr>\n      <tr ng-show=\"ticket.stripe_charge_id\">\n        <th>Stripe Charge</th>\n        <td>{{ ticket.stripe_charge_id }}\n          &emsp; <a href=\"https://dashboard.stripe.com/payments/{{ ticket.stripe_charge_id }}\" target=\"_blank\"><i class=\"fa fa-external-link\"></i></a>\n          &emsp; <button ng-show=\"!ticket.is_refunded\" ng-disabled=\"isRefunding\" ng-click=\"refund()\" class=\"btn btn-danger btn-xs refund\">{{ isRefunding ? 'Refunding...' : 'Refund Ticket' }}</button>\n        </td>\n      </tr>\n      <tr ng-show=\"ticket.pwmb_transaction_id\"><th>PWMB Transaction</th><td>{{ ticket.pwmb_transaction_id }}</td></tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dashboard_scss__);
// Uncomment when all fields are set sortable in the API
// Currently sortable fields: https://github.com/boxcast/boxcast_api/blob/master/app/models/broadcast.rb#L150-L152
//
// import { canPaginate } from '../../mixins/can_paginate';


angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/', {
    template: __webpack_require__(247),
    controller: 'DashboardController'
  });
}]).controller('DashboardController', ["$scope", "$location", "$filter", "$timeout", "$route", "Broadcast", "BroadcastService", function ($scope, $location, $filter, $timeout, $route, Broadcast, BroadcastService) {
  // Uncomment when all fields are set sortable in the API
  // canPaginate($scope, $location);
  // $scope.s || ($scope.s = 'starts_at');
  $scope.settings = {
    showTodayGraph: false
  };
  var reloadHandle,
      reloadInterval = 10000;

  var params = _.pick($scope, 'q', 's', 'p');

  params["filter.exclude_disallowed_accounts"] = "true";
  params["filter.include_archived"] = "false";
  params.q = 'timeframe:preroll timeframe:current';
  params.l = 1000;
  params.include_stream_diagnostics = true;
  var broadcastData = [];
  var cleanBroadcastData = [];
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  $scope.broadcasts = [];
  $scope.loading = true;
  $scope.q = {
    $: ''
  }; // Fetch our active broadcasts

  var load = function load() {
    return Broadcast.queryAll(params).then(function (data) {
      broadcastData = BroadcastService.powerSort(data); // For mock data, swap `data` with `require('./fake-data.json')`

      cleanBroadcastData = broadcastData; // If a search term is entered, do the additional filtering by search

      if ($scope.q.$.length) broadcastData = $filter('filter')(broadcastData, $scope.q.$); // Refresh rate as a function of number of broadcasts....
      // <500 = 10s
      // 500-1000 = 30s
      // 1000+ = 60s

      var refreshRate = 10;

      if (broadcastData.length > 1000) {
        refreshRate = 60;
      } else if (broadcastData.length > 500) {
        refreshRate = 30;
      } // Apply existing sort & direction


      broadcastData = $filter('orderBy')(broadcastData, sort, reverse); // Update the view

      $scope.broadcasts = broadcastData;
      $scope.loading = false;
      reloadHandle = $timeout(load, reloadInterval = refreshRate * 1000);
    })["catch"](function (err) {
      reloadInterval = Math.min(2 * reloadInterval, 120000); //exponential backoff up to 2min

      reloadHandle = $timeout(load, reloadInterval);
    });
  };

  load();
  $scope.$on('$destroy', function () {
    return $timeout.cancel(reloadHandle);
  }); // UI based sort (Use until additional fields are made sortable in the API)

  var sort = localStorage.getItem('dashboard.sort') ? JSON.parse(localStorage.getItem('dashboard.sort')).field : 'starts_at';
  var reverse = localStorage.getItem('dashboard.sort') ? JSON.parse(localStorage.getItem('dashboard.sort')).reverse : false;
  localStorage.setItem('dashboard.sort', JSON.stringify({
    field: sort,
    reverse: reverse
  }));
  var lastSort = sort;

  $scope.uiSort = function ($event) {
    // If the <i> tag is clicked, move upwards to grab the correct data field target
    sort = $event.target.dataset.field ? $event.target.dataset.field : $event.target.parentElement.dataset.field;

    if (sort === lastSort && sort.indexOf('-score') == -1) {
      reverse = reverse ? false : true;
    } else {
      reverse = false;
    }

    lastSort = sort; // Account for multiple fields being passed

    if (sort.slice(0, 1) === "[") sort = JSON.parse(sort); // Sort the data

    broadcastData = $filter('orderBy')(broadcastData, sort, reverse); // If a search term is entered, do the additional filtering by search

    if ($scope.q.$.length) broadcastData = $filter('filter')(broadcastData, $scope.q.$); // Update the view

    $scope.broadcasts = broadcastData; // Store your last sort

    localStorage.setItem('dashboard.sort', JSON.stringify({
      field: sort,
      reverse: reverse
    }));
    gtag('event', 'table_column_sorted', {
      category: sort + " - " + (reverse ? 'descending' : 'ascending')
    });
  }; // Display proper sort icon


  $scope.uiSortClass = function (data) {
    var classes = ['fa'];

    if (sort.indexOf(data) === -1) {
      classes.push('fa-sort');
    } else if (reverse) {
      classes.push('fa-sort-alpha-desc');
    } else {
      classes.push('fa-sort-alpha-asc');
    }

    return classes.join(' ');
  }; // Text search


  var filterTextTimeout;

  $scope.search = function (q) {
    var cleanData = angular.copy(cleanBroadcastData);
    cleanData = $filter('orderBy')(cleanData, sort, reverse);
    $scope.broadcasts = $filter('filter')(cleanData, q); // Our model debounce is super short, only register
    // GA4 analytics after the user stops typing.

    if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
    filterTextTimeout = $timeout(function () {
      if (q.length) {
        gtag('event', 'table_searched', {
          category: q
        });
      }
    }, 1000);
  }; // Format the Start Time Tooltip


  $scope.tooltipDateContent = function (data) {
    var sameDay = moment(data.starts_at).isSame(moment(data.stops_at), 'day');

    if (!sameDay) {
      return "Starts ".concat($filter('date')(data.starts_at), "<br>Stops ").concat($filter('date')(data.stops_at));
    } else {
      return "Starts ".concat($filter('date')(data.starts_at));
    }
  }; // Format Accessibility (Type) Tooltip


  $scope.tooltipAccessibilityContent = function (data) {
    var tip = [];

    if (data.is_ticketed) {
      tip.push("$" + $filter('number')(data.sold_ticket_total, 2));
      if (!$scope.bottomRows.type) tip.push(" total ($" + $filter('number')(data.ticket_price, 2) + " each)");

      if (data.free_variant !== 'none') {
        tip.push("<div class=\"tip-row\">Free: ".concat(data.free_variant, "</div>"));
      }
    }

    return tip.join('');
  }; // Format Stats Tooltip


  $scope.tooltipStatsContent = function (data) {
    var tip = [];
    tip.push("<div class=\"text-left\">" + $filter('number')(data.total_active_viewer_count) + " active viewers</div>");
    tip.push("<div class=\"text-left\">" + $filter('number')(data.total_view_count) + " total viewers</div>");

    if (data.is_ticketed) {
      tip.push("<div class=\"text-left\">" + $filter('number')(data.sold_ticket_count) + " tickets sold</div>");
    }

    return tip.join('');
  }; // Warn for events ending in less than 15 minutes


  $scope.warningTimeCutoff = new Date(new Date().getTime() + 15 * 60000).toISOString();

  $scope.timeLeft = function (stops_at) {
    return moment(stops_at).fromNow();
  }; // Pop the row


  $scope.show = function (b) {
    return $location.url("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */], "/broadcasts/").concat(b.id));
  }; // Display extra fields in table


  $scope.extraFields = localStorage.getItem('dashboard.fields');

  if ($scope.extraFields) {
    $scope.extraFields = JSON.parse($scope.extraFields);
  } else {
    $scope.extraFields = {
      time: true,
      status: true,
      sport: true,
      make: true,
      type: true,
      source: true,
      stats: true
    };
  } // Display the second row


  $scope.bottomRows = localStorage.getItem('dashboard.bottomRows');

  if ($scope.bottomRows) {
    $scope.bottomRows = JSON.parse($scope.bottomRows);
  } else {
    $scope.bottomRows = {
      name: true,
      sport: false,
      make: false,
      time: false,
      status: false,
      type: false,
      stats: true
    };
  }

  $scope.toggle = function (field, e) {
    $scope.extraFields[field] = !$scope.extraFields[field];
    localStorage.setItem('dashboard.fields', JSON.stringify($scope.extraFields));
    e.preventDefault();
    e.stopPropagation();
    $route.reload();
    gtag('event', 'table_column_toggled', {
      category: field,
      label: $scope.extraFields[field]
    });
    return false;
  };

  $scope.toggleBottomRow = function (field, e) {
    $scope.bottomRows[field] = !$scope.bottomRows[field];
    localStorage.setItem('dashboard.bottomRows', JSON.stringify($scope.bottomRows));
    e.preventDefault();
    e.stopPropagation();
    $route.reload();
    gtag('event', 'table_column_bottom_row_toggled', {
      category: field,
      label: $scope.bottomRows[field]
    });
    return false;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(28)))

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = "\n\n<div class=\"row\">\n\n    <div ng-if=\"!settings.showTodayGraph\">\n      <div style=\"margin:-10px 10px 10px; text-align:right\">\n        <button type=\"button\"\n                class=\"btn btn-xs btn-default\"\n                ng-click=\"settings.showTodayGraph = true\">\n          <i class=\"fa fa-line-chart\"></i> Show Broadcasts Timeline\n        </button>\n      </div>\n    </div>\n    <div ng-if=\"settings.showTodayGraph\">\n      <broadcasts-today-graph></broadcasts-today-graph>\n    </div>\n\n    <div ng-if=\"!loading\" id=\"broadcast-search\" class=\"clearfix\">\n        <div class=\"broadcast-search-left\">\n            <div class=\"input-group\">\n                <input ng-model=\"q.$\" ng-change=\"search(q.$)\" class=\"form-control\" placeholder=\"Filter Broadcasts\" ng-disabled=\"broadcasts.length == 0 && !q.$.length\" ng-model-options=\"{ debounce: 200 }\" />\n                <span class=\"input-group-btn\"><button ng-click=\"q.$ = ''; search('')\" class=\"btn btn-default\" type=\"button\" ng-disabled=\"!q.$.length\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></span>\n            </div>\n        </div>\n        <div class=\"broadcast-search-right\">\n            <div class=\"btn-group\" dropdown>\n                <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" dropdown-toggle>\n                    <i class=\"fa fa-cog\" aria-hidden=\"true\"></i><span class=\"caret\" style=\"margin-left:10px;\"></span>\n                </button>\n                <ul class=\"dropdown-menu dropdown-menu-right\">\n                    <li><a href=\"#\" ng-click=\"$event.preventDefault();uiSort($event)\" data-field=\"-score\">Magic Sort</a></li>\n                    <li role=\"separator\" class=\"divider\"></li>\n                    <li class=\"dropdown-menu-header\">Columns</li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('time', $event)\"><i class=\"fa\" ng-class=\"extraFields.time?'fa-check-square-o':'fa-square-o'\"></i> Time</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('status', $event)\"><i class=\"fa\" ng-class=\"extraFields.status?'fa-check-square-o':'fa-square-o'\"></i> Status</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('sport', $event)\"><i class=\"fa\" ng-class=\"extraFields.sport?'fa-check-square-o':'fa-square-o'\"></i> Sport</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('make', $event)\"><i class=\"fa\" ng-class=\"extraFields.make?'fa-check-square-o':'fa-square-o'\"></i> Make</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('type', $event)\"><i class=\"fa\" ng-class=\"extraFields.type?'fa-check-square-o':'fa-square-o'\"></i> Type</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('source', $event)\"><i class=\"fa\" ng-class=\"extraFields.source?'fa-check-square-o':'fa-square-o'\"></i> Source</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('profile', $event)\"><i class=\"fa\" ng-class=\"extraFields.profile?'fa-check-square-o':'fa-square-o'\"></i> Profile</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggle('stats', $event)\"><i class=\"fa\" ng-class=\"extraFields.stats?'fa-check-square-o':'fa-square-o'\"></i> Stats</a></li>\n                    <li role=\"separator\" class=\"divider\"></li>\n                    <li class=\"dropdown-menu-header\">Second Row</li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggleBottomRow('time', $event)\"><i class=\"fa\" ng-class=\"bottomRows.time?'fa-check-square-o':'fa-square-o'\"></i> Time</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggleBottomRow('status', $event)\"><i class=\"fa\" ng-class=\"bottomRows.status?'fa-check-square-o':'fa-square-o'\"></i> Status</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggleBottomRow('name', $event)\"><i class=\"fa\" ng-class=\"bottomRows.name?'fa-check-square-o':'fa-square-o'\"></i> Name</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggleBottomRow('type', $event)\"><i class=\"fa\" ng-class=\"bottomRows.type?'fa-check-square-o':'fa-square-o'\"></i> Type</a></li>\n                    <li class=\"dropdown-checkbox\"><a href=\"#\" ng-click=\"toggleBottomRow('stats', $event)\"><i class=\"fa\" ng-class=\"bottomRows.stats?'fa-check-square-o':'fa-square-o'\"></i> Stats</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"alert alert-info alert-loading\" ng-if=\"loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n\n    <div class=\"alert alert-info alert-no-broadcasts text-center\" role=\"alert\" ng-if=\"!loading && broadcasts.length == 0 && !q.$\">\n        <div>No active broadcasts.</div>\n    </div>\n\n    <div class=\"alert alert-info text-center\" role=\"alert\" ng-if=\"!loading && broadcasts.length == 0 && q.$\">\n        <div>No filtered results.</div>\n        <a href=\"#\" ng-click=\"q.$ = ''; search(q.$)\">Clear filter<i class=\"fa fa-times\" style=\"margin-left:5px;\" aria-hidden=\"true\"></i></a>\n    </div>\n\n    <div class=\"repeater-container\">\n    <table ng-if=\"broadcasts.length > 0\" class=\"table table-striped table-hover table-condensed table-animate\" id=\"broadcasts\">\n        <thead>\n            <tr>\n                <th ng-if=\"::extraFields.time\" class=\"col-xs-2 clickable\" ng-click=\"uiSort($event)\" data-field=\"starts_at\">\n                    Time\n                    <i ng-class=\"uiSortClass('starts_at')\">\n                </th>\n                <th ng-if=\"::extraFields.status\" class=\"col-xs-1 clickable\" ng-click=\"uiSort($event)\" data-field=\"status\">\n                    Status\n                    <i ng-class=\"uiSortClass('status')\">\n                </th>\n                <th class=\"col-xs-4 clickable\" ng-click=\"uiSort($event)\" data-field=[\"name\",\"account_name\"]>\n                    Name\n                    <i ng-class=\"uiSortClass('name')\">\n                </th>\n                <th ng-if=\"::extraFields.sport\" class=\"col-xs-1 clickable\" ng-click=\"uiSort($event)\" data-field=\"scoreboard_configuration.sport\">\n                    Sport\n                    <i ng-class=\"uiSortClass('scoreboard_configuration.sport')\">\n                </th>\n                <th ng-if=\"::extraFields.make\" class=\"col-xs-1 clickable\" ng-click=\"uiSort($event)\" data-field=\"scoreboard_configuration.scoreboard_make\">\n                    Make\n                    <i ng-class=\"uiSortClass('scoreboard_configuration.scoreboard_make')\">\n                </th>\n                <th ng-if=\"::extraFields.type\" class=\"col-xs-1 clickable\" ng-click=\"uiSort($event)\" data-field='[\"is_ticketed\",\"sold_ticket_count\",\"is_private\"]'>\n                    Type\n                    <i ng-class=\"uiSortClass('sold_ticket_count')\">\n                </th>\n                <th ng-if=\"::extraFields.source\" class=\"col-xs-1 clickable\" ng-click=\"uiSort($event)\" data-field=\"stream_source\">\n                    Source\n                    <i ng-class=\"uiSortClass('stream_source')\">\n                </th>\n                <th ng-if=\"::extraFields.profile\" class=\"col-xs-1 clickable\" ng-click=\"uiSort($event)\" data-field=\"transcoder_profile\">\n                    Profile\n                    <i ng-class=\"uiSortClass('transcoder_profile')\">\n                </th>\n                <th ng-if=\"::extraFields.stats\" class=\"col-xs-2 clickable\" ng-click=\"uiSort($event)\" data-field=\"total_active_viewer_count\">\n                    Stats\n                    <i ng-class=\"uiSortClass('total_active_viewer_count')\">\n                </th>\n            </tr>\n        </thead>\n        <tbody vs-repeat=\"{scrollParent: '.repeater-container', size: 44}\">\n            <tr ng-repeat=\"e in broadcasts\" style=\"height:44px; overflow: hidden\" ng-click=\"show(e)\" class=\"clickable\" ng-class=\"::{ 'row-highlight-warning': e.status.indexOf('offline') != -1, 'row-status-priority': e.account_support_plan == 'priority', 'row-status-reduced': e.account_support_plan == 'reduced' }\">\n                <td ng-if=\"::extraFields.time\" class=\"starttime-column\">\n                    <div class=\"top-row\" tooltip-html-unsafe=\"{{ ::tooltipDateContent(e) }}\" tooltip-enable=\"::!bottomRows.time\">\n                        {{ ::e.starts_at | date: 'h:mma' }} - {{ ::e.stops_at | date: 'h:mma' }}\n                    </div>\n                    <div class=\"bottom-row\" ng-if=\"::e.stops_at < warningTimeCutoff || bottomRows.time\">\n                        <span ng-if=\"::e.stops_at < warningTimeCutoff\" class=\"text-ends-soon\">Ends {{ ::timeLeft(e.stops_at) }}</span>\n                        <span ng-if=\"::bottomRows.time && e.stops_at >= warningTimeCutoff\" ng-bind-html=\"tooltipDateContent(e)\"></span>\n                    </div>\n                </td>\n                <td ng-if=\"::extraFields.status\" class=\"status-column\">\n                    <dash-status dash-status=\"{{ ::e.status }}\"\n                                 diagnostic-status=\"{{ ::e.stream_diagnostics.status }}\"\n                                 broadcast=\"::e\"\n                                 bottom-row=\"::bottomRows.status\"></dash-status>\n                </td>\n                <td class=\"name-column\">\n                    <a ng-href=\"{{ newAdminURL }}/broadcasts/{{ ::e.id }}\" ng-click=\"$event.stopPropagation()\">\n                        <div class=\"top-row\">{{ ::e.name }}</div>\n                        <div class=\"bottom-row\" ng-if=\"::bottomRows.name\" ng-switch=\"e.account_support_plan\">\n                            <span ng-if=\"e.account_support_plan == 'reduced'\" class=\"fa fa-ban\"></span>\n                            <span ng-if=\"e.account_support_plan == 'priority'\" class=\"fa fa-star\"></span>\n                            <span ng-if=\"e.account_contract == 'trial'\" class=\"label label-info\">Trial</span>\n                            {{ ::e.account_name }}\n                        </div>\n                    </a>\n                </td>\n                <td ng-if=\"::extraFields.sport\" class=\"icon-{{ ::e.scoreboard_configuration.sport_icon }}\" tooltip=\"{{ ::e.scoreboard_configuration.sport }}\" tooltip-append-to-body=\"true\"></td>\n                <td ng-if=\"::extraFields.make\" class=\"icon-{{ ::e.scoreboard_configuration.make_icon }}\" tooltip=\"{{ ::e.scoreboard_configuration | scoreboardMakeModel }}\" tooltip-append-to-body=\"true\"></td>\n                <td ng-if=\"::extraFields.type\">\n                    <span class=\"label\" ng-class=\"::{ \n                        'label-info': e.is_ticketed && e.free_variant == 'low',\n                        'label-success': e.is_ticketed,\n                        'label-default': !e.is_ticketed}\" tooltip-html-unsafe=\"{{ ::tooltipAccessibilityContent(e) }}\" tooltip-enable=\"::!bottomRows.type\">\n                        {{ ::e | dashAccessibility }}\n                    </span>\n                    <div class=\"bottom-row\" ng-if=\"::bottomRows.type\" ng-bind-html=\"tooltipAccessibilityContent(e)\"></div>\n                </td>\n                <td ng-if=\"::extraFields.source\" class=\"icon-{{ ::e.stream_source }}\" tooltip=\"{{ ::e.stream_source | source }}\" tooltip-append-to-body=\"true\"></td>\n                <td ng-if=\"::extraFields.profile\">\n                    <span class=\"label label-info\">{{ ::e.transcoder_profile | transcoderProfile }}</span>\n                </td>\n                <td ng-if=\"::extraFields.stats\">\n                    <table class=\"stats-column-table\">\n                        <tbody>\n                            <tr class=\"row top-row\">\n                                <td class=\"col-xs-4\">{{ ::e.total_active_viewer_count | number }}</td>\n                                <td class=\"col-xs-4\">{{ ::e.total_view_count | number }}</td>\n                                <td class=\"col-xs-4\">{{ ::e.sold_ticket_count | number }}</td>\n                            </tr>\n                            <tr class=\"row bottom-row\" ng-if=\"::bottomRows.stats\">\n                                <td class=\"col-xs-4\">Active</td>\n                                <td class=\"col-xs-4\">Total</td>\n                                <td class=\"col-xs-4\">Sold</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n    </div>\n\n</div>"

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__new_extended_test_controller__ = __webpack_require__(249);


angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/extended_tests', {
    template: __webpack_require__(250),
    controller: 'ExtendedTestsController'
  });
}]).controller('ExtendedTestsController', ["$scope", "$location", "$modal", "$timeout", "$q", "Broadcast", function ($scope, $location, $modal, $timeout, $q, Broadcast) {
  // How long in the past should we look for recent extended tests
  var RECENT_TIME_HORIZON_MS = 1 * 24 * 60 * 60 * 1000; // 1 day
  // How often to reload current and recent extended tests

  var RELOAD_INTERVAL_MS = 60 * 1000; // This set of functions deals with reloading current and recent extended tests.

  var timeoutId = null;

  var cancelTimeout = function cancelTimeout() {
    if (timeoutId != null) {
      $timeout.cancel(timeoutId);
      return timeoutId = null;
    }
  };

  var reload = function reload() {
    cancelTimeout();
    var b1 = Broadcast.query({
      'filter.account_id': __WEBPACK_IMPORTED_MODULE_0_environment__["a" /* ACCOUNT_ID_FOR_EXTENDED_TESTS */],
      'filter.include_archived': 'false',
      q: "timeframe:current timeframe:preroll timeframe:future +*extended*"
    }, function (data) {
      $scope.current_extended_tests = data;
    });
    var to = new Date();
    var from = new Date(to.getTime() - RECENT_TIME_HORIZON_MS); // XXX: This can be a dreadfully slow query, see PLATFORM-147

    var b2 = Broadcast.query({
      'filter.account_id': __WEBPACK_IMPORTED_MODULE_0_environment__["a" /* ACCOUNT_ID_FOR_EXTENDED_TESTS */],
      'filter.include_archived': 'false',
      q: "timeframe:past +stops_at:[".concat(from.toISOString(), " TO ").concat(to.toISOString(), "] +*extended*"),
      s: '-starts_at'
    }, function (data) {
      $scope.recent_extended_tests = data;
    });
    $q.all([b1.$promise, b2.$promise]).then(function () {
      timeoutId = $timeout(reload, RELOAD_INTERVAL_MS);
    });
  };

  reload();
  $scope.$on('$destroy', cancelTimeout); // Provide a URL for a graphite graph that shows the BoxCaster's uptime for the duration of the test.

  $scope.uptimeUrl = function (broadcast) {
    if (!broadcast.__grafana_url) {
      // XXX: Date.now() in URL would cause Angular to freak out during digest loop
      var starts_at = new Date(Date.parse(broadcast.starts_at)).getTime();
      var stops_at = new Date(Date.parse(broadcast.stops_at)).getTime();
      broadcast.__grafana_url = "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["k" /* GRAFANA_UPTIME_URL */], "?var-boxcaster_id=").concat(broadcast.boxcaster_id, "&from=").concat(starts_at, "&to=").concat(stops_at);
    }

    return broadcast.__grafana_url;
  }; // Provide a URL for a kibana dashbaord that shows link up/down events for the BoxCaster for the
  // duration of the test.


  $scope.boxcasterLinkUrl = function (broadcast) {
    var from = new Date(Date.parse(broadcast.starts_at));
    var to = new Date(Date.parse(broadcast.stops_at));
    return "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["o" /* KIBANA_URL */], "/app/kibana#/discover?_g=(refreshInterval:(display:Off,pause:!f,section:0,value:0),time:(from:'").concat(from.toISOString(), "',mode:absolute,to:'").concat(to.toISOString(), "'))&_a=(columns:!(tag,level,message),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'logs-*',key:hostname,negate:!f,value:").concat(broadcast.boxcaster_id, "),query:(match:(hostname:(query:").concat(broadcast.boxcaster_id, ",type:phrase))))),index:'logs-*',interval:auto,query:(query_string:(analyze_wildcard:!t,query:'message:%22Link%20is%22')),sort:!('@timestamp',desc))");
  }; // Create a new set of extended tests via the modal window.


  $scope.create = function () {
    return $modal.open({
      template: __webpack_require__(251),
      controller: 'NewExtendedTestController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function () {
      return reload();
    });
  }; // Show an extended test's broadcast (admin) page.


  $scope.show = function (broadcast) {
    return $location.url("/broadcasts/".concat(broadcast.id));
  }; // Stop an extended test by setting its stops_at to now.


  $scope.stop = function (broadcast) {
    if (confirm('Are you sure you want to stop this broadcast?')) {
      return Broadcast.update({
        id: broadcast.id
      }, {
        stops_at: new Date().toISOString()
      }, function () {
        return reload();
      });
    }
  }; // Delete an extended test.


  return $scope["delete"] = function (broadcast) {
    if (confirm('Are you sure you want to delete this broadcast?')) {
      return Broadcast["delete"]({
        id: broadcast.id
      }, function () {
        return reload();
      });
    }
  };
}]);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').controller('NewExtendedTestController', ["$scope", "$modalInstance", "$q", "Boxcaster", "Broadcast", function ($scope, $modalInstance, $q, Boxcaster, Broadcast) {
  // Valid extended test durations and a default duration.
  $scope.DURATIONS = [{
    label: "1 hour",
    value: 1 * 60 * 60 * 1000
  }, {
    label: "2 hours",
    value: 2 * 60 * 60 * 1000
  }, {
    label: "3 hours",
    value: 3 * 60 * 60 * 1000
  }, {
    label: "4 hours",
    value: 4 * 60 * 60 * 1000
  }, {
    label: "5 hours",
    value: 5 * 60 * 60 * 1000
  }, {
    label: "6 hours",
    value: 6 * 60 * 60 * 1000
  }, {
    label: "7 hours",
    value: 7 * 60 * 60 * 1000
  }, {
    label: "8 hours",
    value: 8 * 60 * 60 * 1000
  }];
  $scope.DEFAULT_DURATION = 6 * 60 * 60 * 1000; // Valid extended test video bitrates and a default video bitrate.

  $scope.VIDEO_BITRATES = [{
    label: "auto",
    value: "default"
  }, {
    label: "300 kbps",
    value: 300000
  }, {
    label: "500 kbps",
    value: 500000
  }, {
    label: "700 kbps",
    value: 700000
  }, {
    label: "900 kbps",
    value: 900000
  }, {
    label: "1.2 Mbps",
    value: 1200000
  }, {
    label: "1.5 Mbps",
    value: 1500000
  }, {
    label: "2.0 Mbps",
    value: 2000000
  }, {
    label: "2.5 Mbps",
    value: 2500000
  }, {
    label: "3.0 Mbps",
    value: 3000000
  }];
  $scope.DEFAULT_VIDEO_BITRATE = "default"; // Valid extended test audio bitrates and a default audio bitrate.

  $scope.AUDIO_BITRATES = [{
    label: "auto",
    value: "default"
  }, {
    label: "48 kbps",
    value: 48000
  }, {
    label: "64 kbps",
    value: 64000
  }, {
    label: "96 kbps",
    value: 96000
  }, {
    label: "128 kbps",
    value: 128000
  }];
  $scope.DEFAULT_AUDIO_BITRATE = "default"; // Offset from "now" for the start time (15 minutes minimum).
  //
  // The API's forecaster looks at the schedule of upcoming broadcasts to know how many servers to
  // keep up, plus some reserve. During off-peak hours when nothing is broadcasting, only the
  // reserve is kept alive, and starting a large number of extended tests at once will completely
  // consume the reserve servers and delay any "real" broadcasts from starting. Since it takes 10-12
  // minutes to bring up new servers, scheduling extended tests 15 minutes in advance gives the API
  // forecaster enough advance warning to bring up the servers needed for these broadcasts, as well
  // as maintain the reserve in case any new (real) broadcasts are added on the fly.

  $scope.START_OFFSETS = [{
    label: "15 minutes",
    value: 15 * 60 * 1000
  }, {
    label: "1 hour",
    value: 1 * 60 * 60 * 1000
  }, {
    label: "2 hours",
    value: 2 * 60 * 60 * 1000
  }, {
    label: "3 hours",
    value: 3 * 60 * 60 * 1000
  }, {
    label: "4 hours",
    value: 4 * 60 * 60 * 1000
  }, {
    label: "5 hours",
    value: 5 * 60 * 60 * 1000
  }, {
    label: "6 hours",
    value: 6 * 60 * 60 * 1000
  }, {
    label: "7 hours",
    value: 7 * 60 * 60 * 1000
  }, {
    label: "8 hours",
    value: 8 * 60 * 60 * 1000
  }];
  $scope.DEFAULT_START_OFFSET = 15 * 60 * 1000;
  $scope.isCreating = false;
  $scope.duration = $scope.DEFAULT_DURATION;
  $scope.target_video_bitrate = $scope.DEFAULT_VIDEO_BITRATE;
  $scope.target_audio_bitrate = $scope.DEFAULT_AUDIO_BITRATE;
  $scope.start_offset = $scope.DEFAULT_START_OFFSET;
  $scope.boxcasters = []; // Load BoxCasters based on a query from the input control.

  $scope.loadBoxcasters = function (query) {
    return Boxcaster.query({
      q: "+account_id:".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["a" /* ACCOUNT_ID_FOR_EXTENDED_TESTS */], " id:*").concat(query, "*"),
      s: 'id'
    }).$promise;
  }; // Called when the user clicks Create.


  $scope.ok = function () {
    var start = new Date(Date.now() + parseInt($scope.start_offset));
    var stop = new Date(start.getTime() + parseInt($scope.duration));
    $scope.isCreating = true; // Use $q.all to collect promises for each of the new broadcasts -- one for each BoxCaster.

    return $q.all(_.map($scope.boxcasters, function (b) {
      return Broadcast.create({
        account_id: __WEBPACK_IMPORTED_MODULE_0_environment__["a" /* ACCOUNT_ID_FOR_EXTENDED_TESTS */],
        name: "Extended ".concat(b.id.substr(-6)),
        description: "Extended test of ".concat(b.id, " from ").concat(start.toISOString(), " to ").concat(stop.toISOString(), " using target bitrates ").concat($scope.target_video_bitrate, " video / ").concat($scope.target_audio_bitrate, " audio."),
        starts_at: start.toISOString(),
        stops_at: stop.toISOString(),
        target_video_bitrate: $scope.target_video_bitrate,
        target_audio_bitrate: $scope.target_audio_bitrate,
        boxcaster_id: b.id,
        is_private: true
      });
    })).then(function () {
      return $modalInstance.close();
    }, function () {
      return $modalInstance.dismiss('error');
    });
  }; // Called when the user clicks Cancel


  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = "<style>\n  td.status {\n    font-style: italic;\n    font-weight: lighter;\n  }\n</style>\n<div class=\"col-md-10\">\n  <div class=\"row\">\n    <button class=\"btn btn-primary\" ng-click=\"create()\">Create Tests</h4>\n  </div>\n  <div class=\"row\">\n    <h4>Existing Extended Tests</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr ng-if=\"current_extended_tests.length == 0\"><td colspan=\"7\"><i>No existing extended tests.</i></td></tr>\n      <tr ng-repeat=\"t in current_extended_tests\">\n        <td ng-click=\"show(t)\" class=\"clickable\">{{ t.name }}</td>\n        <td ng-click=\"show(t)\" class=\"clickable status\">{{ t.status }}</td>\n        <td ng-click=\"show(t)\" class=\"clickable\">{{ [t.starts_at, t.stops_at] | datespan}}</td>\n        <td>\n          <a href=\"{{ uptimeUrl(t) }}\" target=\"_blank\">\n            <i class=\"fa fa-external-link\"></i>\n            Uptime Graph\n          </a>\n        </td>\n        <td>\n          <a href=\"{{ boxcasterLinkUrl(t) }}\" target=\"_blank\">\n            <i class=\"fa fa-external-link\"></i>\n            BoxCaster Link Logs\n          </a>\n        </td>\n        <td><button ng-click=\"stop(t)\" class=\"btn btn-warning btn-xs\">stop</button></td>\n        <td><button ng-click=\"delete(t)\" class=\"btn btn-danger btn-xs\">delete</button></td>\n      </tr>\n    </table>\n    <h4>Recent Tests</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr ng-if=\"recent_extended_tests.length == 0\"><td colspan=\"6\"><i>No recent extended tests.</i></td></tr>\n      <tr ng-repeat=\"t in recent_extended_tests\">\n        <td ng-click=\"show(t)\" class=\"clickable\">{{ t.name }}</td>\n        <td ng-click=\"show(t)\" class=\"clickable status\">{{ t.status }}</td>\n        <td ng-click=\"show(t)\" class=\"clickable\">{{ [t.starts_at, t.stops_at] | datespan}}</td>\n        <td>\n          <a href=\"{{ uptimeUrl(t) }}\" target=\"_blank\">\n            <i class=\"fa fa-external-link\"></i>\n            Uptime Graph\n          </a>\n        </td>\n        <td>\n          <a href=\"{{ boxcasterLinkUrl(t) }}\" target=\"_blank\">\n            <i class=\"fa fa-external-link\"></i>\n            BoxCaster Link Logs\n          </a>\n        </td>\n        <td><button ng-click=\"delete(t)\" class=\"btn btn-danger btn-xs\">delete</button></td>\n      </tr>\n    </table>\n  </div>\n</div>"

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = "<style>\n  tags-input .host {\n    margin: 0px;\n  }\n  tags-input .tags .tag-item {\n    background: #428bca;\n  }\n</style>\n<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Create New Extended Tests</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form id=\"recording-form\" name=\"form\" role=\"form\">\n    <div class=\"col-sm-5\">\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Duration: </span>\n        <select id=\"duration\" ng-model=\"duration\" required class=\"form-control\">\n          <option ng-repeat=\"d in ::DURATIONS\" value=\"{{ d.value }}\" ng-selected=\"d.value == DEFAULT_DURATION\">{{ d.label }}</option>\n        </select>\n      </div>\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Start in: </span>\n        <select id=\"start_offset\" ng-model=\"start_offset\" required class=\"form-control\">\n          <option ng-repeat=\"b in ::START_OFFSETS\" value=\"{{ b.value }}\" ng-selected=\"b.value == DEFAULT_START_OFFSET\">{{ b.label }}</option>\n        </select>\n      </div>\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Target video bitrate: </span>\n        <select id=\"target_video_bitrate\" ng-model=\"target_video_bitrate\" required class=\"form-control\">\n          <option ng-repeat=\"b in ::VIDEO_BITRATES\" value=\"{{ b.value }}\" ng-selected=\"b.value == DEFAULT_VIDEO_BITRATE\">{{ b.label }}</option>\n        </select>\n      </div>\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Target audio bitrate: </span>\n        <select id=\"target_audio_bitrate\" ng-model=\"target_audio_bitrate\" required class=\"form-control\">\n          <option ng-repeat=\"b in ::AUDIO_BITRATES\" value=\"{{ b.value }}\" ng-selected=\"b.value == DEFAULT_AUDIO_BITRATE\">{{ b.label }}</option>\n        </select>\n      </div>\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">BoxCasters: </span>\n        <tags-input required class=\"bootstrap\" ng-model=\"boxcasters\" add-on-paste=\"true\" add-from-autocomplete-only=\"true\" placeholder=\"Add a BoxCaster\" display-property=\"id\">\n          <auto-complete source=\"loadBoxcasters($query)\" min-length=\"0\" debounce-delay=\"0\"></auto-complete>\n        </tags-input>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isCreating\" class=\"btn btn-primary\"><i ng-show=\"isCreating\" class=\"fa fa-cog fa-spin\"></i> Create</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_scss__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__navigation_scss__);

angular.module('app.views').controller('NavigationController', ["$rootScope", "$scope", "$location", "$window", "User", "Account", "AuthService", function ($rootScope, $scope, $location, $window, User, Account, AuthService) {
  $scope.linkClass = function (path, isExact) {
    var actual = $location.path();

    if (path === actual || !isExact && actual.indexOf(path) === 0) {
      return 'active';
    } else {
      return '';
    }
  };

  var reloadMe = function reloadMe() {
    $scope.me = User.me();
    $rootScope.me = $scope.me;
    $scope.me.$promise.then(function () {
      console.dir($scope.me);

      if (!$scope.me.isBoxcastAdmin()) {
        $window.alert("Whoops -- looks like you're not a BoxCast admin...");
        AuthService.logOut();
      }
    });
  };

  reloadMe();
  $scope.$on('impersonate_initiated', reloadMe);

  $scope.stopImpersonating = function () {
    Account.stopImpersonating().$promise.then(reloadMe);
  };

  $scope.logOut = function () {
    AuthService.logOut();
  };
}]);

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/order/:id', {
    template: __webpack_require__(255),
    controller: 'OrderController'
  });
}]).controller('OrderController', ["$scope", "$routeParams", "$modal", "toaster", "Order", "Account", function ($scope, $routeParams, $modal, toaster, Order, Account) {
  $scope.reload = function () {
    $scope.loading = true;
    Order.get({
      id: $routeParams.id
    }).$promise.then(function (result) {
      $scope.order = result; // Orders can only be updated if they haven't been shipped

      $scope.needsShipped = _.indexOf(['on_hold', 'awaiting_payment', 'awaiting_shipment'], $scope.order.status) > -1;
      $scope.canEdit = !!$scope.needsShipped;
      $scope.shipped = $scope.order.status == 'shipped'; // Get the associated account

      Account.get({
        id: $scope.order.account_id
      }).$promise.then(function (result) {
        $scope.account = result;
      }, function () {
        console.error('error trying to retrieve the account');
        toaster.pop({
          type: 'error',
          body: "There was an error retrieving the associated account. Please try reloading this page.",
          timeout: 2000
        });
      }); // Get all of the orders ahead of this one

      Order.query({
        'filter.until': $scope.order.created_at,
        page_size: 500
      }, function (res) {
        $scope.ordersAhead = _.filter(res, function (o) {
          // Filter out the current order
          if ($scope.order.id == o.id) {
            return false;
          }

          switch ($scope.order.status) {
            // Orders in "awaiting shipment" are shipped first
            case "awaiting_shipment":
              return o.status == "awaiting_shipment";
            // Orders in "awaiting_payment" and "on_hold" are shipped last

            case "awaiting_payment":
            case "on_hold":
              return _.indexOf(['on_hold', 'awaiting_payment', 'awaiting_shipment'], o.status) > -1;

            default:
              return false;
          }
        });
      }, function (err) {
        console.log(err);
      });
      $scope.loading = false;
    }, function () {
      toaster.pop({
        type: 'error',
        body: "Whoops, there was an error trying to retrieve this order.",
        timeout: 2000
      });
    });
  };

  $scope.edit = function () {
    $modal.open({
      template: __webpack_require__(256),
      controller: 'OrderFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        order: function order() {
          return $scope.order;
        }
      }
    }).result.then(function (r) {
      return $scope.reload();
    });
  }; // Load the page


  $scope.reload();
  $scope.loading = true;
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"/orders\">Orders</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Order {{order.orderId}}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <button ng-show=\"canEdit\" ng-click=\"edit()\" class=\"btn btn-sm btn-block btn-info\">Edit</button>\n        <i ng-hide=\"canEdit\">This order cannot be edited</i>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <div ng-if=\"ordersAhead && needsShipped\" class=\"row text-info bg-info\" style=\"padding:10px;margin:15px 0;border:1px solid;width:50%\">\n      Orders ahead of this one: <strong>{{ordersAhead.length}}</strong>\n    </div>\n    <table class=\"table table-condensed table-striped\">\n      <tr><th>Order Placed</th><td>{{order.created_at | date}}</td></tr>\n      <tr><th>Account</th>\n        <td>\n          <!-- The account name is used for order.orderNumber when creating orders in the transaction service -->\n          <a href=\"javascript://\" ng-click=\"openURL('accounts/' + account.id, $event)\">{{account.name}}</a>\n        </td>\n      </tr>\n      <tr>\n        <th>Items</th>\n        <td>\n          <div ng-repeat=\"item in order.items\">\n            <small>{{item.quantity > 1 ? item.quantity + ' x ': ''}} {{item.name}}</small>\n          </div>\n        </td>\n      </tr>\n      <tr ng-if=\"shipped\">\n        <th>Tracking</th>\n        <td>\n          <a ng-if=\"order.tracking_number\"\n              ng-href=\"{{order.tracking_number | trackingLink}}\"\n              target=\"_blank\">\n              {{order.tracking_number}} <i class=\"fa fa-external-link\"></i>\n            </a>\n        </td>\n      </tr>\n      <tr>\n        <th>Order Status</th>\n        <td ng-switch=\"order.status\">\n          <span ng-switch-when=\"on_hold\" class=\"label label-danger\">Backordered</span>\n          <span ng-switch-when=\"awaiting_payment\" class=\"label label-warning\">Awaiting Payment</span>\n          <span ng-switch-when=\"awaiting_shipment\" class=\"label label-success\">Awaiting Shipment</span>\n          <span ng-switch-when=\"shipped\" class=\"label label-success\">Shipped</span>\n          <span ng-switch-when=\"cancelled\" class=\"label label-default\">Cancelled</span>\n        </td>\n      </tr>\n      <tr><th>Email</th><td>{{order.email}}</td></tr>\n      <tr><th>Address</th><td style=\"white-space: pre-wrap;\">{{order.ship_to | orderAddress}}</td></tr>\n      <tr>\n        <th>Internal Notes</th>\n        <td><div style=\"white-space:pre-wrap\">{{order.internal_notes}}</div></td>\n      </tr>\n      <tr ng-if=\"shipped\"><th>Order Shipped</th><td>{{order.ship_date | date}}</td></tr>\n      <tr ng-if=\"shipped\"><th>Carrier</th><td>{{order.carrier_code}}</td></tr>\n      <tr ng-if=\"shipped\"><th>Service</th><td>{{order.service_code}}</td></tr>\n      <tr ng-if=\"shipped\"><th>Package type</th><td>{{order.package_code}}</td></tr>\n      <tr><th>Priority?</th><td><i class=\"fa\" ng-class=\"order.prioritized ? 'fa-check-square-o' : 'fa-square-o'\"></i></td></tr>\n      <tr><th>Replacement?</th><td><i class=\"fa\" ng-class=\"order.replacement ? 'fa-check-square-o' : 'fa-square-o'\"></i></td></tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Edit Order</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-xs-12\">\n      <div class=\"form-group\">\n        <label for=\"email\">Email</label>\n        <input id=\"email\" type=\"text\" class=\"form-control\" ng-model='order.email' ng-trim='true' ng-required=\"true\"/>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"notes\">Internal Notes</label>\n        <textarea id=\"notes\" type=\"text\" ng-model=\"order.internal_notes\" class=\"form-control\"></textarea>\n      </div>\n\n      <div class=\"form-group\">\n        <label>Address</label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"order.ship_to.line1\" placeholder=\"Address\" ng-required=\"true\">\n      </div>\n      <div class=\"row\">\n        <div class=\"col-xs-5\">\n          <div class=\"form-group\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"order.ship_to.city\" placeholder=\"City\" ng-required=\"true\">\n          </div>\n        </div>\n        <div class=\"col-xs-4\">\n          <div class=\"form-group\">\n            <input ng-if=\"order.ship_to.country != 'US'\"\n              ng-model=\"order.ship_to.state\" id=\"state\" name=\"state\" type=\"text\" class=\"form-control\" autocomplete=\"state\" placeholder=\"State\" required>\n            <select ng-if=\"order.ship_to.country == 'US'\"\n              ng-model=\"order.ship_to.state\"\n              ng-options=\"s.code as s.name for s in states\"\n              id=\"state\" name=\"state\" class=\"form-control\" required>\n            </select>\n          </div>\n        </div>\n        <div class=\"col-xs-3\">\n          <div class=\"form-group\">\n            <input type=\"text\" class=\"form-control\" ng-model=\"order.ship_to.postal_code\" placeholder=\"Postal Code\" ng-required=\"true\">\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" style=\"margin-bottom:15px\">\n        <div class=\"form-group\">\n          <div class=\"col-xs-4\">\n            <select ng-model=\"order.ship_to.country\"\n              ng-options=\"c.code as c.name for c in countries\"\n              id=\"country\" name=\"country\" class=\"form-control\" required>\n            </select>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <label for=\"status\">Order Status</label>\n        <select \n          id=\"status\"\n          ng-model=\"order.status\"\n          class=\"form-control\"\n          ng-options=\"s.value as s.label for s in ::orderStatuses\">\n        </select>\n      </div>\n\n      <div class=\"form-group\" style=\"margin-bottom:5px\">\n        <input id=\"priority\" type=\"checkbox\" ng-model=\"order.prioritized\" style=\"margin-right:5px\"></input>\n        <label for=\"priority\">Priority</label>\n      </div>\n\n      <div class=\"form-group\">\n        <input id=\"replacement\" type=\"checkbox\" ng-model=\"order.replacement\" style=\"margin-right:5px\"></input>\n        <label for=\"replacement\">Replacement</label>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"save()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').controller('OrderFormController', ["$scope", "$modalInstance", "$http", "toaster", "Order", "order", function ($scope, $modalInstance, $http, toaster, Order, order) {
  $scope.order = order;
  $scope.countries = [];
  $http.get("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/checkout/countries")).then(function (response) {
    $scope.countries = response.data;
  });
  $scope.states = [];
  $http.get("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/checkout/states")).then(function (response) {
    $scope.states = response.data;
  }); // Orders can be moved between the following statuses

  $scope.orderStatuses = [{
    label: 'Backordered',
    value: 'on_hold'
  }, {
    label: 'Awaiting Payment',
    value: 'awaiting_payment'
  }, {
    label: 'Awaiting Shipment',
    value: 'awaiting_shipment'
  }, {
    label: 'Cancelled',
    value: 'cancelled'
  }];

  $scope.save = function () {
    $scope.isSaving = true;
    Order.update({
      id: $scope.order.id
    }, {
      ship_to: $scope.order.ship_to,
      status: $scope.order.status,
      internal_notes: $scope.order.internal_notes,
      email: $scope.order.email,
      prioritized: $scope.order.prioritized,
      replacement: $scope.order.replacement
    }, function () {
      $modalInstance.close();
      $scope.isSaving = false;
    }, function (err) {
      toaster.pop({
        type: 'error',
        body: "Error saving order: ".concat(err),
        timeout: 2000
      });
      $scope.isSaving = false;
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/orders', {
    template: __webpack_require__(259),
    controller: 'OrdersController'
  });
}]).controller('OrdersController', ["$scope", "$location", "Order", "Inventory", "Account", function ($scope, $location, Order, Inventory, Account) {
  $scope.PAGE_SIZE = 25;
  $scope.selectedAccount = []; // Pick off filter params from the URL

  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);

  _.pick($scope, 'q', 's', 'p'); // Get inventory numbers


  Inventory.get(function (results) {
    $scope.inventory = results;
  }, function (err) {
    toaster.pop({
      type: 'error',
      body: "Error loading inventory.",
      timeout: 2000
    });
    console.error(err);
  });

  function loadOrders(p) {
    $scope.loading = true;
    $scope.pagination = {};
    $scope.orders = [];
    var params = {
      page: p,
      page_size: $scope.PAGE_SIZE,
      'filter.status': $scope.orderStatus,
      'filter.sku': $scope.sku
    }; // Filter bu account, if necessary

    if ($scope.f.account) {
      params['filter.account_id'] = $scope.f.account.id;

      if ($scope.selectedAccount.length == 0) {
        $scope.selectedAccount.push($scope.f.account);
      }
    }

    return Order.query(params, function (res, headers) {
      $scope.orders = res;

      if (headers) {
        var pagination = JSON.parse(headers('x-pagination'));

        if (pagination) {
          $scope.currentPage = pagination.page;
          $scope.totalPages = Math.ceil(pagination.total_count / pagination.page_size);
          $scope.totalOrders = pagination.total_count;
        }
      }

      $scope.loading = false;
    }, function (err) {
      toaster.pop({
        type: 'error',
        body: "Error loading orders.",
        timeout: 2000
      });
      console.error(err);
    }).$promise;
  }

  $scope.setOrderStatus = function (status) {
    $scope.orderStatus = status;
    loadOrders(1);
  };

  $scope.setItem = function (item) {
    $scope.sku = item;
    loadOrders(1);
  };

  $scope.onSelectAccount = function (account) {
    if (account.name.length > 35) {
      account.name = account.name.substring(0, 35) + ' ...';
    }

    $scope.filter('account', account);
    loadOrders(1);
  };

  $scope.onRemoveAccount = function () {
    $scope.filter('account', undefined);
    loadOrders(1);
  };

  $scope.searchAccounts = function (text) {
    return Account.query({
      q: text,
      l: 200
    }).$promise;
  };

  $scope.next = function () {
    return loadOrders($scope.currentPage + 1);
  };

  $scope.previous = function () {
    return loadOrders($scope.currentPage - 1);
  };

  $scope.first = function () {
    return loadOrders(1);
  };

  $scope.last = function () {
    return loadOrders($scope.totalPages);
  }; // Initialize request options


  $scope.orderStatus = 'awaiting_shipment';
  $scope.query = null;
  $scope.sku = null; // Load the first page

  $scope.first();
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default table-animate-aside\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Orders</h3>\n      </div>\n      <div class=\"panel-body\">\n        <h5>Search by Account</h5>\n        <tags-input\n          placeholder=\"Type to search accounts...\"\n          display-property=\"name\"\n          key-property=\"id\"\n          max-tags=\"1\"\n          min-tags=\"0\"\n          add-from-autocomplete-only=\"true\"\n          on-tag-added=\"onSelectAccount($tag)\"\n          on-tag-removed=\"onRemoveAccount()\"\n          ng-model=\"selectedAccount\">\n          <auto-complete \n            source=\"searchAccounts($query)\"\n            max-results-to-show=\"200\"\n            debounce-delay=\"300\">\n          </auto-complete>\n        </tags-input>\n\n        <hr>\n        <h5>Order Status</h5>\n        <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: orderStatus == 'awaiting_shipment'}\" ng-click=\"setOrderStatus('awaiting_shipment')\">Awaiting Shipment</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: orderStatus == 'awaiting_payment'}\" ng-click=\"setOrderStatus('awaiting_payment')\">Awaiting Payment</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: orderStatus =='on_hold'}\" ng-click=\"setOrderStatus('on_hold')\">Backordered</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: orderStatus == 'shipped'}\" ng-click=\"setOrderStatus('shipped')\">Shipped</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: orderStatus == null}\" ng-click=\"setOrderStatus(null)\">All</button>\n        </div>\n\n        <hr>\n        <h5>Item</h5>\n        <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: sku == null}\" ng-click=\"setItem(null)\">All</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: sku == 'BXC-HDSD2'}\" ng-click=\"setItem('BXC-HDSD2')\">BoxCaster</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: sku =='BXC-PRO'}\" ng-click=\"setItem('BXC-PRO')\">BoxCaster Pro</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: sku == 'BXC-AUDIO-IOS'}\" ng-click=\"setItem('BXC-AUDIO-IOS')\">Shure MV88+</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: sku == 'BXC-SB-ASSIST'}\" ng-click=\"setItem('BXC-SB-ASSIST')\">Scoreboard Assist</button>\n        </div>\n      </div>\n    </div>\n\n    <div ng-if=\"inventory\" class=\"panel panel-default table-animate-aside\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Inventory Available to Ship</h3>\n      </div>\n      <div class=\"panel-body\">\n        <table>\n          <tr><td width=\"200px\">BoxCasters</td><td>{{inventory['BXC-HDSD2']}}</td></tr>\n          <tr><td width=\"200px\">BoxCaster Pros</td><td>{{inventory['BXC-PRO']}}</td></tr>\n          <tr><td width=\"200px\">Shure MV88+ Video Kits</td><td>{{inventory['BXC-AUDIO-IOS']}}</td></tr>\n          <tr><td width=\"200px\">Scoreboard Assists</td><td>{{inventory['BXC-SB-ASSIST']}}</td></tr>\n          <tr><td width=\"200px\">Decimator MD-LX</td><td>{{inventory['DEC-MD-LX']}}</td></tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"loading\" class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9\">\n    <table class=\"table table-striped table-light-border table-hover table-condensed table-animate\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>Order Date</th>\n          <th>Account Name</th>\n          <th>Status</th>\n          <th>Items</th>\n          <th>Tracking Number</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr class=\"clickable\" ng-repeat=\"o in orders\" ng-click=\"openURL('/order/'+ o.id, $event)\">\n          <td style=\"text-align:left\">{{$index + 1 + (currentPage - 1)*PAGE_SIZE}}</td>\n          <td>{{ o.created_at | date }}</td>\n          <td>{{ o.account.name }}</td>\n          <td ng-switch=\"o.status\">\n            <span ng-switch-when=\"on_hold\">backordered</span>\n            <span ng-switch-default>{{o.status | underscoreToSpace}}</span>\n          </td>\n          <td width=\"250px\">\n            <li ng-repeat=\"item in o.items\">\n              <small>{{item.quantity > 1 ? item.quantity + ' x ': ''}} {{item.name}}</small>\n            </li>\n          </td>\n          <td style=\"text-align:left\">\n            <a ng-if=\"o.tracking_number\"\n                ng-href=\"{{o.tracking_number | trackingLink}}\"\n                target=\"_blank\">\n              {{o.tracking_number}} <i class=\"fa fa-external-link\"></i>\n            </a>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <button ng-click=\"first()\" ng-disabled=\"currentPage === 1\" class=\"btn btn-default\" type=\"button\">First</button>\n    <button ng-click=\"previous()\" ng-disabled=\"currentPage === 1\" class=\"btn btn-default\" type=\"button\">Previous</button>\n    <button ng-click=\"next()\" ng-disabled=\"currentPage === totalPages\" class=\"btn btn-default\" type=\"button\">Next</button>\n    <button ng-click=\"last()\" ng-disabled=\"currentPage === totalPages\" class=\"btn btn-default\" type=\"button\">Last</button>\n    &nbsp;&nbsp; Total Results: {{totalOrders | number}}\n  </div>\n</div>\n"

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {angular.module('app.views').controller('ConfirmTerminationController', ["$scope", "$modalInstance", "Origin", "broadcast_count", "origin", "total_viewer_count", function ($scope, $modalInstance, Origin, broadcast_count, origin, total_viewer_count) {
  $scope.broadcast_count = broadcast_count;
  $scope.origin = origin;
  $scope.total_viewer_count = total_viewer_count;
  $scope.confirm_origin_name = '';
  $scope.note = '';
  $scope.isWorking = false;

  $scope.dataValid = function () {
    return !_.isEmpty($scope.note) && $scope.confirm_origin_name === $scope.origin;
  };

  $scope.ok = function () {
    $scope.isWorking = true;
    Origin.terminate({
      id: $scope.origin
    }, {
      user_note: $scope.note
    }, function (data) {
      alert("Origin \"".concat($scope.origin, "\" has been terminated. Please check your email for further information."));
      $modalInstance.close(data);
      $scope.isWorking = false;
    }, function (err) {
      console.error(err);
      alert('There was an error terminating the origin.');
      $scope.isWorking = false;
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__origins_scss__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__origins_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__origins_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_origin_thumbnail__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/origins/:id', {
    template: __webpack_require__(262),
    controller: 'OriginController',
    controllerAs: '$ctrl'
  });
}]).controller('OriginController', ["Origin", "$location", "$modal", "$routeParams", "$scope", "$http", "$q", "$window", function (Origin, $location, $modal, $routeParams, $scope, $http, $q, $window) {
  "ngInject";

  var _this = this;

  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];

  var load = function load() {
    return Origin.get({
      id: $routeParams.id
    }, function (data) {
      _this.origin = data;
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_origin_thumbnail__["a" /* OriginThumbnail */])($http, $q, _this.origin.name).then(function (url) {
        return _this.origin_thumbnail = url;
      });
    }, function (err) {
      console.error(err);
    });
  };

  this.loading = true;
  load().$promise["finally"](function () {
    return _this.loading = false;
  });

  this.terminate = function () {
    $modal.open({
      template: __webpack_require__(109),
      controller: 'ConfirmTerminationController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        broadcast_count: function broadcast_count() {
          return _this.origin.broadcasts.length;
        },
        origin: function origin() {
          return _this.origin.name;
        },
        total_viewer_count: function total_viewer_count() {
          return _this.totalViewerCount();
        }
      }
    }).result["finally"](function () {
      return load();
    });
  };

  this.drain = function () {
    if ($window.confirm("Are you sure you wish to drain origin \"".concat(_this.origin.name, "\"?"))) {
      Origin.drain({
        id: _this.origin.name
      }, {}, function () {}, function (err) {
        console.error(err);
        alert('There was an error draining the origin.');
      }).$promise["finally"](load);
    }
  };

  this.totalViewerCount = function () {
    return _.reduce(_.map(_this.origin.broadcasts, function (b) {
      return b.total_active_viewer_count;
    }), function (m, n) {
      return m + n;
    }, 0);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-2\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"/origins\">Origins</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ $ctrl.origin.name }}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <img ng-if=\"$ctrl.origin_thumbnail\" ng-src=\"{{ $ctrl.origin_thumbnail }}\" class=\"img-responsive img-thumbnail\">\n        <br/>\n        <button type=\"button\" class=\"btn btn-danger\" style=\"margin-top: 10px;\" ng-click=\"$ctrl.terminate()\">\n          <i class=\"fa fa-bolt\"></i> Terminate\n        </button>\n        <br ng-show=\"$ctrl.origin.status == 'ready'\" />\n        <button ng-show=\"$ctrl.origin.status == 'ready'\" type=\"button\" class=\"btn btn-warning\" style=\"margin-top: 10px;\"  ng-click=\"$ctrl.drain()\">\n          <i class=\"fa fa-ban\"></i> Drain\n        </button>\n      </div>\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n  <div class=\"col-md-10\">\n    <h4>{{ $ctrl.origin.name }}</h4>\n    <hr style=\"margin:10px 0 10px 0;\">\n    <table class=\"table table-striped table-condensed\">\n      <tr>\n        <th class=\"col-xs-2\">Status</th>\n        <td>\n          <div ng-class=\"'badge origin-status-' + $ctrl.origin.status\">{{ $ctrl.origin.status | uppercase }}</div>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"col-xs-2\">Instance Type</th>\n        <td><code ng-show=\"$ctrl.origin.instance_type\">{{ $ctrl.origin.instance_type }}</code></td>\n      </tr>\n      <tr>\n        <th class=\"col-xs-2\">Instance ID</th>\n        <td><code ng-show=\"$ctrl.origin.instance_id\">{{ $ctrl.origin.instance_id }}</code></td>\n      </tr>\n    </table>\n    <table class=\"table table-striped table-light-border table-hover table-animate table-condensed\">\n      <thead>\n        <tr>\n          <th class=\"col-xs-8\">Broadcast</th>\n          <th class=\"col-xs-4\">Transcode Delay</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!$ctrl.loading && !$ctrl.origin.broadcasts.length\" class=\"tr--no-results\"><td colspan=\"2\">No broadcasts to display.</td></tr>\n        <tr ng-repeat=\"b in $ctrl.origin.broadcasts\">\n          <td><a href=\"{{ newAdminURL }}/broadcasts/{{ b.id }}\">{{ b.name }}</a></td>\n          <td>{{ (b.stream_diagnostics.last_transcode_delay || 0) | number:1 }}s</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__origins_scss__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__origins_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__origins_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_environment__ = __webpack_require__(0);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/origins', {
    template: __webpack_require__(264),
    controller: 'OriginsController',
    controllerAs: '$ctrl'
  });
}]).controller('OriginsController', ["Origin", "$modal", "$scope", "$timeout", "$http", "$q", "$location", "$window", function (Origin, $modal, $scope, $timeout, $http, $q, $location, $window) {
  "ngInject";

  var _this = this;

  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_1_environment__["r" /* NEW_ADMIN_URL */];
  var UNHEALTHY_TRANSCODE_DELAY_LIMIT_S = 60; // Default filter: ready and draining

  this.f = {
    status: {
      stopped: false,
      starting: false,
      ready: true,
      draining: true,
      stopping: false,
      failed: false
    }
  }; // Try loading it from the search, if present

  var locationF = $location.search().f;

  if (locationF) {
    try {
      this.f = JSON.parse(decodeURIComponent(locationF));
    } catch (err) {
      console.error("Error parsing search parameter f", err);
    }
  }

  this.filter = function (key, val) {
    var keyParts = key.split('.');
    var currentFilter = _this.f;

    while (keyParts.length > 1) {
      currentFilter = currentFilter[keyParts.shift()];
    }

    currentFilter[keyParts[0]] = val;
    $location.search('f', encodeURIComponent(JSON.stringify(_this.f)));
    applyFilter();
  };

  var applyFilter = function applyFilter() {
    var filteredOrigins = [];

    _this.allOrigins.forEach(function (origin) {
      var included = true;

      for (var _i = 0, _Object$entries = Object.entries(_this.f); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (!value[origin[key]]) {
          included = false;
          break;
        }
      }

      if (included) {
        filteredOrigins.push(origin);
      }
    });

    _this.origins = _.sortBy(filteredOrigins, 'name');
  };

  this.maxTranscodeDelay = function (origin) {
    if (_.isEmpty(origin.broadcasts)) {
      return 0;
    }

    return _.max(_.map(origin.broadcasts, function (broadcast) {
      return parseFloat((broadcast.stream_diagnostics || {}).last_transcode_delay || 0);
    }));
  };

  this.originIsUnhealthy = function (origin) {
    return _this.maxTranscodeDelay(origin) > UNHEALTHY_TRANSCODE_DELAY_LIMIT_S;
  };

  this.totalViewerCount = function (origin) {
    return _.reduce(_.map(origin.broadcasts, function (b) {
      return b.total_active_viewer_count;
    }), function (m, n) {
      return m + n;
    }, 0);
  };

  this.terminate = function (_origin) {
    $modal.open({
      template: __webpack_require__(109),
      controller: 'ConfirmTerminationController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        broadcast_count: function broadcast_count() {
          return _origin.broadcasts.length;
        },
        origin: function origin() {
          return _origin.name;
        },
        total_viewer_count: function total_viewer_count() {
          return _this.totalViewerCount(_origin);
        }
      }
    }).result["finally"](function () {
      return load();
    });
  };

  this.drain = function (origin) {
    if ($window.confirm("Are you sure you wish to drain origin \"".concat(origin.name, "\"?"))) {
      Origin.drain({
        id: origin.name
      }, {}, function () {}, function (err) {
        console.error(err);
        alert('There was an error draining the origin.');
      }).$promise["finally"](load);
    }
  };

  var load = function load() {
    return Origin.query({}, // no query params
    function (data) {
      _this.allOrigins = data;
      applyFilter();
    }, function (err) {
      console.error(err);
      alert('There was an error loading origins. Please reload the page.');
    });
  };

  this.loading = true;
  load().$promise["finally"](function () {
    return _this.loading = false;
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-2\">\n    <div class=\"panel panel-default table-animate-aside\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Origins</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div>\n          <h5>Filter by Status</h5>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"$ctrl.f.status.stopped\" ng-click=\"$ctrl.filter('status.stopped', !$ctrl.f.status.stopped)\">Stopped</label>\n          </div>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"$ctrl.f.status.starting\" ng-click=\"$ctrl.filter('status.starting', !$ctrl.f.status.starting)\">Starting</label>\n          </div>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"$ctrl.f.status.ready\" ng-click=\"$ctrl.filter('status.ready', !$ctrl.f.status.ready)\">Ready</label>\n          </div>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"$ctrl.f.status.draining\" ng-click=\"$ctrl.filter('status.draining', !$ctrl.f.status.draining)\">Draining</label>\n          </div>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"$ctrl.f.status.stopping\" ng-click=\"$ctrl.filter('status.stopping', !$ctrl.f.status.stopping)\">Stopping</label>\n          </div>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"$ctrl.f.status.failed\" ng-click=\"$ctrl.filter('status.failed', !$ctrl.f.status.failed)\">Failed</label>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"$ctrl.loading\" class=\"col-md-10\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!$ctrl.loading && $ctrl.origins.length === 0\" class=\"col-md-10\">\n    <p>No origins!</p>\n  </div>\n\n  <div ng-if=\"!$ctrl.loading && $ctrl.origins.length > 0\" class=\"col-md-10\">\n    <table class=\"table table-striped table-light-border table-animate table-condensed\">\n      <thead>\n        <tr>\n          <th>Origin Name</th>\n          <th>Status</th>\n          <th>Instance ID</th>\n          <th>Broadcasts</th>\n          <th>Transcode Delays</th>\n          <th>&nbsp;</th>\n        </tr>\n      </thead>\n\n      <tbody>\n        <tr ng-repeat=\"origin in $ctrl.origins track by origin.name\" ng-class=\"{'origin-unhealthy': $ctrl.originIsUnhealthy(origin)}\">\n          <td>\n            <a href=\"/origins/{{ origin.name }}\">{{ origin.name }}</a>\n          </td>\n          <td>\n            <div ng-class=\"'badge origin-status-' + origin.status\">{{ origin.status | uppercase }}</div>\n          </td>\n          <td>\n            <code ng-show=\"origin.instance_id\">{{ origin.instance_id }}</code>\n          </td>\n          <td>\n            <div ng-repeat=\"broadcast in origin.broadcasts\">\n              <a ng-href=\"{{ newAdminURL }}/broadcasts/{{broadcast.id}}\" style=\"white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\">{{ broadcast.name | limitTo:40 }}{{ broadcast.name.length > 40 ? '&hellip;' : '' }}</a>\n            </div>\n          </td>\n          <td>\n            <div ng-repeat=\"broadcast in origin.broadcasts\">\n              {{ (broadcast.stream_diagnostics.last_transcode_delay || 0) | number:1 }}s\n            </div>\n          </td>\n          <td>\n            <button ng-show=\"$ctrl.originIsUnhealthy(origin)\" type=\"button\" class=\"pull-left btn btn-danger\"\n              ng-click=\"$ctrl.terminate(origin)\"><i class=\"fa fa-bolt\"></i> Terminate</button>\n            <button ng-show=\"origin.status == 'ready'\" type=\"button\" class=\"pull-left btn btn-warning\"\n              ng-click=\"$ctrl.drain(origin)\"><i class=\"fa fa-ban\"></i> Drain</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scoreboard_assist_inventory_form_controller__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scoreboard_assist_inventory_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scoreboard_assist_inventory_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scoreboard_assist_register_form_controller__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scoreboard_assist_register_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scoreboard_assist_register_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/scoreboard_assists/:id', {
    template: __webpack_require__(268),
    controller: 'ScoreboardAssistController'
  });
}]).controller('ScoreboardAssistController', ["$scope", "$routeParams", "$modal", "ScoreboardAssist", "Config", function ($scope, $routeParams, $modal, ScoreboardAssist, Config) {
  $scope.config = Config;
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];
  $scope.scoreboardAssist = ScoreboardAssist.get({
    id: $routeParams.id
  });

  $scope.canUnregister = function (scoreboardAssist) {
    return !!scoreboardAssist.account_id;
  };

  $scope.canRegister = function (scoreboardAssist) {
    return !scoreboardAssist.account_id;
  };

  $scope.unregister = function (scoreboardAssist) {
    if (confirm('Are you sure you want to unregister this Scoreboard Assist?')) {
      return ScoreboardAssist.update({
        id: scoreboardAssist.id,
        account_id: ''
      }, function (data) {
        return $scope.scoreboardAssist = data;
      });
    }
  };

  $scope.register = function (scoreboardAssist) {
    $modal.open({
      template: __webpack_require__(269),
      controller: 'ScoreboardAssistRegisterFormController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function (sa) {
      return $scope.scoreboardAssist = sa;
    });
  };

  $scope.editInventory = function (scoreboardAssist) {
    return $modal.open({
      template: __webpack_require__(270),
      controller: 'ScoreboardAssistInventoryFormController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function (sa) {
      return $scope.scoreboardAssist = sa;
    });
  };

  ;
}]);

/***/ }),
/* 266 */
/***/ (function(module, exports) {

angular.module('app.views').controller('ScoreboardAssistInventoryFormController', ["$scope", "$routeParams", "$modalInstance", "ScoreboardAssist", "Account", "Config", function ($scope, $routeParams, $modalInstance, ScoreboardAssist, Account, Config) {
  $scope.config = Config;
  $scope.isSaving = false;
  $scope.isNew = !$routeParams.id;

  if (!$scope.isNew) {
    $scope.scoreboardAssist = ScoreboardAssist.get({
      id: $routeParams.id
    });
    $scope.scoreboardAssist.$promise.then(function (sa) {
      return $scope.selectedAccount = sa.account_id ? [Account.get({
        id: sa.account_id
      })] : null;
    });
  }

  $scope.searchAccounts = function (text) {
    return Account.query({
      q: text
    }).$promise;
  };

  $scope.ok = function () {
    $scope.isSaving = true;
    var sa = $scope.scoreboardAssist;
    var updated = {
      id: sa.id,
      physical_status: sa.physical_status,
      payment_status: sa.payment_status,
      special_notes: sa.special_notes
    };
    return ScoreboardAssist.update(updated, function (sa) {
      return $modalInstance.close(sa);
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {angular.module('app.views').controller('ScoreboardAssistRegisterFormController', ["$scope", "$routeParams", "$modalInstance", "$timeout", "ScoreboardAssist", "Account", function ($scope, $routeParams, $modalInstance, $timeout, ScoreboardAssist, Account) {
  $scope.isSaving = false;
  $scope.selectedAccount = null;
  $scope.isNew = !$routeParams.id;

  if (!$scope.isNew) {
    $scope.scoreboardAssist = ScoreboardAssist.get({
      id: $routeParams.id
    });
  }

  $scope.searchAccounts = function (text) {
    return Account.query({
      q: text
    }).$promise;
  };

  $scope.ok = function () {
    $scope.isSaving = true;
    return ScoreboardAssist.update({
      id: $scope.scoreboardAssist.id,
      account_id: $scope.selectedAccount[0].id
    }, function (a) {
      return $modalInstance.close(a);
    }, function (error) {
      return alert("Error saving: ".concat(error.error_description));
    });
  };

  $timeout(function () {
    $('tags-input input').focus();
  }, 300);

  $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"/scoreboard_assists\">Scoreboard Assists</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ scoreboardAssist.id }}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <button ng-click=\"editInventory(scoreboardAssist)\" class=\"btn btn-sm btn-block btn-info\">Edit Inventory Status</button>\n        <button ng-show=\"canRegister(scoreboardAssist)\" ng-click=\"register(scoreboardAssist)\" class=\"btn btn-sm btn-block btn-primary\">Register</button>\n        <button ng-show=\"canUnregister(scoreboardAssist)\" ng-click=\"unregister(scoreboardAssist)\" class=\"btn btn-sm btn-block btn-danger\">Unregister</button>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <h4>{{ scoreboardAssist.id }}</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr><th>MAC Address:</th><td>{{ scoreboardAssist.mac_address | macAddress }}</td></tr>\n      <tr><th>Side:</th><td><span ng-show=\"scoreboardAssist.is_scoreboard_side\">Scoreboard</span><span ng-hide=\"scoreboardAssist.is_scoreboard_side\">BoxCaster</span></td></tr>\n      <tr ng-show=\"scoreboardAssist.account_id\"><th class=\"col-xs-2\">Account</th><td><a href=\"{{ newAdminURL }}/accounts/{{ scoreboardAssist.account_id }}\">{{ scoreboardAssist.account_name }}</a></td></tr>\n      <tr><th>Physical Status</th><td>{{ scoreboardAssist.physical_status | label: config.boxcaster.physical_statuses }}</td></tr>\n      <tr><th>Payment Status</th><td>{{ scoreboardAssist.payment_status | label: config.boxcaster.payment_statuses }}</td></tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Register Scoreboard Assist</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-sm-12\">\n      <div class=\"form-group\">\n        <label for=\"account\">Account</label>\n        <tags-input\n            placeholder=\"Type to search accounts...\"\n            display-property=\"name\",\n            key-property=\"id\"\n            max-tags=\"1\"\n            min-tags=\"1\"\n            add-from-autocomplete-only=\"true\"\n            ng-model=\"selectedAccount\">\n          <auto-complete source=\"searchAccounts($query)\"></auto-complete>\n        </tags-input>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Edit Scoreboard Assist Inventory Status</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\">\n    <div class=\"col-md-6\">\n      <div class=\"form-group\">\n        <label for=\"account\">Account</label>\n        <div ng-show=\"selectedAccount[0]\">{{ selectedAccount[0].name }}</div>\n        <div ng-hide=\"selectedAccount[0]\"><em>Unregistered</em></div>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"market\">Physical Status</label>\n        <select id=\"market\" ng-model=\"scoreboardAssist.physical_status\" class=\"form-control\">\n          <option value=\"unknown\"></option>\n          <option ng-repeat=\"e in config.boxcaster.physical_statuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n        </select>\n      </div>\n      <div class=\"form-group\">\n        <label for=\"market\">Payment Status</label>\n        <select id=\"market\" ng-model=\"scoreboardAssist.payment_status\" class=\"form-control\">\n          <option value=\"unknown\"></option>\n          <option ng-repeat=\"e in config.boxcaster.payment_statuses\" value=\"{{ e.value }}\">{{ e.label }}</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"col-md-6\">\n      <div class=\"form-group\">\n        <label for=\"special_notes\">Special Notes</label>\n        <textarea id=\"special_notes\" type=\"text\" rows=\"6\" ng-model=\"scoreboardAssist.special_notes\" class=\"form-control\"></textarea>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);


angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/scoreboard_assists', {
    template: __webpack_require__(272),
    controller: 'ScoreboardAssistsController'
  });
}]).controller('ScoreboardAssistsController', ["$scope", "$location", "$modal", "Account", "ScoreboardAssist", "Config", function ($scope, $location, $modal, Account, ScoreboardAssist, Config) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = 'id');
  $scope.config = Config;
  $scope.loading = true;

  var params = _.pick($scope, 'q', 's', 'p');

  if (params.q && params.q.match(/^[a-zA-Z0-9]+$/)) {
    // NOTE: the `id` is just the MAC address with an "s" prefix
    if (params.q.startsWith('s')) {
      params.q = params.q.substring(1);
    }

    params.q = "mac_address:*".concat(params.q, "*");
  }

  if ($scope.f.account && $scope.f.account.active) {
    params['filter.account_id'] = $scope.f.account.id;
  }

  $scope.scoreboardAssists = ScoreboardAssist.query(params, function (data, getResponseHeader) {
    $scope.loading = false;
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });

  $scope.createManufacturingScoreboardAssists = function () {
    $modal.open({
      template: __webpack_require__(273),
      controller: 'ScoreboardAssistsNewMfgController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function (mfgAccountId) {
      Account.get({
        id: mfgAccountId
      }, function (a) {
        var filter = "account:" + encodeURIComponent(JSON.stringify(_.extend({
          active: true
        }, _.pick(a, 'id', 'name'))));
        $location.url("/scoreboard_assists?f=".concat(encodeURIComponent(filter)));
      }, function (err) {
        console.error(err);
        toaster.pop({
          type: 'error',
          body: "Error loading manufacturing account. Please try again.",
          timeout: 2000
        });
      });
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default table-animate-aside\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Scoreboard Assists</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by ID\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n        <div ng-show=\"f.account\">\n          <hr>\n          <h5>Filter by Account</h5>\n          <div class=\"checkbox\">\n            <label><input type=\"checkbox\" ng-checked=\"f.account.active\" ng-click=\"filter('account.active', !f.account.active)\"> {{ f.account.name }}</label>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Manufacturing</h3>\n      </div>\n      <div class=\"panel-body\">\n        <p class=\"help-block\">Create a block of Scoreboard Assist devices to be provided to a manufacturer. Go away unless you know what you're doing. :-)</p>\n        <button type=\"button\"\n                class=\"btn btn-default btn-block\"\n                ng-click=\"createManufacturingScoreboardAssists()\">\n          <i class=\"fa fa-plus\"></i> Create Scoreboard Assists for Manufacturing\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"loading\" class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9\">\n    <table class=\"table table-striped table-light-border table-hover table-condensed table-animate\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('id')\" class=\"clickable\">\n            ID\n            <i ng-show=\"s.indexOf('id') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'id'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-id'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>MAC Address</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!loading && !scoreboardAssists.length\" class=\"tr--no-results\"><td colspan=\"2\">No Scoreboard Assists were found.</td></tr>\n        <tr ng-repeat=\"sa in scoreboardAssists\" ng-click=\"openURL('/scoreboard_assists/'+sa.id, $event)\" class=\"clickable\">\n          <td>{{ sa.id }}</td>\n          <td>{{ sa.mac_address | macAddress }}</td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Create Scoreboard Asssits for Manufacturer</h3>\n</div>\n<div class=\"modal-body clearfix\">\n  <form id=\"recording-form\" name=\"form\" role=\"form\">\n    <div class=\"col-sm-5\">\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Manufacturer: </span>\n        <select id=\"manufacturerId\" ng-model=\"manufacturerId\" required class=\"form-control\" ng-change=\"updateMfgAccount()\">\n          <option ng-repeat=\"m in manufacturers\" value=\"{{ m.id }}\">{{ m.name }}</option>\n        </select>\n      </div>\n      <div class=\"input-group\">\n        <span class=\"input-group-addon\">Count: </span>\n        <input id=\"count\" type=\"number\" ng-model=\"count\" required class=\"form-control\" min=\"1\" max=\"500\">\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isCreating\" class=\"btn btn-primary\"><i ng-show=\"isCreating\" class=\"fa fa-cog fa-spin\"></i> Create</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>\n"

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {angular.module('app.views').controller('ScoreboardAssistsNewMfgController', ["$scope", "$routeParams", "$modalInstance", "ScoreboardAssist", "Manufacturer", function ($scope, $routeParams, $modalInstance, ScoreboardAssist, Manufacturer) {
  $scope.isCreating = false;
  $scope.manufacturerId = null;
  $scope.count = 1;
  $scope.manufacturerAccountId = null;
  $scope.manufacturers = Manufacturer.query(function (data) {
    $scope.manufacturerId = data[0].id;
    $scope.manufacturerAccountId = data[0].account_id;
  });

  $scope.updateMfgAccount = function () {
    $scope.manufacturerAccountId = _.find($scope.manufacturers, function (m) {
      return m.id === $scope.manufacturerId;
    }).account_id;
  };

  $scope.ok = function () {
    $scope.isCreating = true;
    ScoreboardAssist.createBatch({
      count: $scope.count,
      manufacturer_id: $scope.manufacturerId
    }, function (data) {
      // Okay... got the data -- format, convert to CSV, and download
      var csvStr = 'serial_num,mac_id\n';
      csvStr += data.map(function (scoreboardAssist) {
        var macID = scoreboardAssist.mac_address.toUpperCase().replace(/(.{2})/g, "$1-").slice(0, -1);
        return "".concat(scoreboardAssist.id, ",").concat(macID);
      }).join('\n');
      var downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href", "data:text/csv;charset=utf-8,".concat(encodeURIComponent(csvStr)));
      downloadAnchorNode.setAttribute("download", "scoreboard_assists.csv");
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
      return $modalInstance.close($scope.manufacturerAccountId);
    }, function (err) {
      alert('There was an error creating the Scoreboard Assists.');
    });
    $scope.isCreating = false;
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/storage_bill/:id', {
    template: __webpack_require__(276),
    controller: 'StorageBillController'
  });
}]).controller('StorageBillController', ["$scope", "$routeParams", "$location", "StorageBill", "AccountStorageBill", function ($scope, $routeParams, $location, StorageBill, AccountStorageBill) {
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  var id = $routeParams.id;

  if (id == 'peek') {
    $scope.bill = AccountStorageBill.peek({
      account_id: $routeParams.account_id,
      starts_at: $routeParams.starts_at,
      ends_at: $routeParams.ends_at
    });
  } else {
    $scope.bill = StorageBill.get({
      id: id
    });
  }
}]);

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Storage Bill</h3>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <table class=\"table table-striped table-condensed\">\n      <tr><th class=\"col-xs-2\">Billing Period</th><td>{{ bill.starts_at | date: 'yyyy-MM-dd' : 'UTC' }} &mdash; {{ bill.ends_at | date: 'yyyy-MM-dd' : 'UTC' }}</td></tr>\n      <tr><th class=\"col-xs-2\">Charged?</th><td>\n          <span ng-show=\"bill.stripe_charge_id\">Yes</span>\n          <span ng-hide=\"bill.stripe_charge_id\">No</span>\n          <span ng-show=\"bill.stripe_charge_id\">\n            &nbsp;\n            <a href=\"https://dashboard.stripe.com/payments/{{bill.stripe_charge_id}}\" target=\"_blank\">\n              <i class=\"fa fa-external-link\"></i>\n              View in Stripe\n            </a>\n          </span>\n        </td></tr>\n      <tr><th class=\"col-xs-2\">Amount</th><td>{{ bill.total_charge | currency }}</td></tr>\n      <tr><th class=\"col-xs-2\">Broadcast Hours</th><td>{{ bill.total_broadcast_hours | number:2 }}</td></tr>\n    </table>\n    <hr>\n    <h4>Individual Broadcasts</h4>\n    <table class=\"table table-striped table-hover table-condensed\">\n      <thead>\n        <tr>\n          <th class=\"col-xs-2\">Name</th>\n          <th class=\"col-xs-3\">Date/Time</th>\n          <th class=\"col-xs-3\">Amount</th>\n          <th class=\"col-xs-2\">Broadcast Hours</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"b in bill.individual_broadcasts\"\n            ng-click=\"openURL(newAdminURL+'/broadcasts/'+b.broadcast_id, $event)\"\n            class=\"clickable\">\n          <td>{{ b.broadcast_name }}</td>\n          <td>{{ [b.broadcast_starts_at, b.broadcast_stops_at] | datespan }}</td>\n          <td>{{ b.charge | currency }}</td>\n          <td>{{ b.broadcast_hours | number:2 }}</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_csv__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_environment__ = __webpack_require__(0);




angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/storage_bills', {
    template: __webpack_require__(279),
    controller: 'StorageBillsController'
  });
}]).controller('StorageBillsController', ["$scope", "$location", "StorageBill", "$filter", "$q", function ($scope, $location, StorageBill, $filter, $q) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = 'starts_at,account_name');
  $scope.q || ($scope.q = '');
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_3_environment__["r" /* NEW_ADMIN_URL */];
  $scope.loading = true;

  var params = _.pick($scope, 'q', 's', 'p');

  if (!$scope.f.charged && !$scope.f.uncharged) {
    // status not supported by API ... default to uncharged
    $scope.f.uncharged = true;
  }

  if ($scope.f.charged && !$scope.f.uncharged) {
    params['filter.charged'] = 'true';
  }

  if ($scope.f.uncharged && !$scope.f.charged) {
    params['filter.charged'] = 'false';
  }

  params['filter.is_archived'] = 'false';
  $scope.storageBills = StorageBill.query(params, function (data, getResponseHeader) {
    $scope.loading = false;
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });

  $scope.charge = function (bill) {
    bill.__charging__ = true;
    var method = bill.account_payment_status == 'manual' ? 'manual' : 'stripe';
    StorageBill.charge({
      id: bill.id,
      method: method
    }, null, function (data) {
      bill.__charging__ = false;
      bill.stripe_charge_id = data.stripe_charge_id;
    });
  };

  $scope["delete"] = function (bill) {
    if (!confirm("Are you sure you want to delete the bill for ".concat(bill.account_name, "? This cannot be undone."))) {
      return;
    }

    StorageBill["delete"]({
      id: bill.id
    }, null, function (data) {
      $scope.storageBills.splice($scope.storageBills.indexOf(bill), 1);
    });
  };

  $scope.generateCSV = function () {
    $scope.generatingCSV = true;
    $scope.getAllStorageBills('charged:false').then(function (result) {
      var bills = result;
      Object(__WEBPACK_IMPORTED_MODULE_2__create_csv__["b" /* forceDownload */])(Object(__WEBPACK_IMPORTED_MODULE_2__create_csv__["a" /* createCSV */])(bills, $filter));
      $scope.generatingCSV = false;
      $scope.generatedCSV = true;
    });
  };

  $scope.getAllStorageBills = function () {
    var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var allStorageBills = [];
    return $q(function (resolve, reject) {
      var page = 0;

      var queryStorageBills = function queryStorageBills() {
        var query = angular.extend({}, _.pick($scope, 's'), {
          q: filter,
          p: page,
          l: pageSize,
          'filter.is_archived': 'false'
        });
        StorageBill.query(query, function (data, headers) {
          allStorageBills = allStorageBills.concat(data);
          var pagination = JSON.parse(headers('X-Pagination')) || {};

          if (!pagination.last || page >= pagination.last || data.length == 0) {
            resolve(allStorageBills);
          } else {
            page++;
            queryStorageBills();
          }
        }, function (err) {
          reject(err);
        });
      };

      queryStorageBills();
    });
  };

  $scope.accountUrl = function (bill) {
    return "".concat(__WEBPACK_IMPORTED_MODULE_3_environment__["r" /* NEW_ADMIN_URL */], "/accounts/").concat(bill.account_id);
  };

  $scope.showUrl = function (bill) {
    return "".concat(__WEBPACK_IMPORTED_MODULE_3_environment__["r" /* NEW_ADMIN_URL */], "/storage-bills/").concat(bill.id);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCSV;
/* harmony export (immutable) */ __webpack_exports__["b"] = forceDownload;
var XERO_ACCT = 435;
var XERO_HEADER = ",*ContactName,,EmailAddress,POAddressLine1,POAddressLine2,POAddressLine3,POAddressLine4,POCity,PORegion,POPostalCode,POCountry,*InvoiceNumber,*InvoiceDate,*DueDate,InventoryItemCode,Description,*Quantity,*UnitAmount,*AccountCode,*TaxType,TrackingName1,TrackingOption1,TrackingName2,TrackingOption2,Currency";

function csvify(val) {
  var result = val.replace(/"/g, '""');

  if (result.search(/("|,|\n)/g) >= 0) {
    result = '"' + result + '"';
  }

  return result;
}

function processRow(bill, strftime) {
  var starts_at = new Date(Date.parse(bill.starts_at));
  var ends_at = new Date(Date.parse(bill.ends_at));
  var invoice_desc = strftime(starts_at, 'MMMM yyyy') + ' Storage Bill';
  return "\"".concat(invoice_desc, "\",\"").concat(bill.account_name, "\",\"").concat(bill.account_name, " ").concat(invoice_desc, "\",") + ",,,,,,,,," + "".concat(bill.account_name, " ").concat(invoice_desc, "\",") + "".concat(strftime(starts_at, "M/d/yyyy"), ",") + "".concat(strftime(ends_at, "M/d/yyyy"), ",") + "," + "\"".concat(bill.account_name, " ").concat(invoice_desc, "\",") + "1," + "$".concat(bill.total_charge, ",") + "".concat(XERO_ACCT, ",") + "Tax Exempt," + ",,,," + "".concat(bill.stripe_charge_id) + '\n';
}

function createCSV(bills, $filter) {
  function strftime(d, f) {
    var localDate = new Date(d);
    var localTime = localDate.getTime();
    var localOffset = localDate.getTimezoneOffset() * 60000;
    return $filter('date')(new Date(localTime + localOffset), f);
  }

  var csvFile = XERO_HEADER + '\n';

  for (var i = 0; i < bills.length; i++) {
    csvFile += processRow(bills[i], strftime);
  }

  return csvFile;
}
function forceDownload(csvFile) {
  var blob = new Blob([csvFile], {
    type: 'text/csv;charset=utf-8;'
  });
  var link = document.createElement("a");
  var url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", "storage_bills_export.csv");
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3 table-animate-aside\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Storage Bills</h3>\n      </div>\n      <div class=\"panel-body\">\n        <p>Reconcile storage bills.</p>\n\n        <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n          <button type=\"button\" class=\"btn btn-default\" ng-class=\"{active: f.uncharged}\" ng-click=\"filter('uncharged', !f.uncharged)\">Uncharged</button>\n          <button type=\"button\" class=\"btn btn-default\" ng-class=\"{active: f.charged}\" ng-click=\"filter('charged', !f.charged)\">Charged</button>\n        </div>\n\n        <!--div class=\"checkbox\">\n          <label><input type=\"checkbox\" ng-checked=\"f.include_charged\" ng-click=\"filter('include_charged', !f.include_charged)\"> Include Charged</label>\n        </div-->\n\n      </div>\n    </div>\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Xero Import</h3>\n      </div>\n      <div class=\"panel-body\">\n        <p class=\"help-block\">Tapping the button will create and download a CSV file of uncharged bills that can be imported into Xero.</p>\n        <p class=\"text-success bg-success\" ng-show=\"generatedCSV\" style=\"padding:10px; border:1px solid\">\n          CSV file successfully generated. Check your Downloads folder.\n        </p>\n        <button type=\"button\"\n                class=\"btn btn-default btn-block\"\n                ng-disabled=\"generatingCSV\"\n                ng-click=\"generateCSV()\">\n          <em ng-show=\"generatingCSV\">Generating...</em>\n          <span ng-hide=\"generatingCSV\">Generate CSV for Xero</span>\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"loading\" class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9\">\n    <table class=\"table table-striped table-light-border table-hover table-animate table-condensed\">\n      <thead>\n        <tr>\n          <th>Detail</th>\n          <th ng-click=\"sort('account_name')\" class=\"clickable\">\n            Account\n            <i ng-show=\"s.indexOf('account_name') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'account_name'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-account_name'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th ng-click=\"sort('starts_at')\" class=\"clickable\">\n            Date\n            <i ng-show=\"s.indexOf('starts_at') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'starts_at'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-starts_at'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Amount</th>\n          <th>Hours</th>\n          <th>Amt Last Mo</th>\n          <th>Hrs Last Mo</th>\n          <th ng-click=\"sort('account_payment_status')\" class=\"clickable\">\n            Acct Payment Status\n            <i ng-show=\"s.indexOf('account_payment_status') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'account_payment_status'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-account_payment_status'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th></th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!loading && !storageBills.length\" class=\"tr--no-results\"><td colspan=\"8\">No bills to display.</td></tr>\n        <tr ng-repeat=\"bill in storageBills\">\n          <td><a href=\"{{ showUrl(bill) }}\" target=\"_blank\"><i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a></td>\n          <td><a href=\"{{ accountUrl(bill) }}\">{{ bill.account_name }}</a></td>\n          <td ng-click=\"openURL('{{ newAdminURL }}'+'/storage-bills/'+bill.id, $event)\" class=\"clickable\">{{ bill.starts_at | date: 'yyyy-MM-dd' : 'UTC' }}</td>\n          <td ng-click=\"openURL('{{ newAdminURL }}'+'/storage-bills/'+bill.id, $event)\"  class=\"clickable\">{{ bill.total_charge | currency }}</td>\n          <td ng-click=\"openURL('{{ newAdminURL }}'+'/storage-bills/'+bill.id, $event)\"  class=\"clickable\">{{ bill.total_broadcast_hours | number:2 }}</td>\n          <td ng-click=\"openURL('{{ newAdminURL }}'+'/storage-bills/'+bill.id, $event)\"  class=\"clickable\">{{ (bill.last_month || {}).total_charge | currency }}</td>\n          <td ng-click=\"openURL('{{ newAdminURL }}'+'/storage-bills/'+bill.id, $event)\"  class=\"clickable\">\n            {{ (bill.last_month || {}).total_broadcast_hours | number:2 }}\n          </td>\n          <td>\n            <span ng-if=\"bill.account_payment_status == 'manual' && bill.account_xero_handle\">\n              Manual Billing\n              (<a target=\"_blank\" href=\"https://go.xero.com/Contacts/View.aspx?contactID={{ bill.account_xero_handle }}\">Xero</a>)\n            </span>\n            <span ng-if=\"bill.account_payment_status == 'manual' && !bill.account_xero_handle\">\n              Manual Billing\n              (Xero not linked)\n            </span>\n            <span ng-if=\"bill.account_payment_status != 'manual' && bill.account_stripe_customer_handle\">\n              {{  bill.account_payment_status | label: 'paymentStatuses' }}\n              (<a target=\"_blank\" href=\"https://dashboard.stripe.com/customers/{{ bill.account_stripe_customer_handle }}\">Stripe</a>)\n            </span>\n            <span ng-if=\"bill.account_payment_status != 'manual' && !bill.account_stripe_customer_handle\">\n              {{  bill.account_payment_status | label: 'paymentStatuses' }}\n              (Stripe not linked)\n            </span>\n          </td>\n          <td>\n            <span ng-hide=\"bill.stripe_charge_id || bill.__charging__\">\n              <button ng-click=\"charge(bill)\" class=\"btn btn-primary btn-sm\">\n                <i class=\"fa fa-money\"></i>\n                <span ng-if=\"bill.account_payment_status != 'manual'\">Charge</span>\n                <span ng-if=\"bill.account_payment_status == 'manual'\">Mark Manually Charged</span>\n              </button>\n            </span>\n            <span ng-show=\"bill.__charging__\">\n              Processing Charge...\n            </span>\n            <span ng-show=\"bill.stripe_charge_id && bill.stripe_charge_id.startsWith('in_')\">\n              <a href=\"https://dashboard.stripe.com/invoices/{{bill.stripe_charge_id}}\" target=\"_blank\">\n                <i class=\"fa fa-external-link\"></i>\n                View in Stripe\n              </a>\n            </span>\n            <span ng-show=\"bill.stripe_charge_id && bill.stripe_charge_id.startsWith('ch_')\">\n              <a href=\"https://dashboard.stripe.com/payments/{{bill.stripe_charge_id}}\" target=\"_blank\">\n                <i class=\"fa fa-external-link\"></i>\n                View in Stripe\n              </a>\n            </span>\n            <span ng-show=\"bill.stripe_charge_id && bill.stripe_charge_id == 'manual'\">\n              Manually Charged\n            </span>\n          </td>\n          <td>\n            <a href ng-click=\"delete(bill)\" class=\"text-danger\">\n              <i class=\"fa fa-times\"></i>\n            </a>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/suppressed_emails/:id', {
    template: __webpack_require__(281),
    controller: 'SuppressedEmailController'
  });
}]).controller('SuppressedEmailController', ["$scope", "$window", "$routeParams", "SuppressedEmail", function ($scope, $window, $routeParams, SuppressedEmail) {
  $scope.email = SuppressedEmail.get({
    id: $routeParams.id
  });
  return $scope["delete"] = function () {
    SuppressedEmail["delete"]({
      id: $routeParams.id
    }, function () {
      return $window.history.back();
    });
  };
}]);

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"/suppressed_emails\">Suppressed Emails</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ email.email }}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <img ng-show=\"email.email\" src=\"https://www.gravatar.com/avatar/{{ email.email | lowercase | md5 }}?s=192&d=mm\" class=\"img-responsive img-thumbnail pull-right\" style=\"width:50%\">\n        <p><a href=\"#\" ng-click=\"delete()\">\n          <i class=\"fa fa-trash-o\"></i>\n          Delete Suppression\n        </a></p>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <table class=\"table table-striped table-condensed\">\n      <tr><th class=\"col-xs-2\">Email</th><td>{{ email.email }}</td></tr>\n      <tr><th class=\"col-xs-2\">Reason</th><td>{{ email.reason }}</td></tr>\n      <tr><th class=\"col-xs-2\">Suppressed At</th><td>{{ email.updated_at | date: 'MM/dd/yyyy hh:mm a' }}</td></tr>\n    </table>\n    <hr>\n  </div>\n</div>\n"

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__suppressed_email_suppressed_email_form_controller__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__suppressed_email_suppressed_email_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__suppressed_email_suppressed_email_form_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);


angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/suppressed_emails', {
    template: __webpack_require__(284),
    controller: 'SuppressedEmailsController'
  });
}]).controller('SuppressedEmailsController', ["$scope", "$location", "$modal", "SuppressedEmail", function ($scope, $location, $modal, SuppressedEmail) {
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = 'email');
  $scope.loading = true;
  $scope.suppressedEmails = SuppressedEmail.query(_.pick($scope, 'q', 's', 'p'), function (data, getResponseHeader) {
    $scope.loading = false;
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });

  $scope.create = function () {
    return $modal.open({
      template: __webpack_require__(285),
      controller: 'SuppressedEmailFormController',
      size: 'lg',
      backdrop: 'static'
    }).result.then(function (e) {
      return $scope.show(e);
    });
  };

  return $scope.show = function (e) {
    return $location.url("/suppressed_emails/".concat(e.email));
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

angular.module('app.views').controller('SuppressedEmailFormController', ["$scope", "$location", "$modalInstance", "$filter", "SuppressedEmail", function ($scope, $location, $modalInstance, $filter, SuppressedEmail) {
  $scope.isSaving = false;
  $scope.email = {
    email: '',
    reason: ''
  };

  $scope.ok = function () {
    $scope.isSaving = true;
    $scope.email.email = $filter('lowercase')($scope.email.email);
    return SuppressedEmail.save($scope.email, function (e) {
      return $modalInstance.close(e);
    }, function (err) {
      alert('Error creating suppressed email.');
    });
  };

  return $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n\n  <div class=\"col-md-3 table-animate-aside\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Suppressed Emails</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by Name\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n      </div>\n    </div>\n    <p class=\"pull-right\"><button ng-click=\"create()\" class=\"btn btn-primary\"><i class=\"fa fa-plus\"></i> Suppress a New Email</button></p>\n    <div class=\"clearfix\"></div>\n  </div>\n\n  <div ng-if=\"loading\" class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9\">\n    <table class=\"table table-striped table-light-border table-animate table-hover table-condensed\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('email')\" class=\"clickable\">\n            Email\n            <i ng-show=\"s.indexOf('email') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'email'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-email'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Reason</th>\n          <th>Suppressed At</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!loading && !suppressedEmails.length\" class=\"tr--no-results\"><td colspan=\"3\">No suppressed e-mails were found.</td></tr>\n        <tr ng-repeat=\"e in suppressedEmails\" ng-click=\"show(e)\" class=\"clickable\">\n          <td>{{ e.email }}</td>\n          <td>{{ e.reason }}</td>\n          <td>{{ e.updated_at | date:'MM/dd/yyyy hh:mm a' }}</td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Create a New Suppressed Email</h3>\n</div>\n    \n<div class=\"modal-body clearfix\">\n  <form name=\"form\" role=\"form\" style=\"margin-top:15px\">\n    <div class=\"col-xs-12\">\n      <p>Enter as much information as you can for this new account. If you need to edit advanced settings, switch to the\n      Advanced tab or enter them on the account editor after you're done here.</p>\n    </div>\n    <div class=\"col-sm-8\">\n      <div class=\"form-group\">\n        <label for=\"email\">Email</label>\n        <input id=\"email\" type=\"text\" ng-model=\"email.email\" required placeholder=\"Email address to be suppressed\" class=\"form-control\">\n      </div>\n      <div class=\"form-group\">\n        <label for=\"reason\">Reason</label>\n        <input id=\"reason\" type=\"text\" ng-model=\"email.reason\" required placeholder=\"Reason for suppression (e.g. bounce, complaint)\" class=\"form-control\">\n      </div>\n    </div>\n  </form>\n</div>\n\n<div class=\"modal-footer\">\n  <button ng-click=\"ok()\" ng-disabled=\"!form.$valid || isSaving\" class=\"btn btn-primary\"><i ng-show=\"isSaving\" class=\"fa fa-cog fa-spin\"></i> Save</button>\n  <button ng-click=\"cancel()\" class=\"btn btn-link\"><i class=\"fa fa-times\"></i> Cancel</button>\n</div>"

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/broadcasts/:broadcast_id/tickets/:id', {
    template: __webpack_require__(287),
    controller: 'TicketController'
  });
}]).controller('TicketController', ["$scope", "$location", "$routeParams", "$q", "Broadcast", "Ticket", function ($scope, $location, $routeParams, $q, Broadcast, Ticket) {
  $scope.broadcast = Broadcast.get({
    id: $routeParams.broadcast_id
  });
  $scope.ticket = Ticket.get({
    broadcast_id: $routeParams.broadcast_id,
    id: $routeParams.id
  });
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];
  $q.all([$scope.broadcast.$promise, $scope.ticket.$promise]).then(function (res) {
    var b = res[0],
        id = res[1].id;

    $scope.showURL = function () {
      return b.admin_viewer_url.replace(/\/\.[0-9A-Za-z]+$/, "/".concat(id));
    };
  });
  $scope.isRefunding = false;
  return $scope.refund = function () {
    if (confirm('Are you sure you want to refund this ticket?')) {
      $scope.isRefunding = true;
      return Ticket.refund({
        broadcast_id: $routeParams.broadcast_id,
        id: $routeParams.id
      }, null, function (data) {
        return $scope.ticket = data;
      });
    }
  };
}]);

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/broadcasts\">Broadcasts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/broadcasts/{{ broadcast.id }}\">{{ broadcast.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ ticket.name }}</h3>\n      </div>\n      <div class=\"panel-body\">\n\n        <div ng-show=\"ticket.stripe_charge_id\">\n          <button ng-show=\"!ticket.is_refunded\" ng-disabled=\"isRefunding\" ng-click=\"refund()\" class=\"btn btn-danger btn-sm refund\">\n            {{ isRefunding ? 'Refunding...' : 'Refund Ticket' }}\n          </button>\n        </div>\n\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <h4>{{ ticket.name }}</h4>\n    <table class=\"table table-striped table-condensed\">\n      <tr><th class=\"col-xs-2\">Show URL</th><td>\n          <a ng-href=\"{{ showURL() }}\" target=\"_blank\">{{ showURL() }}</a>\n      </td></tr>\n      <tr><th class=\"col-xs-2\">Email</th><td>{{ ticket.email }}</td></tr>\n      <tr><th>Price</th><td>{{ ticket.price | currency }} &emsp; <span ng-show=\"ticket.is_refunded\" class=\"badge\">Refunded</span></td></tr>\n      <tr><th>Purchased</th><td>{{ ticket.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td></tr>\n      <tr><th>Invoice</th><td>{{ ticket.invoice_handle }}</td></tr>\n      <tr ng-show=\"ticket.stripe_charge_id\">\n        <th>Stripe Charge</th>\n        <td>{{ ticket.stripe_charge_id }}\n          &emsp; <a href=\"https://dashboard.stripe.com/payments/{{ ticket.stripe_charge_id }}\" target=\"_blank\"><i class=\"fa fa-external-link\"></i></a>\n          &emsp; <button ng-show=\"!ticket.is_refunded\" ng-disabled=\"isRefunding\" ng-click=\"refund()\" class=\"btn btn-danger btn-xs refund\">{{ isRefunding ? 'Refunding...' : 'Refund Ticket' }}</button>\n        </td>\n      </tr>\n      <tr ng-show=\"ticket.pwmb_transaction_id\"><th>PWMB Transaction</th><td>{{ ticket.pwmb_transaction_id }}</td></tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_paginate__ = __webpack_require__(7);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/tickets', {
    template: __webpack_require__(289),
    controller: 'TicketsController'
  });
}]).controller('TicketsController', ["$scope", "$location", "$modal", "Ticket", "Config", "Channel", function ($scope, $location, $modal, Ticket, Config, Channel) {
  $scope.config = Config;
  $scope.loading = true;
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = '-created_at');
  $scope.type = $location.search().type || 'broadcast';
  $scope.tickets = Ticket.queryGlobal(_.pick($scope, 'q', 's', 'p', 'type'), function (data, getResponseHeader) {
    $scope.loading = false;
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });

  $scope.setType = function (t) {
    return $location.search('type', t);
  };

  $scope.show = function ($event, t) {
    if (t.broadcast_id) {
      $scope.openURL("/broadcasts/".concat(t.broadcast_id, "/tickets/").concat(t.id), $event);
    } else {
      Channel.get({
        id: t.channel_id,
        include_archived: true
      }, function (channel) {
        if (channel.account_id) {
          $scope.openURL("/accounts/".concat(channel.account_id, "/channels/").concat(channel.id, "/tickets/").concat(t.id), $event);
        } else {
          alert("This channel is a multi-account channel; unable to redirect to ticket purchase.");
        }
      }, function (e) {
        console.error(e);
        alert("Unable to look up channel");
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div ng-if=\"loading\" class=\"col-md-12\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-3 table-animate-aside\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Tickets</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by Name\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n\n        <p class=\"help-block\" style=\"margin-top:30px\">\n        <small>\n        Example searches:<br>\n        <code title=\"Use quotes for exact match\">\"Full Name\"</code><br>\n        <code title=\"Use * for partial match\">Partialname*</code><br>\n        <code title=\"Search by email\">email:joe@example.com</code><br>\n        </small>\n        </p>\n\n        <hr>\n        <h5>Ticket Type</h5>\n        <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: type=='broadcast'}\" ng-click=\"setType('broadcast')\">Broadcast</button>\n          <button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{active: type=='channel'}\" ng-click=\"setType('channel')\">Channel</button>\n        </div>\n      </div>\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9 table-animate\">\n    <table class=\"table table-striped table-light-border table-hover\">\n      <thead>\n        <tr>\n          <th class=\"clickable\" ng-click=\"sort('created_at')\">\n            Purchased\n            <i ng-show=\"s.indexOf('created_at') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'created_at'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-created_at'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th class=\"clickable\" ng-click=\"sort('email')\">\n            Contact\n            <i ng-show=\"s.indexOf('email') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'email'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-email'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th class=\"clickable\" ng-click=\"sort('invoice_handle')\">\n            Invoice\n            <i ng-show=\"s.indexOf('invoice_handle') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'invoice_handle'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-invoice_handle'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Amount</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!loading && !tickets.length\" class=\"tr--no-results\"><td colspan=\"4\">No tickets were found.</td></tr>\n        <tr ng-repeat=\"ticket in tickets\" ng-click=\"show($event, ticket)\" class=\"clickable\">\n          <td>{{ ticket.created_at | date: 'MM/dd/yyyy hh:mm a' }}</td>\n          <td>\n            {{ ticket.name }}<br>\n            <small>{{ ticket.email }}</small>\n            <div ng-show=\"ticket.suppressed_reason\" class=\"text-danger\" style=\"font-weight:bold\">\n              <strong><i class=\"fa fa-ban\" aria-hidden=\"true\"></i> Email Suppressed</strong>\n            </div>\n          </td>\n          <td>\n            {{ ticket.broadcast_name || ticket.channel_name }}<br>\n            <small>{{ ticket.invoice_handle }}</small>\n          </td>\n          <td>\n            <span ng-hide=\"ticket.is_refunded\">\n              {{ ticket.price|currency }}\n            </span>\n            <span ng-show=\"ticket.is_refunded\">\n              <strike>{{ ticket.price|currency }}</strike> <span class=\"badge\">Refunded</span>\n            </span>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {angular.module('app.views').controller('AddAuthorizedAccountController', ["$scope", "$routeParams", "$modalInstance", "$timeout", "Account", "User", function ($scope, $routeParams, $modalInstance, $timeout, Account, User) {
  $scope.isSaving = false;
  $scope.selectedAccount = null;
  $scope.user = User.get({
    account_id: $routeParams.account_id,
    id: $routeParams.id
  });

  $scope.searchAccounts = function (text) {
    return Account.query({
      q: text
    }).$promise;
  };

  $scope.ok = function () {
    $scope.isSaving = true;

    var ids = _.pluck($scope.user.authorized_accounts, 'id');

    if (ids.length == 0) {
      ids = [$scope.user.account_id];
    }

    $scope.selectedAccount.forEach(function (a) {
      ids.push(a.id);
    });
    return User.update({
      account_id: $scope.user.account_id,
      id: $scope.user.id,
      authorized_account_ids: ids
    }, function (a) {
      return $modalInstance.close(a);
    }, function (error) {
      return alert("Error saving: ".concat(error.error_description));
    });
  };

  $timeout(function () {
    $('tags-input input').focus();
  }, 300);

  $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_form_controller__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_form_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__user_form_controller__);


angular.module("app.views").config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when("/accounts/:account_id/users/:id", {
    template: __webpack_require__(292),
    controller: "UserController"
  });
}]).controller("UserController", ["$scope", "$location", "$routeParams", "$rootScope", "$modal", "Account", "User", "Config", "$route", function ($scope, $location, $routeParams, $rootScope, $modal, Account, User, Config, $route) {
  $scope.roles = angular.copy(Config.roles);
  $scope.account = Account.get({
    id: $routeParams.account_id
  });
  $scope.contact = {};
  $scope.loading = true;
  $scope.verificationResent = false;
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_0_environment__["r" /* NEW_ADMIN_URL */];

  var updateUser = function updateUser(u) {
    $scope.user = u; // Turn roles into role for convenience

    if ($scope.user.roles.length > 0) {
      $scope.user.role = $scope.user.roles[0];
    }

    if ($scope.user.hubspot_contact_handle && $scope.user.hubspot_contact_handle.length) {
      $scope.contact = User.contact({
        account_id: $routeParams.account_id,
        id: $routeParams.id
      }).$promise.then(function (res) {
        return $scope.contact = res;
      })["catch"](function (err) {
        if (err.status === 404) {// Ignore
        } else {
          alert(err);
          console.error(err);
        }
      })["finally"](function () {
        return $scope.loading = false;
      });
    } else {
      $scope.loading = false;
    }
  };

  $scope.user = User.get({
    account_id: $routeParams.account_id,
    id: $routeParams.id
  }).$promise.then(updateUser);
  $scope.modalInstance;

  $scope.edit = function () {
    $scope.modalInstance = $modal.open({
      template: __webpack_require__(100),
      controller: "UserFormController",
      size: "lg",
      backdrop: "static",
      resolve: {
        account: function account() {
          return $scope.account;
        }
      }
    });
    $scope.modalInstance.result.then(updateUser);
  };

  $scope.ok = function () {
    delete $scope.user.roles;
    User.update($scope.user, function (u) {
      return $route.reload();
    });
    return;
  };

  $scope.resendVerificationEmail = function () {
    if (!confirm("Are you sure you want to resend the verification email to this user?")) {
      return;
    }

    return User.update({
      account_id: $scope.user.account_id,
      id: $scope.user.id,
      requires_verification: true
    }).$promise.then(function (res) {
      $scope.requiresVerification = true;
      $scope.verificationResent = true;
      $scope.user = res;
    });
  };

  $scope.showSuppression = function (email) {
    return $location.url("/suppressed_emails/".concat(email));
  };

  $scope.hubspotContactUrl = function () {
    return "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["l" /* HUBSPOT_BASE_URL */], "/contact/").concat($scope.user.hubspot_contact_handle);
  };

  $scope.intercomContactUrl = function () {
    return "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["n" /* INTERCOM_BASE_URL */], "/users/").concat($scope.user.intercom_contact_id);
  };
}]);

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts\">Accounts</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-right\"></i> <a href=\"{{ newAdminURL }}/accounts/{{ account.id }}\">{{ account.name }}</a></h3>\n      </div>\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> {{ user.name }}</h3>\n      </div>\n      <div class=\"panel-body\">\n        <img ng-show=\"user.email\" src=\"https://www.gravatar.com/avatar/{{ user.email | lowercase | md5 }}?s=192&d=mm\" class=\"img-responsive img-thumbnail pull-right\" style=\"width:50%\">\n        <p ng-hide=\"!$root.me.isSystemAdmin() && user.isAdmin()\"><a href=\"#\" ng-click=\"edit()\">\n          <i class=\"fa fa-pencil-square-o\"></i>\n          Edit User\n        </a></p>\n        <p ng-show=\"user.hubspot_contact_handle\"><a href=\"{{ hubspotContactUrl() }}\" target=\"_blank\">\n          <i class=\"fa fa-external-link\"></i>\n          HubSpot Contact\n        </a></p>\n        <p ng-show=\"user.intercom_contact_id\"><a href=\"{{ intercomContactUrl() }}\" target=\"_blank\">\n          <i class=\"fa fa-external-link\"></i>\n          Intercom Contact\n        </a></p>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-9\">\n    <div class=\"alert alert-warning error-message alert-no-pandadoc\" role=\"alert\" ng-if=\"user.pending_email_update\">\n      <span aria-hidden=\"true\">\n        <i class=\" fa fa-exclamation-triangle\" style=\"color: #EEAD4D; float: left; margin-right: 3px;\"></i>\n      </span>\n    <span> Until <strong>{{user.pending_email_update}}</strong> is verified, the email address <strong>{{user.email}}</strong> remains valid for this account. You can also <a href=\"#\" style=\"display: inline;\" ng-click=\"resendVerificationEmail()\">send a new verification email</a> or <a style=\"display: inline;\" ng-click=\"ok()\">cancel this update.</a></span>\n    <span ng-if=\"verificationResent\">Verification Email Sent</span>\n    </div>\n    <h4>{{ user.name }}</h4>\n    <div ng-if=\"loading\">\n      <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n      </div>\n    </div>\n    <table ng-if=\"!loading\" class=\"table table-striped table-condensed\">\n      <tr>\n        <th class=\"col-xs-2\">Email</th>\n        <td ng-if=\"!user.pending_email_update\">{{ user.email }}</td>\n        <td ng-if=\"user.pending_email_update\">{{ user.pending_email_update }}</td>\n      </tr>\n      <tr>\n        <th class=\"col-xs-2\">Email Status</th>\n        <td ng-if=\"user.is_verified && !user.pending_email_update && !suppressed_at\" class=\"badge badge-secondary\" style=\"margin-top: 1px; background-color: #1CA6A0;\">VERIFIED</td>\n        <td ng-if=\"!user.is_verified\" class=\"badge badge-secondary\" style=\"margin-top: 1px;\">UNVERIFIED</td>\n        <td ng-if=\"user.pending_email_update\" class=\"badge\" style=\"margin-top: 1px; background-color: #EEAD4D;\">PENDING</td>\n        <td ng-if=\"user.suppressed_at\" class=\"badge\" style=\"margin-left: 5px; margin-top: 1px; background-color: #A94342;\">SUPPRESSED</td>\n      </tr>\n      <tr ng-if=\"contact.properties.phone.value\"><th class=\"col-xs-2\">Phone Number</th><td>{{ contact.properties.phone.value }}</td></tr>\n      <tr><th class=\"col-xs-2\">Role</th><td>{{ user.role | label: roles }}</td></tr>\n      <tr ng-show=\"user.authorized_accounts.length\"><th class=\"col-xs-2\">Authorized Accounts</th>\n        <td>\n          <ul class=\"list-unstyled\">\n            <li ng-repeat=\"a in user.authorized_accounts\">\n              {{a.name}}\n            </li>\n          </ul>\n        </td>\n      </tr>\n      <tr ng-show=\"user.suppressed_reason\" >\n        <th class=\"col-xs-2\">Suppressed?</th>\n        <td><a href=\"#\" ng-click=\"showSuppression(user.email)\">Suppressed at {{ user.suppressed_at | date:'MM/dd/yyyy hh:mm a' }} because {{ user.suppressed_reason }}.</a></td>\n      </tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_environment__ = __webpack_require__(0);



angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/users', {
    template: __webpack_require__(294),
    controller: 'UsersController'
  });
}]).controller('UsersController', ["$scope", "$location", "User", function ($scope, $location, User) {
  Object(__WEBPACK_IMPORTED_MODULE_0__mixins_can_filter__["a" /* canFilter */])($scope, $location);
  Object(__WEBPACK_IMPORTED_MODULE_1__mixins_can_paginate__["a" /* canPaginate */])($scope, $location);
  $scope.s || ($scope.s = 'email');
  $scope.loading = true;
  $scope.newAdminURL = __WEBPACK_IMPORTED_MODULE_2_environment__["r" /* NEW_ADMIN_URL */];

  var params = _.pick($scope, 'q', 's', 'p');

  if ($scope.f.account && $scope.f.account.active) {
    params['filter.account_id'] = $scope.f.account.id;
  }

  params['filter.include_archived'] = 'false';
  $scope.users = User.search(params, function (data, getResponseHeader) {
    $scope.loading = false;
    var pagination = getResponseHeader('X-Pagination');
    return $scope.pagination = pagination ? JSON.parse(pagination) : {};
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n  <div class=\"col-md-3\">\n    <div class=\"panel panel-default table-animate-aside\">\n      <div class=\"panel-heading\">\n        <h3 class=\"panel-title\"><i class=\"fa fa-chevron-down\"></i> Users</h3>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"input-group\">\n          <input ng-model=\"q\" ng-enter=\"query(q)\" class=\"form-control\" placeholder=\"Search by Name\" />\n          <span class=\"input-group-btn\"><button ng-click=\"query(q)\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span>\n        </div>\n        <small ng-show=\"q\"><a ng-click=\"q = ''; query()\" href=\"#\"><i class=\"fa fa-times\"></i> Clear Search Filter</a></small>\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"loading\" class=\"col-md-9\">\n    <div class=\"alert alert-info alert-loading\">\n        <span>Loading...</span><i class=\"fa fa-spinner\" aria-hidden=\"true\"></i>\n    </div>\n  </div>\n\n  <div ng-if=\"!loading\" class=\"col-md-9\">\n    <table class=\"table table-striped table-light-border table-hover table-condensed table-animate\">\n      <thead>\n        <tr>\n          <th ng-click=\"sort('email')\" class=\"clickable\">\n            Email\n            <i ng-show=\"s.indexOf('email') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'email'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-email'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th ng-click=\"sort('name')\" class=\"clickable\">\n            Name\n            <i ng-show=\"s.indexOf('name') === -1\" class=\"fa fa-sort\"></i>\n            <i ng-show=\"s === 'name'\" class=\"fa fa-sort-alpha-asc\"></i>\n            <i ng-show=\"s === '-name'\" class=\"fa fa-sort-alpha-desc\"></i>\n          </th>\n          <th>Account</th>\n          <th>Email Status</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-if=\"!loading && !users.length\" class=\"tr--no-results\"><td colspan=\"4\">No users were found.</td></tr>\n        <tr ng-repeat=\"u in users\" ng-click=\"openURL('{{newAdminURL}}'+'/accounts/'+u.account_id+'/users/'+u.id, $event)\" class=\"clickable\">\n          <td ng-if=\"!u.pending_email_update\">{{ u.email }}</td>\n          <td ng-if=\"u.pending_email_update\">{{ u.pending_email_update }}</td>\n          <td>{{ u.name }}</td>\n          <td>{{ u.account_name }}</td>\n          <td>\n            <span ng-if=\"u.is_verified && !u.pending_email_update && !u.suppressed_at\" class=\"badge badge-secondary\" style=\"background-color: #1CA6A0; width:100px\">VERIFIED</span>\n            <span ng-if=\"!u.is_verified\" class=\"badge badge-secondary\" style=\"width:100px\">UNVERIFIED</span>\n            <span ng-if=\"u.pending_email_update\"class=\"badge\" style=\"background-color: #EEAD4D; width:100px\">PENDING</span>\n            <span ng-if=\"u.suppressed_at\" class=\"badge\" style=\"background-color: #A94342; width:100px\">SUPPRESSED</span>\n          </td>  \n        </tr>\n      </tbody>\n    </table>\n    <app-pagination />\n  </div>\n</div>\n"

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pandadoc_service__ = __webpack_require__(296);

angular.module('app.views').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/pandadoc', {
    template: "\n          <h3 ng-if=\"!error\">Please wait...</h3>\n          <h3 ng-if=\"error\">{{error}}: {{error_description}}</h3>\n        ",
    controller: 'PandadocController'
  });
}]).service('PandadocService', __WEBPACK_IMPORTED_MODULE_0__pandadoc_service__["a" /* default */]).controller('PandadocController', ["$window", "$location", "$scope", "PandadocService", function ($window, $location, $scope, PandadocService) {
  var params = $location.search();

  if (params.code) {
    console.log('Exchanging Pandadoc code for token...');
    PandadocService.tokenFromCode(params.code).then(function (data) {
      console.log('Got token: ', data);
      PandadocService.storeToken(data);

      if (sessionStorage.getItem('accountRedirect')) {
        $window.location.replace(sessionStorage.getItem('accountRedirect'));
        sessionStorage.removeItem('accountRedirect');
      } else {
        $window.location.replace('/');
      }
    })["catch"](function (err) {
      console.error('Unable to get token', err);
      $window.location.replace('/');
    });
  } else {
    $scope.error = params.error;
    $scope.error_description = params.error_description;
  }
}]);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = PandadocService;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

function PandadocService($window, $modal, $http, $q) {
  this.tokenFromCode = function (code) {
    return $http.post('https://api.pandadoc.com/oauth2/access_token', $.param({
      grant_type: 'authorization_code',
      client_id: __WEBPACK_IMPORTED_MODULE_0_environment__["s" /* PANDADOC_CLIENT_ID */],
      client_secret: __WEBPACK_IMPORTED_MODULE_0_environment__["u" /* PANDADOC_SECRET */],
      code: code,
      scope: 'read+write',
      redirect_uri: __WEBPACK_IMPORTED_MODULE_0_environment__["t" /* PANDADOC_REDIRECT_URL */]
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
      }
    }).then(function (resp) {
      return resp.data;
    });
  };

  this.storeToken = function (data) {
    localStorage.setItem('pandadocAccessToken', data.access_token);
    localStorage.setItem('pandadocRefreshToken', data.refresh_token);
    localStorage.setItem('pandadocTokenExpires', Date.now() + data.expires_in);
  };

  this.authURL = 'https://app.pandadoc.com/oauth2/authorize?' + $.param({
    client_id: __WEBPACK_IMPORTED_MODULE_0_environment__["s" /* PANDADOC_CLIENT_ID */],
    redirect_uri: __WEBPACK_IMPORTED_MODULE_0_environment__["t" /* PANDADOC_REDIRECT_URL */],
    scope: 'read+write',
    response_type: 'code'
  });

  this.getUserAccessToken = function () {
    var _this = this;

    // Prefer cached version (refreshing token as necessary)
    var accessToken = localStorage.getItem('pandadocAccessToken');
    var refreshToken = localStorage.getItem('pandadocRefreshToken');
    var tokenExpires = localStorage.getItem('pandadocTokenExpires');
    sessionStorage.setItem("accountRedirect", window.location.pathname);

    if (accessToken && refreshToken && tokenExpires) {
      var padding = 1000 * 60 * 30; // 30 min padding before expiration

      if (tokenExpires > Date.now() + padding) {
        return $q(function (resolve, reject) {
          return resolve(accessToken);
        });
      } else {
        return this.refreshToken(refreshToken).then(function (result) {
          _this.storeToken(result);

          return result.access_token;
        });
      }
    }

    return $q(function (resolve, reject) {
      return reject();
    });
  };

  this.refreshToken = function (refreshToken) {
    return $http.post('https://api.pandadoc.com/oauth2/access_token', $.param({
      grant_type: 'refresh_token',
      client_id: __WEBPACK_IMPORTED_MODULE_0_environment__["s" /* PANDADOC_CLIENT_ID */],
      client_secret: __WEBPACK_IMPORTED_MODULE_0_environment__["u" /* PANDADOC_SECRET */],
      refresh_token: refreshToken,
      scope: 'read+write'
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
      }
    }).then(function (resp) {
      return resp.data;
    });
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.directives', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(298);

__webpack_require__(299);

__webpack_require__(300);

__webpack_require__(301);

__webpack_require__(302);

__webpack_require__(303);

__webpack_require__(304);

__webpack_require__(305);

__webpack_require__(306);

__webpack_require__(307);

__webpack_require__(308);

__webpack_require__(309);

__webpack_require__(310);

__webpack_require__(311);

__webpack_require__(312);

__webpack_require__(313);

__webpack_require__(314);

__webpack_require__(315);

__webpack_require__(316);

__webpack_require__(317); // View-specific directives


__webpack_require__(318);

/* unused harmony default export */ var _unused_webpack_default_export = (module);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module('app.directives').directive('backhaulGraph', ["$timeout", "$window", "StatsService", function ($timeout, $window, StatsService) {
  return {
    restrict: 'E',
    scope: {
      boxcasterId: '@',
      startsAt: '@',
      stopsAt: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.timeoutId = null;
      $scope.hovering = false;
      $scope.statsData = null;
      $scope.packetsOptions = {
        renderer: 'multi',
        interpolation: 'step-after',
        height: 75,
        min: 0
      };
      $scope.packetsSeries = [{
        name: 'sent',
        renderer: 'area',
        data: [],
        color: 'rgba(8,61,119, 0.8)'
      }, {
        name: 'resent',
        renderer: 'area',
        data: [],
        color: 'rgba(64,61,119, 0.6)'
      }, {
        name: 'lost',
        renderer: 'stack',
        stack: false,
        data: [],
        color: 'rgb(149,61,81)'
      }];
      $scope.rttTcpOptions = {
        renderer: 'multi',
        interpolation: 'step-after',
        height: 60,
        min: 0
      };
      $scope.rttTcpSeries = [{
        name: 'rtt',
        renderer: 'line',
        data: [],
        color: 'rgba(238,150,75,1.0)'
      }, {
        name: 'rtt+1s',
        renderer: 'line',
        data: [],
        color: 'rgba(238,150,75,0.5)'
      }, {
        name: 'rtt-1s',
        renderer: 'line',
        data: [],
        color: 'rgba(238,150,75,0.5)'
      }, {
        name: 'tcp-open',
        renderer: 'area',
        data: [],
        color: 'rgba(235,235,75, 0.3)'
      }];
      $scope.videoBitrateOptions = {
        renderer: 'multi',
        interpolation: 'step-after',
        height: 60,
        min: 0
      };
      $scope.videoBitrateSeries = [{
        name: 'target',
        renderer: 'line',
        data: [],
        color: 'rgba(249,87,56,1.0)'
      }, {
        name: 'actual',
        renderer: 'line',
        data: [],
        color: 'rgba(249,87,56,0.5)'
      }];
      $scope.audioBitrateOptions = {
        renderer: 'multi',
        interpolation: 'step-after',
        height: 60,
        min: 0
      };
      $scope.audioBitrateSeries = [{
        name: 'target',
        renderer: 'line',
        data: [],
        color: 'rgba(50,147,111,1.0)'
      }, {
        name: 'actual',
        renderer: 'line',
        data: [],
        color: 'rgba(50,147,111,0.5)'
      }];
      $scope.latencyOptions = {
        renderer: 'line',
        interpolation: 'step-after',
        height: 60,
        min: 0
      };
      $scope.latencySeries = [{
        name: 'latency',
        data: [],
        color: 'rgba(8,61,119, 0.8)'
      }]; // This data represents the individual stats for the specific time being shown.

      $scope.statsAtTime = {
        time: null,
        packets: {},
        rttMs: null,
        tcpStatus: null,
        video: {},
        audio: {},
        latencyMs: null
      };
      return $scope.$on('$destroy', function () {
        if ($scope.timeoutId != null) {
          return $timeout.cancel($scope.timeoutId);
        }
      });
    }],
    link: function link(scope, element, attrs) {
      // Convenience method to get stats values from one or more keys
      var statsForTime = function statsForTime(keys, time) {
        return _.map(keys, function (k) {
          return (scope.statsData[k] || {})[time];
        }).reduce(function (a, b) {
          if ((a === null || a === undefined) && (b === null || b === undefined)) {
            return null;
          } else if (a !== null && a !== undefined && (b === null || b === undefined)) {
            return a;
          } else if ((a === null || a === undefined) && b !== null && b !== undefined) {
            return b;
          } else {
            return a + b;
          }
        });
      }; // This function is a common function to show the BoxCaster stats for a specific moment in
      // time, based on either hovering over the chart, or showing the latest value.
      //
      // The 'pct' parameter should be a float value between 0 and 1 (inclusive) representing
      // where, in the time window, data values should be shown.


      var showGraphStats = function showGraphStats(pct) {
        // Update the time we're showing based on pct.
        var times = _.keys(scope.statsData[_.keys(scope.statsData)[0]]);

        times.sort(function (a, b) {
          return a - b;
        });
        var time = times[Math.round(pct * (times.length - 1))];
        scope.statsAtTime.time = time; // This block of code pulls out all the individual stats that are used below in the
        // templates. Most of these are numeric, but some are converted to boolean.

        scope.statsAtTime.packets.sent = statsForTime(['pipeline.backhaul.sent.buffers'], time);
        scope.statsAtTime.packets.resent = statsForTime(['pipeline.backhaul.resent.buffers'], time);
        scope.statsAtTime.packets.lost = statsForTime(['pipeline.backhaul.lost.buffers'], time);
        scope.statsAtTime.rttMs = statsForTime(['pipeline.backhaul.rtt-us-average'], time);

        if (scope.statsAtTime.rttMs != null) {
          scope.statsAtTime.rttMs /= 1000.0;
        }

        scope.statsAtTime.tcpStatus = statsForTime(['pipeline.backhaul.tcp-socket-open'], time);

        if (scope.statsAtTime.tcpStatus != null) {
          var _statusMap;

          var statusMap = (_statusMap = {}, _defineProperty(_statusMap, 0, 'Closed'), _defineProperty(_statusMap, 1, 'Open'), _statusMap);
          scope.statsAtTime.tcpStatus = statusMap[scope.statsAtTime.tcpStatus];
        }

        scope.statsAtTime.video.target = statsForTime(['pipeline.target-video-bitrate'], time);
        scope.statsAtTime.video.actual = statsForTime(['pipeline.video-byte-count'], time);
        scope.statsAtTime.audio.target = statsForTime(['pipeline.target-audio-bitrate'], time);
        scope.statsAtTime.audio.actual = statsForTime(['pipeline.audio-byte-count'], time);
        scope.statsAtTime.latencyMs = statsForTime(['pipeline.backhaul.buffer-latency-average'], time);

        if (scope.statsAtTime.latencyMs != null) {
          return scope.statsAtTime.latencyMs /= 1000.0;
        }
      }; // This function calculates the extents of the embedded graph area.


      var getGraphExtents = function getGraphExtents() {
        var graphExtents = angular.copy($(element).find('td .rickshaw_graph').position());
        graphExtents.width = $(element).find('td .rickshaw_graph').width();
        graphExtents.height = $(element).find('table').height();
        return graphExtents;
      }; // This function is called whenever the graph is hovered over (when the mouse enters or moves
      // over the graph area).


      var onGraphHoverEnter = function onGraphHoverEnter(evt) {
        return scope.$apply(function () {
          var graphExtents = getGraphExtents();
          var offset_left = $(evt.currentTarget).parents('backhaul-graph').offset().left;
          $(element).find('#cursor').css('left', "".concat(evt.clientX - offset_left - 2, "px"));
          var left = evt.clientX - $(evt.currentTarget)[0].getBoundingClientRect().left;
          $(element).find('#cursor').show();
          var pct = left * 1.0 / graphExtents.width;

          if (pct != null && pct >= 0.0 && pct <= 1.0) {
            showGraphStats(pct);
            return scope.hovering = true;
          }
        });
      }; // This function is called whenever the mouse leaves the graph area.


      var onGraphHoverExit = function onGraphHoverExit(evt) {
        return scope.$apply(function () {
          $(element).find('#cursor').hide();
          showGraphStats(1.0);
          return scope.hovering = false;
        });
      };

      $(element).find('td.boxcaster-diagnostic-graph-cell').hover(onGraphHoverEnter, onGraphHoverExit);
      $(element).find('td.boxcaster-diagnostic-graph-cell').mousemove(onGraphHoverEnter); // The following keys are data that will be retrieved for display.

      scope.keys = [{
        field: 'derivative(sum("sent.buffers")) / 10',
        value: 'boxcaster.pipeline.backhaul',
        as: 'pipeline.backhaul.sent.buffers'
      }, {
        field: '(derivative(sum("resent.nack.buffers")) + derivative(sum("resent.rtt.buffers"))) / 10',
        value: 'boxcaster.pipeline.backhaul',
        as: 'pipeline.backhaul.resent.buffers'
      }, {
        field: 'derivative(sum("lost.buffers")) / 10',
        value: 'boxcaster.pipeline.backhaul',
        as: 'pipeline.backhaul.lost.buffers'
      }, {
        field: 'mean("rtt-us-average")',
        value: 'boxcaster.pipeline.backhaul',
        as: 'pipeline.backhaul.rtt-us-average'
      }, {
        field: 'mean("rtt-us-std_dev")',
        value: 'boxcaster.pipeline.backhaul',
        as: 'pipeline.backhaul.rtt-us-std_dev'
      }, {
        field: 'last("tcp-socket-open")',
        value: 'boxcaster.pipeline.backhaul',
        as: 'pipeline.backhaul.tcp-socket-open'
      }, {
        field: 'mean("target-video-bitrate")',
        value: 'boxcaster.pipeline',
        as: 'pipeline.target-video-bitrate'
      }, {
        field: 'derivative(sum("video-byte-count")) * 8 / 10',
        value: 'boxcaster.pipeline',
        as: 'pipeline.video-byte-count'
      }, {
        field: 'mean("target-audio-bitrate")',
        value: 'boxcaster.pipeline',
        as: 'pipeline.target-audio-bitrate'
      }, {
        field: 'derivative(sum("audio-byte-count")) * 8 / 10',
        value: 'boxcaster.pipeline',
        as: 'pipeline.audio-byte-count'
      }, {
        field: 'mean("buffer-latency-average")',
        value: 'boxcaster.pipeline.backhaul',
        as: 'pipeline.backhaul.buffer-latency-average'
      }];
      var startsAtDate = new Date(Date.parse(scope.startsAt));
      var stopsAtDate = new Date(Date.parse(scope.stopsAt)); // This function will be periodically called to refresh stats data.

      var refreshFn = function refreshFn() {
        var req_params = {
          boxcaster: scope.boxcasterId,
          time: ["time > ".concat(startsAtDate.getTime() / 1000, "s")],
          targets: scope.keys
        };

        if (stopsAtDate.getTime() < Date.now()) {
          req_params.time.push("time < ".concat(stopsAtDate.getTime() / 1000, "s"));
        }

        var request = StatsService.fetch(req_params);
        return request.then(function (data) {
          scope.statsData = data;

          if (new Date() - new Date(scope.stopsAt) < 60 * 60 * 1000) {
            return scope.timeoutId = $timeout(refreshFn, 10000);
          } else {
            return scope.timeoutId = null;
          }
        });
      };

      refreshFn(); // When the window is resized, we need to manually update the child graphs' sizes, since
      // Rickshaw uses SVG, and the SVG elements themselves are particularly bad about sizing.

      angular.element($window).bind('resize', function () {
        // The actual graph width is the panel width minus the width of the first and last columns.
        var panelWidth = $(element).find('#backhaul-chart-panel')[0].getBoundingClientRect().width;
        var prevColWidth = $(element).find('#backhaul-chart-panel table tr th')[0].getBoundingClientRect().width;
        var nextColWidth = $(element).find('#backhaul-chart-panel table tr td')[1].getBoundingClientRect().width;
        var newWidth = panelWidth - prevColWidth - nextColWidth;
        return scope.$apply(function () {
          scope.packetsOptions.width = newWidth;
          scope.rttTcpOptions.width = newWidth;
          scope.videoBitrateOptions.width = newWidth;
          return scope.audioBitrateOptions.width = newWidth;
        });
      });
      element.on('$destroy', function () {
        if (scope.timeoutId != null) {
          return $timeout.cancel(scope.timeoutId);
        }
      });
      var FILTER_COUNTER_ERROR_PERCENT = 5.0;
      return scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          _.each(newval, function (values, key) {
            if (key.match(/\.buffers/) || key.match(/\.byte-count/)) {
              var times = _.keys(values).sort();

              var tofix = {};

              _.each(times, function (t, i) {
                if (i > 0 && i < times.length - 1) {
                  var prev = values[times[i - 1]];
                  var val = values[t];
                  var next = values[times[i + 1]];

                  if (prev !== 0 && val === 0 && next !== 0) {
                    if (Math.abs(next * 2.0 - prev) / prev < FILTER_COUNTER_ERROR_PERCENT / 100.0) {
                      //prev =~= next * 2.0
                      values[t] = prev / 2.0;
                      return tofix[times[i - 1]] = values[t];
                    } else if (Math.abs(prev * 2.0 - next) / next < FILTER_COUNTER_ERROR_PERCENT / 100.0) {
                      //next =~= prev * 2.0
                      values[t] = next / 2.0;
                      return tofix[times[i + 1]] = values[t];
                    }
                  }
                }
              });

              return _.each(tofix, function (v, k) {
                return values[k] = v;
              });
            } else {
              // Remove nulls from gauges
              return _.each(values, function (v, k) {
                if (v == null) {
                  return delete values[k];
                }
              });
            }
          });

          var all_times = _.union.apply(this, _.map(_.keys(newval), function (k) {
            return _.keys(newval[k]);
          })).sort(function (a, b) {
            return a - b;
          });

          _.each(_.keys(newval), function (k) {
            var lastValue = null;
            return _.each(all_times, function (t) {
              if (!_.has(newval[k], t)) {
                newval[k][t] = lastValue || 0;
              }

              return lastValue = newval[k][t];
            });
          });

          scope.packetsSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.packetsSeries[0].data, _.map(newval['pipeline.backhaul.sent.buffers'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.packetsSeries[1].data.length = 0;
          Array.prototype.push.apply(scope.packetsSeries[1].data, _.map(newval['pipeline.backhaul.resent.buffers'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.packetsSeries[2].data.length = 0;
          Array.prototype.push.apply(scope.packetsSeries[2].data, _.map(newval['pipeline.backhaul.lost.buffers'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.rttTcpSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.rttTcpSeries[0].data, _.map(newval['pipeline.backhaul.rtt-us-average'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.rttTcpSeries[1].data.length = 0;
          Array.prototype.push.apply(scope.rttTcpSeries[1].data, _.map(_.keys(newval['pipeline.backhaul.rtt-us-average']).sort(), function (t) {
            return {
              x: parseInt(t),
              y: newval['pipeline.backhaul.rtt-us-average'][t] + newval['pipeline.backhaul.rtt-us-std_dev'][t]
            };
          }));
          scope.rttTcpSeries[2].data.length = 0;
          Array.prototype.push.apply(scope.rttTcpSeries[2].data, _.map(_.keys(newval['pipeline.backhaul.rtt-us-average']).sort(), function (t) {
            return {
              x: parseInt(t),
              y: newval['pipeline.backhaul.rtt-us-average'][t] - newval['pipeline.backhaul.rtt-us-std_dev'][t]
            };
          }));
          scope.rttTcpOptions.max = _.max(_.pluck(scope.rttTcpSeries[1].data, 'y'));
          scope.rttTcpSeries[3].data.length = 0;
          Array.prototype.push.apply(scope.rttTcpSeries[3].data, _.map(newval['pipeline.backhaul.tcp-socket-open'], function (v, k) {
            return {
              x: parseInt(k),
              y: v * 10000000
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.videoBitrateSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.videoBitrateSeries[0].data, _.map(newval['pipeline.target-video-bitrate'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.videoBitrateSeries[1].data.length = 0;
          Array.prototype.push.apply(scope.videoBitrateSeries[1].data, _.map(newval['pipeline.video-byte-count'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.audioBitrateSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.audioBitrateSeries[0].data, _.map(newval['pipeline.target-audio-bitrate'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.audioBitrateSeries[1].data.length = 0;
          Array.prototype.push.apply(scope.audioBitrateSeries[1].data, _.map(newval['pipeline.audio-byte-count'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.latencySeries[0].data.length = 0;
          Array.prototype.push.apply(scope.latencySeries[0].data, _.map(newval['pipeline.backhaul.buffer-latency-average'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));

          if (!scope.hovering) {
            return showGraphStats(1.0);
          }
        }
      });
    },
    template: "<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    Backhaul <span ng-show=\"!!statsAtTime.time\">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span>\n  </div>\n  <div class=\"panel-body\" id=\"backhaul-chart-panel\" style=\"padding: 0px; position: relative;\">\n    <table class=\"table\" style=\"width: 100%; margin: 0px;\">\n      <tr>\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Packets</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\">\n          <app-rickshaw rickshaw-options=\"packetsOptions\" rickshaw-series=\"packetsSeries\"></app-rickshaw>\n        </td>\n        <td>\n          <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">Sent: {{ statsAtTime.packets.sent | number:0 }}<br/>Re-sent: {{ statsAtTime.packets.resent | number:0 }}<br/>Un-ACKed: {{ statsAtTime.packets.lost | number:0 }}</div>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">RTT/TCP</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\">\n          <app-rickshaw rickshaw-options=\"rttTcpOptions\" rickshaw-series=\"rttTcpSeries\"></app-rickshaw>\n        </td>\n        <td>\n          <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">RTT: {{ statsAtTime.rttMs | numberWithUnit:1:\"ms\" }}<br/>TCP: {{ statsAtTime.tcpStatus }}</div>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Video</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\">\n          <app-rickshaw rickshaw-options=\"videoBitrateOptions\" rickshaw-series=\"videoBitrateSeries\"></app-rickshaw>\n        </td>\n        <td>\n          <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">Target: {{ statsAtTime.video.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.video.actual | metricPrefix:'bps' }}</div>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Audio</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\">\n          <app-rickshaw rickshaw-options=\"audioBitrateOptions\" rickshaw-series=\"audioBitrateSeries\"></app-rickshaw>\n        </td>\n        <td>\n          <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">Target: {{ statsAtTime.audio.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.audio.actual | metricPrefix:'bps' }}</div>\n        </td>\n      </tr>\n      <tr>\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Latency</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\">\n          <app-rickshaw rickshaw-options=\"latencyOptions\" rickshaw-series=\"latencySeries\"></app-rickshaw>\n        </td>\n        <td>\n          <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">Latency: {{ statsAtTime.latencyMs | numberWithUnit:1:\"ms\" }}</div>\n        </td>\n      </tr>\n    </table>\n    <div id=\"cursor\" class=\"cursor\"></div>\n  </div>\n</div>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// This directive shows a graph of a BoxCaster's CPU usage.
angular.module('app.directives').directive('appBoxcasterCpuGraph', ["$location", function ($location) {
  return {
    require: '^^appBoxcasterGraph',
    restrict: 'E',
    scope: {
      statsData: '=',
      numCores: '='
    },
    controller: ["$scope", function controller($scope) {
      $scope.data = [];
      $scope.options = {
        renderer: 'area',
        height: 40,
        min: 0,
        max: 100
      };
      return $scope.series = [{
        data: $scope.data,
        color: 'rgb(255,160,160)'
      }];
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          var times = _.keys(newval[_.keys(newval)[0]]);

          times.sort(function (a, b) {
            return a - b;
          }); // Find CPU-related keys

          var cpuKeys = _.filter(_.keys(newval), function (k) {
            return k.match(/^cpu\./);
          }); // Rebuild data with sums


          scope.data.length = 0;

          _.each(times, function (t) {
            return scope.data.push({
              x: parseInt(t),
              y: appBoxcasterGraph.statsForTime(cpuKeys, t) / scope.numCores
            });
          });

          return scope.data.sort(function (a, b) {
            return a.x - b.x;
          });
        }
      });
      return appBoxcasterGraph.registerGraphWidthCallback(function (newWidth) {
        return scope.$apply(function () {
          return scope.options.width = newWidth;
        });
      });
    },
    template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {// This directive places two panels in a page; the first panel displays a time graph of several of
// the BoxCaster's stats and allows for quick display of mouseover data. The second panel displays
// more detailed explosions of BoxCaster stats data for detailed diagnosis.
//
// This directive utilizes stats data obtained by the StatsService, which pulls stats data out
// of the the Graphite server.
angular.module('app.directives').directive('appBoxcasterGraph', ["$timeout", "$window", "StatsService", function ($timeout, $window, StatsService) {
  return {
    restrict: 'E',
    scope: {
      boxcasterId: '='
    },
    controller: ["$scope", function controller($scope) {
      $scope.isPro = $scope.boxcasterId[0] === 'p';
      $scope.totalMemory = $scope.isPro ? 2103558144 : 90 * 1024 * 1024;
      $scope.maxVideoBitrate = $scope.isPro ? 50000000 : 4800000;
      $scope.maxAudioBitrate = $scope.isPro ? 320000 : 128000;
      $scope.numCores = $scope.isPro ? 4 : 1; // The following keys are a starting point for all the data that will be retrieved for
      // display. Other keys are added by child graphs (via registerData).

      $scope.keys = [{
        field: 'last("total")',
        value: 'boxcaster.uptime',
        as: 'uptime.total'
      }, {
        field: "".concat($scope.totalMemory, " - mean(\"free\")"),
        value: 'boxcaster.memory',
        as: 'memory.used'
      }, {
        field: 'derivative(sum("video-buffer-count")) / 10',
        value: 'boxcaster.pipeline',
        as: 'pipeline.video-buffer-count'
      }, {
        field: 'derivative(sum("video-byte-count")) * 8 / 10',
        value: 'boxcaster.pipeline',
        as: 'pipeline.video-byte-count'
      }, {
        field: 'derivative(sum("audio-buffer-count")) / 10',
        value: 'boxcaster.pipeline',
        as: 'pipeline.audio-buffer-count'
      }, {
        field: 'derivative(sum("audio-byte-count")) * 8 / 10',
        value: 'boxcaster.pipeline',
        as: 'pipeline.audio-byte-count'
      }, {
        field: 'last("serial-src-is-open")',
        value: 'boxcaster.pipeline',
        as: 'pipeline.serial-src-is-open'
      }, {
        field: 'derivative(sum("serial-bytes-received")) * 8 / 10',
        value: 'boxcaster.pipeline',
        as: 'pipeline.serial-bytes-received'
      }, {
        field: 'last("carrier")',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.carrier',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("tx_packets")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.tx_packets',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("tx_bytes")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.tx_bytes',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("tx_errors")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.tx_errors',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("rx_packets")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.rx_packets',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("rx_bytes")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.rx_bytes',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("rx_errors")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.rx_errors',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("collisions")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.collisions',
        where: '"interface" =~ /eth0/'
      }, {
        field: 'derivative(sum("multicast")) / 10',
        value: 'boxcaster.network.interface',
        as: 'network.interface.ethernet.multicast',
        where: '"interface" =~ /eth0/'
      }];
      $scope.timeoutId = null;
      $scope.hovering = false;
      $scope.detail = {
        cpu: {
          open: false
        },
        encoder: {
          open: false
        },
        video_inputs: {
          open: false
        },
        sdi: {
          open: false
        },
        hdmi: {
          open: false
        },
        network: {
          open: false
        }
      };

      if ($scope.isPro) {
        _.each([{
          field: 'last("control-plane.logging")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.control-plane.logging'
        }, {
          field: 'last("control-plane.miscellaneous")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.control-plane.miscellaneous'
        }, {
          field: 'last("control-plane.remote-diagnostics")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.control-plane.remote-diagnostics'
        }, {
          field: 'last("control-plane.stats-collection")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.control-plane.stats-collection'
        }, {
          field: 'last("control-plane.stream-management")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.control-plane.stream-management'
        }, {
          field: 'last("control-plane.ui-and-preview")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.control-plane.ui-and-preview'
        }, {
          field: 'last("data-plane.audio.capture")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.audio.capture'
        }, {
          field: 'last("data-plane.audio.encode")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.audio.encode'
        }, {
          field: 'last("data-plane.audio.monitor")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.audio.monitor'
        }, {
          field: 'last("data-plane.audio.payload")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.audio.payload'
        }, {
          field: 'last("data-plane.serial.capture-and-payload")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.serial.capture-and-payload'
        }, {
          field: 'last("data-plane.transmission")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.transmission'
        }, {
          field: 'last("data-plane.video.capture")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.video.capture'
        }, {
          field: 'last("data-plane.video.encode")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.video.encode'
        }, {
          field: 'last("data-plane.video.payload")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.video.payload'
        }, {
          field: 'last("data-plane.video.scale-and-preview")',
          value: 'boxcaster.cpu.summary',
          as: 'cpu.data-plane.video.scale-and-preview'
        }], function (k) {
          return $scope.keys.push(k);
        });
      } else {
        _.each([{
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.BoxCasterRemo',
          where: '"component" =~ /BoxCasterRemo/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.DiagnosticSessi',
          where: '"component" =~ /DiagnosticSessi/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.EncoderGlibM',
          where: '"component" =~ /EncoderGlibM/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.IpcServermai',
          where: '"component" =~ /IpcServermai/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.Mainrun',
          where: '"component" =~ /Mainrun/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.Mainsignal',
          where: '"component" =~ /Mainsignal/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.PeriodicStatCol',
          where: '"component" =~ /PeriodicStatCol/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.PipelineGoverno',
          where: '"component" =~ /PipelineGoverno/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.ProcessControl',
          where: '"component" =~ /ProcessControl/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.StreamManagerr',
          where: '"component" =~ /StreamManagerr/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.SyslogTailerru',
          where: '"component" =~ /SyslogTailerru/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.VideoInputMonit',
          where: '"component" =~ /VideoInputMonit/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.alsasrcsrc',
          where: '"component" =~ /alsasrcsrc/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.alsasrc-analog',
          where: '"component" =~ /alsasrc-analog/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.alsasrc-embedde',
          where: '"component" =~ /alsasrc-embedde/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.audiomixerserc',
          where: '"component" =~ /audiomixerserc/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.audioqueuesrc',
          where: '"component" =~ /audioqueuesrc/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.audioqueue0src',
          where: '"component" =~ /audioqueue0src/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.audioqueue1src',
          where: '"component" =~ /audioqueue1src/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.audiosrc-ringbu',
          where: '"component" =~ /audiosrc-ringbu/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.boxcastcommsink',
          where: '"component" =~ /boxcastcommsink/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.boxcastserialsr',
          where: '"component" =~ /boxcastserialsr/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.dbclient_stdout',
          where: '"component" =~ /dbclient_stdout/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.dropbear_stdout',
          where: '"component" =~ /dropbear_stdout/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.pool',
          where: '"component" =~ /pool/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.ruby_timer_thr',
          where: '"component" =~ /ruby-timer-thr/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.ui_stdout',
          where: '"component" =~ /ui_stdout/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.v4l2srcsrc',
          where: '"component" =~ /v4l2srcsrc/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.vencsrc',
          where: '"component" =~ /vencsrc/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.videoqueue1src',
          where: '"component" =~ /videoqueue1src/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.videoqueue2src',
          where: '"component" =~ /videoqueue2src/'
        }, {
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.watchdog',
          where: '"component" =~ /watchdog/'
        }], function (k) {
          return $scope.keys.push(k);
        });
      }

      $scope.hasAdv7842 = _.include(['n', 'o'], $scope.boxcasterId[0]);

      if ($scope.hasAdv7842) {
        _.each([{
          field: 'mean("system") + mean("user")',
          value: 'boxcaster.cpu.main',
          as: 'cpu.main.Adv7842Monitor',
          where: '"component" =~ /Adv7842Monitor/'
        }, {
          field: 'last("dsd")',
          value: 'boxcaster.adv7842.audio',
          as: 'adv7842.audio.dsd'
        }, {
          field: 'last("hbr")',
          value: 'boxcaster.adv7842.audio',
          as: 'adv7842.audio.hbr'
        }, {
          field: 'last("multi-channel")',
          value: 'boxcaster.adv7842.audio',
          as: 'adv7842.audio.multi-channel'
        }, {
          field: 'last("pcm")',
          value: 'boxcaster.adv7842.audio',
          as: 'adv7842.audio.pcm'
        }, {
          field: 'last("cts")',
          value: 'boxcaster.adv7842.clocks',
          as: 'adv7842.clocks.cts'
        }, {
          field: 'last("fs-khz")',
          value: 'boxcaster.adv7842.clocks',
          as: 'adv7842.clocks.fs-khz'
        }, {
          field: 'last("mclkout-mhz")',
          value: 'boxcaster.adv7842.clocks',
          as: 'adv7842.clocks.mclkout-mhz'
        }, {
          field: 'last("n")',
          value: 'boxcaster.adv7842.clocks',
          as: 'adv7842.clocks.n'
        }, {
          field: 'last("tmds-mhz")',
          value: 'boxcaster.adv7842.clocks',
          as: 'adv7842.clocks.tmds-mhz'
        }, {
          field: 'last("standard")',
          value: 'boxcaster.adv7842.composite',
          as: 'adv7842.composite.standard'
        }, {
          field: 'last("valid")',
          value: 'boxcaster.adv7842.composite',
          as: 'adv7842.composite.valid'
        }, {
          field: 'last("video-detected")',
          value: 'boxcaster.adv7842.composite',
          as: 'adv7842.composite.video-detected'
        }, {
          field: 'last("bl")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.bl'
        }, {
          field: 'last("cable-detected")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.cable-detected'
        }, {
          field: 'last("encrypted")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.encrypted'
        }, {
          field: 'last("fcl")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.fcl'
        }, {
          field: 'last("hdmi_mode")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.hdmi_mode'
        }, {
          field: 'last("interlaced")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.interlaced'
        }, {
          field: 'last("lcf")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.lcf'
        }, {
          field: 'last("lcvs")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.lcvs'
        }, {
          field: 'last("standard")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.standard'
        }, {
          field: 'last("valid")',
          value: 'boxcaster.adv7842.hdmi',
          as: 'adv7842.hdmi.valid'
        }, {
          field: 'last("audio-locked")',
          value: 'boxcaster.adv7842.plls',
          as: 'adv7842.plls.audio-locked'
        }, {
          field: 'last("tmds-locked")',
          value: 'boxcaster.adv7842.plls',
          as: 'adv7842.plls.tmds-locked'
        }], function (k) {
          return $scope.keys.push(k);
        });
      }

      if ($scope.isPro) {
        _.each([{
          field: 'last("framerate")',
          value: 'boxcaster.video.hdmi',
          as: 'hdmi.framerate'
        }, {
          field: 'last("height")',
          value: 'boxcaster.video.hdmi',
          as: 'hdmi.height'
        }, {
          field: 'last("interlaced")',
          value: 'boxcaster.video.hdmi',
          as: 'hdmi.interlaced'
        }, {
          field: 'last("width")',
          value: 'boxcaster.video.hdmi',
          as: 'hdmi.width'
        }, {
          field: 'last("framerate")',
          value: 'boxcaster.video.sdi',
          as: 'sdi.framerate'
        }, {
          field: 'last("height")',
          value: 'boxcaster.video.sdi',
          as: 'sdi.height'
        }, {
          field: 'last("interlaced")',
          value: 'boxcaster.video.sdi',
          as: 'sdi.interlaced'
        }, {
          field: 'last("width")',
          value: 'boxcaster.video.sdi',
          as: 'sdi.width'
        }, {
          field: 'last("cable_length_m")',
          value: 'boxcaster.lmh1219',
          as: 'sdi.cable_length_m'
        }, {
          field: 'last("heo_ui")',
          value: 'boxcaster.lmh1219',
          as: 'sdi.heo_ui'
        }, {
          field: 'last("link_rate")',
          value: 'boxcaster.lmh1219',
          as: 'sdi.link_rate'
        }, {
          field: 'last("locked")',
          value: 'boxcaster.lmh1219',
          as: 'sdi.locked'
        }, {
          field: 'last("veo_mv")',
          value: 'boxcaster.lmh1219',
          as: 'sdi.veo_mv'
        }], function (k) {
          return $scope.keys.push(k);
        });
      }

      $scope.hasPowerSequencer = $scope.boxcasterId[0] === 'o';

      if ($scope.hasPowerSequencer) {
        $scope.keys.push({
          field: 'mean("temperature")',
          value: 'boxcaster.powersequencer',
          as: 'powersequencer.temperature'
        });
      } // Add temperature data from the BoxCaster Pro


      if ($scope.isPro) {
        $scope.keys.push({
          field: 'mean("ps")',
          value: 'boxcaster.temperature',
          as: 'temperature.ps'
        });
        $scope.keys.push({
          field: 'mean("pl")',
          value: 'boxcaster.temperature',
          as: 'temperature.pl'
        });
        $scope.keys.push({
          field: 'mean("max_touch_plastic")',
          value: 'boxcaster.temperature.model',
          as: 'temperature.max_touch_plastic'
        });
        $scope.keys.push({
          field: 'mean("max_touch_metal")',
          value: 'boxcaster.temperature.model',
          as: 'temperature.max_touch_metal'
        });
      }

      $scope.hasWireless = _.include(['o', 'p'], $scope.boxcasterId[0]);

      if ($scope.hasWireless) {
        var wifiInterfaceName = $scope.boxcasterId[0] === 'p' ? 'mlan0' : 'wlan0';

        _.each([{
          field: 'last("carrier")',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.carrier',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("tx_packets")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.tx_packets',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("tx_bytes")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.tx_bytes',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("tx_errors")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.tx_errors',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("rx_packets")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.rx_packets',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("rx_bytes")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.rx_bytes',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("rx_errors")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.rx_errors',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("collisions")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.collisions',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }, {
          field: 'derivative(sum("multicast")) / 10',
          value: 'boxcaster.network.interface',
          as: 'network.interface.wireless.multicast',
          where: "\"interface\" =~ /".concat(wifiInterfaceName, "/")
        }], function (k) {
          return $scope.keys.push(k);
        });
      } // This data represents the individual stats for the specific time being shown.


      $scope.statsAtTime = {
        time: null,
        cpu: {
          control_plane: {},
          data_plane: {
            video: {},
            audio: {},
            serial: {}
          }
        },
        encoder: {},
        adv7842: {
          audio: {},
          clocks: {},
          composite: {},
          hdmi: {},
          plls: {}
        },
        hdmi: {},
        sdi: {},
        network: {
          "interface": {
            total_bytes: null,
            ethernet: {},
            wireless: {}
          }
        }
      }; // Convenience method to get stats values from one or more keys

      $scope.statsForTime = function (keys, time) {
        return (// Currently, all values are expected to be >= 0, so treat them here as null/invalid
          _.map(keys, function (k) {
            return ($scope.statsData[k] || {})[time];
          }).reduce(function (a, b) {
            if ((a === null || a === undefined || a < 0) && (b === null || b === undefined || b < 0)) {
              return null;
            } else if (a !== null && a !== undefined && a >= 0 && (b === null || b === undefined || b < 0)) {
              return a;
            } else if ((a === null || a === undefined || a < 0) && b !== null && b !== undefined && b >= 0) {
              return b;
            } else {
              return a + b;
            }
          })
        );
      };

      this.statsForTime = $scope.statsForTime;
      $scope.timeInterval = '2h';
      $scope.fnsGraphWidthCallback = []; // This function is called by "child" graphs to add functions to be called when the graph
      // width is to be changed (e.g. in a window resize).

      this.registerGraphWidthCallback = function (fn) {
        return $scope.fnsGraphWidthCallback.push(fn);
      }; // This function will be periodically called to refresh stats data.


      var allowAutoRefresh = true;

      var refreshFn = function refreshFn() {
        var request = StatsService.fetch({
          time: ["time > now() - ".concat($scope.timeInterval)],
          boxcaster: $scope.boxcasterId,
          targets: $scope.keys
        });
        return request.then(function (data) {
          $scope.statsData = data;
          if (allowAutoRefresh) $scope.timeoutId = $timeout(refreshFn, 10000);
        });
      };

      refreshFn(); // This function is called to update the time interval of the stats data graph.

      $scope.updateTimeInterval = function (timeInterval) {
        $scope.timeInterval = timeInterval;

        if ($scope.timeoutId != null) {
          $timeout.cancel($scope.timeoutId);
        }

        return refreshFn();
      };

      $scope.$on('$destroy', function () {
        allowAutoRefresh = false;
        $timeout.cancel($scope.timeoutId);
      });
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      // This function is a common function to show the BoxCaster stats for a specific moment in
      // time, based on either hovering over the chart, or showing the latest value.
      //
      // The 'pct' parameter should be a float value between 0 and 1 (inclusive) representing
      // where, in the time window, data values should be shown.
      var showGraphStats = function showGraphStats(pct) {
        if (scope.statsData != null) {
          // Update the time we're showing based on pct.
          var times = _.keys(scope.statsData[_.keys(scope.statsData)[0]]);

          times.sort(function (a, b) {
            return a - b;
          });
          var time = times[Math.round(pct * (times.length - 1))];
          scope.statsAtTime.time = time; // Calculate the cpu busy and idle time.

          var cpu = scope.statsForTime(_.filter(_.keys(scope.statsData), function (k) {
            return k.match(/^cpu\./);
          }), time) / scope.numCores;

          if (cpu > 100.0) {
            cpu = 100.0;
          }

          scope.statsAtTime.cpu.busy = cpu;
          scope.statsAtTime.cpu.idle = 100.0 - cpu; // This block of code pulls out all the individual stats that are used below in the
          // templates. Most of these are numeric, but some are converted to boolean.

          if (scope.isPro) {
            scope.statsAtTime.cpu.control_plane.logging = scope.statsForTime(['cpu.control-plane.logging'], time) / scope.numCores;
            scope.statsAtTime.cpu.control_plane.miscellaneous = scope.statsForTime(['cpu.control-plane.miscellaneous'], time) / scope.numCores;
            scope.statsAtTime.cpu.control_plane.remote_diagnostics = scope.statsForTime(['cpu.control-plane.remote-diagnostics'], time) / scope.numCores;
            scope.statsAtTime.cpu.control_plane.stats_collection = scope.statsForTime(['cpu.control-plane.stats-collection'], time) / scope.numCores;
            scope.statsAtTime.cpu.control_plane.stream_management = scope.statsForTime(['cpu.control-plane.stream-management'], time) / scope.numCores;
            scope.statsAtTime.cpu.control_plane.ui_and_preview = scope.statsForTime(['cpu.control-plane.ui-and-preview'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.audio.capture = scope.statsForTime(['cpu.data-plane.audio.capture'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.audio.encode = scope.statsForTime(['cpu.data-plane.audio.encode'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.audio.monitor = scope.statsForTime(['cpu.data-plane.audio.monitor'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.audio.payload = scope.statsForTime(['cpu.data-plane.audio.payload'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.serial.capture_and_payload = scope.statsForTime(['cpu.data-plane.serial.capture-and-payload'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.transmission = scope.statsForTime(['cpu.data-plane.transmission'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.video.capture = scope.statsForTime(['cpu.data-plane.video.capture'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.video.encode = scope.statsForTime(['cpu.data-plane.video.encode'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.video.payload = scope.statsForTime(['cpu.data-plane.video.payload'], time) / scope.numCores;
            scope.statsAtTime.cpu.data_plane.video.scale_and_preview = scope.statsForTime(['cpu.data-plane.video.scale-and-preview'], time) / scope.numCores;
          } else {
            scope.statsAtTime.cpu.video_input_monitoring = scope.statsForTime(['cpu.main.Adv7842Monitor', 'cpu.main.VideoInputMonit'], time) / scope.numCores;
            scope.statsAtTime.cpu.remote_logging = scope.statsForTime(['cpu.main.BoxCasterRemo', 'cpu.main.SyslogTailerru'], time) / scope.numCores;
            scope.statsAtTime.cpu.lifecycle_management = scope.statsForTime(['cpu.main.DiagnosticSessi', 'cpu.main.IpcServermai', 'cpu.main.StreamManagerr', 'cpu.main.Mainrun', 'cpu.main.Mainsignal', 'cpu.main.dbclient_stdout', 'cpu.main.dropbear_stdout', 'cpu.main.ruby_timer_thr', 'cpu.main.ui_stdout'], time) / scope.numCores;
            scope.statsAtTime.cpu.watchdog = scope.statsForTime(['cpu.main.watchdog'], time) / scope.numCores;
            scope.statsAtTime.cpu.metrics_collection = scope.statsForTime(['cpu.main.PeriodicStatCol'], time) / scope.numCores;
            scope.statsAtTime.cpu.audio_capture = scope.statsForTime(['cpu.main.audiosrc-ringbu', 'cpu.main.alsasrcsrc', 'cpu.main.alsasrc-embedde', 'cpu.main.alsasrc-analog', 'cpu.main.audiomixerserc'], time) / scope.numCores;
            scope.statsAtTime.cpu.audio_encoding = scope.statsForTime(['cpu.main.audioqueuesrc', 'cpu.main.audioqueue0src', 'cpu.main.audioqueue1src'], time) / scope.numCores;
            scope.statsAtTime.cpu.video_capture = scope.statsForTime(['cpu.main.v4l2srcsrc'], time) / scope.numCores;
            scope.statsAtTime.cpu.video_transmission = scope.statsForTime(['cpu.main.videoqueue1src', 'cpu.main.videoqueue2src', 'cpu.main.vencsrc'], time) / scope.numCores;
            scope.statsAtTime.cpu.serial = scope.statsForTime(['cpu.main.boxcastserialsr'], time) / scope.numCores;
            scope.statsAtTime.cpu.backhaul = scope.statsForTime(['cpu.main.boxcastcommsink', 'cpu.main.PipelineGoverno'], time) / scope.numCores;
            scope.statsAtTime.cpu.housekeeping = scope.statsForTime(['cpu.main.EncoderGlibM', 'cpu.main.pool', 'cpu.main.ProcessControl'], time) / scope.numCores;
          }

          scope.statsAtTime.memory = scope.statsForTime(['memory.used'], time);
          scope.statsAtTime.temperature = scope.statsForTime(['powersequencer.temperature'], time);
          scope.statsAtTime.temperature_ps = scope.statsForTime(['temperature.ps'], time);
          scope.statsAtTime.temperature_pl = scope.statsForTime(['temperature.pl'], time);
          scope.statsAtTime.temperature_max_touch_plastic = scope.statsForTime(['temperature.max_touch_plastic'], time);
          scope.statsAtTime.temperature_max_touch_metal = scope.statsForTime(['temperature.max_touch_metal'], time);
          scope.statsAtTime.encoder.video_bitrate = scope.statsForTime(['pipeline.video-byte-count'], time);
          scope.statsAtTime.encoder.video_buffer_rate = scope.statsForTime(['pipeline.video-buffer-count'], time);
          scope.statsAtTime.encoder.audio_bitrate = scope.statsForTime(['pipeline.audio-byte-count'], time);
          scope.statsAtTime.encoder.audio_buffer_rate = scope.statsForTime(['pipeline.audio-buffer-count'], time);
          scope.statsAtTime.encoder.serial_bitrate = scope.statsForTime(['pipeline.serial-bytes-received'], time);
          scope.statsAtTime.encoder.serial_src_is_open = scope.statsForTime(['pipeline.serial-src-is-open'], time);
          scope.statsAtTime.adv7842.audio.dsd = scope.statsForTime(['adv7842.audio.dsd'], time);

          if (scope.statsAtTime.adv7842.audio.dsd != null) {
            scope.statsAtTime.adv7842.audio.dsd = scope.statsAtTime.adv7842.audio.dsd === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.audio.hbr = scope.statsForTime(['adv7842.audio.hbr'], time);

          if (scope.statsAtTime.adv7842.audio.hbr != null) {
            scope.statsAtTime.adv7842.audio.hbr = scope.statsAtTime.adv7842.audio.hbr === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.audio.multi_channel = scope.statsForTime(['adv7842.audio.multi-channel'], time);

          if (scope.statsAtTime.adv7842.audio.multi_channel != null) {
            scope.statsAtTime.adv7842.audio.multi_channel = scope.statsAtTime.adv7842.audio.multi_channel === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.audio.pcm = scope.statsForTime(['adv7842.audio.pcm'], time);

          if (scope.statsAtTime.adv7842.audio.pcm != null) {
            scope.statsAtTime.adv7842.audio.pcm = scope.statsAtTime.adv7842.audio.pcm === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.clocks.cts = scope.statsForTime(['adv7842.clocks.cts'], time);
          scope.statsAtTime.adv7842.clocks.fs_khz = scope.statsForTime(['adv7842.clocks.fs-khz'], time);
          scope.statsAtTime.adv7842.clocks.mclkout_mhz = scope.statsForTime(['adv7842.clocks.mclkout-mhz'], time);
          scope.statsAtTime.adv7842.clocks.n = scope.statsForTime(['adv7842.clocks.n'], time);
          scope.statsAtTime.adv7842.clocks.tmds_mhz = scope.statsForTime(['adv7842.clocks.tmds-mhz'], time);
          scope.statsAtTime.adv7842.composite.standard = scope.statsForTime(['adv7842.composite.standard'], time);
          scope.statsAtTime.adv7842.composite.valid = scope.statsForTime(['adv7842.composite.valid'], time);

          if (scope.statsAtTime.adv7842.composite.valid != null) {
            scope.statsAtTime.adv7842.composite.valid = scope.statsAtTime.adv7842.composite.valid === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.composite.video_detected = scope.statsForTime(['adv7842.composite.video-detected'], time);

          if (scope.statsAtTime.adv7842.composite.video_detected != null) {
            scope.statsAtTime.adv7842.composite.video_detected = scope.statsAtTime.adv7842.composite.video_detected === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.hdmi.bl = scope.statsForTime(['adv7842.hdmi.bl'], time);
          scope.statsAtTime.adv7842.hdmi.cable_detected = scope.statsForTime(['adv7842.hdmi.cable-detected'], time);

          if (scope.statsAtTime.adv7842.hdmi.cable_detected != null) {
            scope.statsAtTime.adv7842.hdmi.cable_detected = scope.statsAtTime.adv7842.hdmi.cable_detected === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.hdmi.encrypted = scope.statsForTime(['adv7842.hdmi.encrypted'], time);

          if (scope.statsAtTime.adv7842.hdmi.encrypted != null) {
            scope.statsAtTime.adv7842.hdmi.encrypted = scope.statsAtTime.adv7842.hdmi.encrypted === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.hdmi.fcl = scope.statsForTime(['adv7842.hdmi.fcl'], time);
          scope.statsAtTime.adv7842.hdmi.hdmi_mode = scope.statsForTime(['adv7842.hdmi.hdmi_mode'], time);

          if (scope.statsAtTime.adv7842.hdmi.hdmi_mode != null) {
            scope.statsAtTime.adv7842.hdmi.hdmi_mode = scope.statsAtTime.adv7842.hdmi.hdmi_mode === 1 ? 'HDMI' : 'DVI';
          }

          scope.statsAtTime.adv7842.hdmi.interlaced = scope.statsForTime(['adv7842.hdmi.interlaced'], time);

          if (scope.statsAtTime.adv7842.hdmi.interlaced != null) {
            scope.statsAtTime.adv7842.hdmi.interlaced = scope.statsAtTime.adv7842.hdmi.interlaced === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.hdmi.lcf = scope.statsForTime(['adv7842.hdmi.lcf'], time);
          scope.statsAtTime.adv7842.hdmi.lcvs = scope.statsForTime(['adv7842.hdmi.lcvs'], time);
          scope.statsAtTime.adv7842.hdmi.standard = scope.statsForTime(['adv7842.hdmi.standard'], time);
          scope.statsAtTime.adv7842.hdmi.valid = scope.statsForTime(['adv7842.hdmi.valid'], time);

          if (scope.statsAtTime.adv7842.hdmi.valid != null) {
            scope.statsAtTime.adv7842.hdmi.valid = scope.statsAtTime.adv7842.hdmi.valid === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.plls.audio_locked = scope.statsForTime(['adv7842.plls.audio-locked'], time);

          if (scope.statsAtTime.adv7842.plls.audio_locked != null) {
            scope.statsAtTime.adv7842.plls.audio_locked = scope.statsAtTime.adv7842.plls.audio_locked === 1 ? true : false;
          }

          scope.statsAtTime.adv7842.plls.tmds_locked = scope.statsForTime(['adv7842.plls.tmds-locked'], time);

          if (scope.statsAtTime.adv7842.plls.tmds_locked != null) {
            scope.statsAtTime.adv7842.plls.tmds_locked = scope.statsAtTime.adv7842.plls.tmds_locked === 1 ? true : false;
          }

          scope.statsAtTime.hdmi.framerate = scope.statsForTime(['hdmi.framerate'], time);
          scope.statsAtTime.hdmi.height = scope.statsForTime(['hdmi.height'], time);
          scope.statsAtTime.hdmi.interlaced = scope.statsForTime(['hdmi.interlaced'], time);

          if (scope.statsAtTime.hdmi.interlaced != null) {
            scope.statsAtTime.hdmi.interlaced = scope.statsAtTime.hdmi.interlaced === 1 ? true : false;
          }

          scope.statsAtTime.hdmi.width = scope.statsForTime(['hdmi.width'], time);
          scope.statsAtTime.sdi.framerate = scope.statsForTime(['sdi.framerate'], time);
          scope.statsAtTime.sdi.height = scope.statsForTime(['sdi.height'], time);
          scope.statsAtTime.sdi.interlaced = scope.statsForTime(['sdi.interlaced'], time);

          if (scope.statsAtTime.sdi.interlaced != null) {
            scope.statsAtTime.sdi.interlaced = scope.statsAtTime.sdi.interlaced === 1 ? true : false;
          }

          scope.statsAtTime.sdi.width = scope.statsForTime(['sdi.width'], time);
          scope.statsAtTime.sdi.cable_length_m = scope.statsForTime(['sdi.cable_length_m'], time);
          scope.statsAtTime.sdi.heo_ui = scope.statsForTime(['sdi.heo_ui'], time);
          scope.statsAtTime.sdi.link_rate = scope.statsForTime(['sdi.link_rate'], time);
          scope.statsAtTime.sdi.locked = scope.statsForTime(['sdi.locked'], time);

          if (scope.statsAtTime.sdi.locked != null) {
            scope.statsAtTime.sdi.locked = scope.statsAtTime.sdi.locked === 1 ? true : false;
          }

          scope.statsAtTime.sdi.veo_mv = scope.statsForTime(['sdi.veo_mv'], time);
          scope.statsAtTime.sdi.errors = scope.statsForTime(['sdi.errors'], time);
          scope.statsAtTime.network["interface"].ethernet.tx_bytes = scope.statsForTime(['network.interface.ethernet.tx_bytes'], time);
          scope.statsAtTime.network["interface"].ethernet.rx_bytes = scope.statsForTime(['network.interface.ethernet.rx_bytes'], time);
          scope.statsAtTime.network["interface"].wireless.tx_bytes = scope.statsForTime(['network.interface.wireless.tx_bytes'], time);
          scope.statsAtTime.network["interface"].wireless.rx_bytes = scope.statsForTime(['network.interface.wireless.rx_bytes'], time);

          if (scope.statsAtTime.network["interface"].ethernet.tx_bytes != null || scope.statsAtTime.network["interface"].ethernet.rx_bytes != null || scope.statsAtTime.network["interface"].wireless.tx_bytes != null || scope.statsAtTime.network["interface"].wireless.rx_bytes != null) {
            scope.statsAtTime.network["interface"].total_bytes = (scope.statsAtTime.network["interface"].ethernet.tx_bytes || 0) + (scope.statsAtTime.network["interface"].ethernet.rx_bytes || 0) + (scope.statsAtTime.network["interface"].wireless.tx_bytes || 0) + (scope.statsAtTime.network["interface"].wireless.rx_bytes || 0);
          } else {
            scope.statsAtTime.network["interface"].total_bytes = null;
          }

          scope.statsAtTime.network["interface"].ethernet.carrier = scope.statsForTime(['network.interface.ethernet.carrier'], time);

          if (scope.statsAtTime.network["interface"].ethernet.carrier != null) {
            scope.statsAtTime.network["interface"].ethernet.carrier = scope.statsAtTime.network["interface"].ethernet.carrier === 1 ? true : false;
          }

          scope.statsAtTime.network["interface"].wireless.carrier = scope.statsForTime(['network.interface.wireless.carrier'], time);

          if (scope.statsAtTime.network["interface"].wireless.carrier != null) {
            scope.statsAtTime.network["interface"].wireless.carrier = scope.statsAtTime.network["interface"].wireless.carrier === 1 ? true : false;
          }

          scope.statsAtTime.network["interface"].ethernet.tx_packets = scope.statsForTime(['network.interface.ethernet.tx_packets'], time);
          scope.statsAtTime.network["interface"].wireless.tx_packets = scope.statsForTime(['network.interface.wireless.tx_packets'], time);
          scope.statsAtTime.network["interface"].ethernet.tx_errors = scope.statsForTime(['network.interface.ethernet.tx_errors'], time);
          scope.statsAtTime.network["interface"].wireless.tx_errors = scope.statsForTime(['network.interface.wireless.tx_errors'], time);
          scope.statsAtTime.network["interface"].ethernet.rx_packets = scope.statsForTime(['network.interface.ethernet.rx_packets'], time);
          scope.statsAtTime.network["interface"].wireless.rx_packets = scope.statsForTime(['network.interface.wireless.rx_packets'], time);
          scope.statsAtTime.network["interface"].ethernet.rx_errors = scope.statsForTime(['network.interface.ethernet.rx_errors'], time);
          scope.statsAtTime.network["interface"].wireless.rx_errors = scope.statsForTime(['network.interface.wireless.rx_errors'], time);
          scope.statsAtTime.network["interface"].ethernet.collisions = scope.statsForTime(['network.interface.ethernet.collisions'], time);
          scope.statsAtTime.network["interface"].wireless.collisions = scope.statsForTime(['network.interface.wireless.collisions'], time);
          scope.statsAtTime.network["interface"].ethernet.multicast = scope.statsForTime(['network.interface.ethernet.multicast'], time);
          return scope.statsAtTime.network["interface"].wireless.multicast = scope.statsForTime(['network.interface.wireless.multicast'], time);
        }
      }; // This function calculates the extents of the embedded graph area.


      var getGraphExtents = function getGraphExtents() {
        var graphExtents = angular.copy($(element).find('td .rickshaw_graph').position());
        graphExtents.width = $(element).find('td .rickshaw_graph').width();
        graphExtents.height = $(element).find('table').height();
        return graphExtents;
      }; // This function is called whenever the graph is hovered over (when the mouse enters or moves
      // over the graph area).


      var onGraphHoverEnter = function onGraphHoverEnter(evt) {
        return scope.$apply(function () {
          var graphExtents = getGraphExtents();
          var offset_left = $(evt.currentTarget).parents('app-boxcaster-graph').offset().left;
          $(element).find('#cursor').css('left', evt.clientX - offset_left - 2 + 'px');
          $(element).find('#cursor').show();
          var pct = (evt.clientX - (offset_left + graphExtents.left)) * 1.0 / graphExtents.width;

          if (pct != null && pct >= 0.0 && pct <= 1.0) {
            showGraphStats(pct);
            return scope.hovering = true;
          }
        });
      }; // This function is called whenever the mouse leaves the graph area.


      var onGraphHoverExit = function onGraphHoverExit(evt) {
        return scope.$apply(function () {
          $(element).find('#cursor').hide();
          showGraphStats(1.0);
          return scope.hovering = false;
        });
      };

      $(element).find('td.boxcaster-diagnostic-graph-cell').hover(onGraphHoverEnter, onGraphHoverExit);
      $(element).find('td.boxcaster-diagnostic-graph-cell').mousemove(onGraphHoverEnter); // Run whenever the stats data is refreshed from the stats service.

      scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          if (!scope.hovering) {
            showGraphStats(1.0);
          } // We use the uptime data to figure out when the BoxCaster is actually offline/rebooted
          // (vs. just being busy and missing stats update intervals). Here we calculate those
          // gaps.


          var uptimeData = newval['uptime.total'];

          if (uptimeData != null) {
            // Remove any existing 'reboot' rectangles
            $(element).find('.reboot').remove(); // Sort uptime data and remove nulls.

            uptimeData = angular.copy(uptimeData);

            var times = _.keys(uptimeData);

            times.sort(function (a, b) {
              return a - b;
            });
            var startTime = times[0];
            var endTime = times[times.length - 1];

            _.each(uptimeData, function (v, k) {
              if (v == null) {
                return delete uptimeData[k];
              }
            }); // Here we calculate each spot where it looks like the BoxCaster rebooted. Our
            // rubric for determining whether a reboot happened is if the actual time between log
            // entries has advanced by 30 seconds or more, and the uptime value has either not
            // advanced or has gone backwards.


            var reboots = [];
            var lastTime = null;
            var lastVal = null;

            _.each(uptimeData, function (val, time, arr) {
              time = parseInt(time);

              if (lastTime != null && lastVal != null) {
                if (time - lastTime >= 30.0 && val - lastVal <= 0) {
                  reboots.push({
                    from: lastTime,
                    to: time
                  });
                }
              }

              lastTime = time;
              return lastVal = val;
            }); // For each 'reboot', add a rectangle to the graph to represent it.


            var graphExtents = getGraphExtents();

            _.each(reboots, function (r) {
              var left = graphExtents.left + (r.from - startTime) * graphExtents.width * 1.0 / (endTime - startTime);
              var width = (r.to - r.from) * graphExtents.width * 1.0 / (endTime - startTime);
              return $(element).find('#boxcaster-chart-panel').append("<div class=\"reboot\" style=\"left: ".concat(left, "px; top: 0px; width: ").concat(width, "px; height: 100%;\" data-from=\"").concat(r.from, "\" data-to=\"").concat(r.to, "\"></div>"));
            }); // Reconnect our hover handlers for the reboot rectangles.


            $(element).find('.reboot').hover(onGraphHoverEnter, onGraphHoverExit);
            return $(element).find('.reboot').mousemove(onGraphHoverEnter);
          }
        }
      }); // When the window is resized, we need to manually update the child graphs' sizes, since
      // Rickshaw uses SVG, and the SVG elements themselves are particularly bad about sizing.

      angular.element($window).bind('resize', function () {
        // The actual graph width is the panel width minus the width of the first and last columns.
        var panelWidth = $(element).find('#boxcaster-chart-panel')[0].getBoundingClientRect().width;
        var prevColWidth = $(element).find('#boxcaster-chart-panel table tr th')[0].getBoundingClientRect().width;
        var nextColWidth = $(element).find('#boxcaster-chart-panel table tr td')[1].getBoundingClientRect().width;
        return _.each(scope.fnsGraphWidthCallback, function (fn) {
          return fn.call(null, panelWidth - prevColWidth - nextColWidth);
        });
      });
      return element.on('$destroy', function () {
        if (scope.timeoutId != null) {
          return $timeout.cancel(scope.timeoutId);
        }
      });
    },
    template: "\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n          Diagnostics\n          <div class=\"btn-group btn-group-xs\" role=\"group\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"updateTimeInterval('4h')\" ng-class=\"{'active': timeInterval == '4h'}\">4h</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"updateTimeInterval('2h')\" ng-class=\"{'active': timeInterval == '2h'}\">2h</button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"updateTimeInterval('30m')\" ng-class=\"{'active': timeInterval == '30m'}\">30m</button>\n          </div>\n          <span ng-show=\"!!statsAtTime.time\">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span>\n        </div>\n        <div class=\"panel-body\" id=\"boxcaster-chart-panel\" style=\"padding: 0px;\">\n          <table class=\"table\" style=\"width: 100%; margin: 0px;\">\n            <tr class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">CPU</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-cpu-graph stats-data=\"statsData\" num-cores=\"numCores\"></app-boxcaster-cpu-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.cpu.busy | numberWithUnit:1:'%' }}</div>\n              </td>\n            </tr>\n            <tr class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Memory</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-single-value-graph stats-data=\"statsData\" renderer=\"area\" min=\"0\" max=\"{{ ::totalMemory }}\" color=\"rgb(160,160,255)\" target=\"memory.used\"></app-boxcaster-single-value-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.memory | metricPrefix:'B' }}</div>\n              </td>\n            </tr>\n            <tr ng-show=\"::hasPowerSequencer\" class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Temperature</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-single-value-graph stats-data=\"statsData\" renderer=\"line\" min=\"-20\" max=\"107.5\" color=\"rgb(128,176,128)\" target=\"powersequencer.temperature\"></app-boxcaster-single-value-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.temperature | numberWithUnit:1:\"&deg;C\" }}</div>\n              </td>\n            </tr>\n            <tr ng-show=\"::isPro\" class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Temperature</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-pro-temperature-graph stats-data=\"statsData\" boxcaster-id=\"{{ boxcasterId }}\"></app-boxcaster-pro-temperature-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">\n                  <span ng-hide=\"statsAtTime.temperature_max_touch_plastic\">\n                    PS: {{ statsAtTime.temperature_ps | numberWithUnit:1:\"&deg;C\" }} <br/>\n                    PL: {{ statsAtTime.temperature_pl | numberWithUnit:1:\"&deg;C\" }}\n                  </span>\n                  <span ng-show=\"statsAtTime.temperature_max_touch_plastic\">\n                    Plastic: {{ statsAtTime.temperature_max_touch_plastic | numberWithUnit:1:\"&deg;C\" }} <br/>\n                    Metal: {{ statsAtTime.temperature_max_touch_metal | numberWithUnit:1:\"&deg;C\" }}\n                  </span>\n                </div>\n              </td>\n            </tr>\n            <tr class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Video Bitrate</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-single-value-graph stats-data=\"statsData\" renderer=\"area\" min=\"0\" max=\"{{ ::maxVideoBitrate }}\" color=\"rgb(64,96,128)\" target=\"pipeline.video-byte-count\"></app-boxcaster-single-value-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.encoder.video_bitrate | metricPrefix:'bps' }}</div>\n              </td>\n            </tr>\n            <tr class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Audio Bitrate</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-single-value-graph stats-data=\"statsData\" renderer=\"area\" min=\"0\" max=\"{{ ::maxAudioBitrate }}\" color=\"rgb(128,96,64)\" target=\"pipeline.audio-byte-count\"></app-boxcaster-single-value-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.encoder.audio_bitrate | metricPrefix:'bps' }}</div>\n              </td>\n            </tr>\n            <tr class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Serial Bitrate</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-serial-input-graph stats-data=\"statsData\" boxcaster-id=\"{{ boxcasterId }}\"></app-boxcaster-serial-input-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.encoder.serial_bitrate | metricPrefix:'bps' }}</div>\n              </td>\n            </tr>\n            <tr ng-show=\"::hasAdv7842\" class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Video Inputs</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-video-inputs-graph stats-data=\"statsData\" boxcaster-id=\"{{ boxcasterId }}\"></app-boxcaster-video-inputs-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.adv7842 | detectedVideoInput }}</div>\n              </td>\n            </tr>\n            <tr ng-show=\"::isPro\" class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">SDI Input</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-pro-video-inputs-graph which=\"sdi\" stats-data=\"statsData\" boxcaster-id=\"{{ boxcasterId }}\"></app-boxcaster-pro-video-inputs-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.sdi | detectedProVideoInput }}</div>\n              </td>\n            </tr>\n            <tr ng-show=\"::isPro\" class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">HDMI Input</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-pro-video-inputs-graph which=\"hdmi\" stats-data=\"statsData\" boxcaster-id=\"{{ boxcasterId }}\"></app-boxcaster-pro-video-inputs-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.hdmi | detectedProVideoInput }}</div>\n              </td>\n            </tr>\n            <tr class=\"boxcaster-diagnostic-graph-row\">\n              <th class=\"boxcaster-diagnostic-graph-rowhead\">Network</th>\n              <td class=\"boxcaster-diagnostic-graph-cell\">\n                <app-boxcaster-network-graph stats-data=\"statsData\" boxcaster-id=\"{{ boxcasterId }}\"></app-boxcaster-network-graph>\n              </td>\n              <td>\n                <div class=\"boxcaster-diagnostic-graph-value\">{{ statsAtTime.network.interface.total_bytes | metricPrefix:'Bps' }}</div>\n              </td>\n            </tr>\n          </table>\n          <div id=\"cursor\" class=\"cursor\"></div>\n        </div>\n      </div>\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">Diagnostics Detail <span ng-show=\"!!statsAtTime.time\">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span></div>\n        <div class=\"panel-body\">\n          <table class=\"table\" style=\"width: 100%; margin: 0px;\">\n            <tr>\n              <th>CPU <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': detail.cpu.open, 'glyphicon-chevron-right': !detail.cpu.open}\" ng-click=\"detail.cpu.open = !detail.cpu.open\"></i></th>\n              <td style=\"width: 90%\">\n                <div collapse=\"!detail.cpu.open\">\n                  <table class=\"boxcaster-stats-detail\" id=\"boxcaster-cpu-detail\" ng-if=\"::!isPro\">\n                    <tr ng-if=\"::hasAdv7842\">\n                      <td>Video Input Monitoring:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.video_input_monitoring | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>Remote Logging:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.remote_logging | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>Lifecycle Management:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.lifecycle_management | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>Watchdog:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.watchdog | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>Metrics Collection:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.metrics_collection | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">Encoder</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio Capture:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.audio_capture | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio Encoding and Payloading:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.audio_encoding | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Video Capture and Encoding:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.video_capture | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Video Payloading:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.video_transmission | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Serial Capture/Encode/Payload:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.serial | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Backhaul:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.backhaul | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Housekeeping:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.housekeeping | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td><i>Idle:</i></td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.idle | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                  </table>\n                  <table class=\"boxcaster-stats-detail\" id=\"boxcaster-cpu-detail\" ng-if=\"::isPro\">\n                    <tr>\n                      <td colspan=\"2\">Data Plane</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">&nbsp;&nbsp;Video</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Capture:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.video.capture | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Encode:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.video.encode | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Payload:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.video.payload | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Scale/preview:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.video.scale_and_preview | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">&nbsp;&nbsp;Audio</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Capture:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.audio.capture | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Encode:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.audio.encode | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Payload:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.audio.payload | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Monitor:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.audio.monitor | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">&nbsp;&nbsp;Serial</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Capture/payload:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.serial.capture_and_payload | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;Transmission/backhaul:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.data_plane.transmission | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">Control Plane</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;UI and preview:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.control_plane.ui_and_preview | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;Stream Management:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.control_plane.stream_management | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;Stats Collection:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.control_plane.stats_collection | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;Logging:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.control_plane.logging | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;Remote Diagnostics:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.control_plane.remote_diagnostics | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;Miscellaneous:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.control_plane.miscellaneous | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                    <tr>\n                      <td><i>Idle:</i></td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.cpu.idle | numberWithUnit:1:'%' }}</td>\n                    </tr>\n                  </table>\n                </div>\n              </td>\n            </tr>\n            <tr>\n              <th>Encoder <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': detail.encoder.open, 'glyphicon-chevron-right': !detail.encoder.open}\" ng-click=\"detail.encoder.open = !detail.encoder.open\"></i></th>\n              <td style=\"width: 90%\">\n                <div collapse=\"!detail.encoder.open\">\n                  <table class=\"boxcaster-stats-detail\" id=\"boxcaster-encoder-detail\">\n                    <tr>\n                      <td>Video bitrate:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.encoder.video_bitrate | metricPrefix:'bps' }}</td>\n                    </tr>\n                    <tr>\n                      <td>Video buffer rate:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.encoder.video_buffer_rate | number:1 }}</td>\n                    </tr>\n                    <tr>\n                      <td>Audio bitrate:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.encoder.audio_bitrate | metricPrefix:'bps' }}</td>\n                    </tr>\n                    <tr>\n                      <td>Audio buffer rate:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.encoder.audio_buffer_rate | number:1 }}</td>\n                    </tr>\n                    <tr>\n                      <td>Serial bitrate:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.encoder.serial_bitrate | metricPrefix:'bps' }}</td>\n                    </tr>\n                    <tr>\n                      <td>Serial source is open:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.encoder.serial_src_is_open | boolean }}</td>\n                    </tr>\n                  </table>\n                </div>\n              </td>\n            </tr>\n            <tr ng-if=\"::isPro\">\n              <th>SDI Input <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': detail.sdi.open, 'glyphicon-chevron-right': !detail.sdi.open}\" ng-click=\"detail.sdi.open = !detail.sdi.open\"></i></th>\n              <td style=\"width: 90%\">\n                <div collapse=\"!detail.sdi.open\">\n                  <table class=\"boxcaster-stats-detail\" id=\"boxcaster-sdi-detail\">\n                    <tr>\n                      <td>Video standard:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.sdi | detectedProVideoInput }}</td>\n                    </tr>\n                    <tr>\n                      <td>Locked:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.sdi.locked | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td>Link rate:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.sdi.link_rate | sdiLinkRate }}</td>\n                    </tr>\n                    <tr>\n                      <td>Cable length (m, approximate):</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.sdi.cable_length_m | number:0 }}</td>\n                    </tr>\n                    <tr>\n                      <td>HEO/VEO:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ [statsAtTime.sdi.heo_ui, statsAtTime.sdi.veo_mv] | sdiHeoVeo }}</td>\n                    </tr>\n                  </table>\n                </div>\n              </td>\n            </tr>\n            <tr ng-if=\"::hasAdv7842\">\n              <th>Video Inputs <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': detail.video_inputs.open, 'glyphicon-chevron-right': !detail.video_inputs.open}\" ng-click=\"detail.video_inputs.open = !detail.video_inputs.open\"></i></th>\n              <td style=\"width: 90%\">\n                <div collapse=\"!detail.video_inputs.open\">\n                  <table class=\"boxcaster-stats-detail\" id=\"boxcaster-video-inputs-detail\">\n                    <tr>\n                      <td colspan=\"2\">Composite input</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Video detected:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.composite.video_detected | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Valid standard:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.composite.valid | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Detected standard:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.composite.standard | compositeStandard }}</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">HDMI input</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Cable detected:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.cable_detected | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Valid standard:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.valid | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Detected standard:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi | hdmiStandard }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Mode:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.hdmi_mode }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Encrypted:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.encrypted | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;BL:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.bl }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;LCVS:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.lcvs }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;LCF:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.lcf }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;FCL:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.fcl }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Interlaced:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.hdmi.interlaced | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">Audio</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio packet type:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.audio | audioPacketFormat }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Audio PLL locked:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.plls.audio_locked | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td colspan=\"2\">Clocking</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;CTS:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.clocks.cts }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;N:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.clocks.n }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;F<sub>S</sub>:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.clocks.fs_khz | numberWithUnit:3:'kHz' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;MCLK out:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.clocks.mclkout_mhz | numberWithUnit:3:'MHz' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TMDS:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.clocks.tmds_mhz | numberWithUnit:3:'MHz' }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TMDS PLL locked:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.adv7842.plls.tmds_locked | boolean }}</td>\n                    </tr>\n                  </table>\n                </div>\n              </td>\n            </tr>\n            <tr>\n              <th>Network <i class=\"pull-right glyphicon\" ng-class=\"{'glyphicon-chevron-down': detail.network.open, 'glyphicon-chevron-right': !detail.network.open}\" ng-click=\"detail.network.open = !detail.network.open\"></i></th>\n              <td style=\"width: 90%\">\n                <div collapse=\"!detail.network.open\">\n                  <table class=\"boxcaster-stats-detail\" id=\"boxcaster-network-detail\">\n                    <tr>\n                      <td colspan=\"2\">Wired:</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Connected:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.ethernet.carrier | boolean }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TX bytes / packets / errors:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.ethernet.tx_bytes }} / {{ statsAtTime.network.interface.ethernet.tx_packets }} / {{ statsAtTime.network.interface.ethernet.tx_errors }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;RX bytes / packets / errors:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.ethernet.rx_bytes }} / {{ statsAtTime.network.interface.ethernet.rx_packets }} / {{ statsAtTime.network.interface.ethernet.rx_errors }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Collisions:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.ethernet.collisions }}</td>\n                    </tr>\n                    <tr>\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Multicast:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.ethernet.multicast }}</td>\n                    </tr>\n                    <tr ng-if=\"::hasWireless\">\n                      <td colspan=\"2\">Wireless:</td>\n                    </tr>\n                    <tr ng-if=\"::hasWireless\">\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Connected:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.wireless.carrier | boolean }}</td>\n                    </tr>\n                    <tr ng-if=\"::hasWireless\">\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;TX bytes / packets / errors:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.wireless.tx_bytes }} / {{ statsAtTime.network.interface.wireless.tx_packets }} / {{ statsAtTime.network.interface.wireless.tx_errors }}</td>\n                    </tr>\n                    <tr ng-if=\"::hasWireless\">\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;RX bytes / packets / errors:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.wireless.rx_bytes }} / {{ statsAtTime.network.interface.wireless.rx_packets }} / {{ statsAtTime.network.interface.wireless.rx_errors }}</td>\n                    </tr>\n                    <tr ng-if=\"::hasWireless\">\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Collisions:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.wireless.collisions }}</td>\n                    </tr>\n                    <tr ng-if=\"::hasWireless\">\n                      <td>&nbsp;&nbsp;&nbsp;&nbsp;Multicast:</td>\n                      <td class=\"boxcaster-stats-detail-value\">{{ statsAtTime.network.interface.wireless.multicast }}</td>\n                    </tr>\n                  </table>\n                </div>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    "
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// This directive shows an area graph of network activity on a BoxCaster.
angular.module('app.directives').directive('appBoxcasterNetworkGraph', ["$location", function ($location) {
  return {
    require: '^^appBoxcasterGraph',
    restrict: 'E',
    scope: {
      statsData: '=',
      boxcasterId: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.options = {
        renderer: 'multi',
        height: 40
      };
      $scope.series = [{
        name: 'ethernet tx',
        renderer: 'area',
        data: [],
        color: 'rgba(255,0,0,0.5)'
      }, {
        name: 'ethernet rx',
        renderer: 'area',
        data: [],
        color: 'rgba(0,255,255,0.5)'
      }];

      if (_.include(['o', 'p'], $scope.boxcasterId[0])) {
        $scope.series = $scope.series.concat([{
          name: 'wireless tx',
          renderer: 'area',
          data: [],
          color: 'rgba(0,0,255,0.5)'
        }, {
          name: 'wireless rx',
          renderer: 'area',
          data: [],
          color: 'rgba(255,255,0,0.5)'
        }]);
      }

      return $scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          _.each($scope.series, function (s) {
            return s.data.length = 0;
          });

          var interfaces = ['ethernet'];

          if (_.include(['o', 'p'], $scope.boxcasterId[0])) {
            interfaces.push('wireless');
          }

          return _.each(interfaces, function (iface, idx1) {
            return _.each(['tx', 'rx'], function (direction, idx2) {
              var data = newval["network.interface.".concat(iface, ".").concat(direction, "_bytes")];

              if (data != null) {
                return Array.prototype.push.apply($scope.series[2 * idx1 + idx2].data, _.map(data, function (v, k) {
                  if (v < 0) {
                    v = null;
                  }

                  return {
                    x: parseInt(k),
                    y: v
                  };
                }).sort(function (a, b) {
                  return a.x - b.x;
                }));
              }
            });
          });
        }
      });
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      _.each([], function (k) {
        return appBoxcasterGraph.registerData(k);
      });

      return appBoxcasterGraph.registerGraphWidthCallback(function (newWidth) {
        return scope.$apply(function () {
          return scope.options.width = newWidth;
        });
      });
    },
    template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// This directive shows an area graph of network activity on a BoxCaster.
angular.module('app.directives').directive('appBoxcasterProTemperatureGraph', ["$location", function ($location) {
  return {
    require: '^^appBoxcasterGraph',
    restrict: 'E',
    scope: {
      statsData: '=',
      boxcasterId: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.options = {
        renderer: 'multi',
        height: 52,
        min: 0
      };
      $scope.series = [{
        name: 'ps',
        renderer: 'line',
        data: [],
        color: 'rgba(255,0,0,0.5)'
      }, {
        name: 'pl',
        renderer: 'line',
        data: [],
        color: 'rgba(0,255,255,0.5)'
      }];
      return $scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          _.each($scope.series, function (s) {
            return s.data.length = 0;
          });

          var keys = ['temperature.ps', 'temperature.pl'];

          if (newval['temperature.max_touch_plastic']) {
            keys[0] = 'temperature.max_touch_plastic';
            $scope.series[0].name = 'plastic';
            keys[1] = 'temperature.max_touch_metal';
            $scope.series[1].name = 'metal';
          } else {
            $scope.series[0].name = 'ps';
            $scope.series[1].name = 'pl';
          }

          return _.each(keys, function (which, idx) {
            var data = newval[which];

            if (data != null) {
              return Array.prototype.push.apply($scope.series[idx].data, _.map(data, function (v, k) {
                if (v < 0) {
                  v = null;
                }

                return {
                  x: parseInt(k),
                  y: v
                };
              }).sort(function (a, b) {
                return a.x - b.x;
              }));
            }
          });
        }
      });
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      _.each([], function (k) {
        return appBoxcasterGraph.registerData(k);
      });

      return appBoxcasterGraph.registerGraphWidthCallback(function (newWidth) {
        return scope.$apply(function () {
          return scope.options.width = newWidth;
        });
      });
    },
    template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// This directive shows an area graph representing the video inputs of a BoxCaster Pro. Different
// colors are used to represent different input types.
angular.module('app.directives').directive('appBoxcasterProVideoInputsGraph', ["$location", function ($location) {
  return {
    require: '^^appBoxcasterGraph',
    restrict: 'E',
    scope: {
      statsData: '=',
      boxcasterId: '@',
      which: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.options = {
        renderer: 'area',
        interpolation: 'step-after',
        height: 40,
        min: 0,
        max: 1
      };
      $scope.series = [{
        name: 'present',
        data: [],
        color: '#f000000'
      }];
      return $scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          // TODO: This function is horribly inefficient.
          // Search for requested adv7842 data targets
          var data = {
            framerate: newval["".concat($scope.which, ".framerate")],
            height: newval["".concat($scope.which, ".height")],
            width: newval["".concat($scope.which, ".width")]
          }; // Pluck just the times and sort them

          var times = _.union(_.keys(data.framerate), _.keys(data.height), _.keys(data.width));

          times.sort(function (a, b) {
            return a - b;
          }); // Now iterate through the times and construct series data for each series for each time

          var seriesData = [];

          _.each(times, function (t) {
            t = parseInt(t);
            var framerate = (data.framerate || [])[t];
            var height = (data.height || [])[t];
            var width = (data.height || [])[t];
            return seriesData.push({
              x: t,
              y: framerate * height * width > 0 ? 1 : 0
            });
          });

          $scope.series[0].data.length = 0;
          return Array.prototype.push.apply($scope.series[0].data, seriesData.sort(function (a, b) {
            return a.x - b.x;
          }));
        }
      });
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      return appBoxcasterGraph.registerGraphWidthCallback(function (newWidth) {
        return scope.$apply(function () {
          return scope.options.width = newWidth;
        });
      });
    },
    template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// This directive shows an area graph of serial input (i.e. scoreboard adapter) activity on a
// BoxCaster.
angular.module('app.directives').directive('appBoxcasterSerialInputGraph', ["$location", function ($location) {
  return {
    require: '^^appBoxcasterGraph',
    restrict: 'E',
    scope: {
      statsData: '=',
      boxcasterId: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.options = {
        renderer: 'multi',
        height: 40,
        min: 0,
        max: 57600
      };
      return $scope.series = [{
        name: 'Serial bitrate',
        renderer: 'area',
        data: [],
        color: '#00a000'
      }, {
        name: 'Serial src present',
        renderer: 'area',
        interpolation: 'step-after',
        data: [],
        color: '#c080f0'
      }];
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      return appBoxcasterGraph.registerGraphWidthCallback(function (newWidth) {
        return scope.$apply(function () {
          return scope.options.width = newWidth;
        });
      });
    },
    template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
  };
}]);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// This directive shows a graph of a single value from BoxCaster stats. Many options are
// configurable via attributes.
angular.module('app.directives').directive('appBoxcasterSingleValueGraph', ["$location", function ($location) {
  return {
    require: '^^appBoxcasterGraph',
    restrict: 'E',
    scope: {
      statsData: '=',
      target: '@',
      renderer: '@',
      min: '@',
      max: '@',
      color: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.data = [];
      $scope.options = {
        renderer: $scope.renderer,
        height: 40,
        min: $scope.min,
        max: $scope.max
      };
      $scope.series = [{
        data: $scope.data,
        color: $scope.color
      }];
      return $scope.$watch('statsData', function (newval, oldval) {
        if (newval != null && newval[$scope.target] != null) {
          $scope.data.length = 0;
          return Array.prototype.push.apply($scope.data, _.map(newval[$scope.target], function (v, k) {
            if (v < 0) {
              v = null;
            }

            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
        }
      });
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      return appBoxcasterGraph.registerGraphWidthCallback(function (newWidth) {
        return scope.$apply(function () {
          return scope.options.width = newWidth;
        });
      });
    },
    template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {// This directive shows an area graph representing the video inputs of a BoxCaster. Different
// colors are used to represent different input types.
angular.module('app.directives').directive('appBoxcasterVideoInputsGraph', ["$location", function ($location) {
  return {
    require: '^^appBoxcasterGraph',
    restrict: 'E',
    scope: {
      statsData: '=',
      boxcasterId: '@'
    },
    controller: ["$scope", function controller($scope) {
      var STD_525_60 = 1;
      var STD_625_50 = 2;
      var STD_480i60 = 3;
      var STD_480p60 = 4;
      var STD_576p50 = 5;
      var STD_720p30 = 6;
      var STD_720p50 = 7;
      var STD_720p60 = 8;
      var STD_1080i50 = 10;
      var STD_1080i60 = 11;
      var STD_1080p30 = 12;
      var STD_1080p50 = 13;
      var STD_1080p60 = 14;
      var STD_480p30 = 15;
      var STD_576p25 = 16;
      var STD_720p25 = 17;
      var STD_1080p25 = 18;
      var ANALOG_STANDARDS = [STD_525_60, STD_625_50];
      var DIGITAL_STANDARDS = [STD_480i60, STD_480p60, STD_576p50, STD_720p30, STD_720p50, STD_720p60, STD_1080i50, STD_1080i60, STD_1080p30, STD_1080p50, STD_1080p60, STD_480p30, STD_576p25, STD_720p25, STD_1080p25];
      $scope.options = {
        renderer: 'area',
        interpolation: 'step-after',
        height: 40,
        min: 0,
        max: 1
      };
      $scope.series = [{
        name: 'Analog present but no standard',
        data: [],
        color: '#000000'
      }, {
        name: '525@60',
        data: [],
        color: '#000028'
      }, {
        name: '625@50',
        data: [],
        color: '#000050'
      }, {
        name: 'HDMI present but no standard',
        data: [],
        color: '#000078'
      }, {
        name: '480i60',
        data: [],
        color: '#0000a0'
      }, {
        name: '480p60',
        data: [],
        color: '#0000c8'
      }, {
        name: '576p50',
        data: [],
        color: '#0000f0'
      }, {
        name: '720p30',
        data: [],
        color: '#002800'
      }, {
        name: '720p50',
        data: [],
        color: '#005000'
      }, {
        name: '720p60',
        data: [],
        color: '#007800'
      }, {
        name: '1080i50',
        data: [],
        color: '#00a000'
      }, {
        name: '1080i60',
        data: [],
        color: '#00c800'
      }, {
        name: '1080p30',
        data: [],
        color: '#00f000'
      }, {
        name: '1080p50',
        data: [],
        color: '#280000'
      }, {
        name: '1080p60',
        data: [],
        color: '#500000'
      }, {
        name: '480p30',
        data: [],
        color: '#780000'
      }, {
        name: '576p25',
        data: [],
        color: '#a00000'
      }, {
        name: '720p25',
        data: [],
        color: '#c800000'
      }, {
        name: '1080p25',
        data: [],
        color: '#f000000'
      }];
      return $scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          // TODO: This function is horribly inefficient.
          // Search for requested adv7842 data targets
          var adv7842data = {
            composite_video_detected: newval['adv7842.composite.video-detected'],
            composite_standard: newval['adv7842.composite.standard'],
            hdmi_cable_detected: newval['adv7842.hdmi.cable-detected'],
            hdmi_standard: newval['adv7842.hdmi.standard']
          }; // Pluck just the times and sort them

          var times = _.union(_.keys(adv7842data.composite_video_detected), _.keys(adv7842data.composite_standard), _.keys(adv7842data.hdmi_cable_detected), _.keys(adv7842data.hdmi_standard));

          times.sort(function (a, b) {
            return a - b;
          }); // Now iterate through the times and construct series data for each series for each time

          var seriesData = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []];

          _.each(times, function (t) {
            t = parseInt(t);
            var composite_video_detected = (adv7842data.composite_video_detected || [])[t];
            var composite_standard = (adv7842data.composite_standard || [])[t];
            var hdmi_cable_detected = (adv7842data.hdmi_cable_detected || [])[t];
            var hdmi_standard = (adv7842data.hdmi_standard || [])[t];
            seriesData[0].push({
              x: t,
              y: composite_video_detected === 1 && !_.contains(ANALOG_STANDARDS, composite_standard) ? 1 : 0
            });
            seriesData[1].push({
              x: t,
              y: composite_standard === STD_525_60 ? 1 : 0
            });
            seriesData[2].push({
              x: t,
              y: composite_standard === STD_625_50 ? 1 : 0
            });
            seriesData[3].push({
              x: t,
              y: hdmi_cable_detected === 1 && !_.contains(DIGITAL_STANDARDS, hdmi_standard) ? 1 : 0
            });
            seriesData[4].push({
              x: t,
              y: hdmi_standard === STD_480i60 ? 1 : 0
            });
            seriesData[5].push({
              x: t,
              y: hdmi_standard === STD_480p60 ? 1 : 0
            });
            seriesData[6].push({
              x: t,
              y: hdmi_standard === STD_576p50 ? 1 : 0
            });
            seriesData[7].push({
              x: t,
              y: hdmi_standard === STD_720p30 ? 1 : 0
            });
            seriesData[8].push({
              x: t,
              y: hdmi_standard === STD_720p50 ? 1 : 0
            });
            seriesData[9].push({
              x: t,
              y: hdmi_standard === STD_720p60 ? 1 : 0
            });
            seriesData[10].push({
              x: t,
              y: hdmi_standard === STD_1080i50 ? 1 : 0
            });
            seriesData[11].push({
              x: t,
              y: hdmi_standard === STD_1080i60 ? 1 : 0
            });
            seriesData[12].push({
              x: t,
              y: hdmi_standard === STD_1080p30 ? 1 : 0
            });
            seriesData[13].push({
              x: t,
              y: hdmi_standard === STD_1080p50 ? 1 : 0
            });
            seriesData[14].push({
              x: t,
              y: hdmi_standard === STD_1080p60 ? 1 : 0
            });
            seriesData[15].push({
              x: t,
              y: hdmi_standard === STD_480p30 ? 1 : 0
            });
            seriesData[16].push({
              x: t,
              y: hdmi_standard === STD_576p25 ? 1 : 0
            });
            seriesData[17].push({
              x: t,
              y: hdmi_standard === STD_720p25 ? 1 : 0
            });
            return seriesData[18].push({
              x: t,
              y: hdmi_standard === STD_1080p25 ? 1 : 0
            });
          }); // Clear and apply data to the actual series


          return _.each($scope.series, function (s, idx) {
            s.data.length = 0;
            return Array.prototype.push.apply(s.data, seriesData[idx].sort(function (a, b) {
              return a.x - b.x;
            }));
          });
        }
      });
    }],
    link: function link(scope, element, attrs, appBoxcasterGraph) {
      return appBoxcasterGraph.registerGraphWidthCallback(function (newWidth) {
        return scope.$apply(function () {
          return scope.options.width = newWidth;
        });
      });
    },
    template: "<app-rickshaw rickshaw-options=\"options\" rickshaw-series=\"series\"></app-rickshaw>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {angular.module('app.directives').directive('broadcastGraph', ["$timeout", "StatsService", function ($timeout, StatsService) {
  return {
    restrict: 'E',
    scope: {
      streamId: '@',
      broadcastId: '@',
      streamedAt: '@',
      isLive: '@',
      startsAt: '@',
      stopsAt: '@',
      originVersion: '@',
      isRtmp: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.packetLossLoaded = false;
      $scope.packetLossOptions = {
        renderer: 'bar',
        height: 100 //max: 20, TODO: consider a way to dynamically set max to balance
        //         not over-emphasizing tiny packet losses but also not hide them entirely.
        //         Probably warrants other custom handling of massive spikes rather than
        //         just scaling axes.

      };
      $scope.packetLossSeries = [{
        data: [],
        name: 'video',
        color: '#ff0000'
      }, {
        data: [],
        name: 'audio',
        color: '#0000ff'
      }];
      $scope.packetLossFeatures = {
        xAxis: {
          timeUnit: '15 minute'
        },
        hover: {
          xFormatter: function xFormatter(x) {
            return new Date(x * 1000).toLocaleString();
          }
        },
        minimum_bar_width: 1
      };
      $scope.numPacketLossResults = null;
      $scope.transcodeDelayLoaded = false;
      $scope.transcodeDelayOptions = {
        renderer: 'line',
        height: 50
      };
      $scope.transcodeDelaySeries = [{
        data: [],
        name: 'delay',
        color: '#ffc107' //orange

      }];
      $scope.transcodeDelayFeatures = {
        hover: {
          xFormatter: function xFormatter(x) {
            return new Date(x * 1000).toLocaleString();
          },
          yFormatter: false,
          formatter: function formatter(series, x, y) {
            var totalDelay = Math.round(1000.0 * y) / 1000.0;

            if (totalDelay >= 30) {
              return "<strong>Warning: Transcode delayed ".concat(totalDelay, " seconds. Could cause buffering");
            } else {
              return "".concat(totalDelay, " seconds");
            }
          }
        }
      };
      $scope.ingestLatencyLoaded = false;
      $scope.ingestLatencyOptions = {
        renderer: 'line',
        height: 50
      };
      $scope.ingestLatencySeries = [{
        data: [],
        name: 'latency',
        color: '#1AA8A1' //teal

      }];
      $scope.ingestLatencyFeatures = {
        hover: {
          xFormatter: function xFormatter(x) {
            return new Date(x * 1000).toLocaleString();
          },
          yFormatter: false,
          formatter: function formatter(series, x, y) {
            var latency = Math.round(1000.0 * y) / 1000.0;

            if (Math.abs(latency) < 1.0) {
              return "".concat(Math.round(1000.0 * latency), " ms");
            }

            return "".concat(latency, " seconds");
          }
        }
      };
      $scope.packetsRxLoaded = false;
      $scope.packetsRxOptions = {
        renderer: 'line',
        height: 100
      };
      $scope.packetsRxSeries = [{
        data: [],
        name: 'video',
        color: '#ff0000'
      }, {
        data: [],
        name: 'audio',
        color: '#0000ff'
      }, {
        data: [],
        name: 'ancillary',
        color: '#00ff00'
      }];
      $scope.packetsRxFeatures = {
        hover: {
          xFormatter: function xFormatter(x) {
            return new Date(x * 1000).toLocaleString();
          }
        }
      };
      $scope.timeoutId = null;
    }],
    link: function link(scope, element, attrs) {
      scope.parseGoTs = function (ts) {
        var vMs = 0;

        _.each(ts.match(/\d+(\.\d+)?[a-z]+/g), function (component) {
          var m = component.match(/(\d+(?:\.\d+)?)([a-z]+)/);

          if (m && m.length == 3) {
            var n = parseFloat(m[1]);
            var unit = m[2];

            if (unit == 'h') {
              vMs += n * 60 * 60 * 1000;
            } else if (unit == 'm') {
              vMs += n * 60 * 1000;
            } else if (unit == 's') {
              vMs += n * 1000;
            }
          }
        });

        return vMs;
      };

      scope.startsAtDate = new Date(scope.startsAt);
      scope.stopsAtDate = new Date(scope.stopsAt);

      if (scope.streamedAt) {
        scope.streamedAtDate = new Date(scope.streamedAt);
      } else {
        scope.streamedAtDate = null;
      }

      if (scope.originVersion <= 4) {
        scope.influxKeys = [{
          field: 'derivative(sum("count"))',
          as: 'video-packet-loss',
          value: 'origin.rtpbuf.packets_lost',
          where: "\"media\" = 'video'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'audio-packet-loss',
          value: 'origin.rtpbuf.packets_lost',
          where: "\"media\" = 'audio'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'video-packets-rx',
          value: 'origin.mux.packets_total',
          where: "\"index\" = '0' AND \"media\" = 'media'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'audio-packets-rx',
          value: 'origin.mux.packets_total',
          where: "\"index\" = '1' AND \"media\" = 'media'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'ancillary-packets-rx',
          value: 'origin.mux.packets_total',
          where: "\"index\" = '2' AND \"media\" = 'media'"
        }, {
          field: 'last("value")',
          as: 'transcode-delay',
          value: 'origin.transcode.delay_seconds',
          where: ""
        }];

        if (scope.isRtmp === 'true') {
          scope.influxKeys.push({
            field: 'last("value")',
            as: 'ingest-latency',
            value: 'origin.rtmpsrc.packet_latency'
          });
        }
      } else {
        scope.influxKeys = [{
          field: 'derivative(sum("count"))',
          as: 'video-packet-loss',
          value: 'stream_ingest_service.stream.packets_lost',
          where: "\"element\" = 'rtpbuf:video'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'audio-packet-loss',
          value: 'stream_ingest_service.stream.packets_lost',
          where: "\"element\" = 'rtpbuf:audio'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'video-packets-rx',
          value: 'stream_ingest_service.stream.packets_total',
          where: "\"element\" = 'mux:media' AND \"index\" = '0'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'audio-packets-rx',
          value: 'stream_ingest_service.stream.packets_total',
          where: "\"element\" = 'mux:media' AND \"index\" = '1'"
        }, {
          field: 'derivative(sum("count"))',
          as: 'ancillary-packets-rx',
          value: 'stream_ingest_service.stream.packets_total',
          where: "\"element\" = 'mux:media' AND \"index\" = '2'"
        }, {
          field: 'last("value")',
          as: 'transcode-delay',
          value: 'stream_collect_service.transcode_delay',
          where: ""
        }];

        if (scope.isRtmp === 'true') {
          scope.influxKeys.push({
            field: 'last("value")',
            as: 'ingest-latency',
            value: 'stream_ingest_service.stream.packet_latency'
          });
        }
      }

      var refreshFn = function refreshFn() {
        // Packet loss and RX come from stats
        var req_params = {
          datasource: 'origin',
          time: ["time > ".concat(scope.startsAtDate.getTime() / 1000, "s")],
          targets: scope.influxKeys
        };

        if (scope.originVersion <= 4) {
          req_params.broadcastId = scope.broadcastId;
        } else {
          req_params.stream = scope.streamId;
        }

        if (scope.stopsAtDate.getTime() < Date.now()) {
          req_params.time.push("time < ".concat(scope.stopsAtDate.getTime() / 1000, "s"));
        }

        StatsService.fetch(req_params).then(function (data) {
          scope.packetLossLoaded = true;
          scope.packetsRxLoaded = true;
          scope.transcodeDelayLoaded = true; // Packet loss

          scope.packetLossSeries[0].data.length = 0;
          scope.packetLossSeries[1].data.length = 0;
          scope.numPacketLossResults = _.map([data['video-packet-loss'], data['audio-packet-loss']], function (pairs) {
            return _.map(pairs, function (v) {
              return v || 0;
            }).reduce(function (a, b) {
              return a + b;
            }, 0);
          }).reduce(function (a, b) {
            return a + b;
          }, 0);

          if (scope.numPacketLossResults > 0) {
            Array.prototype.push.apply(scope.packetLossSeries[0].data, _.map(data['video-packet-loss'], function (v, k) {
              return {
                x: parseInt(k),
                y: v
              };
            }).sort(function (a, b) {
              return a.x - b.x;
            }));
            Array.prototype.push.apply(scope.packetLossSeries[1].data, _.map(data['audio-packet-loss'], function (v, k) {
              return {
                x: parseInt(k),
                y: v
              };
            }).sort(function (a, b) {
              return a.x - b.x;
            }));
          } // Packets RX


          scope.packetsRxSeries[0].data.length = 0;
          scope.packetsRxSeries[1].data.length = 0;
          scope.packetsRxSeries[2].data.length = 0;
          Array.prototype.push.apply(scope.packetsRxSeries[0].data, _.map(data['video-packets-rx'], function (v, k) {
            return {
              x: parseInt(k),
              y: v / 10.0
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          Array.prototype.push.apply(scope.packetsRxSeries[1].data, _.map(data['audio-packets-rx'], function (v, k) {
            return {
              x: parseInt(k),
              y: v / 10.0
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          Array.prototype.push.apply(scope.packetsRxSeries[2].data, _.map(data['ancillary-packets-rx'], function (v, k) {
            return {
              x: parseInt(k),
              y: v / 10.0
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          })); // Transcode delay

          scope.transcodeDelaySeries[0].data.length = 0;
          Array.prototype.push.apply(scope.transcodeDelaySeries[0].data, _.map(data['transcode-delay'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));

          if (scope.isRtmp === 'true') {
            // Ingest latency (for RTMP sources)
            scope.ingestLatencyLoaded = true;
            scope.ingestLatencySeries[0].data.length = 0;
            Array.prototype.push.apply(scope.ingestLatencySeries[0].data, _.map(data['ingest-latency'], function (v, k) {
              return {
                x: parseInt(k),
                y: v
              };
            }).sort(function (a, b) {
              return a.x - b.x;
            }));
          }
        }); // Reload

        if (scope.isLive === 'true') {
          scope.timeoutId = $timeout(refreshFn, 10000);
        }
      };

      refreshFn();
      /* This trick doesn't work reliably becuase the div inside the table can overflow still.
       * `table-layout: fixed` opens a whole new can of worms.  Ugh.
      angular.element($window).bind('resize', () =>
          scope.$apply(function() {
              const containerWidth = $('.boxcaster-diagnostic-graph-cell')[0].getBoundingClientRect().width;
              scope.packetLossOptions.width = containerWidth;
              scope.packetsRxOptions.width = containerWidth;
          })
      );
      */

      return element.on('$destroy', function () {
        if (scope.timeoutId != null) {
          return $timeout.cancel(scope.timeoutId);
        }
      });
    },
    template: "<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    Broadcast (Origin)\n  </div>\n  <div class=\"panel-body\" id=\"backhaul-chart-panel\" style=\"padding: 0px; position: relative; overflow: visible;\">\n    <table class=\"table\" style=\"width: 100%; margin: 0px;\">\n      <tr ng-switch=\"packetLossLoaded\" class=\"boxcaster-diagnostic-graph-row\">\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Packet Loss</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\" ng-switch-when=\"true\">\n          <app-rickshaw rickshaw-options=\"packetLossOptions\" rickshaw-series=\"packetLossSeries\" rickshaw-features=\"packetLossFeatures\"></app-rickshaw>\n          <div ng-show=\"numPacketLossResults == 0\" class=\"bg-info\" style=\"text-align: center;\">\n            <strong>No reported packet loss.</strong>\n          </div>\n        </td>\n        <td ng-switch-default style=\"padding-left:10px;\" class=\"boxcaster-diagnostic-graph-cell\">\n          Loading packet loss graph...\n        </td>\n      </tr>\n      <tr ng-switch=\"packetsRxLoaded\" class=\"boxcaster-diagnostic-graph-row\">\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Packets Rx/s</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\" ng-switch-when=\"true\">\n          <app-rickshaw rickshaw-options=\"packetsRxOptions\" rickshaw-series=\"packetsRxSeries\" rickshaw-features=\"packetsRxFeatures\"></app-rickshaw>\n        </td>\n        <td ng-switch-default style=\"padding-left:10px;\" class=\"boxcaster-diagnostic-graph-cell\">\n          Loading packets rx/s graph...\n        </td>\n      </tr>\n      <tr ng-switch=\"transcodeDelayLoaded\" class=\"boxcaster-diagnostic-graph-row\">\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Transcode Delay</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\" ng-switch-when=\"true\">\n          <app-rickshaw rickshaw-options=\"transcodeDelayOptions\" rickshaw-series=\"transcodeDelaySeries\" rickshaw-features=\"transcodeDelayFeatures\"></app-rickshaw>\n        </td>\n        <td ng-switch-default style=\"padding-left:10px;\" class=\"boxcaster-diagnostic-graph-cell\">\n          Loading transcode delay graph...\n        </td>\n      </tr>\n      <tr ng-if=\"isRtmp === 'true'\" ng-switch=\"ingestLatencyLoaded\" class=\"boxcaster-diagnostic-graph-row\">\n        <th class=\"boxcaster-diagnostic-graph-rowhead\">Ingest Latency</th>\n        <td class=\"boxcaster-diagnostic-graph-cell\" ng-switch-when=\"true\">\n          <app-rickshaw rickshaw-options=\"ingestLatencyOptions\" rickshaw-series=\"ingestLatencySeries\" rickshaw-features=\"ingestLatencyFeatures\"></app-rickshaw>\n        </td>\n        <td ng-switch-default style=\"padding-left:10px;\" class=\"boxcaster-diagnostic-graph-cell\">\n          Loading ingest latency graph...\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>"
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module('app.directives').directive('broadcasterGraph', ["$timeout", "$window", "StatsService", function ($timeout, $window, StatsService) {
  return {
    restrict: 'E',
    scope: {
      streamId: '@',
      startsAt: '@',
      stopsAt: '@'
    },
    controller: ["$scope", function controller($scope) {
      $scope.timeoutId = null;
      $scope.hovering = false;
      $scope.statsData = null;
      $scope.memoryUsageOptions = {
        renderer: 'multi',
        height: 50,
        min: 0,
        padding: {
          top: 0.10
        }
      };
      $scope.memoryUsageSeries = [{
        name: 'usage',
        renderer: 'area',
        data: [],
        color: '#5e9d2f'
      }];
      $scope.cpuUsageOptions = {
        renderer: 'multi',
        height: 50,
        min: 0,
        max: 100
      };
      $scope.cpuUsageSeries = [{
        name: 'usage',
        renderer: 'area',
        data: [],
        color: '#73c03a'
      }];
      $scope.diskUsageOptions = {
        renderer: 'multi',
        height: 50,
        min: 0,
        max: 100
      };
      $scope.diskUsageSeries = [{
        name: 'usage',
        renderer: 'area',
        data: [],
        color: '#4682b4'
      }];
      $scope.batteryLevelOptions = {
        renderer: 'multi',
        height: 50,
        min: 0,
        max: 100
      };
      $scope.batteryLevelSeries = [{
        name: 'level',
        renderer: 'area',
        data: [],
        color: '#7bc3b8'
      }];
      $scope.networkOptions = {
        renderer: 'multi',
        height: 50,
        min: 0
      };
      $scope.networkSeries = [{
        name: 'type',
        renderer: 'area',
        data: [],
        color: '#a47493'
      }];
      $scope.captureDeviceSystemPressureLevelOptions = {
        renderer: 'multi',
        height: 50,
        min: 0,
        max: 5
      };
      $scope.captureDeviceSystemPressureLevelSeries = [{
        name: 'pressure',
        renderer: 'area',
        data: [],
        color: '#446E70'
      }];
      $scope.videoBitrateOptions = {
        renderer: 'multi',
        height: 50,
        min: 0,
        padding: {
          top: 0.10
        }
      };
      $scope.videoBitrateSeries = [{
        name: 'target',
        renderer: 'line',
        data: [],
        color: 'rgba(200,9,62,0.3)'
      }, {
        name: 'actual',
        renderer: 'line',
        data: [],
        color: 'rgba(200,9,62,1)'
      }];
      $scope.audioBitrateOptions = {
        renderer: 'multi',
        height: 50,
        min: 0,
        padding: {
          top: 0.10
        }
      };
      $scope.audioBitrateSeries = [{
        name: 'target',
        renderer: 'line',
        data: [],
        color: 'rgba(9,67,200,0.3)'
      }, {
        name: 'actual',
        renderer: 'line',
        data: [],
        color: 'rgba(9,67,200,1)'
      }]; // This data represents the individual stats for the specific time being shown.

      $scope.statsAtTime = {
        time: null,
        video: {},
        audio: {},
        battery: {},
        memory: {},
        disk: {},
        cpu: {},
        networkType: null,
        captureDeviceSystemPressureLevel: null
      };
      return $scope.$on('$destroy', function () {
        if ($scope.timeoutId != null) {
          return $timeout.cancel($scope.timeoutId);
        }
      });
    }],
    link: function link(scope, element, attrs) {
      // Convenience method to get stats values from one or more keys
      var statsForTime = function statsForTime(keys, time) {
        return _.map(keys, function (k) {
          return (scope.statsData[k] || {})[time];
        }).reduce(function (a, b) {
          if ((a === null || a === undefined || a < 0) && (b === null || b === undefined || b < 0)) {
            return null;
          } else if (a !== null && a !== undefined && a >= 0 && (b === null || b === undefined || b < 0)) {
            return a;
          } else if ((a === null || a === undefined || a < 0) && b !== null && b !== undefined && b >= 0) {
            return b;
          } else {
            return a + b;
          }
        });
      }; // This function is a common function to show the BoxCaster stats for a specific moment in
      // time, based on either hovering over the chart, or showing the latest value.
      //
      // The 'pct' parameter should be a float value between 0 and 1 (inclusive) representing
      // where, in the time window, data values should be shown.


      var showGraphStats = function showGraphStats(pct) {
        // Update the time we're showing based on pct.
        var times = _.keys(scope.statsData[_.keys(scope.statsData)[0]]);

        times.sort(function (a, b) {
          return a - b;
        });
        var time = times[Math.round(pct * (times.length - 1))];
        scope.statsAtTime.time = time; // This block of code pulls out all the individual stats that are used below in the
        // templates. Most of these are numeric, but some are converted to boolean.

        scope.statsAtTime.battery.level = statsForTime(['battery-level'], time);
        scope.statsAtTime.memory.usage = statsForTime(['memory-usage'], time);
        scope.statsAtTime.disk.usage = statsForTime(['disk-usage'], time);
        scope.statsAtTime.cpu.usage = statsForTime(['cpu-usage'], time);
        scope.statsAtTime.networkType = statsForTime(['network-type'], time);

        if (scope.statsAtTime.networkType != null) {
          var _statusMap;

          var statusMap = (_statusMap = {}, _defineProperty(_statusMap, 0, 'Cellular'), _defineProperty(_statusMap, 1, 'Wi-Fi'), _statusMap);
          scope.statsAtTime.networkType = statusMap[scope.statsAtTime.networkType];
        }

        scope.statsAtTime.captureDeviceSystemPressureLevel = statsForTime(['system-pressure'], time);

        if (scope.statsAtTime.captureDeviceSystemPressureLevel != null) {
          var _pressureLevelMap;

          var pressureLevelMap = (_pressureLevelMap = {}, _defineProperty(_pressureLevelMap, 0, 'Nominal'), _defineProperty(_pressureLevelMap, 1, 'Fair'), _defineProperty(_pressureLevelMap, 2, 'Serious'), _defineProperty(_pressureLevelMap, 3, 'Critical'), _defineProperty(_pressureLevelMap, 4, 'Shutdown'), _pressureLevelMap);
          scope.statsAtTime.captureDeviceSystemPressureLevel = pressureLevelMap[scope.statsAtTime.captureDeviceSystemPressureLevel];
        }

        scope.statsAtTime.video.target = statsForTime(['target-video-bitrate'], time);
        scope.statsAtTime.video.actual = statsForTime(['actual-video-bitrate'], time);
        scope.statsAtTime.audio.target = statsForTime(['target-audio-bitrate'], time);
        return scope.statsAtTime.audio.actual = statsForTime(['actual-audio-bitrate'], time);
      }; // This function calculates the extents of the embedded graph area.


      var getGraphExtents = function getGraphExtents() {
        var graphExtents = angular.copy($(element).find('td .rickshaw_graph').position());
        graphExtents.width = $(element).find('td .rickshaw_graph').width();
        graphExtents.height = $(element).find('table').height();
        return graphExtents;
      }; // This function is called whenever the graph is hovered over (when the mouse enters or moves
      // over the graph area).


      var onGraphHoverEnter = function onGraphHoverEnter(evt) {
        return scope.$apply(function () {
          var graphExtents = getGraphExtents();
          var offset_left = $(evt.currentTarget).parents('broadcaster-graph').offset().left;
          $(element).find('#cursor').css('left', "".concat(evt.clientX - offset_left - 2, "px"));
          var left = evt.clientX - $(evt.currentTarget)[0].getBoundingClientRect().left;
          $(element).find('#cursor').show();
          var pct = left * 1.0 / graphExtents.width;

          if (pct != null && pct >= 0.0 && pct <= 1.0) {
            showGraphStats(pct);
            return scope.hovering = true;
          }
        });
      }; // This function is called whenever the mouse leaves the graph area.


      var onGraphHoverExit = function onGraphHoverExit(evt) {
        return scope.$apply(function () {
          $(element).find('#cursor').hide();
          showGraphStats(1.0);
          return scope.hovering = false;
        });
      };

      $(element).find('td.boxcaster-diagnostic-graph-cell').hover(onGraphHoverEnter, onGraphHoverExit);
      $(element).find('td.boxcaster-diagnostic-graph-cell').mousemove(onGraphHoverEnter); // The following keys are data that will be retrieved for display.

      scope.keys = [{
        field: 'mean("level") * 100',
        value: 'broadcaster.battery',
        as: 'battery-level'
      }, {
        field: 'mean("resident")',
        value: 'broadcaster.memory',
        as: 'memory-usage'
      }, {
        field: '(mean("system") + mean("user")) * 100',
        value: 'broadcaster.cpu',
        as: 'cpu-usage'
      }, {
        field: 'mean("used") / mean("total") * 100',
        value: 'broadcaster.disk',
        as: 'disk-usage'
      }, {
        field: 'last("wifi")',
        value: 'broadcaster.network',
        as: 'network-type'
      }, {
        field: 'max("system_pressure_state_level")',
        value: 'broadcaster.capture_device',
        as: 'system-pressure'
      }, {
        field: 'mean(value)',
        value: 'broadcaster.target-video-bitrate',
        as: 'target-video-bitrate'
      }, {
        field: 'mean(value)',
        value: 'broadcaster.actual-video-bitrate',
        as: 'actual-video-bitrate'
      }, {
        field: 'mean(value)',
        value: 'broadcaster.target-audio-bitrate',
        as: 'target-audio-bitrate'
      }, {
        field: 'mean(value)',
        value: 'broadcaster.actual-audio-bitrate',
        as: 'actual-audio-bitrate'
      }];
      var startsAtDate = new Date(Date.parse(scope.startsAt));
      var stopsAtDate = new Date(Date.parse(scope.stopsAt)); // This function will be periodically called to refresh stats data.

      var refreshFn = function refreshFn() {
        var req_params = {
          stream: scope.streamId,
          time: ["time > ".concat(startsAtDate.getTime() / 1000, "s")],
          targets: scope.keys
        };

        if (stopsAtDate.getTime() < Date.now()) {
          req_params.time.push("time < ".concat(stopsAtDate.getTime() / 1000, "s"));
        }

        var request = StatsService.fetch(req_params);
        return request.then(function (data) {
          scope.statsData = data;

          if (new Date() - new Date(scope.stopsAt) < 60 * 60 * 1000) {
            return scope.timeoutId = $timeout(refreshFn, 10000);
          } else {
            return scope.timeoutId = null;
          }
        });
      };

      refreshFn(); // When the window is resized, we need to manually update the child graphs' sizes, since
      // Rickshaw uses SVG, and the SVG elements themselves are particularly bad about sizing.

      angular.element($window).bind('resize', function () {
        // The actual graph width is the panel width minus the width of the first and last columns.
        var panelWidth = $(element).find('#backhaul-chart-panel')[0].getBoundingClientRect().width;
        var prevColWidth = $(element).find('#backhaul-chart-panel table tr th')[0].getBoundingClientRect().width;
        var nextColWidth = $(element).find('#backhaul-chart-panel table tr td')[1].getBoundingClientRect().width;
        var newWidth = panelWidth - prevColWidth - nextColWidth;
        return scope.$apply(function () {
          scope.videoBitrateOptions.width = newWidth;
          scope.audioBitrateOptions.width = newWidth;
          scope.batteryLevelOptions.width = newWidth;
          scope.memoryUsageOptions.width = newWidth;
          scope.diskUsageOptions.width = newWidth;
          scope.cpuUsageOptions.width = newWidth;
          return scope.networkOptions.width = newWidth;
        });
      });
      element.on('$destroy', function () {
        if (scope.timeoutId != null) {
          return $timeout.cancel(scope.timeoutId);
        }
      });
      var FILTER_COUNTER_ERROR_PERCENT = 5.0;
      return scope.$watch('statsData', function (newval, oldval) {
        if (newval != null) {
          _.each(newval, function (values, key) {
            if (key.match(/\.buffers/) || key.match(/\.byte-count/)) {
              var times = _.keys(values).sort();

              var tofix = {};

              _.each(times, function (t, i) {
                if (i > 0 && i < times.length - 1) {
                  var prev = values[times[i - 1]];
                  var val = values[t];
                  var next = values[times[i + 1]];

                  if (prev !== 0 && val === 0 && next !== 0) {
                    if (Math.abs(next * 2.0 - prev) / prev < FILTER_COUNTER_ERROR_PERCENT / 100.0) {
                      //prev =~= next * 2.0
                      values[t] = prev / 2.0;
                      return tofix[times[i - 1]] = values[t];
                    } else if (Math.abs(prev * 2.0 - next) / next < FILTER_COUNTER_ERROR_PERCENT / 100.0) {
                      //next =~= prev * 2.0
                      values[t] = next / 2.0;
                      return tofix[times[i + 1]] = values[t];
                    }
                  }
                }
              });

              return _.each(tofix, function (v, k) {
                return values[k] = v;
              });
            } else {
              // Remove nulls from gauges
              return _.each(values, function (v, k) {
                if (v == null) {
                  return delete values[k];
                }
              });
            }
          });

          var all_times = _.union.apply(this, _.map(_.keys(newval), function (k) {
            return _.keys(newval[k]);
          })).sort(function (a, b) {
            return a - b;
          });

          _.each(_.keys(newval), function (k) {
            var lastValue = null;
            return _.each(all_times, function (t) {
              if (!_.has(newval[k], t)) {
                newval[k][t] = lastValue || 0;
              }

              return lastValue = newval[k][t];
            });
          });

          scope.batteryLevelSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.batteryLevelSeries[0].data, _.map(newval['battery-level'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.memoryUsageSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.memoryUsageSeries[0].data, _.map(newval['memory-usage'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.cpuUsageSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.cpuUsageSeries[0].data, _.map(newval['cpu-usage'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.diskUsageSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.diskUsageSeries[0].data, _.map(newval['disk-usage'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.networkSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.networkSeries[0].data, _.map(newval['network-type'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.captureDeviceSystemPressureLevelSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.captureDeviceSystemPressureLevelSeries[0].data, _.map(newval['system-pressure'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.videoBitrateSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.videoBitrateSeries[0].data, _.map(newval['target-video-bitrate'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.videoBitrateSeries[1].data.length = 0;
          Array.prototype.push.apply(scope.videoBitrateSeries[1].data, _.map(newval['actual-video-bitrate'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.audioBitrateSeries[0].data.length = 0;
          Array.prototype.push.apply(scope.audioBitrateSeries[0].data, _.map(newval['target-audio-bitrate'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));
          scope.audioBitrateSeries[1].data.length = 0;
          Array.prototype.push.apply(scope.audioBitrateSeries[1].data, _.map(newval['actual-audio-bitrate'], function (v, k) {
            return {
              x: parseInt(k),
              y: v
            };
          }).sort(function (a, b) {
            return a.x - b.x;
          }));

          if (!scope.hovering) {
            return showGraphStats(1.0);
          }
        }
      });
    },
    template: "\n                <div class=\"panel panel-default\">\n                    <div class=\"panel-heading\">\n                    Broadcaster <span ng-show=\"!!statsAtTime.time\">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span>\n                    </div>\n                    <div class=\"panel-body\" id=\"broadcaster-chart-panel\" style=\"padding: 0px; position: relative;\">\n                    <table class=\"table\" style=\"width: 100%; margin: 0px;\">\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">Video Bit Rate</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"videoBitrateOptions\" rickshaw-series=\"videoBitrateSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">Target: {{ statsAtTime.video.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.video.actual | metricPrefix:'bps' }}</div>\n                            </td>\n                        </tr>\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">Audio Bit Rate</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"audioBitrateOptions\" rickshaw-series=\"audioBitrateSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">Target: {{ statsAtTime.audio.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.audio.actual | metricPrefix:'bps' }}</div>\n                            </td>\n                        </tr>\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">Battery Level</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"batteryLevelOptions\" rickshaw-series=\"batteryLevelSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">{{ statsAtTime.battery.level | numberWithUnit:1:'%' }}</div>\n                            </td>\n                        </tr>\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">Memory Usage</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"memoryUsageOptions\" rickshaw-series=\"memoryUsageSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">{{ statsAtTime.memory.usage | metricPrefix:'MB' }}</div>\n                            </td>\n                        </tr>\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">CPU Usage</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"cpuUsageOptions\" rickshaw-series=\"cpuUsageSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">{{ statsAtTime.cpu.usage | numberWithUnit:1:'%' }}</div>\n                            </td>\n                        </tr>\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">Disk Space</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"diskUsageOptions\" rickshaw-series=\"diskUsageSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">{{ statsAtTime.disk.usage | numberWithUnit:1:'%' }}</div>\n                            </td>\n                        </tr>\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">Network Type</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"networkOptions\" rickshaw-series=\"networkSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">{{ statsAtTime.networkType }}</div>\n                            </td>\n                        </tr>\n                        <tr class=\"boxcaster-diagnostic-graph-row\">\n                            <th class=\"boxcaster-diagnostic-graph-rowhead\">System Pressure</th>\n                            <td class=\"boxcaster-diagnostic-graph-cell\">\n                                <app-rickshaw rickshaw-options=\"captureDeviceSystemPressureLevelOptions\" rickshaw-series=\"captureDeviceSystemPressureLevelSeries\"></app-rickshaw>\n                            </td>\n                            <td>\n                                <div class=\"boxcaster-diagnostic-graph-value\" style=\"width:150px\">{{ statsAtTime.captureDeviceSystemPressureLevel }}</div>\n                            </td>\n                        </tr>\n                    </table>\n                    <div id=\"cursor\" class=\"cursor\"></div>\n                    </div>\n                </div>\n                "
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This directive shows an area graph of all Broadcasts today.
angular.module('app.directives').directive('broadcastsTodayGraph', ["Broadcast", function (Broadcast) {
  return {
    restrict: 'E',
    template: "\n        <div class=\"events-by-hour-graph\" style=\"height:50px\">\n           <app-rickshaw ng-if=\"countByHourData.length\" rickshaw-options=\"{height: 50}\" rickshaw-features=\"eventsByHourFeatures\" rickshaw-series=\"eventsByHourSeries\"></app-rickshaw>\n        </div>\n        ",
    controller: ["$scope", function controller($scope) {
      var todayRange = new Date().todayRangeUTC();

      var hourRangeForBroadcast = function hourRangeForBroadcast(b) {
        var start = new Date(b.starts_at);
        var stops = new Date(b.stops_at);

        if (start.getDate() !== stops.getDate()) {
          return _.range(start.getHours(), 24); //wraps around midnight
        } else {
          return _.range(start.getHours(), stops.getHours() + 1);
        }
      };

      var idxToDate = function idxToDate(k) {
        var dt = new Date();
        dt.setHours(k);
        dt.setMinutes(0);
        dt.setSeconds(0);
        return dt.getTime() / 1000;
      };

      return Broadcast.query({
        "filter.exclude_disallowed_accounts": "true",
        "filter.include_archived": "false",
        q: "+starts_at:[".concat(todayRange.from, " TO ").concat(todayRange.to, "]"),
        l: 1000
      }, function (data, getResponseHeader) {
        var todayBroadcasts = _.map(data, function (b) {
          return {
            hours: hourRangeForBroadcast(b)
          };
        });

        var countByHour = {};

        _.each(_.range(24), function (h) {
          return countByHour[h] = _.reduce(todayBroadcasts, function (sum, b) {
            var left;
            return sum + ((left = Array.from(b.hours).includes(h)) != null ? left : _defineProperty({}, 1, 0));
          }, 0);
        });

        var countByHourHoverFormatter = function countByHourHoverFormatter(series, x, y) {
          var content;
          return content = "<strong>".concat(y, "</strong> event(s) at <strong>").concat(new Date(x * 1000).toLocaleTimeString(), "</strong>");
        };

        $scope.countByHourData = _.map(countByHour, function (v, k) {
          return {
            x: idxToDate(k),
            y: parseInt(v)
          };
        });
        $scope.eventsByHourSeries = [{
          name: 'Number of Events Today By Hour',
          renderer: 'bar',
          data: $scope.countByHourData,
          color: 'rgba(0,0,0,0.5)'
        }];
        return $scope.eventsByHourFeatures = {
          yAxis: false,
          xAxis: false,
          annotate: [{
            x: new Date().getTime() / 1000,
            label: 'Now'
          }],
          hover: {
            xFormatter: false,
            yFormatter: false,
            formatter: countByHourHoverFormatter
          }
        };
      });
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 310 */
/***/ (function(module, exports) {

angular.module('app.directives').directive('ngEnter', function () {
  return function (scope, elem, attrs) {
    return elem.bind('keydown keypress', function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          return scope.$eval(attrs.ngEnter, {
            event: event
          });
        });
        return event.preventDefault();
      }
    });
  };
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.directives').directive('lowLatencyPlayer', ["$timeout", function ($timeout) {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '='
    },
    template: "\n        <div id=\"{{:: id}}\" class=\"player\"></div>\n        <div ng-if=\"no_op\" class=\"bg-warning text-warning text-center\" style=\"border:1px solid;margin:45px 15px 15px 15px;padding:15px;\">\n          Flash is required to view the low latency preview.\n          <a href=\"https://get.adobe.com/flashplayer\" target=\"_blank\">\n            Click to enable or download Flash\n          </a>\n        </div>\n      ",
    link: function link(scope, element, attrs, ngModel) {
      scope.id = "player-".concat(0 | Math.random() * 1000000);
      scope.no_op = false;
      var ctx = boxcast("#".concat(scope.id));
      scope.$watch(function () {
        return scope.broadcast && scope.broadcast.rtmp_preview_url;
      }, function (rtmp_preview_url) {
        if (rtmp_preview_url) {
          ctx.unload();
          ctx.loadLowLatency(rtmp_preview_url, {
            disableMetrics: true,
            debug: true,
            env: __WEBPACK_IMPORTED_MODULE_0_environment__["v" /* PLAYER_ENV */],
            onLoadPlayer: function onLoadPlayer(p) {
              if (p.core.getCurrentPlayback().name == 'no_op') {
                ctx.unload();
                scope.$evalAsync(function () {
                  return scope.no_op = true;
                });

                if (canRequestPermission) {
                  // in case, when flash is not available, try to prompt user to enable it
                  requestFlashPermission(); // Chrome requires user's click in order to allow iframe embeding

                  $(window).one('click', requestFlashPermission);
                }
              }
            }
          });
        } else {
          ctx.unload();
        }
      });
      scope.$on('$destroy', function () {
        if (ctx) ctx.unload();
      });
    }
  };
}]);
/**
 * Tries to show browser's promt for enabling flash
 *
 * Chrome starting from 56 version and Edge from 15 are disabling flash
 * by default. To promt user to enable flash, they suggest to send user to
 * flash player download page. Then this browser will catch such request
 * and show a promt to user:
 * https://www.chromium.org/flash-roadmap#TOC-Developer-Recommendations
 * In this method we are forcing such promt by navigating user to adobe
 * site in iframe, instead of top window
 */

function requestFlashPermission() {
  var iframe = document.createElement('iframe');
  iframe.src = 'https://get.adobe.com/flashplayer';
  iframe.sandbox = '';
  document.body.appendChild(iframe);
  document.body.removeChild(iframe);
}

var isNewEdge = (navigator.userAgent.match(/Edge\/(\d+)/) || [])[1] > 14;
var isNewSafari = (navigator.userAgent.match(/OS X (\d+)/) || [])[1] > 9;
var isNewChrome = (navigator.userAgent.match(/Chrom(e|ium)\/(\d+)/) || [])[2] > 56 && !/Mobile/i.test(navigator.userAgent);
var canRequestPermission = isNewEdge || isNewSafari || isNewChrome;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 312 */
/***/ (function(module, exports) {

angular.module('app.directives').directive('firmwareVersion', function () {
  return {
    restrict: 'E',
    scope: {
      boxcaster: '=',
      concise: '=',
      "float": '='
    },
    template: "\n          <span ng-if=\"showVersion\">\n            {{boxcaster.firmware_released_at | date:'shortDate'}}\n          </span>\n          <span ng-if=\"!showVersion\">\n            (N/A)\n          </span>\n          <span ng-if=\"!concise\">\n            &nbsp;&nbsp;\n            v{{ boxcaster.firmware_revision }}\n            &nbsp;&nbsp;\n          </span>\n          <span ng-switch=\"boxcaster.firmware_status\" ng-class=\"{'pull-right': float}\">\n            <span ng-switch-when=\"current\" class=\"text-success\">\n              <i class=\"fa fa-check\"></i>\n            </span>\n            <span ng-switch-when=\"outdated\" class=\"text-warning\">\n              <i class=\"fa fa-warning\"></i>\n              <span ng-if=\"!concise\">Outdated</span>\n            </span>\n            <span ng-switch-when=\"invalid\" class=\"text-danger\">\n              <i class=\"fa fa-warning\"></i>\n              <span ng-if=\"!concise\">Invalid</span>\n            </span>\n          </span>\n          ",
    link: function link(scope, element, attr) {
      return scope.$watch(function () {
        return scope.boxcaster.firmware_released_at;
      }, function (d) {
        return scope.showVersion = d && !d.startsWith('1970');
      });
    }
  };
});

/***/ }),
/* 313 */
/***/ (function(module, exports) {

angular.module('app.directives').directive('match', function () {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      match: '='
    },
    link: function link(scope, elem, attrs, ctrl) {
      var expression = function expression() {
        /* This original implementation assumes ngRequired-like semantics
           in addition to matching.  Let's simplify to just matching...
        const v = ctrl.$modelValue || ctrl.$$invalidModelValue;
        if (ctrl.$pristine) {
            return angular.isUndefined(v);
        } else {
            return scope.match === v;
        }
        */
        return scope.match == ctrl.$modelValue;
      };

      var listener = function listener(v) {
        return ctrl.$setValidity('match', v);
      };

      return scope.$watch(expression, listener);
    }
  };
});

/***/ }),
/* 314 */
/***/ (function(module, exports) {

angular.module('app.directives').directive('appPagination', ["$location", function ($location) {
  var button = function button(label, rel) {
    return "<div ng-click=\"page(pagination.".concat(rel, ")\"\n        ng-class=\"{ disabled: pagination.").concat(rel, " === undefined }\"\n        class=\"btn btn-default\">").concat(label, "</div>");
  };

  return {
    restrict: 'E',
    template: button('First', 'first') + button('&laquo; Previous', 'previous') + button('Next &raquo;', 'next') + button('Last', 'last') + ' &nbsp;&nbsp; Total Results: {{pagination.total | number}}'
  };
}]);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.directives').directive('appPlayer', function () {
  return {
    restrict: 'E',
    scope: {
      channelId: '=',
      ticketId: '=',
      reload: '=',
      onRefresh: '='
    },
    template: "<div class=\"player\"></div>",
    link: function link(scope, element, attrs, ngModel) {
      var id = "player-".concat(0 | Math.random() * 1000000);
      $(element).find('.player').attr('id', id);
      var ctx = null;
      scope.$watchGroup(['channelId', 'reload'], function (values) {
        var channelId = values[0];

        if (channelId) {
          ctx = boxcast("#".concat(id));
          var options = {
            disableMetrics: true,
            autoplay: false,
            playInline: true,
            autostart: false,
            ticketId: scope.ticketId,
            env: __WEBPACK_IMPORTED_MODULE_0_environment__["v" /* PLAYER_ENV */],
            geoblock: {},
            cryptblock: {},
            onRefresh: function onRefresh() {
              scope.$apply(function () {
                scope.onRefresh && scope.onRefresh();
              });
            }
          };
          return ctx.loadChannel(channelId, options);
        }
      });
      return element.on('$destroy', function () {
        if (ctx) ctx.unload();
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Rickshaw, $, _) {angular.module('app.directives').directive('appRickshaw', ["$compile", "$window", function ($compile, $window) {
  'ngInject';

  var originalBarWidth = Rickshaw.Graph.Renderer.Bar.prototype.barWidth;
  return {
    restrict: 'EA',
    scope: {
      options: '=rickshawOptions',
      series: '=rickshawSeries',
      features: '=rickshawFeatures'
    },
    link: function link(scope, element, attrs) {
      var graph = null;

      var getSettings = function getSettings(el) {
        var settings = angular.copy(scope.options);
        settings.element = el;
        settings.series = scope.series;
        return settings;
      };

      var update = function update() {
        var mainEl = angular.element(element);
        var graphEl = $compile('<div></div>')(scope); // Fix the height (if specified in the options) so that replacing the html contents won't
        // monkey with the page scrolling

        if (scope.options.height != null) {
          $(graphEl[0]).css('height', "".concat(scope.options.height, "px"));
        }

        mainEl.html(graphEl);
        var settings = getSettings(graphEl[0]);
        graph = new Rickshaw.Graph(settings);

        if (scope.features && scope.features.hover) {
          var hoverConfig = {
            graph: graph
          };
          hoverConfig.xFormatter = scope.features.hover.xFormatter;
          hoverConfig.yFormatter = scope.features.hover.yFormatter;
          hoverConfig.formatter = scope.features.hover.formatter;
          var hoverDetail = new Rickshaw.Graph.HoverDetail(hoverConfig);
        }

        if (scope.features && scope.features.palette) {
          var palette = new Rickshaw.Color.Palette({
            scheme: scope.features.palette
          });

          for (var _i = 0, _Array$from = Array.from(settings.series); _i < _Array$from.length; _i++) {
            var series = _Array$from[_i];
            series.color = palette.color();
          }
        }

        if (scope.options && scope.options.renderer === 'bar' && scope.features && (scope.features.minimum_bar_width || scope.features.maximum_bar_width)) {
          var min = scope.features.minimum_bar_width || 0;
          var max = scope.features.maximum_bar_width || 999999;

          if (max < min) {
            max = min;
          }

          Rickshaw.Graph.Renderer.Bar.prototype.barWidth = function (series) {
            var orig = originalBarWidth.apply(graph.renderer, [series]);
            return Math.min(Math.max(orig, min), max);
          };
        }

        graph.render();

        if (scope.features && scope.features.xAxis) {
          var xAxisConfig = {
            graph: graph
          };

          if (scope.features.xAxis.timeUnit) {
            var time = new Rickshaw.Fixtures.Time.Local();
            xAxisConfig.timeUnit = time.unit(scope.features.xAxis.timeUnit);
          }

          var xAxis = new Rickshaw.Graph.Axis.Time(xAxisConfig);
          xAxis.render();
        }

        if (scope.features && scope.features.yAxis) {
          var yAxisConfig = {
            graph: graph
          };

          if (scope.features.yAxis.tickFormat) {
            yAxisConfig.tickFormat = Rickshaw.Fixtures.Number[scope.features.yAxis.tickFormat];
          }

          var yAxis = new Rickshaw.Graph.Axis.Y(yAxisConfig);
          yAxis.render();
        }

        if (scope.features && scope.features.legend) {
          var legendEl = $compile('<div></div>')(scope);
          mainEl.append(legendEl);
          var legend = new Rickshaw.Graph.Legend({
            graph: graph,
            element: legendEl[0]
          });

          if (scope.features.legend.toggle) {
            var shelving = new Rickshaw.Graph.Behavior.Series.Toggle({
              graph: graph,
              legend: legend
            });
          }

          if (scope.features.legend.highlight) {
            var highlighter = new Rickshaw.Graph.Behavior.Series.Highlight({
              graph: graph,
              legend: legend
            });
          }
        }

        if (scope.features && scope.features.annotate) {
          var annEl = $compile('<div></div>')(scope);
          mainEl.append(annEl);
          var annotator = new Rickshaw.Graph.Annotate({
            graph: graph,
            element: annEl.get(0)
          });

          _.each(scope.features.annotate, function (a) {
            return annotator.add(a.x, a.label);
          });

          return annotator.update();
        }
      };

      var optionsWatch = scope.$watch('options', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          return update();
        }
      }, true);
      var seriesWatch = scope.$watch(function (scope) {
        var series;

        if (scope.features && scope.features.directive && scope.features.directive.watchAllSeries) {
          var watches = {};

          for (var i = 0; i < scope.series.length; i++) {
            series = scope.series[i];
            watches["series".concat(i)] = series.data;
          }

          return watches;
        } else {
          return scope.series[0].data;
        }
      }, function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          return update();
        }
      }, true);
      var featuresWatch = scope.$watch('features', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          return update();
        }
      });
      /*
      angular.element($window).bind('resize', () => {
        if (graph) {
          graph.configure({width: element.find('div').width()});
        }
      });
      */

      scope.$on('$destroy', function () {
        optionsWatch();
        seriesWatch();
        return featuresWatch();
      });
      return update();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {angular.module('app.directives').directive('appSlider', ["$timeout", function ($timeout) {
  return {
    require: 'ngModel',
    restrict: 'E',
    scope: {
      min: '@',
      max: '@',
      range: '='
    },
    template: "<div class=\"slider\"></div>",
    link: function link(scope, element, attrs, ngModel) {
      var el = $(element).find('.slider');
      el.slider({
        min: parseInt(attrs.min, 10),
        max: parseInt(attrs.max, 10),
        range: !!attrs.range
      });
      el.bind('slide', function (event, ui) {
        ngModel.$setViewValue(ui.values || ui.value);
        return scope.$apply();
      });
      attrs.$observe('min', function (v) {
        return el.slider('option', 'min', parseInt(v, 10));
      });
      attrs.$observe('max', function (v) {
        return el.slider('option', 'max', parseInt(v, 10));
      });
      return scope.$watch(function () {
        return ngModel.$modelValue;
      }, function (v) {
        var m = el.slider('option', 'range') ? 'values' : 'value';
        return el.slider(m, v);
      }, true);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var colors = {
  orange: {
    fg: 'rgb(240,173,78)',
    bg: 'rgb(212,153,70)'
  },
  green: {
    fg: 'rgb(92,184,92)',
    bg: 'rgb(82,160,82)'
  },
  blue: {
    fg: 'rgb(91,192,222)',
    bg: 'rgb(82,169,195)'
  },
  grey: {
    fg: 'rgb(33,33,33)',
    bg: 'rgb(100,100,100)'
  }
};
angular.module('app.directives').directive('dashStatus', ["$filter", function ($filter) {
  return {
    restrict: 'E',
    scope: {
      dashStatus: '@',
      diagnosticStatus: '@',
      broadcast: '=',
      bottomRow: '=bottomRow'
    },
    link: function link(scope, element, attrs) {
      // Split the status string into two separate strings
      var str = $filter('underscoreToSpace')(scope.dashStatus); // Statuses come back with info split by ":" from the API.
      // We make the assumption that any number is indicative of 
      // a status.  The first portion of the split populates our
      // label, the second (if not a number), gets added to a tooltip.
      // Any piece that a number is used to fill out the label's background
      // as if it were a mini progress bar.  We also append the number to
      // tooltip values as a percentage.

      var statusArray = str.split(':'); // Label is the first chunk

      scope.statusLabel = statusArray[0];

      if (scope.broadcast.stream_source == 'imported') {
        scope.statusLabel = 'Uploaded';
      } // Evaluate remaining chunks


      statusArray.splice(0, 1);
      var percent = null;
      var moreInfo = null;

      for (var i = 0; i < statusArray.length; i++) {
        if (parseInt(statusArray[i].match(/\d+/g))) {
          percent = statusArray[i] + "%";
        } else {
          moreInfo = statusArray[i];
        }
      } // Consider states where we want to avoid unnecessary stream health labelling


      scope.hideDiagnostics = false;

      if (scope.dashStatus == 'upcoming' || scope.dashStatus.indexOf('preparing') >= 0 || scope.broadcast.stream_source == 'imported') {
        scope.hideDiagnostics = true;
      }

      if (moreInfo && percent) {
        scope.moreInfo = moreInfo + " at " + percent;
      } else if (percent) {
        scope.moreInfo = percent;
      } else {
        scope.moreInfo = moreInfo;
      } // Override status color and show tooltip if stream diagnostics says a "LIVE" broadcast is struggling.


      var alerts = _.filter(((scope.broadcast || {}).stream_diagnostics || {}).alerts || [], function (a) {
        return a.is_active;
      });

      var hasDiagnosticsAlerts = alerts.length > 0;

      if (scope.dashStatus == 'live' && hasDiagnosticsAlerts) {
        var alertMessages = _.map(alerts, 'message');

        scope.moreInfo = alertMessages.join(',');
      }

      scope.textClassForDiagnosticStatus = function (diagnosticStatus) {
        switch ((diagnosticStatus || '').toLowerCase()) {
          case "ok":
            return 'text-success';

          case "warning":
            return 'text-warning-alt';

          case "critical":
            return 'text-danger';
        }

        return 'text-muted';
      };

      scope.labelStyle = function (status) {
        if (!percent) return; // Mirror the colors used for our '.label' status classes
        // e.g. [ "fillColor" |  "backColor" ]

        var fillColor = colors.blue.fg;
        var backColor = colors.blue.bg;

        if (status === 'live') {
          if (hasDiagnosticsAlerts) {
            fillColor = colors.orange.fg;
            backColor = colors.orange.bg;
          } else {
            fillColor = colors.green.fg;
            backColor = colors.green.bg;
          }
        }

        if (status == 'recorded') {
          fillColor = colors.grey.fg;
          backColor = colors.grey.bg;
        }

        if (/(stalled|catching_up|missed)/i.test(status)) {
          fillColor = colors.orange.fg;
          backColor = colors.orange.bg;
        }

        return "background-image: linear-gradient(to right, ".concat(fillColor, " 0%, ").concat(fillColor, " ").concat(percent, ", ").concat(backColor, " ").concat(percent, ", ").concat(backColor, " 100%);");
      };

      scope.labelClassForStatus = function (status) {
        if (status === 'live') {
          if (hasDiagnosticsAlerts) {
            return 'label-warning';
          } else {
            return 'label-success';
          }
        }

        if (status === 'recorded') {
          return 'label-default';
        }

        if (/(stalled|catching_up|missed)/i.test(status)) {
          return 'label-warning';
        }

        return 'label-info';
      };
    },
    template: "<div>\n        <span class=\"label\" ng-class=\"::labelClassForStatus(dashStatus)\" ng-model=\"statusLabel\" style=\"{{ ::labelStyle(dashStatus) }}\" tooltip=\"{{ ::moreInfo }}\" tooltip-enable=\"::!bottomRow && moreInfo\">\n            {{ ::statusLabel }}\n        </span>\n    </div>\n    <div ng-if=\"::bottomRow\" class=\"bottom-row clearfix\" style=\"margin-left:0;white-space:nowrap;text-overflow:ellipsis;text-transform:capitalize;\">\n        <span ng-if=\"!hideDiagnostics\" class=\"{{textClassForDiagnosticStatus(diagnosticStatus)}}\" style=\"display:inline-block;max-width:50%;padding-right:5px;overflow:hidden;\">\n          <i class=\"fa fa-circle\"></i>\n          {{diagnosticStatus || 'Unknown'}}\n        </span>\n        <span style=\"display:inline-block;max-width:50%;overflow:hidden;\">\n          {{ ::moreInfo }}\n        </span>\n    </div>"
  };
}]).directive('registerWaypoint', function () {
  return {
    restrict: 'A',
    scope: {},
    template: "",
    link: function link(scope, element, attrs) {
      var $shortcut = angular.element(document.getElementById('shortcut-to-top'));
      var waypoint = new Waypoint({
        element: element[0],
        handler: function handler(direction) {// TODO: Add shortcut to scroll to top
        }
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.filters', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(320);

__webpack_require__(321);

__webpack_require__(322);

__webpack_require__(323);

__webpack_require__(324);

__webpack_require__(325);

__webpack_require__(326);

__webpack_require__(327);

__webpack_require__(328);

__webpack_require__(329);

__webpack_require__(330);

__webpack_require__(331);

__webpack_require__(332);

__webpack_require__(333);

__webpack_require__(334);

__webpack_require__(335);

__webpack_require__(336);

__webpack_require__(337);

__webpack_require__(338);

__webpack_require__(339);

__webpack_require__(340);

__webpack_require__(341);

__webpack_require__(342);

__webpack_require__(343);

__webpack_require__(344);

__webpack_require__(345);

__webpack_require__(346);

__webpack_require__(347);

__webpack_require__(348);

__webpack_require__(349);

__webpack_require__(350);

__webpack_require__(351);

__webpack_require__(352);

__webpack_require__(353);

__webpack_require__(354); // View-specific directives


__webpack_require__(355);

/* unused harmony default export */ var _unused_webpack_default_export = (module);

/***/ }),
/* 320 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('accessibility', function () {
  return function (input) {
    var tags = [];

    if (input.is_ticketed) {
      tags.push('ticketed');

      if (input.free_variant !== 'none') {
        tags.push("free: ".concat(input.free_variant));
      }
    }

    if (input.is_private) {
      tags.push('private');
    }

    if (tags.length > 0) {
      return tags.join(', ');
    } else {
      return 'public';
    }
  };
});

/***/ }),
/* 321 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('audioPacketFormat', function () {
  return function (audio) {
    if (audio.dsd == null && audio.hbr == null && audio.multi_channel == null && audio.pcm == null) {
      return '';
    }

    if (audio.dsd) {
      return 'DSD';
    } else if (audio.hbr) {
      return 'HBR';
    } else if (audio.multi_channel) {
      return 'Multi-channel';
    } else if (audio.pcm) {
      return 'PCM';
    } else {
      return '(none)';
    }
  };
});

/***/ }),
/* 322 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('boolean', function () {
  return function (b, trueText, falseText) {
    if (b == null) {
      return '';
    }

    if (b) {
      return trueText || 'Yes';
    } else {
      return falseText || 'No';
    }
  };
});

/***/ }),
/* 323 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('boxcastTvLink', function () {
  return function (showUrl) {
    return (showUrl || '').replace('https://www.boxcast.com/show/#/', 'https://boxcast.tv/channel/');
  };
});

/***/ }),
/* 324 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('boxcasterKey', function () {
  return function (k) {
    if (k == null) {
      return '';
    }

    if (k.set && k.value != null) {
      return k.value;
    } else {
      return '(not set)';
    }
  };
});

/***/ }),
/* 325 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('boxcasterName', function () {
  return function (broadcast) {
    if (broadcast.stream_source === 'switcher') {
      return 'Switcher Studio (iOS)';
    } else if (broadcast.stream_source === 'app') {
      return 'BoxCast Broadcaster (iOS)';
    } else if (broadcast.boxcaster_name) {
      return broadcast.boxcaster_name;
    } else {
      return broadcast.boxcaster_id;
    }
  };
});

/***/ }),
/* 326 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('brandedAppStatus', function () {
  return function (status) {
    var s = status.replace(/_/g, ' ').replace(/boxcast/gi, 'BoxCast');
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
});

/***/ }),
/* 327 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('compositeStandard', function () {
  var STD_525_60 = 1;
  var STD_625_50 = 2;
  return function (std) {
    if (std == null) {
      return '';
    }

    switch (std) {
      case STD_525_60:
        return '525@60';

      case STD_625_50:
        return '625@50';

      default:
        return "None or unknown (".concat(std, ")");
    }
  };
});

/***/ }),
/* 328 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('datespan', ["$filter", function ($filter) {
  var dateFilter = $filter('date');
  var ndash = " ".concat(String.fromCharCode(8211), " ");
  return function (input) {
    var startsAt = new Date(input[0]);
    var stopsAt = new Date(input[1]);
    var from = dateFilter(startsAt, 'MM/dd/yyyy hh:mm a');

    if (stopsAt.getFullYear() >= 9000) {
      return from + ' (open-ended)';
    } else if (startsAt.toDateString() === stopsAt.toDateString()) {
      return from + ndash + dateFilter(stopsAt, 'hh:mm a');
    } else {
      return from + ndash + dateFilter(stopsAt, 'MM/dd/yyyy hh:mm a');
    }
  };
}]);

/***/ }),
/* 329 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('detectedProVideoInput', ["$filter", function ($filter) {
  return function (input) {
    if (input.height > 0 && input.width > 0 && input.framerate > 0) {
      var framerate = input.framerate;
      framerate = Math.round(framerate * 100) / 100;
      return "".concat(input.height).concat(input.interlaced ? 'i' : 'p').concat(framerate);
    } else {
      return '';
    }
  };
}]);

/***/ }),
/* 330 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('detectedVideoInput', ["$filter", function ($filter) {
  var STD_525_60 = 1;
  var STD_625_50 = 2;
  var STD_480i60 = 3;
  var STD_480p60 = 4;
  var STD_576p50 = 5;
  var STD_720p30 = 6;
  var STD_720p50 = 7;
  var STD_720p60 = 8;
  var STD_1080i50 = 10;
  var STD_1080i60 = 11;
  var STD_1080p30 = 12;
  var STD_1080p50 = 13;
  var STD_1080p60 = 14;
  var STD_480p30 = 15;
  var STD_576p25 = 16;
  var STD_720p25 = 17;
  var STD_1080p25 = 18;
  var compositeStandard = $filter('compositeStandard');
  var hdmiStandard = $filter('hdmiStandard');
  return function (adv7842) {
    if (adv7842 == null) {
      return '';
    } else if (adv7842.hdmi && adv7842.hdmi.cable_detected) {
      return hdmiStandard(adv7842.hdmi);
    } else if (adv7842.composite && adv7842.composite.video_detected) {
      return compositeStandard(adv7842.composite.standard);
    } else {
      return '';
    }
  };
}]);

/***/ }),
/* 331 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('facebookLiveSettings', function () {
  return function (settings) {
    if (settings && settings.fb_feed_id && settings.fb_privacy) {
      var feedType = settings.fb_feed_id.split(':', 1)[0];
      var feedId = settings.fb_feed_id.replace(feedType + ':', '');
      var url = null;

      if (settings.permalink_url) {
        url = settings.permalink_url;
      }

      var status = 'Linked';

      if (settings.fb_id) {
        status = 'Published';
      }

      var privacy = null;

      if (settings.fb_privacy == 'EVERYONE') {
        privacy = 'publicly';
      } else if (settings.fb_privacy == 'ALL_FRIENDS') {
        privacy = 'to friends';
      } else if (settings.fb_privacy == 'SELF') {
        privacy = 'privately';
      }

      var byWhom = null;

      if (settings.fb_user_name) {
        byWhom = settings.fb_user_name.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }

      var dest = null;

      switch (feedType) {
        case 'event':
          dest = 'to an event';
          break;

        case 'group': // fall-through

        case 'page':
          dest = 'to a ' + feedType;
          break;

        case 'user':
          dest = "to a user's timeline";
          break;
      }

      return "Facebook: ".concat(url ? "<a href=\"".concat(url, "\" target=\"_blank\">") : '').concat(status).concat(privacy ? " ".concat(privacy) : '').concat(dest ? " ".concat(dest) : '').concat(byWhom ? " by ".concat(byWhom) : '').concat(url ? "</a>" : '');
    } else {
      return 'Facebook: Not linked';
    }
  };
});

/***/ }),
/* 332 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('genericRtmpPushSettings', function () {
  return function (settings) {
    var url = "".concat(settings.stream_url, "/").concat(settings.stream_key);
    var maxRes = '';

    if (settings.max_resolution) {
      maxRes = " (limited to ".concat(settings.max_resolution, "p)");
    }

    return "Generic RTMP: <code>".concat(url, "</code>").concat(maxRes);
  };
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module('app.filters').filter('hdmiStandard', function () {
  var _svga, _vga, _xga;

  var STD_480i60 = 3;
  var STD_480p60 = 4;
  var STD_576p50 = 5;
  var STD_720p30 = 6;
  var STD_720p50 = 7;
  var STD_720p60 = 8;
  var STD_1080i50 = 10;
  var STD_1080i60 = 11;
  var STD_1080p30 = 12;
  var STD_1080p50 = 13;
  var STD_1080p60 = 14;
  var STD_480p30 = 15;
  var STD_576p25 = 16;
  var STD_720p25 = 17;
  var STD_1080p25 = 18; // The following metadata ignored LCVS, just like the BoxCaster firmware does. Otherwise, these
  // represent Table 56 of http://www.analog.com/media/en/technical-documentation/user-guides/UG-214.pdf.

  var graphicsStandards = {
    svga: (_svga = {}, _defineProperty(_svga, 56, {
      bl: 6508,
      lcf: 624,
      fcl: 1997
    }), _defineProperty(_svga, 60, {
      bl: 6039,
      lcf: 626,
      fcl: 1868
    }), _defineProperty(_svga, 72, {
      bl: 4756,
      lcf: 663,
      fcl: 1493
    }), _defineProperty(_svga, 75, {
      bl: 4878,
      lcf: 623.5,
      fcl: 1554
    }), _defineProperty(_svga, 85, {
      bl: 4259,
      lcf: 629.5,
      fcl: 1316
    }), _svga),
    sxga: _defineProperty({}, 60, {
      bl: 3571,
      lcf: 1064.5,
      fcl: 1868
    }),
    vga: (_vga = {}, _defineProperty(_vga, 60, {
      bl: 7272,
      lcf: 524,
      fcl: 1868
    }), _defineProperty(_vga, 72, {
      bl: 6042,
      lcf: 518.5,
      fcl: 1554
    }), _defineProperty(_vga, 75, {
      bl: 6098,
      lcf: 498.5,
      fcl: 1493
    }), _defineProperty(_vga, 85, {
      bl: 5286,
      lcf: 507.5,
      fcl: 1316
    }), _vga),
    xga: (_xga = {}, _defineProperty(_xga, 60, {
      bl: 4726,
      lcf: 803,
      fcl: 1868
    }), _defineProperty(_xga, 70, {
      bl: 4048,
      lcf: 803,
      fcl: 1598
    }), _defineProperty(_xga, 75, {
      bl: 3808,
      lcf: 798.5,
      fcl: 1493
    }), _defineProperty(_xga, 85, {
      bl: 3327,
      lcf: 806.5,
      fcl: 1316
    }), _xga) // TODO: Figure out what the values are for SXGA75, WXGA, SXGA+, UXGA(R), and WSXGA(R)

  }; // The tolerance we allow from the params above. Again, matches the BoxCaster firmware.

  var TOLERANCE = 0.01;
  return function (hdmi) {
    if (!hdmi.cable_detected) {
      return '';
    } else {
      switch (hdmi.standard) {
        case STD_480i60:
          return '480i60';

        case STD_480p60:
          return '480p60';

        case STD_576p50:
          return '576p50';

        case STD_720p30:
          return '720p30';

        case STD_720p50:
          return '720p50';

        case STD_720p60:
          return '720p60';

        case STD_1080i50:
          return '1080i50';

        case STD_1080i60:
          return '1080i60';

        case STD_1080p30:
          return '1080p30';

        case STD_1080p50:
          return '1080p50';

        case STD_1080p60:
          return '1080p60';

        case STD_480p30:
          return '480p30';

        case STD_576p25:
          return '576p25';

        case STD_720p25:
          return '720p25';

        case STD_1080p25:
          return '1080p25';

        default:
          if (!hdmi.interlaced) {
            // Lookup graphics standard
            for (var _i = 0, _Object$keys = Object.keys(graphicsStandards || {}); _i < _Object$keys.length; _i++) {
              var gstd = _Object$keys[_i];
              var rates = graphicsStandards[gstd];

              for (var _i2 = 0, _Object$keys2 = Object.keys(rates || {}); _i2 < _Object$keys2.length; _i2++) {
                var frate = _Object$keys2[_i2];
                var params = rates[frate];
                var _ref = [Math.floor(params.bl * (1 - TOLERANCE)), Math.ceil(params.bl * (1 + TOLERANCE))],
                    blMin = _ref[0],
                    blMax = _ref[1];
                var _ref2 = [Math.floor(params.lcf * (1 - TOLERANCE)), Math.ceil(params.lcf * (1 + TOLERANCE))],
                    lcfMin = _ref2[0],
                    lcfMax = _ref2[1];
                var _ref3 = [Math.floor(params.fcl * (1 - TOLERANCE)), Math.ceil(params.fcl * (1 + TOLERANCE))],
                    fclMin = _ref3[0],
                    fclMax = _ref3[1];

                if (hdmi.bl >= blMin && hdmi.bl <= blMax && hdmi.lcf >= lcfMin && hdmi.lcf <= lcfMax && hdmi.fcl >= fclMin && hdmi.fcl <= fclMax) {
                  return gstd.toUpperCase() + frate.toString();
                }
              }
            }

            return "None or unknown";
          } else {
            return "None or unknown";
          }

      }
    }
  };
});

/***/ }),
/* 334 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('highFrameRate', function () {
  return function (hfr) {
    if (hfr == 'auto') return 'auto';
    return hfr ? 'enabled' : 'disabled';
  };
});

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {angular.module('app.filters').filter('label', ["Config", "$sce", function (Config, $sce) {
  return function (input, collection) {
    if (typeof collection === 'string') {
      collection = Config[collection];
    }

    var selected = _.find(collection, function (e) {
      return e.value === input;
    }); // XXX: using the trustAsHtml means we need to use <span ng-bind-html="foo|label" /> instead of straight {{foo|label}}
    //if selected?.label and selected?.hint
    //  $sce.trustAsHtml("<span title=#{selected.hint}>#{selected.label}</span>")
    //else if selected?.label


    if (selected && selected.label) {
      return selected.label;
    } else if (input === 'unknown') {
      return 'Unknown';
    } else if (!input) {
      return 'Default';
    } else {
      return "Unknown: ".concat(input);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 336 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('macAddress', function () {
  return function (input, separator) {
    if (separator == null) {
      separator = ':';
    }

    if (!!input) {
      return input.match(/.{1,2}/g).join(separator);
    }

    return '';
  };
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_blueimp_md5__);

angular.module('app.filters').filter('md5', function () {
  return function (input) {
    return __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default()(input);
  };
});

/***/ }),
/* 338 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('metricPrefix', ["$filter", function ($filter) {
  var numberWithUnitFilter = $filter('numberWithUnit');
  return function (number, extraText) {
    if (number == null) {
      return '';
    }

    extraText || (extraText = ''); // Reduce the number to be < 1000

    var tridecadic_reduction = 0;

    while (number >= 1000.0) {
      number /= 1000.0;
      tridecadic_reduction += 1;
    }

    var prefix = function () {
      switch (tridecadic_reduction) {
        case 0:
          return '';

        case 1:
          return 'k';

        case 2:
          return 'M';

        case 3:
          return 'G';

        case 4:
          return 'T';

        case 5:
          return 'P';

        default:
          return "10^".concat(3 * tridecadic_reduction, " ");
      }
    }();

    return numberWithUnitFilter(number, 1, prefix + extraText);
  };
}]);

/***/ }),
/* 339 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('numberWithUnit', ["$filter", function ($filter) {
  var numberFilter = $filter('number');
  return function (number, fractionSize, unit) {
    if (number == null) {
      return '';
    }

    unit || (unit = '');
    return "".concat(numberFilter(number, fractionSize), " ").concat(unit);
  };
}]);

/***/ }),
/* 340 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('orderAddress', function () {
  return function (input) {
    if (!input) {
      return '';
    }

    var addrStr = "";

    if (input.name) {
      addrStr += input.name + '\n';
    }

    if (input.company) {
      addrStr += input.company + '\n';
    }

    addrStr += input.line1 + '\n';
    addrStr += "".concat(input.city, ", ").concat(input.state, " ").concat(input.postal_code, " ").concat(input.country);
    return addrStr;
  };
});

/***/ }),
/* 341 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('periscopeSettings', function () {
  return function (settings) {
    if (settings && settings.periscope_display_name && settings.share_url) {
      var url = null;

      if (settings.share_url) {
        url = settings.share_url;
      }

      var tweeted = true;

      if (settings.should_not_tweet) {
        tweeted = !settings.should_not_tweet;
      }

      var byWhom = null;

      if (settings.periscope_display_name) {
        byWhom = settings.periscope_display_name;
      }

      return "Periscope: ".concat(url ? "<a href=\"".concat(url, "\" target=\"_blank\">") : '', "Linked").concat(tweeted ? ' and tweeted' : '').concat(byWhom ? " by ".concat(byWhom) : '').concat(url ? "</a>" : '');
    } else {
      return 'Periscope: Not linked';
    }
  };
});

/***/ }),
/* 342 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('boxcastFlowControl', function () {
  return function (input) {
    var requestedLatency = input[0];
    var targetLatency = input[1];
    var latency = requestedLatency != '' ? requestedLatency : targetLatency;

    switch (latency) {
      case 'default':
        return 'Default BoxCast Flow control (use BoxCaster setting or 2s)';
        break;

      case 'standard':
        return 'Standard BoxCast Flow control (2s)';
        break;

      case 'enhanced':
        return 'Enhanced BoxCast Flow control (15s)';
        break;

      case 'maximum':
        return 'Maximum BoxCast Flow control (45s-90s)';
        break;

      default:
        return "Unknown (".concat(latency, ")");
        break;
    }
  };
});

/***/ }),
/* 343 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('rtmpPushChannelPushSettings', function () {
  return function (settings) {
    var url = "".concat(settings.stream_url, "/").concat(settings.stream_key);
    var maxRes = '';

    if (settings.max_resolution) {
      maxRes = " (limited to ".concat(settings.max_resolution, "p)");
    }

    return "RTMP Push Channel: ".concat(settings.name, " (<code>").concat(url, "</code>)").concat(maxRes);
  };
});

/***/ }),
/* 344 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('sdiHeoVeo', function () {
  return function (val) {
    var heo_ui = val[0];
    var veo_mv = val[1];

    if (heo_ui && heo_ui != 0 && veo_mv && veo_mv != 0) {
      return "HEO: ".concat(heo_ui, " UI, VEO: ").concat(veo_mv, " mV");
    } else {
      return '';
    }
  };
});

/***/ }),
/* 345 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('sdiLinkRate', function () {
  var LINK_RATE_11_88_GBPS = 0;
  var LINK_RATE_5_94_GBPS = 1;
  var LINK_RATE_2_97_GBPS = 2;
  var LINK_RATE_1_48_GBPS = 3;
  var LINK_RATE_0_27_GBPS = 4;
  return function (rate) {
    if (rate === LINK_RATE_11_88_GBPS) {
      return '11.88 Gbps (12G-SDI)';
    } else if (rate === LINK_RATE_5_94_GBPS) {
      return '5.94 Gbps (6G-SDI)';
    } else if (rate === LINK_RATE_2_97_GBPS) {
      return '2.97 Gbps (3G-SDI)';
    } else if (rate === LINK_RATE_1_48_GBPS) {
      return '1.48 Gbps (HD-SDI)';
    } else if (rate === LINK_RATE_0_27_GBPS) {
      return '270 Mbps (SDI)';
    } else {
      return 'None or unknown';
    }
  };
});

/***/ }),
/* 346 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('scoreboardMakeModel', ["$filter", function ($filter) {
  return function (input) {
    if (!input.sport || !input.scoreboard_make || !input.scoreboard_model) {
      return '';
    }

    if (input.scoreboard_make == 'Manual') {
      return input.scoreboard_model; // "Manual Manual Input" is redundant in this case
    }

    return "".concat(input.scoreboard_make, " ").concat(input.scoreboard_model);
  };
}]);

/***/ }),
/* 347 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('source', ["$filter", function ($filter) {
  return function (input) {
    switch (input) {
      case "boxcaster":
        return "BoxCaster";
        break;

      case "rtmp":
        return "RTMP";
        break;

      case "recording":
        return "Simulated Live";
        break;

      default:
        return input;
        break;
    }
  };
}]);

/***/ }),
/* 348 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('timespan', ["$filter", function ($filter) {
  var dateFilter = $filter('date');
  var ndash = " ".concat(String.fromCharCode(8211), " ");
  return function (input) {
    var startsAt = new Date(input[0]);
    var stopsAt = new Date(input[1]);
    var from = dateFilter(startsAt, 'hh:mm a');

    if (stopsAt.getFullYear() >= 9000) {
      return from + ' (open-ended)';
    } else {
      return from + ndash + dateFilter(stopsAt, 'hh:mm a');
    }
  };
}]);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('timestamp', ["$filter", function ($filter) {
  var dateFilter = $filter('date');
  return function (ts) {
    if (ts == null) {
      return '';
    }

    return dateFilter(new Date(ts), 'MM/dd/yyyy hh:mm:ss a');
  };
}]);

/***/ }),
/* 350 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('trackingLink', function () {
  return function (trackingNumber) {
    console.log(trackingNumber.length);

    switch (trackingNumber.length) {
      case 10:
        return "https://www.dhl.com/content/g0/en/express/tracking.shtml?AWB=".concat(trackingNumber, "&brand=DHL");

      case 12:
      case 15:
        return "https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=".concat(trackingNumber);

      case 20:
      case 21:
      case 22:
        return "https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=".concat(trackingNumber);

      default:
        return "";
    }
  };
});

/***/ }),
/* 351 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('transcoderProfile', function () {
  return function (input) {
    var profile = input;
    var lowCost = false;

    if (profile.includes('plc')) {
      lowCost = true;
      profile = profile.replace('plc', 'p');
    }

    var hevc = false;

    if (profile.includes(':hevc')) {
      hevc = true;
      profile = profile.replace(':hevc', '');
    }

    var rtmp = false;

    if (profile.includes(':rtmp')) {
      rtmp = true;
      profile = profile.replace(':rtmp', '');
    }

    var upscaled = false;

    if (profile.includes(':us')) {
      upscaled = true;
      profile = profile.replace(':us', '');
    }

    var passThrough = false;

    if (profile.endsWith("Pass")) {
      passThrough = true;
      profile = profile.replace(/Pass$/, '');
    }

    var only = false;

    if (profile.endsWith("Only")) {
      only = true;
      profile = profile.replace(/Only$/, '');
    }

    var extraStr = '';

    if (lowCost) {
      extraStr = ' (low-cost)';
    } else if (hevc) {
      extraStr = ' (HEVC)';
    } else if (rtmp) {
      extraStr = ' (RTMP)';
    } else if (upscaled) {
      extraStr = ' (HDSD2)';
    } else if (passThrough) {
      extraStr = ' (pass-through)';
    } else if (only) {
      extraStr = ' only';
    }

    return "".concat(profile).concat(extraStr);
  };
});

/***/ }),
/* 352 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('twitterSettings', function () {
  return function (settings) {
    if (settings && settings.twitter_display_name && settings.share_url) {
      var url = null;

      if (settings.share_url) {
        url = settings.share_url;
      }

      var tweeted = true;

      if (settings.should_not_tweet) {
        tweeted = !settings.should_not_tweet;
      }

      var byWhom = null;

      if (settings.twitter_display_name) {
        byWhom = settings.twitter_display_name;
      }

      return "Twitter: ".concat(url ? "<a href=\"".concat(url, "\" target=\"_blank\">") : '', "Linked").concat(tweeted ? ' and tweeted' : '').concat(byWhom ? " by ".concat(byWhom) : '').concat(url ? "</a>" : '');
    } else {
      return 'Twitter: Not linked';
    }
  };
});

/***/ }),
/* 353 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('underscoreToSpace', ["$filter", function ($filter) {
  return function (input) {
    return input.replace(/_/g, ' ');
  };
}]);

/***/ }),
/* 354 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('youtubeLiveSettings', function () {
  return function (settings) {
    if (settings && settings.youtube_account_id && settings.privacy) {
      var url = null;

      if (settings.youtube_broadcast_id && (settings.privacy == 'public' || settings.privacy == 'unlisted')) {
        url = "https://www.youtube.com/watch?v=".concat(settings.youtube_broadcast_id);
      }

      var status = 'Linked';

      if (settings.youtube_broadcast_id) {
        status = 'Published';
      }

      var privacy = null;

      if (settings.privacy == 'public') {
        privacy = 'publicly';
      } else if (settings.privacy == 'private') {
        privacy = 'privately';
      } else if (settings.privacy == 'unlisted') {
        privacy = 'and set unlisted';
      }

      var byWhom = null;

      if (settings.youtube_display_name) {
        byWhom = settings.youtube_display_name.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }

      return "YouTube: ".concat(url ? "<a href=\"".concat(url, "\" target=\"_blank\">") : '').concat(status).concat(privacy ? " ".concat(privacy) : '').concat(byWhom ? " by ".concat(byWhom) : '').concat(url ? "</a>" : '');
    } else {
      return 'YouTube: Not linked';
    }
  };
});

/***/ }),
/* 355 */
/***/ (function(module, exports) {

angular.module('app.filters').filter('dashStatus', ["$filter", function ($filter) {
  return function (input) {
    // Replace the underscores with spaces
    return input.replace(/_/g, ' ');
  };
}]).filter('dashAccessibility', function () {
  return function (input) {
    var tags = [];

    if (input.is_ticketed && input.free_variant === "low") {
      tags.push('flex');
    } else if (input.is_ticketed) {
      tags.push('ticketed');
    }

    if (input.is_private) {
      tags.push('private');
    }

    if (tags.length > 0) {
      return tags.join(', ');
    } else {
      return 'public';
    }
  };
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
 // create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons

var module = angular.module('app.resources', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(357);

__webpack_require__(358);

__webpack_require__(359);

__webpack_require__(360);

__webpack_require__(361);

__webpack_require__(362);

__webpack_require__(363);

__webpack_require__(364);

__webpack_require__(365);

__webpack_require__(366);

__webpack_require__(367);

__webpack_require__(368);

__webpack_require__(369);

__webpack_require__(370);

__webpack_require__(371);

__webpack_require__(372);

__webpack_require__(373);

__webpack_require__(374);

__webpack_require__(375);

__webpack_require__(376);

__webpack_require__(377);

__webpack_require__(378);

__webpack_require__(379);

__webpack_require__(380);

__webpack_require__(381);

__webpack_require__(382);

__webpack_require__(383);

/* unused harmony default export */ var _unused_webpack_default_export = (module);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Account', ["$q", "$resource", function ($q, $resource) {
  var Account = $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:id"), {
    id: '@id'
  }, {
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data) {
        var account = angular.fromJson(data);

        if (!account.internal_metadata) {
          account.internal_metadata = {};
        }

        return account;
      }
    },
    update: {
      method: 'PUT'
    },
    impersonate: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/user/impersonate_account/:id")
    },
    stopImpersonating: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/user/stop_impersonating")
    }
  });

  Account.prototype.hasExtraFeature = function (extraFeature) {
    return this.extra_features.split(/\s+/).indexOf(extraFeature) >= 0;
  };

  Account.prototype.hasFeatureFlag = function (featureFlag) {
    return this.feature_flags.indexOf(featureFlag) >= 0;
  };

  return Account;
}]);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('AccountAppleTvApp', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/apple_tv_apps/:id"), {
    id: '@id',
    account_id: '@account_id'
  }, {
    update: {
      method: 'PUT'
    }
  });
}]);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('AccountRokuApp', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/roku_apps/:id"), {
    id: '@id',
    account_id: '@account_id'
  }, {
    update: {
      method: 'PUT'
    }
  });
}]);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('AccountChannel', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/channels/:id"), {
    account_id: '@account_id',
    id: '@id'
  }, {
    getPublicBroadcasts: {
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/channels/:id/broadcasts?__no_auth__"),
      isArray: true
    }
  });
}]);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('AccountStaticRtmp', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/static_rtmps/:id"), {
    id: '@id',
    account_id: '@account_id'
  });
}]);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('AccountStorageBill', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/storage_bills/:id"), {
    id: '@id',
    account_id: '@account_id'
  }, {
    peek: {
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/storage_bills/peek?starts_at=:starts_at&ends_at=:ends_at")
    }
  });
}]);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('AccountSubscriptions', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/subscriptions"), {
    account_id: '@account_id'
  }, {
    peek: {
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/subscriptions")
    }
  });
}]);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('ActivationCodes', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/activations/:id"), {
    id: '@id'
  }, {
    getSafe: {
      method: 'GET',
      'Interceptor-Ignore-Errors': true
    },
    create: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/activations"),
      isArray: true
    },
    update: {
      method: 'PUT',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/activations/:id")
    },
    list: {
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/activations"),
      isArray: true
    },
    queryAccount: {
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/activations"),
      isArray: true
    }
  });
}]);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Boxcaster', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/boxcasters/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    create: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/boxcasters")
    },
    createBatch: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/boxcasters"),
      isArray: true
    }
  });
}]);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Broadcast', ["$q", "$resource", function ($q, $resource) {
  var Broadcast = $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/broadcasts/:id"), {
    id: '@id'
  }, {
    create: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/broadcasts"),
      transformRequest: function transformRequest(data, headersGetter) {
        if (data.stream_source === 'boxcaster-pro') {
          data.stream_source = 'boxcaster';
        }

        return angular.toJson(data);
      }
    },
    get: {
      method: 'GET',
      transformResponse: function transformResponse(data, headersGetter, status) {
        data = angular.fromJson(data); // Give BoxCaster Pros a unique stream_source ('boxcaster-pro')

        if (data.stream_source === 'boxcaster' && data.boxcaster_id[0] === 'p') {
          data.stream_source = 'boxcaster-pro';
        }

        return data;
      }
    },
    update: {
      method: 'PUT',
      transformRequest: function transformRequest(data, headersGetter) {
        if (data.stream_source === 'boxcaster-pro') {
          data.stream_source = 'boxcaster';
        }

        return angular.toJson(data);
      },
      transformResponse: function transformResponse(data, headersGetter, status) {
        data = angular.fromJson(data); // Give BoxCaster Pros a unique stream_source ('boxcaster-pro')

        if (data.stream_source === 'boxcaster' && data.boxcaster_id[0] === 'p') {
          data.stream_source = 'boxcaster-pro';
        }

        return data;
      }
    },
    undelete: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/broadcasts/:id/undelete")
    },
    query: {
      method: 'GET',
      isArray: true,
      transformResponse: function transformResponse(data, headersGetter, status) {
        data = angular.fromJson(data); // Give BoxCaster Pros a unique stream_source ('boxcaster-pro')

        _.each(data, function (b) {
          if (b.stream_source === 'boxcaster' && b.boxcaster_id[0] === 'p') {
            b.stream_source = 'boxcaster-pro';
          }

          if (b.scoreboard_configuration) {
            b.scoreboard_configuration.sport_icon = (b.scoreboard_configuration.sport || '').toLowerCase();

            if (b.scoreboard_configuration.sport_icon.startsWith('basketball')) {
              b.scoreboard_configuration.sport_icon = 'basketball';
            }

            if (b.scoreboard_configuration.sport_icon.startsWith('baseball')) {
              b.scoreboard_configuration.sport_icon = 'baseball';
            }

            b.scoreboard_configuration.make_icon = (b.scoreboard_configuration.scoreboard_make || '').toLowerCase();

            if (!b.scoreboard_configuration.sport) {
              b.scoreboard_configuration.make_icon = '';
            }

            if (b.scoreboard_configuration.make_icon.startsWith('daktronics')) {
              b.scoreboard_configuration.make_icon = 'automated_scoreboard';
            }

            if (b.scoreboard_configuration.make_icon.startsWith('trans')) {
              b.scoreboard_configuration.make_icon = 'automated_scoreboard';
            }

            if (b.scoreboard_configuration.make_icon.startsWith('oes')) {
              b.scoreboard_configuration.make_icon = 'automated_scoreboard';
            }

            if (b.scoreboard_configuration.make_icon.startsWith('boxcast')) {
              b.scoreboard_configuration.make_icon = 'scoreboard_assist';
            }
          }
        });

        return data;
      }
    }
  });

  Broadcast.queryAll = function (params) {
    var broadcasts = [];
    var d = $q.defer();
    var paramsCopy = angular.copy(params);
    paramsCopy.p = 0;
    Broadcast.query(paramsCopy, function (results, headers) {
      broadcasts = broadcasts.concat(results);
      var pagination = JSON.parse(headers('x-pagination'));

      if (!pagination || !pagination.last) {
        d.resolve(broadcasts);
        return;
      }

      var promises = [];

      for (var p = 1; p <= pagination.last; p++) {
        var paramsCopy2 = angular.copy(params);
        paramsCopy2.p = p;
        promises.push(Broadcast.query(paramsCopy2, function (results) {
          broadcasts = broadcasts.concat(results);
        }).$promise);
      }

      $q.all(promises).then(function () {
        d.resolve(broadcasts);
      })["catch"](function (e) {
        return d.reject(e);
      });
    }, function (err) {
      d.reject(err);
    });
    return d.promise;
  };

  return Broadcast;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('BroadcastUpload', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/broadcasts/:broadcast_id/uploads/:id"), {
    id: '@id',
    broadcast_id: '@broadcast_id'
  });
}]);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Channel', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/channels/:id"), {
    id: '@id'
  }, {
    getPublicBroadcasts: {
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/channels/:id/broadcasts?__no_auth__"),
      isArray: true
    }
  });
}]);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('ChannelTicket', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/channels/:channel_id/tickets/:id"), {
    id: '@id',
    channel_id: '@channel_id'
  }, {
    refund: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/channels/:channel_id/tickets/:id/refund")
    }
  });
}]);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Donation', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/donations/:id"), {
    id: '@id',
    broadcast_id: '@broadcast_id'
  }, {
    refund: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/donations/:id/refund")
    }
  });
}]);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Inventory', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/inventory"));
}]);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Manufacturer', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/manufacturers/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    create: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/manufacturers")
    }
  });
}]);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Order', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/orders/:id"), {
    id: '@id'
  }, {
    query: {
      isArray: true,
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/orders")
    },
    update: {
      method: 'PUT'
    }
  });
}]);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Origin', ["$q", "$resource", function ($q, $resource) {
  var Origin = $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/origins/:id"), {
    id: '@id'
  }, {
    get: {
      method: 'GET'
    },
    drain: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/origins/:id/drain")
    },
    terminate: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/origins/:id/delete")
    }
  });
  return Origin;
}]);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Pandadoc', ["$resource", function ($resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["m" /* INTEGRATIONS_ROOT */], "/pandadoc"), {}, {
    getTemplates: {
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["m" /* INTEGRATIONS_ROOT */], "/pandadoc/templates"),
      isArray: true
    },
    getTemplateFolders: {
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["m" /* INTEGRATIONS_ROOT */], "/pandadoc/template_folders"),
      isArray: true
    }
  });
}]);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Recording', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/recordings/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    segments: {
      method: 'GET',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/recordings/:id/segments"),
      isArray: true
    }
  });
}]);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Reseller', ["$resource", function ($resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/resellers/:id"), {
    id: '@id'
  });
}]);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('ScoreboardAssist', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/scoreboard_assists/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT'
    },
    createBatch: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/scoreboard_assists"),
      isArray: true
    }
  });
}]);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('StorageBill', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/storage_bills/:id"), {
    id: '@id'
  }, {
    charge: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/storage_bills/:id/charge")
    }
  });
}]);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('SuppressedEmail', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/suppressed_email_addresses/:id"));
}]);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Ticket', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/broadcasts/:broadcast_id/tickets/:id"), {
    id: '@id',
    broadcast_id: '@broadcast_id'
  }, {
    refund: {
      method: 'POST',
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/broadcasts/:broadcast_id/tickets/:id/refund")
    },
    queryAccount: {
      method: 'GET',
      isArray: true,
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/tickets")
    },
    queryGlobal: {
      method: 'GET',
      isArray: true,
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/tickets")
    }
  });
}]);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module('app.resources').factory('Upgrade', ["$q", "$resource", function ($q, $resource) {
  return $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/upgrades/:id"), {
    account_id: '@account_id',
    id: '@id'
  }, {
    create: {
      method: 'POST'
    }
  });
}]);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);

angular.module("app.resources").factory("User", ["$q", "$resource", function ($q, $resource) {
  var User = $resource("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/users/:id"), {
    account_id: "@account_id",
    id: "@id"
  }, {
    me: {
      method: "GET",
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/user")
    },
    get: {
      method: "GET",
      transformResponse: function transformResponse(data) {
        var user = angular.fromJson(data);

        if (!user.internal_metadata) {
          user.internal_metadata = {};
        }

        return user;
      }
    },
    update: {
      method: "PUT"
    },
    search: {
      method: "GET",
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/users"),
      isArray: true
    },
    contact: {
      method: "GET",
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/users/:id/contact"),
      // Since 404s will happen for any contact that was deleted from HubSpot,
      // do our own error handling.
      "Interceptor-Ignore-Errors": true
    },
    passwordReset: {
      method: "POST",
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/accounts/:account_id/users/:id/reset_password")
    }
  });

  User.prototype.isAdmin = function () {
    return _.contains(this.roles, "boxcast-admin") || _.contains(this.roles, "boxcast-system-admin") || _.contains(this.roles, "reseller-admin");
  };

  User.prototype.isBoxcastAdmin = function () {
    return _.contains(this.roles, "boxcast-admin") || _.contains(this.roles, "boxcast-system-admin");
  };

  User.prototype.isSystemAdmin = function () {
    return _.contains(this.roles, "boxcast-system-admin");
  };

  User.prototype.isCustomAppDev = function () {
    // XXX: Special dispensation for Gary to be a custom app developer ;-)
    return this.isSystemAdmin() || this.email == "gary.buchanan@boxcast.com" || this.email == "brent.sisley@boxcast.com";
  };

  return User;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
var module = angular.module('app.services', []); // The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.

__webpack_require__(112);

__webpack_require__(387);

__webpack_require__(388);

__webpack_require__(389);

__webpack_require__(390);

__webpack_require__(391);

__webpack_require__(392);

/* unused harmony default export */ var _unused_webpack_default_export = (module);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA256_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD = "function" === 'function' && __webpack_require__(386);
  var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (outputType, is224) {
    return function (message) {
      return new Sha256(is224, true).update(message)[outputType]();
    };
  };

  var createMethod = function (is224) {
    var method = createOutputMethod('hex', is224);
    if (NODE_JS) {
      method = nodeWrap(method, is224);
    }
    method.create = function () {
      return new Sha256(is224);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type, is224);
    }
    return method;
  };

  var nodeWrap = function (method, is224) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var algorithm = is224 ? 'sha224' : 'sha256';
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw new Error(ERROR);
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash(algorithm).update(new Buffer(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  var createHmacOutputMethod = function (outputType, is224) {
    return function (key, message) {
      return new HmacSha256(key, is224, true).update(message)[outputType]();
    };
  };

  var createHmacMethod = function (is224) {
    var method = createHmacOutputMethod('hex', is224);
    method.create = function (key) {
      return new HmacSha256(key, is224);
    };
    method.update = function (key, message) {
      return method.create(key).update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createHmacOutputMethod(type, is224);
    }
    return method;
  };

  function Sha256(is224, sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    if (is224) {
      this.h0 = 0xc1059ed8;
      this.h1 = 0x367cd507;
      this.h2 = 0x3070dd17;
      this.h3 = 0xf70e5939;
      this.h4 = 0xffc00b31;
      this.h5 = 0x68581511;
      this.h6 = 0x64f98fa7;
      this.h7 = 0xbefa4fa4;
    } else { // 256
      this.h0 = 0x6a09e667;
      this.h1 = 0xbb67ae85;
      this.h2 = 0x3c6ef372;
      this.h3 = 0xa54ff53a;
      this.h4 = 0x510e527f;
      this.h5 = 0x9b05688c;
      this.h6 = 0x1f83d9ab;
      this.h7 = 0x5be0cd19;
    }

    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
  }

  Sha256.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
          blocks[4] = blocks[5] = blocks[6] = blocks[7] =
          blocks[8] = blocks[9] = blocks[10] = blocks[11] =
          blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Sha256.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
  };

  Sha256.prototype.hash = function () {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6,
      h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;

    for (j = 16; j < 64; ++j) {
      // rightrotate
      t1 = blocks[j - 15];
      s0 = ((t1 >>> 7) | (t1 << 25)) ^ ((t1 >>> 18) | (t1 << 14)) ^ (t1 >>> 3);
      t1 = blocks[j - 2];
      s1 = ((t1 >>> 17) | (t1 << 15)) ^ ((t1 >>> 19) | (t1 << 13)) ^ (t1 >>> 10);
      blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }

    bc = b & c;
    for (j = 0; j < 64; j += 4) {
      if (this.first) {
        if (this.is224) {
          ab = 300032;
          t1 = blocks[0] - 1413257819;
          h = t1 - 150054599 << 0;
          d = t1 + 24177077 << 0;
        } else {
          ab = 704751109;
          t1 = blocks[0] - 210244248;
          h = t1 - 1521486534 << 0;
          d = t1 + 143694565 << 0;
        }
        this.first = false;
      } else {
        s0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        s1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        ab = a & b;
        maj = ab ^ (a & c) ^ bc;
        ch = (e & f) ^ (~e & g);
        t1 = h + s1 + ch + K[j] + blocks[j];
        t2 = s0 + maj;
        h = d + t1 << 0;
        d = t1 + t2 << 0;
      }
      s0 = ((d >>> 2) | (d << 30)) ^ ((d >>> 13) | (d << 19)) ^ ((d >>> 22) | (d << 10));
      s1 = ((h >>> 6) | (h << 26)) ^ ((h >>> 11) | (h << 21)) ^ ((h >>> 25) | (h << 7));
      da = d & a;
      maj = da ^ (d & b) ^ ab;
      ch = (h & e) ^ (~h & f);
      t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
      t2 = s0 + maj;
      g = c + t1 << 0;
      c = t1 + t2 << 0;
      s0 = ((c >>> 2) | (c << 30)) ^ ((c >>> 13) | (c << 19)) ^ ((c >>> 22) | (c << 10));
      s1 = ((g >>> 6) | (g << 26)) ^ ((g >>> 11) | (g << 21)) ^ ((g >>> 25) | (g << 7));
      cd = c & d;
      maj = cd ^ (c & a) ^ da;
      ch = (g & h) ^ (~g & e);
      t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
      t2 = s0 + maj;
      f = b + t1 << 0;
      b = t1 + t2 << 0;
      s0 = ((b >>> 2) | (b << 30)) ^ ((b >>> 13) | (b << 19)) ^ ((b >>> 22) | (b << 10));
      s1 = ((f >>> 6) | (f << 26)) ^ ((f >>> 11) | (f << 21)) ^ ((f >>> 25) | (f << 7));
      bc = b & c;
      maj = bc ^ (b & d) ^ cd;
      ch = (f & g) ^ (~f & h);
      t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
      t2 = s0 + maj;
      e = a + t1 << 0;
      a = t1 + t2 << 0;
    }

    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
  };

  Sha256.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var hex = HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
      HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F] +
      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h4 >> 28) & 0x0F] + HEX_CHARS[(h4 >> 24) & 0x0F] +
      HEX_CHARS[(h4 >> 20) & 0x0F] + HEX_CHARS[(h4 >> 16) & 0x0F] +
      HEX_CHARS[(h4 >> 12) & 0x0F] + HEX_CHARS[(h4 >> 8) & 0x0F] +
      HEX_CHARS[(h4 >> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F] +
      HEX_CHARS[(h5 >> 28) & 0x0F] + HEX_CHARS[(h5 >> 24) & 0x0F] +
      HEX_CHARS[(h5 >> 20) & 0x0F] + HEX_CHARS[(h5 >> 16) & 0x0F] +
      HEX_CHARS[(h5 >> 12) & 0x0F] + HEX_CHARS[(h5 >> 8) & 0x0F] +
      HEX_CHARS[(h5 >> 4) & 0x0F] + HEX_CHARS[h5 & 0x0F] +
      HEX_CHARS[(h6 >> 28) & 0x0F] + HEX_CHARS[(h6 >> 24) & 0x0F] +
      HEX_CHARS[(h6 >> 20) & 0x0F] + HEX_CHARS[(h6 >> 16) & 0x0F] +
      HEX_CHARS[(h6 >> 12) & 0x0F] + HEX_CHARS[(h6 >> 8) & 0x0F] +
      HEX_CHARS[(h6 >> 4) & 0x0F] + HEX_CHARS[h6 & 0x0F];
    if (!this.is224) {
      hex += HEX_CHARS[(h7 >> 28) & 0x0F] + HEX_CHARS[(h7 >> 24) & 0x0F] +
        HEX_CHARS[(h7 >> 20) & 0x0F] + HEX_CHARS[(h7 >> 16) & 0x0F] +
        HEX_CHARS[(h7 >> 12) & 0x0F] + HEX_CHARS[(h7 >> 8) & 0x0F] +
        HEX_CHARS[(h7 >> 4) & 0x0F] + HEX_CHARS[h7 & 0x0F];
    }
    return hex;
  };

  Sha256.prototype.toString = Sha256.prototype.hex;

  Sha256.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var arr = [
      (h0 >> 24) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 8) & 0xFF, h0 & 0xFF,
      (h1 >> 24) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 8) & 0xFF, h1 & 0xFF,
      (h2 >> 24) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 8) & 0xFF, h2 & 0xFF,
      (h3 >> 24) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 8) & 0xFF, h3 & 0xFF,
      (h4 >> 24) & 0xFF, (h4 >> 16) & 0xFF, (h4 >> 8) & 0xFF, h4 & 0xFF,
      (h5 >> 24) & 0xFF, (h5 >> 16) & 0xFF, (h5 >> 8) & 0xFF, h5 & 0xFF,
      (h6 >> 24) & 0xFF, (h6 >> 16) & 0xFF, (h6 >> 8) & 0xFF, h6 & 0xFF
    ];
    if (!this.is224) {
      arr.push((h7 >> 24) & 0xFF, (h7 >> 16) & 0xFF, (h7 >> 8) & 0xFF, h7 & 0xFF);
    }
    return arr;
  };

  Sha256.prototype.array = Sha256.prototype.digest;

  Sha256.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) {
      dataView.setUint32(28, this.h7);
    }
    return buffer;
  };

  function HmacSha256(key, is224, sharedMemory) {
    var i, type = typeof key;
    if (type === 'string') {
      var bytes = [], length = key.length, index = 0, code;
      for (i = 0; i < length; ++i) {
        code = key.charCodeAt(i);
        if (code < 0x80) {
          bytes[index++] = code;
        } else if (code < 0x800) {
          bytes[index++] = (0xc0 | (code >> 6));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes[index++] = (0xe0 | (code >> 12));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (key.charCodeAt(++i) & 0x3ff));
          bytes[index++] = (0xf0 | (code >> 18));
          bytes[index++] = (0x80 | ((code >> 12) & 0x3f));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        }
      }
      key = bytes;
    } else {
      if (type === 'object') {
        if (key === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
          key = new Uint8Array(key);
        } else if (!Array.isArray(key)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
    }

    if (key.length > 64) {
      key = (new Sha256(is224, true)).update(key).array();
    }

    var oKeyPad = [], iKeyPad = [];
    for (i = 0; i < 64; ++i) {
      var b = key[i] || 0;
      oKeyPad[i] = 0x5c ^ b;
      iKeyPad[i] = 0x36 ^ b;
    }

    Sha256.call(this, is224, sharedMemory);

    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
  }
  HmacSha256.prototype = new Sha256();

  HmacSha256.prototype.finalize = function () {
    Sha256.prototype.finalize.call(this);
    if (this.inner) {
      this.inner = false;
      var innerHash = this.array();
      Sha256.call(this, this.is224, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(innerHash);
      Sha256.prototype.finalize.call(this);
    }
  };

  var exports = createMethod();
  exports.sha256 = exports;
  exports.sha224 = createMethod(true);
  exports.sha256.hmac = createHmacMethod();
  exports.sha224.hmac = createHmacMethod(true);

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha256 = exports.sha256;
    root.sha224 = exports.sha224;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98), __webpack_require__(15)))

/***/ }),
/* 386 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment) {function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function fixNaN(val) {
  if (isNaN(val) || !val) {
    return 0;
  } else {
    return val;
  }
}

var BroadcastService = /*#__PURE__*/function () {
  function BroadcastService() {
    _classCallCheck(this, BroadcastService);

    // Viewer min and max values for normalization
    this.minViewerCount = 0;
    this.maxViewerCount = 0; // Viewer min and max values for normalization

    this.minTicketCount = 0;
    this.maxTicketCount = 0; // Rough returned value ranges included

    this.weight = {
      ending: 15,
      // 0-100
      active: 45,
      // 0-100 (allow floats)
      tickets: 15,
      // 0-100
      status: 75,
      // 0-100
      support: 100,
      // 0-100
      accessibility: 15,
      // -25-50
      source: 88,
      // 0-100
      diagnostics: 25 // 0-100

    };
  } // Magical weighting for sort


  _createClass(BroadcastService, [{
    key: "powerSort",
    value: function powerSort(broadcasts) {
      var _this = this;

      var formatted = {};
      var score = 0; // Get the min/max viewer count

      this.minViewerCount = Math.min.apply(Math, broadcasts.map(function (row) {
        return row.total_active_viewer_count;
      }));
      this.maxViewerCount = Math.max.apply(Math, broadcasts.map(function (row) {
        return row.total_active_viewer_count;
      })); // Get the min/max ticket count

      this.minTicketCount = Math.min.apply(Math, broadcasts.map(function (row) {
        return row.sold_ticket_count;
      }));
      this.maxTicketCount = Math.max.apply(Math, broadcasts.map(function (row) {
        return row.sold_ticket_count;
      }));
      broadcasts.map(function (row) {
        formatted = row;
        score = 0;
        score += _this.weight.ending * fixNaN(_this.scoreTime(row.stops_at, row.total_active_viewer_count));
        score += _this.weight.active * fixNaN(_this.scoreViewerCount(row.total_active_viewer_count));
        score += _this.weight.tickets * fixNaN(_this.scoreTicketCount(row.sold_ticket_count));
        score += _this.weight.status * fixNaN(_this.scoreStatus(row.status));
        score += _this.weight.support * fixNaN(_this.scoreSupportPlan(row.account_support_plan));
        score += _this.weight.accessibility * fixNaN(_this.scoreAccessibility(row.is_private, row.is_ticketed, row.free_variant));
        score += _this.weight.source * fixNaN(_this.scoreSource(row.stream_source));
        score += _this.weight.diagnostics * fixNaN(_this.scoreDiagnostics(row.stream_diagnostics));
        formatted.score = parseInt(score, 10);
        return formatted;
      });
      return broadcasts;
    }
  }, {
    key: "scoreTime",
    value: function scoreTime(stopsAt, viewers) {
      // We only care if you're within the 15-minute window of a broadcast ending
      // and there are people currently viewing
      var secondsLeft = moment(stopsAt).diff(moment(), 'seconds');
      var doesTimeMatter = secondsLeft > 0 && secondsLeft <= 15 * 60 ? true : false;
      return doesTimeMatter ? 1 / secondsLeft * 100 : 0;
    }
  }, {
    key: "scoreViewerCount",
    value: function scoreViewerCount(viewers) {
      var normalized = (viewers - this.minViewerCount) / (this.maxViewerCount - this.minViewerCount) * 100;
      return normalized;
    }
  }, {
    key: "scoreTicketCount",
    value: function scoreTicketCount(tickets) {
      var normalized = !this.maxTicketCount ? 0 : parseInt((tickets - this.minTicketCount) / (this.maxTicketCount - this.minTicketCount) * 100);
      return normalized;
    }
  }, {
    key: "scoreStatus",
    value: function scoreStatus(status) {
      // If a broadcast is live, that's good and somewhat important!
      if (status === 'live') {
        return 15;
      } // Pay more careful attention to broadcasts that are stalled.


      if (/stalled/i.test(status) && !/catching_up/i.test(status)) {
        return 100;
      } // Still on high alert, but probably on track.


      if (/catching_up/i.test(status)) {
        return 65;
      } // All is well, but it's spinning up


      if (/preparing/i.test(status)) {
        return 20;
      }

      return 0; // TODO: Consider % of prepartion?
      // TODO: Consider special cases -- e.g. no video?
    }
  }, {
    key: "scoreDiagnostics",
    value: function scoreDiagnostics(d) {
      var status = (d || {}).status;

      if (status === 'OK') {
        return 0;
      } else if (status === 'Warning') {
        return 50;
      } else if (status === 'Critical') {
        return 100;
      } else {
        return 10; //is it unknown for some strange reason?
      }
    }
  }, {
    key: "scoreSupportPlan",
    value: function scoreSupportPlan(plan) {
      // Embiggenification of higher priority support plan customers
      if (plan === 'reduced') {
        return -100;
      }

      if (plan === 'priority') {
        return 100;
      }

      return 0;
    }
  }, {
    key: "scoreAccessibility",
    value: function scoreAccessibility(isPrivate, isTicketed, freeQuality) {
      var accessibility = 0; // Private events are less exposed

      if (isPrivate) {
        accessibility += -15;
      } // Ticketed events means people spent moola!


      if (isTicketed) {
        accessibility += 50;
      } // Score lower if we're giving away the highest quality broadcast


      if (freeQuality === "low") {
        accessibility += 25;
      }

      return accessibility;
    }
  }, {
    key: "scoreSource",
    value: function scoreSource(streamSource) {
      switch (streamSource) {
        case 'boxcaster-pro':
          // BoxCaster Pros are elevated for now.
          return 100;
          break;
      } // Everybody else... meh...


      return 0;
    }
  }]);

  return BroadcastService;
}();

angular.module('app.services').service('BroadcastService', BroadcastService);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 // Keep track of the config at the window level to help app bootstrapping
// Note: the js/app.coffee has to work the injector a bit to help

var lastConfigFromServer = null;

var ConfigService = /*#__PURE__*/function () {
  ConfigService.$inject = ["$http", "$q"];

  function ConfigService($http, $q) {
    _classCallCheck(this, ConfigService);

    this.$http = $http;
    this.$q = $q; // Streaming quality options on account form

    this.streamingQualityLevels = [{
      value: 'sd',
      label: 'SD - 480 (LEGACY)'
    }, {
      value: 'low_cost',
      label: 'Low-Cost - 720'
    }, {
      value: '720',
      label: 'HD - 720'
    }, {
      value: 'hd',
      label: 'Full HD - 1080'
    } // { value: '4k', label: '4K Ultra HD - 2160' }, // XXX: TODO: Uncomment when 4K is actually supported.
    ]; // Storage rate options

    this.storageRates = [{
      value: 0.49,
      label: '$0.49 / broadcast-hr'
    }, {
      value: 0.25,
      label: '$0.25 / broadcast-hr'
    }]; // Max Broadcast Duration options

    this.maxBroadcastDurations = [{
      value: 1,
      label: '1 Hour'
    }, {
      value: 3,
      label: '3 Hours'
    }, {
      value: 8,
      label: '8 Hours'
    }, {
      value: 24,
      label: '24 Hours'
    }]; // Ticket revenue share options

    this.ticketRevenueShareOptions = [{
      value: "75",
      label: '75 Customer / 25 BoxCast (Default)'
    }, {
      value: "25",
      label: '25 Customer / 75 BoxCast'
    }, {
      value: "50",
      label: '50 Customer / 50 BoxCast'
    }, {
      value: "60",
      label: '60 Customer / 40 BoxCast'
    }, {
      value: "85",
      label: '85 Customer / 15 BoxCast'
    }]; // Roles available for user permissioning

    this.userRoles = []; // Roles available for admin user permissioning

    this.adminRoles = [];
    this.boxcaster = {};
    this.accountTags = [];
    this.accountTagsByCategory = {};
    this.updateFromApi();
  }

  _createClass(ConfigService, [{
    key: "updateFromApi",
    value: function updateFromApi() {
      if (lastConfigFromServer) {
        var deferred = this.$q.defer();
        this.storeApiResult(lastConfigFromServer, this);
        deferred.resolve();
        return this.promise = deferred.promise;
      } else {
        var self = this;
        return this.promise = this.$http.get("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/api_configuration")).then(function (res) {
          return self.storeApiResult(res, self);
        });
      }
    }
  }, {
    key: "storeApiResult",
    value: function storeApiResult(c, self) {
      lastConfigFromServer = c;
      self.accountTags = c.data.account.feature_flags;
      self.accountTagsByCategory = {};

      var categories = _.sortBy(_.uniq(_.pluck(self.accountTags, 'category')), function (c) {
        return c;
      });

      _.each(categories, function (category) {
        var categoryTags = [];

        _.each(self.accountTags, function (tag) {
          if (tag.category === category) {
            categoryTags.push(tag);
          }
        });

        self.accountTagsByCategory[category] = _.sortBy(categoryTags, function (tag) {
          return tag.label;
        });
      });

      self.extraFeatures = c.data.account.extra_features;
      self.usageFlags = c.data.account.usage_flags;
      self.behaviorModifications = c.data.account.behavior_modifications;
      self.markets = angular.copy(c.data.account.markets);
      self.markets.push({
        value: "unknown",
        label: "Unknown"
      });
      self.contractTypes = c.data.account.contract_types;
      self.accountStatuses = c.data.account.statuses;
      self.paymentStatuses = c.data.account.payment_statuses;
      self.paymentMethods = c.data.account.payment_methods || [];
      self.storagePolicies = c.data.account.storage_policies;
      self.supportPlans = c.data.account.support_plans;
      self.boxcaster = c.data.boxcaster;
      self.backhaulProtocols = self.boxcaster.backhaul_protocols;
      self.userRoles = c.data.user_roles;
      self.adminRoles = c.data.admin_roles;
      self.roles = self.userRoles.concat(self.adminRoles);
      return self.timeZones = c.data.time_zones;
    }
  }]);

  return ConfigService;
}();

angular.module('app.services').service('Config', ConfigService);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var ElasticsearchService = /*#__PURE__*/function () {
  ElasticsearchService.$inject = ["$http"];

  function ElasticsearchService($http) {
    _classCallCheck(this, ElasticsearchService);

    this.$http = $http;
  } // Generate a list of ElasticSearch logs indices, assuming we have daily index rotation
  // Called by BroadcastGraph directive using broadcast.starts_at -> stops_at
  // Called by BoxCaster form controller to look at yesterday -> today


  _createClass(ElasticsearchService, [{
    key: "formatIndices",
    value: function formatIndices(fromDate) {
      var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var millisecondsPerDay = 24 * 60 * 60 * 1000; // Loop through from-to and build indices

      var indices = [this.getLogIndexForDate(fromDate)];

      if (toDate && toDate > fromDate) {
        // start with the first UTC moment of the _next_ calendar day after fromDate
        var dt = new Date(new Date(fromDate.getUTCFullYear(), fromDate.getUTCMonth(), fromDate.getUTCDate(), 0, 0, 0).getTime() + millisecondsPerDay);

        while (true) {
          if (dt.getTime() > toDate.getTime() + millisecondsPerDay || dt.getTime() > Date.now()) {
            break;
          }

          var i = this.getLogIndexForDate(dt);

          if (!_.contains(indices, i)) {
            indices.push(i);
          }

          dt = new Date(dt.getTime() + millisecondsPerDay);
        }
      }

      return indices;
    }
  }, {
    key: "getLogIndexForDate",
    value: function getLogIndexForDate(dt) {
      // Don't try to query tomorrow before it actually exists
      // XXX: this is dependent on browser clock, which could be out
      // of sync, but it's the best we got for right now :(
      var now = new Date(),
          nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());

      if (dt > nowUtc) {
        dt = nowUtc;
      }

      var m = (dt.getMonth() + 1).toString(),
          ms = m < 10 ? "0" + m : m,
          d = dt.getDate().toString(),
          ds = d < 10 ? "0" + d : d;
      return "logs-".concat(dt.getUTCFullYear(), "-").concat(ms, "-").concat(ds);
    }
  }, {
    key: "query",
    value: function query(indices, q) {
      return this.$http.post("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["o" /* KIBANA_URL */], "/elasticsearch/").concat(indices.join(','), "/_search"), q, {
        headers: {
          'kbn-version': '6.5.4'
        },
        'Interceptor-Ignore-Errors': true
      });
    }
  }]);

  return ElasticsearchService;
}();

angular.module('app.services').service('ElasticsearchService', ElasticsearchService);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VALID_SUBSCRIPTION_STATUSES = ['active', 'past_due', 'trialing', 'unpaid'];

var FeatureBillingService = /*#__PURE__*/function () {
  FeatureBillingService.$inject = ["Config"];

  function FeatureBillingService(Config) {
    _classCallCheck(this, FeatureBillingService);

    this.Config = Config;
  }

  _createClass(FeatureBillingService, [{
    key: "featureSummary",
    value: function featureSummary(account, billingFeatures) {
      var _this = this;

      var flagMap = _.reduce(this.Config.accountTags, function (acc, item) {
        acc[item.value] = angular.copy(item); //copy to avoid keeping mutated value around

        return acc;
      }, {});

      this.featuresFromAccount(account).forEach(function (key) {
        if (flagMap[key]) {
          flagMap[key].active = true;
        }
      });
      billingFeatures.tags.forEach(function (key) {
        if (flagMap[key]) {
          flagMap[key].withPlan = true;
        }
      });
      var extraFlags = [],
          missingFlags = [];

      _.each(flagMap, function (obj, key) {
        if (obj.beta) {
          return;
        }

        if (obj.active && !obj.withPlan) extraFlags.push(obj);
        if (!obj.active && obj.withPlan) missingFlags.push(obj);
      });

      var supportPlanMismatch = null;
      var billedPlan = billingFeatures.support_plan;

      if (billedPlan !== null && billedPlan != account.support_plan) {
        supportPlanMismatch = {
          billedPlan: billedPlan,
          currentPlan: account.support_plan
        };
      }

      var storagePlanMismatch = null;
      var billedStorage = billingFeatures.storage_policy;

      if (billingFeatures.storage_policy != account.storage_policy || billingFeatures.storage_duration_days != account.storage_duration_days) {
        storagePlanMismatch = {
          billedPolicy: billingFeatures.storage_policy,
          currentPolicy: account.storage_policy,
          billedDurationDays: billingFeatures.storage_duration_days,
          currentDurationDays: account.storage_duration_days
        };
      }

      var streamingQualityMismatch = null;
      var billedResolutionLimit = billingFeatures.resolution_limit;
      var billedLowCost = flagMap.low_cost_plan.withPlan || false;
      var currentResolutionLimit = account.resolution_limit;
      var currentLowCost = flagMap.low_cost_plan.active || false;

      if (billedResolutionLimit != null && billedResolutionLimit != currentResolutionLimit || billedLowCost != null && billedLowCost != currentLowCost) {
        var resolutionLimitAndQualityToLabel = function resolutionLimitAndQualityToLabel(rl, lc) {
          if (rl == 480) {
            return _.find(_this.Config.streamingQualityLevels, function (l) {
              return l.value == 'sd';
            }).label;
          } else if (rl == 720) {
            if (lc) {
              return _.find(_this.Config.streamingQualityLevels, function (l) {
                return l.value == 'low_cost';
              }).label;
            } else {
              return _.find(_this.Config.streamingQualityLevels, function (l) {
                return l.value == '720';
              }).label;
            }
          } else if (rl == 1080) {
            return _.find(_this.Config.streamingQualityLevels, function (l) {
              return l.value == 'hd';
            }).label;
          } else {
            return (_.find(_this.Config.streamingQualityLevels, function (l) {
              return l.value == '4k';
            }) || {}).label;
          }
        };

        var billedStreamingQuality = resolutionLimitAndQualityToLabel(billedResolutionLimit, billedLowCost);
        var currentStreamingQuality = resolutionLimitAndQualityToLabel(currentResolutionLimit, currentLowCost);
        streamingQualityMismatch = {
          billedStreamingQuality: billedStreamingQuality,
          currentStreamingQuality: currentStreamingQuality
        };
      }

      var maxDurationMismatch = null;
      var billedMaxDuration = billingFeatures.max_broadcast_duration_hrs;

      if (billedMaxDuration !== null && billedMaxDuration != account.max_broadcast_duration_hrs) {
        maxDurationMismatch = {
          billedMaxDuration: billedMaxDuration,
          currentMaxDuration: account.max_broadcast_duration_hrs
        };
      }

      var maxSimultaneousMismatch = null;
      var billedMaxSimultaneous = billingFeatures.max_simultaneous_streams;

      if (billedMaxSimultaneous !== null && billedMaxSimultaneous != account.max_simultaneous_streams) {
        maxSimultaneousMismatch = {
          billedMaxSimultaneous: billedMaxSimultaneous,
          currentMaxSimultaneous: account.max_simultaneous_streams
        };
      }

      return {
        flagMap: flagMap,
        extraFlags: extraFlags,
        missingFlags: missingFlags,
        supportPlanMismatch: supportPlanMismatch,
        storagePlanMismatch: storagePlanMismatch,
        streamingQualityMismatch: streamingQualityMismatch,
        maxDurationMismatch: maxDurationMismatch,
        maxSimultaneousMismatch: maxSimultaneousMismatch
      };
    }
  }, {
    key: "featuresFromAccount",
    value: function featuresFromAccount(account) {
      var tags = account.tags.split(' ');
      tags.sort();
      return tags;
    }
  }, {
    key: "removeTag",
    value: function removeTag(tags, tag) {
      var idx = tags.indexOf(tag);

      if (idx >= 0) {
        tags.splice(idx, 1);
      }

      return tags;
    }
  }]);

  return FeatureBillingService;
}();

angular.module('app.services').service('FeatureBillingService', FeatureBillingService);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var RPCService = /*#__PURE__*/function () {
  RPCService.$inject = ["$http", "$q", "$timeout", "$log"];

  function RPCService($http, $q, $timeout, $log) {
    _classCallCheck(this, RPCService);

    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$log = $log;
    this.inFlight = {};
  }

  _createClass(RPCService, [{
    key: "cancelAll",
    value: function cancelAll() {
      var _this = this;

      Object.keys(this.inFlight).forEach(function (handle) {
        return _this.cancel(handle);
      });
    }
  }, {
    key: "cancel",
    value: function cancel(handle) {
      if (this.inFlight[handle]) {
        this.$timeout.cancel(this.inFlight[handle].timeout);
        delete this.inFlight[handle];
      }
    }
  }, {
    key: "call",
    value: function call(boxcaster_id, rpc_data) {
      var _this2 = this;

      var $http = this.$http,
          $timeout = this.$timeout,
          $log = this.$log; // How long to wait when refreshing the RPC (to see if it's done)

      var REFRESH_PERIOD_MS = 2000; // How long to keep refreshing before giving up

      var TIMEOUT_PERIOD_MS = 60000;
      var deferred = this.$q.defer();
      var handle = deferred.promise;
      this.inFlight[handle] = {};
      var post = $http.post("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/boxcasters/").concat(boxcaster_id, "/rpcs"), rpc_data);
      post.success(function (data) {
        var postedTime = new Date(); // We have successfully posted the RPC. Now we refresh it until complete (or timeout).

        var refreshFn = function refreshFn() {
          var get = $http.get("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/boxcasters/").concat(boxcaster_id, "/rpcs/").concat(data.id));
          get.success(function (data) {
            if (data.response != null) {
              // Got it!
              return deferred.resolve(data.response);
            } else {
              // Don't got it... if it's been longer than TIMEOUT_PERIOD_MS, then give up,
              // delete the RPC, and return an error
              var d = new Date();
              var elapsed = d - postedTime;

              if (elapsed > TIMEOUT_PERIOD_MS) {
                $http["delete"]("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["b" /* API_ROOT */], "/boxcasters/").concat(boxcaster_id, "/rpcs/").concat(data.id));
                var msg = "RPC ID ".concat(data.id, " for BoxCaster ").concat(boxcaster_id, " has timed out after ").concat(elapsed / 1000.0, " seconds and has been deleted.");
                deferred.reject(msg);
                $log.error(msg);
              } else if (_this2.inFlight[handle]) {
                // Otherwise, try again later.
                _this2.inFlight[handle].timeout = $timeout(refreshFn, REFRESH_PERIOD_MS);
              } else {// Looks like it was already cancelled, stop trying
              }
            }
          });
          get.error(function (msg, code) {
            deferred.reject(msg);
            $log.error(msg, code);
          });
        };

        _this2.inFlight[handle].timeout = $timeout(refreshFn, REFRESH_PERIOD_MS);
      });
      post.error(function (msg, code) {
        deferred.reject(msg);
        $log.error(msg, code);
      });
      return handle;
    }
  }]);

  return RPCService;
}();

angular.module('app.services').service('RPC', RPCService);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_environment__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var StatsService = /*#__PURE__*/function () {
  StatsService.$inject = ["$http", "$q", "$log"];

  function StatsService($http, $q, $log) {
    _classCallCheck(this, StatsService);

    this.$http = $http;
    this.$q = $q;
    this.$log = $log;
  }

  _createClass(StatsService, [{
    key: "fetch",
    value: function fetch(params) {
      var _this = this;

      // Split targets into groups of 14 so as not to exceed the proxy query string limit
      var chunkSize = 14;
      var targetChunks = [];

      for (var i = 0, end = Math.ceil(1.0 * params.targets.length / chunkSize), asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
        targetChunks.push(params.targets.slice(chunkSize * i, chunkSize * (i + 1)));
      } // Collect actual params for each set of targets


      var chunkParams = _.map(targetChunks, function (targets) {
        var newParams = {
          db: 'metrics',
          epoch: 'ms'
        };
        newParams.q = _.map(targets, function (e) {
          var where = "".concat(params.time.join(" AND "));

          if (params.boxcaster) {
            where += " AND boxcaster_id =~ /^".concat(params.boxcaster, "$/");
          }

          if (params.stream) {
            where += " AND stream_id =~ /^".concat(params.stream, "$/");
          }

          if (params.broadcastId) {
            where += " AND broadcast_id =~ /^".concat(params.broadcastId, "$/");
          }

          if (e.where) {
            where += " AND ".concat(e.where);
          }

          return "SELECT ".concat(e.field, " AS \"").concat(e.as, "\" FROM \"").concat(e.value, "\" WHERE ").concat(where, " GROUP BY time(10s) fill(null)");
        }).join(';');
        return _.map(newParams, function (v, k) {
          return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v));
        }).join('&');
      });

      var deferred = this.$q.defer(); // Collect promises for each request

      var datasource = params.datasource == 'origin' ? __WEBPACK_IMPORTED_MODULE_0_environment__["j" /* GRAFANA_ORIGIN_DATASOURCE */] : __WEBPACK_IMPORTED_MODULE_0_environment__["i" /* GRAFANA_DEFAULT_DATASOURCE */];

      var promises = _.map(chunkParams, function (query) {
        return _this.$http.get("".concat(__WEBPACK_IMPORTED_MODULE_0_environment__["h" /* GRAFANA_API_URL */], "/").concat(datasource, "/query?").concat(query), {
          headers: {
            'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_environment__["g" /* GRAFANA_API_KEY */]
          }
        });
      });

      Promise.all(promises).then(function (responses) {
        // Flatten all the results together
        var values = _.map(responses, function (r) {
          return r.data.results;
        }).reduce(function (a, b) {
          return a.concat(b);
        }); // Map just the values


        values = _.map(values, function (v) {
          if (v.series) {
            return v.series[0].values;
          } else {
            return [];
          }
        }); // Find all the times

        var times = [];

        _.each(values, function (v) {
          return _.each(v, function (e) {
            var t = e[0] / 1000;
            return times.push(t);
          });
        });

        times.sort();
        times = _.uniq(times, true); // Transform the returned data into a hash with targets as keys and datapoints as key-value pairs with times as keys,
        // filling in any non-existent times with nil values

        var newdata = {};

        _.each(params.targets, function (target, idx) {
          var datapoints = {};

          _.each(values[idx], function (dataPoint) {
            return datapoints[dataPoint[0] / 1000] = dataPoint[1];
          });

          _.each(times, function (t) {
            if (!datapoints.hasOwnProperty(t)) {
              return datapoints[t] = null;
            }
          });

          return newdata[target.as] = datapoints;
        });

        return deferred.resolve(newdata);
      }, function (reason) {
        deferred.reject(reason);
        return _this.$log.error(reason);
      });
      return deferred.promise;
    }
  }]);

  return StatsService;
}();

angular.module('app.services').service('StatsService', StatsService);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 393 */
/***/ (function(module, exports) {

Date.prototype.todayRangeUTC = function () {
  var dt = new Date();
  var tz = "0".concat(dt.getTimezoneOffset() / 60 | 0).slice(-2);
  var from = "".concat(dt.getFullYear(), "-").concat("0".concat(dt.getMonth() + 1).slice(-2), "-").concat("0".concat(dt.getDate()).slice(-2), "T").concat(tz, ":00:00Z");
  dt = new Date(dt.getTime() + 86400000);
  var to = "".concat(dt.getFullYear(), "-").concat("0".concat(dt.getMonth() + 1).slice(-2), "-").concat("0".concat(dt.getDate()).slice(-2), "T").concat(tz, ":00:00Z");
  return {
    from: from,
    to: to
  };
};

Date.prototype.rangeUTC = function () {
  var dt = this;
  var tz = "0".concat(dt.getTimezoneOffset() / 60 | 0).slice(-2);
  var from = "".concat(dt.getFullYear(), "-").concat("0".concat(dt.getMonth() + 1).slice(-2), "-").concat("0".concat(dt.getDate()).slice(-2), "T").concat(tz, ":00:00Z");
  dt = new Date(dt.getTime() + 86400000 + 60 * 60 * 1000); //extra hour fixes DST edge transition

  var to = "".concat(dt.getFullYear(), "-").concat("0".concat(dt.getMonth() + 1).slice(-2), "-").concat("0".concat(dt.getDate()).slice(-2), "T").concat(tz, ":00:00Z");
  return {
    from: from,
    to: to
  };
};

/***/ }),
/* 394 */
/***/ (function(module, exports) {

function _toConsumableArray(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _sliceIterator(e,t){var n=[],r=!0,o=!1,a=void 0;try{for(var s,i=e[Symbol.iterator]();!(r=(s=i.next()).done)&&(n.push(s.value),!t||n.length!==t);r=!0);}catch(e){o=!0,a=e}finally{try{r||null==i.return||i.return()}finally{if(o)throw a}}return n}function _slicedToArray(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return _sliceIterator(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}!function(U,X){var G=X.element.prototype.closest;if(!G){var r=["matches","matchesSelector","webkitMatches","webkitMatchesSelector","msMatches","msMatchesSelector","mozMatches","mozMatchesSelector"].reduce(function(e,t){var n;return null!==(n=e)&&void 0!==n?n:t in document.documentElement?t:null},null);G=function(e){for(var t,n=this[0].parentNode;n!==document.documentElement&&null!=n&&!n[r](e);)n=n.parentNode;return(null===(t=n)||void 0===t?void 0:t[r](e))?X.element(n):X.element()}}function K(){var e,t,n,r;return"pageYOffset"in U?{scrollTop:U.pageYOffset,scrollLeft:U.pageXOffset}:{scrollTop:null!==(e=null!==(t=document.documentElement.scrollTop)&&void 0!==t?t:document.body.scrollTop)&&void 0!==e?e:0,scrollLeft:null!==(n=null!==(r=document.documentElement.scrollLeft)&&void 0!==r?r:document.body.scrollLeft)&&void 0!==n?n:0}}function Q(e,t){return e===U?"clientWidth"===t?U.innerWidth:U.innerHeight:e[t]}function d(e,t){var n,r;n=t,r="".concat(e," attribute is deprecated. Pass the options object to vs-repeat attribute instead https://github.com/kamilkp/angular-vs-repeat#options"),console.warn("vs-repeat deprecation: ".concat(r),n[0])}var V={latch:!1,preserveLatchOnRefresh:!1,container:null,scrollParent:null,size:null,offsetBefore:0,offsetAfter:0,scrolledToBeginning:X.noop,scrolledToEnd:X.noop,scrolledToBeginningOffset:0,scrolledToEndOffset:0,scrollMargin:0,horizontal:!1,autoresize:!1,hunked:!1,hunkSize:0},e=X.module("vs-repeat",[]);e.directive("vsRepeat",["$compile","$parse","vsRepeatConfig",function(F,J,Y){return{restrict:"A",scope:!0,compile:function(t,n){var e="vsRepeatContainer"in n?X.element(t[0].querySelector(n.vsRepeatContainer)):t,r=e.children(),o=r.eq(0),L=o[0].outerHTML,W="$vs_collection";["vsSize","vsScrollParent","vsSizeProperty","vsHorizontal","vsOffsetBefore","vsOffsetAfter","vsScrolledToEndOffset","vsScrolledToBeginningOffset","vsExcess","vsScrollMargin"].forEach(function(e){e in n&&d(e,t)});var a=_slicedToArray(function(e){for(var t=["ng-repeat","data-ng-repeat","ng-repeat-start","data-ng-repeat-start"],n=0;n<t.length;n++){var r=t[n];if(e.attr(r))return[r,e.attr(r),0<=r.indexOf("-start")]}throw new Error("angular-vs-repeat: no ng-repeat directive on a child element")}(o),3),q=a[0],s=a[1],H=a[2],i=_slicedToArray(/^\s*(\S+)\s+in\s+([\S\s]+?)(track\s+by\s+\S+)?$/.exec(s),4),j=i[1],N=i[2],D=i[3];if(H)for(var l=0,c=r.eq(l);null==c.attr("ng-repeat-end")&&null==c.attr("data-ng-repeat-end");)l++,c=r.eq(l),L+=c[0].outerHTML;return e.empty(),{pre:function(g,m,e){var t;function n(e){if("number"==typeof e.size)e.getSize=function(){return e.size};else{var t=J(String(e.size));e.getSize=function(e){return t(g,_defineProperty({},j,e))}}}g.vsRepeat={options:_extends({},V,null!==(t=g.$eval(e.vsRepeat))&&void 0!==t?t:{})};var R=g.vsRepeat.options;n(R);var x,z=X.isDefined(e.vsRepeatContainer)?X.element(m[0].querySelector(e.vsRepeatContainer)):m,r=X.element(L),o=r[0].tagName.toLowerCase(),$=[],y=X.element("<"+o+' class="vs-repeat-before-content"></'+o+">"),b=X.element("<"+o+' class="vs-repeat-after-content"></'+o+">"),I=null===R.size,S=R.scrollParent?"window"===R.scrollParent?X.element(U):G.call(z,R.scrollParent):z,w=R.horizontal?"clientWidth":"clientHeight",a=R.horizontal?"offsetWidth":"offsetHeight",T=R.horizontal?"scrollWidth":"scrollHeight",C=R.horizontal?"scrollLeft":"scrollTop";if((g.vsRepeat.totalSize=0)===S.length)throw"Specified scroll parent selector did not match any element";if(g.vsRepeat.$scrollParent=S,g.vsRepeat.sizesCumulative=[],R.debug){var s="window"===R.scrollParent?X.element(document.body):S,i=X.element('<div class="vs-repeat-debug-element"></div>');i.css("position","window"===R.scrollParent?"fixed":"absolute"),s.append(i),g.$on("$destroy",function(){i.remove()})}var O,A,M,_,l,c=Q(S[0],w)||50;function d(){!$||$.length<1?(g[W]=[],x=0,g.vsRepeat.sizesCumulative=[0]):(x=$.length,R.size?u():p()),h()}function u(){var n=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null,e=$.map(function(e){var t;return null!==(t=n)&&void 0!==t?t:R.getSize(e)}),t=0;g.vsRepeat.sizesCumulative=[0].concat(_toConsumableArray(e.map(function(e){return t+=e})))}function p(){I?g.$$postDigest(function(){if(z[0].offsetHeight||z[0].offsetWidth){for(var e=z.children(),t=0,n=!1,r=!1;t<e.length;){if(null!=e[t].attributes[q]||r){if(n||(c=0),n=!0,e[t][a]&&(c+=e[t][a]),!H)break;if(null!=e[t].attributes["ng-repeat-end"]||null!=e[t].attributes["data-ng-repeat-end"])break;r=!0}t++}n&&(u(c),h(),I=!1,g.$root&&!g.$root.$$phase&&g.$digest())}else var o=g.$watch(function(){(z[0].offsetHeight||z[0].offsetWidth)&&(o(),p())})}):u(c)}function B(n){var r=R.horizontal?"width":"height";return["","min-","max-"].reduce(function(e,t){return e["".concat(t).concat(r)]=n,e},{})}function v(){var e=S[0][C];k()&&(g.$digest(),R._ensureScrollIntegrity&&(S[0][C]=e))}function f(){R.autoresize&&(I=!0,p(),g.$root&&!g.$root.$$phase&&g.$digest()),k()&&g.$digest()}function h(){var e;A=O=void 0,R.preserveLatchOnRefresh&&void 0!==M&&void 0!==_||(M=x,_=0),e=g.vsRepeat.sizesCumulative[x],g.vsRepeat.totalSize=R.offsetBefore+e+R.offsetAfter,k(),g.$emit("vsRepeatReinitialized",g.vsRepeat.startIndex,g.vsRepeat.endIndex)}function E(){var e=Q(S[0],w);e!==l&&(h(),g.$root&&!g.$root.$$phase&&g.$digest()),l=e}function P(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0,r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:e.length-1,o=4<arguments.length&&void 0!==arguments[4]?arguments[4]:1;if(e[n]===t)return[n,n,o];if(e[r]===t)return[r,r,o];if(1<r-n){var a=Math.floor((n+r)/2);return e[a]>t?P(e,t,n,a,o+1):P(e,t,a,r,o+1)}return[t>e[r]?r:n,t<e[n]?n:r,o]}function k(){var e,t,n=(e=S[0],t=C,e===U?K()[t]:e[t]),r=Q(S[0],w);R.debug&&(r/=2);var o,a,s,i=z[0]===S[0]?0:(o=z[0],a=S[0],s=R.horizontal,o.getBoundingClientRect()[s?"left":"top"]-(a===U?0:a.getBoundingClientRect()[s?"left":"top"])+(a===U?K():a)[s?"scrollLeft":"scrollTop"]),l=g.vsRepeat.startIndex,c=g.vsRepeat.endIndex;if(I&&!R.size)l=0,c=1;else{g.$$postDigest(function(){U.requestAnimationFrame(function(){var e=g.vsRepeat.sizesCumulative[x],n=U.getComputedStyle(z[0]),t=R.horizontal?["paddingLeft","paddingRight"]:["paddingTop","paddingBottom"],r=z[0][T]-t.reduce(function(e,t){return e+Number(n[t].slice(0,-2))},0);!Y.sizeMismatchWarningsSilenced&&z[0][T]&&e!==r&&console.warn("vsRepeat: size mismatch. Expected size "+e+"px whereas actual size is "+r+"px. Fix vsSize on element:",m[0])})});var d=n-R.offsetBefore-i;l=_slicedToArray(P(g.vsRepeat.sizesCumulative,d-R.scrollMargin),1)[0],l=Math.max(l,0),c=_slicedToArray(P(g.vsRepeat.sizesCumulative,d+R.scrollMargin+r,l),2)[1],c=Math.min(c,x)}M=Math.min(l,M),_=Math.max(c,_),g.vsRepeat.startIndex=R.latch?M:l,g.vsRepeat.endIndex=R.latch?_:c,_<g.vsRepeat.startIndex&&(g.vsRepeat.startIndex=_);var u=!1;if(null==O?u=!0:null==A&&(u=!0),u||(R.hunked?Math.abs(g.vsRepeat.startIndex-O)>=R.hunkSize||0===g.vsRepeat.startIndex&&0!==O?u=!0:(Math.abs(g.vsRepeat.endIndex-A)>=R.hunkSize||g.vsRepeat.endIndex===x&&A!==x)&&(u=!0):u=g.vsRepeat.startIndex!==O||g.vsRepeat.endIndex!==A),u){var p;g[W]=$.slice(g.vsRepeat.startIndex,g.vsRepeat.endIndex),g.$emit("vsRepeatInnerCollectionUpdated",g.vsRepeat.startIndex,g.vsRepeat.endIndex,O,A),R.scrolledToEnd&&(p=$.length-R.scrolledToEndOffset,(g.vsRepeat.endIndex>=p&&A<p||$.length&&g.vsRepeat.endIndex===$.length)&&g.$eval(R.scrolledToEnd)),R.scrolledToBeginning&&(p=R.scrolledToBeginningOffset,g.vsRepeat.startIndex<=p&&O>g.vsRepeat.startIndex&&g.$eval(R.scrolledToBeginning)),O=g.vsRepeat.startIndex,A=g.vsRepeat.endIndex;var v=g.vsRepeat.sizesCumulative[g.vsRepeat.startIndex]+R.offsetBefore,f=g.vsRepeat.sizesCumulative[g.vsRepeat.startIndex+g[W].length]+R.offsetBefore,h=g.vsRepeat.totalSize;y.css(B(v+"px")),b.css(B(h-f+"px"))}return u}R.horizontal?(y.css("height","100%"),b.css("height","100%")):(y.css("width","100%"),b.css("width","100%")),e.vsRepeatOptions&&g.$watchCollection(e.vsRepeatOptions,function(e){var t=_extends({},R,e);JSON.stringify(t)!==JSON.stringify(R)&&(Object.assign(R,e),n(R),h())}),g.$watchCollection(N,function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:[];$=e,d()}),r.eq(0).attr(q,j+" in "+W+(D?" "+D:"")),r.addClass("vs-repeat-repeated-element"),z.append(y),z.append(r),F(r)(g),z.append(b),g.vsRepeat.startIndex=0,g.vsRepeat.endIndex=0,S.on("scroll",v),X.element(U).on("resize",f),g.$on("$destroy",function(){X.element(U).off("resize",f),S.off("scroll",v)}),g.$on("vsRepeatTrigger",d),g.$on("vsRepeatResize",function(){I=!0,p()}),g.$on("vsRenderAll",function(){R.latch&&(g.vsRepeat.endIndex!==x?setTimeout(function(){var e=x;_=Math.max(e,_),g.vsRepeat.endIndex=R.latch?_:e,g[W]=$.slice(g.vsRepeat.startIndex,g.vsRepeat.endIndex),A=g.vsRepeat.endIndex,y.css(B(0)),b.css(B(0)),g.$emit("vsRenderAllDone"),g.$root&&!g.$root.$$phase&&g.$digest()}):g.$emit("vsRenderAllDone"))}),g.$watch(function(){"function"==typeof U.requestAnimationFrame?U.requestAnimationFrame(E):E()})}}}}}]),e.provider("vsRepeatConfig",function(){var e=!1;return{silenceSizeMismatchWarnings:function(){console.warn("vsRepeat size mismatch warnings silenced - not recommended"),e=!0},$get:function(){return{get sizeMismatchWarningsSilenced(){return e}}}}}),X.element(document.head).append('<style id="angular-vs-repeat-style">\n\t  \t.vs-repeat-debug-element {\n        top: 50%;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background: red;\n        z-index: 99999999;\n        box-shadow: 0 0 20px red;\n      }\n\n      .vs-repeat-debug-element + .vs-repeat-debug-element {\n        display: none;\n      }\n\n      .vs-repeat-before-content,\n      .vs-repeat-after-content {\n        border: none !important;\n        padding: 0 !important;\n      }\n    </style>'),"undefined"!=typeof module&&module.exports&&(module.exports=e.name)}(window,window.angular);

/***/ })
],[113]);


// WEBPACK FOOTER //
// app.832a2534ed4f8aa04dd4.js